// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/gif;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAeCAYAAADaW7vzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Q0NBRjI1NjM0M0UwMTFFNDk4NkFGMzJFQkQzQjEwRUIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Q0NBRjI1NjQ0M0UwMTFFNDk4NkFGMzJFQkQzQjEwRUIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpDQ0FGMjU2MTQzRTAxMUU0OTg2QUYzMkVCRDNCMTBFQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDQ0FGMjU2MjQzRTAxMUU0OTg2QUYzMkVCRDNCMTBFQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PoNEP54AAAIOSURBVHja7Jq9TsMwEMcxrZD4WpBYeKUCe+kTMCACHZh4BFfHO/AAIHZGFhYkBBsSEqxsLCAgXKhbXYOTxh9pfJVP+qutnZ5s/5Lz2Y5I03QhWji2GIcgAokWgfCxNvcOCCGKqiSqhUp0laHOne05vdEyGMfkdxJDVjgwDlEQgYQBgx+ULJaWSXXS6r/ER5FBVR8VfGftTKcITNs+a1XpcFoExREIDF14AVIFxgQUS+h520cdud6wNkC0UBw6BCO/HoCYwBhD8QCkQ/x1mwDyD4plh4D6DDV0TAGyo4HcawLIBBSLDkHeH0Mg2yVP3l4TQMZQDDsEOl/MgHQqhMNuE0D+oBh0CIr8MAKyazBH9WyBuKxDWgbXfjNf32TZ1KWm/Ap1oSk/R53UtQ5xTh3LUlMmT8gt6g51Q9p+SobxgJQ/qmsfZhWywGFSl0yBjCLJCMgXail3b7+rumdVJ2YRss4cN+r6qAHDkPWjPjdJCF4n9RmAD/V9A/Wp4NQassDjwlB6XBiCxcJQWmZZb8THFilfy/lfrTvLghq2TqTHrRMTKNJ0sIhdo15RT+RpyWwFdY96UZ/LdQKBGjcXpcc1AlSFEfLmouD+1knuxBDUVrvOBmoOC/rEcN7OQxKVeJTCiAdUzUJhA2Oez9QTkp72OTVcxDcXY8iKNkxGAJXmJCOQwOa6dhyXsOa6XwEGAKdeb5ET3rQdAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAeCAYAAADaW7vzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QUExQUUzOTA0M0UyMTFFNDlBM0FFQTJENTExRDVBODYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QUExQUUzOTE0M0UyMTFFNDlBM0FFQTJENTExRDVBODYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpBQTFBRTM4RTQzRTIxMUU0OUEzQUVBMkQ1MTFENUE4NiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBQTFBRTM4RjQzRTIxMUU0OUEzQUVBMkQ1MTFENUE4NiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pp0VxGEAAAIASURBVHja7JrNSgMxEMebtgh+3MSLr1T1Xn2CHoSKB08+QmR8Bx9A8e7RixdB9CKCoNdexIugxFlJa7rNZneTbLIpM/CnNLsdMvNjM8l0mRCiQ9Ye61IKCAgZAUnH+mU3MMZaHYChBnJUDzWOFZdVfc5+ZFLbrWDeXPwbxIqrLLfaeS0hEBVGIRQCEiZoHQwtlGSByCCdYBl8g8egTTAWoKQMRBRBcZxYlhzhKegqMOageErsCHVkk3hXIFooDgHB1KkHIHVgzKB4ADJQ/A1jAFmAYhkQqA5TOBtocrKrgXwQA8gcFIuAIO8sQSA7hidvPwaQGZSaAYHOUWJABhWWw2EMIH9QagQERU4SArJXo0ZZL18uvaxejXt/Em8xjVBXmvFr1KVm/AJ10tRe2XnraNqaJvKE3KHuUbfK1E+VHB0q40/y3sdQSxY4FHWeKJCunP8UyDdqJZenT3ntVV5jIYCAh20vT7ioP8tpf6E2lfEMwERe+whV1MHjwZB7PBiCxcGQWwKZKD62lfGNnP/1poFAA60T7rF1UgcKd2id3KDeUS+oLWV8DfWAepOfq00CgQabi9zjcgJVYVD7PVzQUAUGAQkbNJTBICDhgwYTjDYD6XeW08ZKh+A4pYkzenOxXUbvZcWz7E8ykRMnIHGX1XPl+1m2vPYpL+2qdb8CDAARlKFEz/ZVkAAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:application/x-font-ttf;charset=utf-8;base64,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", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Public Sans" !important;
  background-color: #e4e4e4;
}

.login-button {
  margin-block: 2rem;
}

@keyframes login-slide {
  0% {
    width: 0rem;
  }

  100% {
    width: 27rem;
  }
}

.login-form {
  border-radius: 17px 0px 0px 17px;
  width: 0;
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  opacity: 0.9;
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
  animation: login-slide 0.8s forwards;
}

.login-textbox {
  width: 20rem;
  height:37px;
  background-color: #fff;
}

.login-custom {
  margin-inline: 3rem;
}

.login-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  position: fixed;
  width: 100%;
  height: 100%;
  animation: opac 3s forwards;
}

.eye-icon {
  position: absolute;
  top: 54%;
  transform: translateY(-50%);
  right: 5rem;
  cursor: pointer;
}

.primary-button {
  background-color: #00C292;
  border: 0px;
  color: #ffff;
  padding-block: 5.2px;
  padding-inline: 1rem;
  display: flex;
  cursor: pointer;
}

.cus-main-header {
  position: fixed !important;
}

.page-main-header .main-header-left .logo-wrapper img {
  height: auto;
}

.page-wrapper .page-main-header {
  height: 45px;
}

.page-main-header .main-header-left .logo-wrapper {
  height: 62px;
}

.sidemenu {
  position: absolute;
  left: -5px;
  z-index: 11;
  top: 25px;
  background: #e4e4e4;
  padding: 5px 10px;
  border-radius: 100%;
}
.anchor-down {
  position: absolute;
  content: "";
  left: 50%;
  bottom: -24px; /* Adjust this based on your layout */
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #fff; /* Color of the triangle */
  transform: translateX(-50%);
}
.anchor-down1 {
  position: absolute;
  content: "";
  left: 50%;
  bottom: -38px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #fff;
  transform: translateX(-50%);
}
.page-wrapper .page-body-wrapper .page-body {
  min-height: calc(100vh - 80px);
  margin-top: 40px;
  padding-top: 40px;
  padding-left: 45px;
}

.page-wrapper .page-body-wrapper .page-sidebar {
  top: 40px;
  position: absolute;
}
.bold-header{
  font-weight: 700;
  color:#000
}
.page-wrapper .page-body-wrapper .page-body {
  background: #f7f7f7 !important;
}
.rm-br{
  border-right: 0px !important;
}
.topmenu {
  position: absolute;
  top: 8px;
  z-index: 8;
  right: 35px;
  background: #e4e4e4;
  padding: 5px 5px 5px 5px;
  border-radius: 100%;
}

.emptyli {
  width: 45px;
}

.onhover-show-div {
  top: 60px;
}
.custom-LR-btn{
  min-width: 210px;
}
.topbar-close {
  transform: translateY(-40px);
  transition: 0.5s;
}

.movetp {
  top: 37px;
  transition: 0.5s;
  border-radius: 0;
  right: 42px;
  background: #fff;
}

.pbdy {
  margin-top: 0px !important;
  transition: 0.5s;
}

.whgb {
  background-color: #fff !important;
  padding: 10px 10px;
}

.whbg-bg {
  width: 57px;
  position: absolute;
  height: 57px;
  border-radius: 15px;
  left: -30px;
  z-index: 11;
  top: 15px;
  background: #fff;
  transform: rotate(45deg);
}

.map-legends.row.col-xl-12.col-lg-12 img {
  height: 24px;
  width: 24px;
}

#mapweather button.gm-ui-hover-effect {
  display: none !important;
}

.weather-marker-tooltip {
  padding: 9px;
  color: #6e3c7e;
}

.weather-marker-tooltip .forecast-labels {
  font-weight: bold;
}

.weather-marker-tooltip .forecast-date,
.address,
.weather-desc,
.last-updated {
  font-weight: 400;
}

#mapweather .gm-style .gm-style-iw-c {
  position: absolute;
  box-sizing: border-box;
  overflow: hidden;
  top: 0;
  left: 0;
  height: 13em !important;
  transform: translate(-50%, -100%);
  background-color: white;
  border-radius: 0px !important;
  padding: 12px;
  box-shadow: 0 2px 7px 1px rgba(0, 0, 0, 0.3);
}

.bluebg {
  background: #fff !important;
  top: 60px;
  left: -18px;
  padding: 0;
}

.vline {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 11;
  background: #fff;
  width: 4px;
  height: 100%;
}

#inner {
  transform: rotate(45deg);
  /*background-color: #e4e4e4;*/
  background: transparent;
  width: 75px;
  height: 75px;
  top: 50px;
  left: 33px;
  position: relative;
  border-radius: 20px;
}

#outer {
  width: 88px;
  /* height: 115px; */
  top: 10px;
  left: 10px;
  overflow: hidden;
  border: 0px solid red;
}

#outer1 {
  width: 125px;
  height: 115px;
  top: 10px;
  left: 10px;
  overflow: hidden;
  border: 0px solid red;
}

#sinner {
  transform: rotate(45deg);
  background-color: #fff;
  width: 75px;
  height: 75px;
  top: 23px;
  left: 33px;
  position: relative;
  border-radius: 20px;
  transition: 0.5s;
}

#souter {
  width: 125px;
  height: 115px;
  top: 10px;
  left: 10px;
  overflow: hidden;
  border: 0px solid red;
}

#ssinner {
  width: 57px;
  position: absolute;
  height: 57px;
  border-radius: 15px;
  left: -20px;
  z-index: 11;
  top: 46px;
  background: #e4e4e4;
  transform: rotate(45deg);
}

#ssinnerOpen {
  width: 70px;
  position: absolute;
  height: 70px;
  border-radius: 15px;
  left: -30px;
  z-index: 11;
  top: 0px;
  background: #e4e4e4;
  transform: rotate(45deg);
}

.row.col-xl-12.col-lg-12.ml-0p.n-p-0.mt-20p.road-pick-up-grid {
  margin-top: -1%;
  padding-left: 68% !important;
}

.flitrblock {
  width: 230px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 12;
  background: #fff;
}

.trucks-dropdown {
  background: white;
  /* height: 18em; */
  width: 17em;
  position: absolute;
  overflow-y: scroll;
  left: 32px;
  z-index: 1000;
  top: 36px;
  border-radius: 5px;
  border: 0.1px solid cornflowerblue;
}

.trucks-dropdown>ul>li {
  padding: 10px;
  padding-left: 13px;
}

.trucks-dropdown>ul>li:hover {
  background: #e4e4e4;
}

.transporter-dropdown {
  background: white;
  height: 18em;
  width: 22.3em;
  position: absolute;
  overflow-y: scroll;
  left: 32px;
  z-index: 1000;
  top: 36px;
  border-radius: 5px;
  border: 0.1px solid cornflowerblue;
}

.transporter-dropdown>ul>li {
  padding: 10px;
  padding-left: 13px;
}

.transporter-dropdown>ul>li:hover {
  background: #e4e4e4;
}

.cellStyleRed {
  background: #ff90a3
}

.cellStyleGridHeader {
  background: #FEFFC9 !important
}

.shwfilt {
  display: none;
}

.brd {
  position: absolute;
  left: 0;
  top: 0;
  width: 7px;
  height: 100%;
}

.brd-gry {
  background: #ccc;
}

.brd-gb {
  background: #22aade;
}

.brd-gb1 {
  background: #22debb;
}

.brd-gb2 {
  background: #ded022;
}

.brd-gb3 {
  background: #dead22;
}

.brd-gb4 {
  background: #de7922;
}

.brd-txt1 {
  background: #ab8ce4
}

.brd-txt2 {
  background: #26c6da
}

.brd-txt3 {
  background: #00c292
}

.brd-txt4 {
  background: #4099ff
}

.brd-txt5 {
  background: #ff7700
}

.fnt3 {
  font-size: 3rem;
}

.stat-widget-dashboard .media img {
  width: 50px;
}

.card-header {
  padding: 10px !important;
}

.n-p-0 {
  padding: 0 !important;
}

.f10 {
  font-size: 10px;
}

.f13 {
  font-size: 13px;
}

.f14 {
  font-size: 14px;
}

.f15 {
  font-size: 15px;
}

.card .card-header h5 {
  text-transform: none !important;
  font-size: 13px;
}

.cust-btn {
  border-radius: 0px;
  height: 38px;
}

.pb-0 {
  padding-bottom: 0px !important;
}

.p-r0 {
  padding-right: 0px;
}

.p-l0 {
  padding-left: 0px;
}

.border-radius-0 {
  border-radius: 0px;
}

.tmenus {
  margin: 0 0 20px 0;
  padding: 0
}

.tmenus li {
  display: inline;
  padding: 10px;
}

.tmenus li a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
  padding: 10px;
  background: #daebfd;
}

.tmenus li a:hover {
  background: #e6ddf7;
}

.h-title {
  font-size: 1.1rem;
  margin-bottom: 30px;
}

.h-title span {
  margin-top: 2px;
  margin-left: 10px;
}

.cus-i {
  font-size: 1.5rem;
}

.cs-btn {
  padding: 0.375rem 0.75rem;
  margin: 0px 10px 0 0px;
}

.white-bg {
  background: #fff;
  padding: 10px;
}

.form-control {
  border: 1px solid #b5b5b5;
  font-size: 0.8rem;
  border-radius: 5px;
}

label.c-lbl {
  margin-top: 5px;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
}

.cs-radio {
  margin: 4px 5px 0 0;
}

.mt-5p {
  margin-top: 5px;
}

.mt-8p {
  margin-top: 8px;
}

.mt-9p {
  margin-top: 9px;
}

.mt-10p {
  margin-top: 10px;
}

.mt-15p {
  margin-top: 15px;
}

.mt-20p {
  margin-top: 20px;
}

.mt-21p {
  margin-top: 21px;
}

.mt-22p {
  margin-top: 22px;
}

.mt-23p {
  margin-top: 23px;
}

.mt-24p {
  margin-top: 24px;
}

.mt-25p {
  margin-top: 25px;
}

.mt-26p {
  margin-top: 26px;
}

.mt-27p {
  margin-top: 27px;
}

.mt-28p {
  margin-top: 28px;
}

.mt-29p {
  margin-top: 29px;
}

.mt-30p {
  margin-top: 30px;
}

.mt-35p {
  margin-top: 35px;
}

.mt-40p {
  margin-top: 40px;
}

.mt-50p {
  margin-top: 50px;
}

.mt-60p {
  margin-top: 60px;
}

.mt-70p {
  margin-top: 70px;
}

.mt-80p {
  margin-top: 80px;
}


.ml-0p {
  margin-left: 0px;
}

.ml-5p {
  margin-left: 5px;
}

.ml-8p {
  margin-left: 8px;
}

.ml-10p {
  margin-left: 10px;
}

.ml-15p {
  margin-left: 15px;
}

.ml-18p {
  margin-left: 18px;
}

.ml-20p {
  margin-left: 20px;
}

.ml-30p {
  margin-left: 30px;
}

.ml-40p {
  margin-left: 40px;
}

.ml-50p {
  margin-left: 50px;
}

.ml-60p {
  margin-left: 60px;
}

.ml-70p {
  margin-left: 70px;
}

.ml-80p {
  margin-left: 80px;
}


.mr-5p {
  margin-right: 5px !important;
}

.mr-8p {
  margin-right: 8px !important;
}

.mr-10p {
  margin-right: 10px !important;
}

.mr-20p {
  margin-right: 20px !important;
}

.mr-30p {
  margin-right: 30px !important;
}

.mr-40p {
  margin-right: 40px !important;
}

.mr-50p {
  margin-right: 50px !important;
}

.mr-60p {
  margin-right: 60px !important;
}

.mr-70p {
  margin-right: 70px !important;
}

.mr-80p {
  margin-right: 80px !important;
}

.rd-text {
  margin-right: 10px !important;
}

.mb-0p {
  margin-bottom: 0px !important;
}

.mb-5p {
  margin-bottom: 5px !important;
}

.mb-10p {
  margin-bottom: 10px !important;
}

.mb-15p {
  margin-bottom: 15px !important;
}

.mb-20p {
  margin-bottom: 20px !important;
}

.mb-25p {
  margin-bottom: 25px !important;
}

.mb-30p {
  margin-bottom: 30px !important;
}

.mb-40p {
  margin-bottom: 40px !important;
}

.mb-50p {
  margin-bottom: 50px !important;
}

.mb-60p {
  margin-bottom: 60px !important;
}

.mb-70p {
  margin-bottom: 70px !important;
}

.pl-0px {
  padding-left: 0px !important;
}

.pl-10px {
  padding-left: 10px !important;
}

.pl-15px {
  padding-left: 15px !important;
}

.pl-20px {
  padding-left: 20px !important;
}

.pl-25px {
  padding-left: 25px !important;
}

.pl-26px {
  padding-left: 26px !important;
}

.pr-0px {
  padding-right: 0px !important;
}

.pr-10px {
  padding-right: 10px !important;
}

.pr-15px {
  padding-right: 15px !important;
}

.pr-20px {
  padding-right: 20px !important;
}

.pr-25px {
  padding-right: 25px !important;
}

.pr-26px {
  padding-right: 26px !important;
}

.pt-0px {
  padding-top: 0px !important;
}

.pt-10px {
  padding-top: 10px !important;
}

.pt-15px {
  padding-top: 15px !important;
}

.pt-20px {
  padding-top: 20px !important;
}

.pt-25px {
  padding-top: 25px !important;
}

.pt-26px {
  padding-top: 26px !important;
}

.pb-0px {
  padding-bottom: 0px !important;
}

.pb-5px {
  padding-bottom: 5px !important;
}

.pb-10px {
  padding-bottom: 10px !important;
}

.p-0px {
  padding: 0px !important;
}

.p-2px {
  padding: 2px !important;
}

.p-4px {
  padding: 4px !important;
}

.p-5px {
  padding: 5px !important;
}

.p-6px {
  padding: 6px !important;
}

.p-7px {
  padding: 7px !important;
}

.p-8px {
  padding: 8px !important;
}

.p-9px {
  padding: 9px !important;
}

.p-10px {
  padding: 10px !important;
}

.p-11px {
  padding: 11px !important;
}

.p-12px {
  padding: 12px !important;
}

.p-13px {
  padding: 13px !important;
}

.p-14px {
  padding: 14px !important;
}

.p-15px {
  padding: 15px !important;
}

.p-16px {
  padding: 16px !important;
}

.p-17px {
  padding: 17px !important;
}

.p-18px {
  padding: 18px !important;
}

.p-19px {
  padding: 19px !important;
}

.p-20px {
  padding: 20px !important;
}

.p-21px {
  padding: 21px !important;
}

.p-22px {
  padding: 22px !important;
}

.p-23px {
  padding: 23px !important;
}

.p-24px {
  padding: 24px !important;
}

.p-25px {
  padding: 25px !important;
}

.p-26px {
  padding: 26px !important;
}

.p-271px {
  padding: 27px !important;
}

.p-28px {
  padding: 28px !important;
}

.p-29px {
  padding: 29px !important;
}

.p-30px {
  padding: 30px !important;
}

.btn {
  border-radius: 0px;
}

#map_canvas {
  box-shadow: 0px 0px 10px #ccc;
  border: 1px solid #ccc;
  margin-left: 20px;
}

.custom-btn {
  padding: 3px 5px;
  background: transparent;
  color: #333;
  border: 0px;
}

.icolor-green {
  color: #00c292
}

.icolor-red {
  color: #FF5722
}

.ag-theme-balham .ag-menu {
  transition: all 3s fade-in !important;
}

.show-m {
  display: block;
}

.show-n {
  display: none;
}

.tp40 {
  top: 40px !important;
}

.tp0 {
  top: 0px !important;
}

.tp10 {
  top: 10px !important;
}

.r42 {
  right: 42px !important;
}

.l20n {
  left: -20px !important;
}

.beffect {
  opacity: 0;
  animation-name: bounceIn;
  animation-duration: 450ms;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}

.beffect:nth-child(2) {
  animation-delay: 0.3s;
}

.beffect:nth-child(3) {
  animation-delay: 0.6s;
}

.beffect:nth-child(4) {
  animation-delay: 0.9s;
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3) translate3d(0, 0, 0);
  }

  50% {
    opacity: 0.9;
    transform: scale(1.1);
  }

  80% {
    opacity: 1;
    transform: scale(0.89);
  }

  100% {
    opacity: 1;
    transform: scale(1) translate3d(0, 0, 0);
  }
}

.beffectFade {
  opacity: 0;
  animation: fadein 0.1s;
  -moz-animation: fadein 0.1s;
  /* Firefox */
  -webkit-animation: fadein 0.1s;
  /* Safari and Chrome */
  -o-animation: fadein 0.1s;
  /* Opera */
}

@keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.slide-r {
  position: fixed;
  right: 0px;
  top: 0;
  background: #fff;
  width: 0;
  overflow-y: auto;
  height: 100%;
  z-index: 11;
  box-shadow: 0.5rem 0.5rem 2rem rgba(0, 0, 0, 0.2);
  transition: 0.5s;
  transform: translateX(100%);
}

.slide1-r {
  position: absolute;
  right: -15px;
  top: -38px;
  background: #fff;
  width: 0;
  overflow-y: auto;
  height: 150%;
  z-index: 10;
  box-shadow: 0.5rem 0.5rem 2rem 1rem rgba(0, 0, 0, 0.2);
  transition: 0.5s;
  transform: translateX(100%);
}

.custom {
  width: 30%;
  transform: translateX(0%);
}

.slider-translate {
  width: 25%;
  transform: translateX(0%);
}

.slider-translate-30p {
  width: 34%;
  transform: translateX(0%);
}
.slider-translate-35p {
  width: 35%;
  transform: translateX(0%);
}
.slider-translate-40p {
  width: 40%;
  transform: translateX(0%);
}

.slider-translate-50p {
  width: 50%;
  transform: translateX(0%);
}

.slider-translate-60p {
  width: 60%;
  transform: translateX(0%);
}

.slider-translate-65p {
  width: 65%;
  transform: translateX(0%);
}

.slider-translate-75p {
  width: 75%;
  transform: translateX(0%);
}

.slider-translate-84p {
  width: 84%;
  transform: translateX(0%);
}

.slider-translate-90p {
  width: 90%;
  transform: translateX(0%);
}

.slider-translate-95p {
  width: 95%;
  transform: translateX(0%);
}

.slider-translate-98p {
  width: 98%;
  transform: translateX(0%);
}

.slider-translate-100p {
  width: 100%;
  transform: translateX(0%);
}
.slider-header{
  background: blue;
  color: #fff;
  /* padding: 1px 15px; */
  font-size: 16px;
  margin: 0;
}
.slider-header button{padding:0px 8px !important;color:#fff;}
.slide-r-title {
  font-size: 14px;
  color: #fff;
  border-bottom: 1px solid #ccc;
  position: relative;

}
h4.slide-r-title {
  font-size: 16px;
  position: relative;
  text-align: center;
  background: #21759D;
  padding: 8px 5px;
  margin: 0;
}

.slider-translate-101p{
  width:101%;
  transform: translateX(0%);
  box-shadow:0.5rem 0.5rem 2rem 1rem rgba(0, 0, 0, 0.2);
}

.slide-r-body {
  font-size: 14px;
  padding: 10px;
}

.fslide-r {
  position: absolute;
  right: 1.8%;
  top: 7.6%;
  background: #fff;
  width: 0px;
  overflow: hidden;
  height: 80.3%;
  z-index: 10;
  border: 1px solid #ccc;
  transition: 0.5s;
  transform: translateX(100%);
}

.fslider-translate-40p {
  width: 40%;
  transform: translateX(0%);
}

.fslide-r-title {
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ccc;
  position: relative;

}

.fslide-r-title h4 {
  font-size: 14px;
  position: relative;
  text-align: left;
  background: #e9f5fa;
  padding: 5px 10px;
  margin: 0;
}

.fslide-r-body {
  font-size: 14px;
  padding: 10px;
}

.fclose {
  padding: 5px 8px;
  border: 1px solid #ccc;
  margin-top: -6px;
  margin-right: -12px;
  cursor: pointer;
}

.posrel {
  position: relative;
}

.fcslide-r {
  position: absolute;
  right: 0;
  top: 0%;
  width: 0px;
  overflow: hidden;
  background: #fff;
  height: 100%;
  z-index: 10;
  border-left: 1px solid #ccc;
  border-top: 1px solid #eee;
  transition: 0.5s;
  box-shadow: -1px 0px 16px #ccc;
  transform: translateX(100%);
}

.fcslide-translate-25p {
  width: 25%;
  transform: translateX(0%);
}

.fcslide-translate-40p {
  width: 40%;
  transform: translateX(0%);
}

.fcslide-r-title {
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ccc;
  position: relative;

}

.fcslide-r-title h4 {
  font-size: 14px;
  position: relative;
  text-align: left;
  background: #e9f5fa;
  padding: 5px 10px;
  margin: 0;
}

.fcslide-r-body {
  font-size: 14px;
  padding: 10px;
}

@keyframes slide {
  100% {
    right: 0;
  }
}

.c-btn {
  background: #e44343 !important;
  border: 0px !important;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  position: absolute;
  right: 0;
  top: 0px;
  width: auto;
  text-align: center;
  height: 35px;
}

.dataLoad {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 10;
}

.dataLoad img {
  position: absolute;
  top: 50%;
  left: 40%;
  z-index: 99999;
}

.dataLoadpage {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 10;
  opacity: 0.5;
}

.dataLoadpageimg {
  position: absolute;
  top: 40%;
  left: 45%;
  z-index: 99999;
}

.sweet-alert h2 {
  font-size: 14px !important;
  line-height: 25px;
}

.accordion__button {
  padding: 10px 10px;
  background: #0b9ce1;
  color: #fff;
  margin-bottom: 5px;
}

.grid-h5 {
  width: 75%;
}

.actions-list {
  margin: 0;
  padding: 0;
  position: absolute;
  right: 5px;
  top: 10px;
}

.actions-list li {
  display: inline;
}

.actions-list li a {
  color: #6e6d6d;
  padding: 0px 5px;
  width: 24px;
  height: 24px;
  border: 0px solid #ccc;
  margin: 1px;
}

.grid-mx:hover {
  color: #333
}

.ly {
  font-size: 31px;
  margin-right: 4%;
  background: #fff;
  padding: 0px 2px;
  cursor: pointer;
  line-height: 1;
  color: #4ac292;
}

.viewport-r {
  position: fixed;
  right: -15px;
  top: 0;
  background: #fff;
  width: 0;
  height: 100%;
  overflow-y: auto;
  z-index: 10;
  box-shadow: 0.5rem 0.5rem 2rem 1rem rgba(0, 0, 0, 0.2);
  transition: 0.5s;
  transform: translateX(100%);
}

.viewport-r h4 {
  font-size: 16px;
  position: relative;
  text-align: center;
  background: #21759d;
  padding: 8px 5px;
  margin: 0;
  color: #fff;
}

.vwTranslate {
  width: 30%;
  transform: translateX(0%);
}

.inner-srcn {
  max-height: 600px;
  overflow: auto;
}

.f10 {
  font-size: 10px !important;
}

.f11 {
  font-size: 11px !important;
}

.f12 {
  font-size: 12px !important;
}

.f13 {
  font-size: 13px !important;
}

.f14 {
  font-size: 14px !important;
}

.f15 {
  font-size: 15px !important;
}

.f16 {
  font-size: 16px !important;
}

.f17 {
  font-size: 17px !important;
}

.f18 {
  font-size: 18px !important;
}

.f19 {
  font-size: 19px !important;
}

.f20 {
  font-size: 20px !important;
}

.f21 {
  font-size: 21px !important;
}

.f22 {
  font-size: 22px !important;
}

.f24 {
  font-size: 24px !important;
}

.f25 {
  font-size: 25px !important;
}

.f26 {
  font-size: 26px !important;
}

.f27 {
  font-size: 27px !important;
}

.f28 {
  font-size: 28px !important;
}

.f29 {
  font-size: 29px !important;
}

.f30 {
  font-size: 30px !important;
}

.f31 {
  font-size: 31px !important;
}

.f32 {
  font-size: 32px !important;
}

.f33 {
  font-size: 33px !important;
}

.f34 {
  font-size: 34px !important;
}

.f35 {
  font-size: 35px !important;
}

.f36 {
  font-size: 36px !important;
}

.f37 {
  font-size: 37px !important;
}

.f38 {
  font-size: 38px !important;
}

.f39 {
  font-size: 39px !important;
}

.f40 {
  font-size: 40px !important;
}

.f41 {
  font-size: 41px !important;
}

.f42 {
  font-size: 42px !important;
}

.f43 {
  font-size: 43px !important;
}

.f44 {
  font-size: 44px !important;
}

.f45 {
  font-size: 45px !important;
}

.f46 {
  font-size: 46px !important;
}

.f47 {
  font-size: 47px !important;
}

.f48 {
  font-size: 48px !important;
}

.f49 {
  font-size: 49px !important;
}

.f50 {
  font-size: 50px !important;
}

.react-autosuggest__container {
  position: relative;
}

.react-autosuggest__input {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.react-autosuggest__input--focused {
  outline: none;
}

.react-autosuggest__input--open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.react-autosuggest__suggestions-container {
  display: none;
}

.react-autosuggest__suggestions-container--open {
  display: block;
  position: absolute;
  top: 40px;
  width: 100%;
  border: 1px solid #d2d1d1;
  background-color: #fff;
  font-family: Helvetica, sans-serif;
  font-weight: 300;
  font-size: 16px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  max-height: 100px;
  overflow-y: auto;
  z-index: 2;
}

.react-autosuggest__suggestions-list {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.react-autosuggest__suggestion {
  cursor: pointer;
  padding: 8px 15px;
  font-size: 12px;
  ;
}

.react-autosuggest__suggestion--highlighted {
  background-color: #ddd;
}

.tree li {
  list-style-type: none;
  margin: 0;
  padding: 10px 5px 0 5px;
  position: relative
}

.tree li::before,
.tree li::after {
  content: '';
  left: 20px;
  position: absolute;
  right: auto
}

.tree li::before {
  border-left: 2px solid #000;
  bottom: 50px;
  height: 100%;
  top: 0;
  width: 1px
}

.tree li::after {
  border-top: 2px solid #000;
  height: 20px;
  top: 25px;
  width: 25px
}

.tree li span {
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  color: #333;
  border: 1px solid #000;
  border-radius: 3px;
  display: inline-block;
  padding: 3px 8px;
  text-decoration: none;
  cursor: pointer;
}

.tree li span a {
  color: #333;
}

.tree>ul>li::before,
.tree>ul>li::after {
  border: 0
}

.tree li:last-child::before {
  height: 27px
}

.tree li span:hover {
  background: rgb(6, 194, 138);
  border: 1px solid #94a0b4;
  color: #333;
}

.tree li span:hover a {
  color: #333;
}

.tree li ul li {
  padding: 10px 5px 0 45px
}

[aria-expanded="false"]>.expanded,
[aria-expanded="true"]>.collapsed {
  display: none;
}

.tree li span.active {
  background: rgb(6, 194, 138);
  border: 1px solid #94a0b4;
  color: #333;
}

.sidediv {
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}

.closebtn {
  cursor: pointer;
  background: rgba(0, 0, 0, 0.5);
  padding: 5px 9px;
  margin-top: -5px;
  border-radius: 100%;
}

.vertical-timeline::before {
  background: #e3dbdb !important;
}

.vertical-timeline--two-columns .vertical-timeline-element-icon {
  width: 25px !important;
  height: 25px !important;
  left: 53% !important;
  margin-left: -28px !important;
  top: 9% !important;
}

.vertical-timeline-element-icon {
  box-shadow: 0 0 0 4px #d7d7d7, inset 0 2px 0 rgba(0, 0, 0, .08), 0 3px 0 4px rgba(0, 0, 0, .05) !important;

}

.vertical-timeline-element-title {
  font-size: 15px !important;
}

.vertical-timeline-element-content p {
  font-size: 0.8rem !important;
}

.vertical-timeline--two-columns .vertical-timeline-element-content .vertical-timeline-element-date {
  color: #333 !important;
}

.vertical-timeline-element-subtitle {
  font-size: 16px !important;
  margin-bottom: 10px !important;
}

.vertical-timeline--two-columns .vertical-timeline-element-content .vertical-timeline-element-date {
  color: #333;
}

.mb30np {
  margin-bottom: -30px;
}

.fc-input {
  border: 1px solid #BDC3C7;
  font-size: 12px !important;
  color: #333 !important;
  padding: 5px 10px;
}

.highlitRow {
  background: #f1cdcd !important;
}

.whiteRow {
  background: #ffffff;
}

.tbmap {
  font-size: 15px;
  font-weight: 400;
}

.tdmapsp {
  color: #4c7eb7;
  font-size: 13px;
  font-weight: 500;
}

td.custb {
  padding: 6px 5px !important;
  background-image: linear-gradient(#efefef, #ffffff);
}

.maptitle {
  color: #ff1212;
  margin-bottom: 0px;
  font-size: 17px;
}

.gm-style-iw .gm-style-iw-c {
  box-shadow: rgb(51, 51, 51) 0px 5px 15px !important;
  height: 13em !important;
}

.popup-bubble {
  /* Position the bubble centred-above its parent. */
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -100%);
  /* Style the bubble. */
  background-color: white;
  padding: 5px;
  border-radius: 5px;
  font-family: sans-serif;
  overflow-y: auto;
  max-height: 60px;
  box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.5);
}

/* The parent of the bubble. A zero-height div at the top of the tip. */
.popup-bubble-anchor {
  /* Position the div a fixed distance above the tip. */
  position: absolute;
  width: 100%;
  bottom:
    /* TIP_HEIGHT= */
    8px;
  left: 0;
}

/* This element draws the tip. */
.popup-bubble-anchor::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  /* Center the tip horizontally. */
  transform: translate(-50%, 0);
  /* The tip is a https://css-tricks.com/snippets/css/css-triangle/ */
  width: 0;
  height: 0;
  /* The tip is 8px high, and 12px wide. */
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top:
    /* TIP_HEIGHT= */
    8px solid white;
}

/* JavaScript will position this div at the bottom of the popup tip. */
.popup-container {
  cursor: auto;
  height: 0;
  position: absolute;
  /* The max width of the info window. */
  width: 200px;
}

.forecast-warning {
  position: absolute;
  top: 317px;
  left: 19em;
  display: none;
}

.rselect {
  border-radius: 0px;
  margin-bottom: 20px;
}

.mapico {
  width: 32px;
  height: 32px;
  margin-top: -5px;
  margin-right: 5px;
}

.mapico1 {
  width: 24px;
  height: 24px;
  margin-right: 5px;
}

.mapico2 {
  width: 42px;
  height: 42px;
  margin-top: -8px;
  margin-right: 5px;
}

.cellstylegrid {
  background: rgb(241, 251, 255);
  color: #333;
}

.cellstylegridB {
  background: #fff0ef;
  color: #333
}

.cellTopHeader {
  font-size: 25px;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.cellTopHeaderTemplate {
  font-size: 16px;
  text-transform: uppercase;
  vertical-align: middle;
  padding: 20px 10px !important;
}

.cellTopHeaderTemplateH {
  font-size: 14px;
  text-transform: uppercase;
  vertical-align: middle;
  padding: 20px 10px !important;
}

.cellTopHeaderTemplate16 {
  padding-top: 10px;
  font-family: Arial, Helvetica, sans-serif;
  vertical-align: middle;
  font-size: 16px;
  text-align: center !important;
  font-weight: 400;
  justify-content: center;
}

.cellTopHeaderTemplate14 {
  font-family: Arial, Helvetica, sans-serif;
  vertical-align: middle;
  font-weight: bold;
  text-align: center !important;
}

.cellTopHeaderTemplatenb {
  font-family: Arial, Helvetica, sans-serif;
  vertical-align: middle;
  font-size: 14px;
  text-align: center !important;
}

.green {
  background: #bfffc1 !important;
}

.red {
  background: #ff0000;
  color: #ffffff;
}

.redclr {
  background: #f9bebe;
  color: #ffffff;
}

.yellow {
  background: #f1ffb4 !important;
}

.lightred {
  background: #ffa2a2;
  color: #333;
}

.defaultclr {
  color: #000
}

.cellstylegridG {
  background: #ffe4bb;
  color: #333;
  border-bottom: "2px solid black";
}

.cellstylegridG2 {
  background: #FEF0DA;
  color: #333
}

.cellstylegridGBg {
  background: #29c21b;
  color: #333
}

.cellstylegridTPFM {
  background: rgb(191, 195, 237);
  color: #333
}

.cellstylegridTPSMG {
  background: rgb(196, 240, 207);
  color: #333
}

.cellstylegridTPBNG {
  background: rgb(244, 196, 196);
  color: #333
}

.cellstylegridY {
  background: rgb(255, 251, 216);
  color: #333
}

.cellstylegridDY {
  background: rgb(255, 244, 147) !important;
  color: #333
}

.cellstylegridM {
  background: rgb(255, 225, 225);
  color: #333
}

.cellstylegridSk {
  background: rgb(195, 253, 255);
  color: #333
}

.subtotalrow {
  background: skyblue !important;
  /* font-size: 16px !important; */
}

.subtotalrow .cellstylegridB,
.subtotalrow .cellstylegridG {
  background: skyblue !important;
}

.cellstylegridW {
  background: rgb(255, 255, 255);
  color: #333
}

.cellstylegridR {
  background: #ff0000;
  color: #FFF
}

.mobile-search {
  outline: none;
  position: absolute;
  right: 0;
  background: #fff;
  border-right: 0px solid #ddd;
  border-top: 0px solid #ddd;
  border-bottom: 1px solid #ddd;
  border-left: 0px solid #ddd;
  height: 31px;
  border-radius: 3px;
}

@media print {
  .searchConsSegRoute {
    display: none;
  }

  .col-xl-4 {
    font-size: 10px !important;
  }

  .consignment-info .row {
    float: left;
    width: 30%
  }

  .slide-r-title {
    display: none;
  }

  .table {
    margin: 30px;
    float: left;
    width: 50%;
  }

  #mygrid {
    display: none;
  }

  #mapweather {
    width: 50%
  }
}

.mobile-search:focus {
  outline: none;
}

.form-control-plaintext:focus {
  outline: none;
}

.search-form input {
  font-size: 14px !important
}

.MuiAutocomplete-popper {
  max-height: 300px !important;
  overflow-y: auto !important;
}

.MuiTypography-root {
  max-height: 300px !important;
  overflow-y: auto !important;
}

.redfont {
  color: #ff0000;
}

.grayfont {
  color: #ccc;
}

.greenfont {
  color: rgb(10, 153, 34);
}

.yellowfont {
  color: rgba(255, 200, 0, 1);
}

.bluefont {
  color: rgb(57, 113, 235);
}

.darkgrayfont {
  color: #333;
}

.drpselect {
  width: 300px;
}

.gm-style-iw {
  padding: 0px !important;
  /* border-radius: 50px !important;
      border-bottom-right-radius: 50px !important;*/
  z-index: 9;
  box-shadow: 10px 0px 45px 0px #333 !important;

}

.subH {
  background: rgb(3, 145, 79);
  font-size: 18px;
  color: #fff;
  padding: 5px
}

.g-header {
  background: #4d4d4d;
  color: #ffffff;
  font-size: 16px;
  padding: 5px;
}

.gm-style-iw-chr {
  position: absolute;
  right: 0px;
  z-index: 2;
}

.gm-ui-hover-effect>span {
  width: 18px !important;
  height: 19px !important;
  margin: 0 !important;
}

.gm-ui-hover-effect img {
  filter: invert(150%) !important;
}

.c-google {
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 400;
}

.fw400 {
  font-weight: 400 !important;
}

.c-google-img {
  width: 24px;
  height: 24px;
  border-radius: 100%;
  padding: 3px;
  background: #ffffff;
}

.route-block {
  margin-bottom: 15px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
}

.sidebar-label {
  font-weight: 600;
}

.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 7;
  background: #fff;
  opacity: 0.5;
}

.overlay-part {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 7;
  background: #fff;
  opacity: 0.5;
}

.ul-tabs {
  padding: 5px 0 0 0;
  margin: 0;
  background-image: linear-gradient(rgb(223, 223, 223), rgb(245, 245, 245), rgb(223, 223, 223));
}

.ul-tabs li {
  display: inline;
  padding: 8px 0px;
}

.ul-tabs li a {
  padding: 10px 10px;
  color: #333;
  text-decoration: none;
  line-height: 30px;
  border-right: 1px solid #aaa;
  background-image: linear-gradient(rgb(223, 223, 223), rgb(245, 245, 245), rgb(223, 223, 223));
}

.ul-tabs li:last-child a {
  border-right: 0px;
}

.cpointer {
  cursor: pointer;
}

.ul-tabs li a.active {
  background-image: linear-gradient(rgb(61, 180, 130), rgb(245, 245, 245), rgb(61, 180, 130));
}

.d-none {
  display: none;
}

.fnt2 {
  font-size: 2rem;
}

.fnt1 {
  font-size: 1rem;
}

.boxbgblue {
  background-color: #d5e9f0 !important;
}

.boxbgblue2 {
  background-color: #efefef !important;
}

.boxbgblue3 {
  background-color: #d5daf0 !important;
}

.boxbgblue4 {
  background-color: #ece2b1 !important;
}

.boxbgblue5 {
  background-color: #ebcaab !important;
}

.bgColorDangerLight {
  background-color: #ffb9c5 !important;
}

.bgColorAshLight {
  background-color: #e0dddd !important;
}

.bgColorDangerMedium {
  background-color: #ff90a3 !important;
}

.bgColorDangerDark {
  background-color: #ff7289 !important;
}

.bgColorSuccessLight {
  background-color: #00f0b5 !important;
}

.bgColorSuccessMedium {
  background-color: #00dea7 !important;
}

.bgColorSuccessDark {
  background-color: #00d09c !important;
}

.colorWhite {
  color: #ffffff !important;
  padding-left: 5px
}

.colorForDangerLight {
  background-color: #a5d1ef !important;
  font-weight: bold;
}

.colorForDangerMedium {
  background-color: #ff90a3 !important;
}

.colorForDangerDark {
  background-color: #ff7289 !important;
}

.txt-black {
  color: #000000
}

.txt-success-light {
  color: #00f0b5
}

.txt-success-medium {
  color: #00dea7
}

.txt-success-dark {
  color: #00d09c
}

.txt-primary-light {
  color: #d8caf3
}

.txt-primary-medium {
  color: #c6b1ed
}

.txt-primary-dark {
  color: #b99fe8
}

.txt-secondary-light {
  color: #a9e8f0
}

.txt-secondary-medium {
  color: #67d7ef
}

.txt-secondary-dark {
  color: #4dd0e1
}

.txt-info-light {
  color: #c0ddff
}

.txt-info-medium {
  color: #8dc2ff
}

.txt-info-dark {
  color: #66adff
}

.txt-warning-light {
  color: #fff28d
}

.txt-warning-medium {
  color: #ffec50
}

.txt-warning-dark {
  color: #ffe622
}

.txt-grey-light {
  color: #bebebe
}

.txt-grey-medium {
  color: #9f9f9f
}

.txt-grey-dark {
  color: #888888
}

.txt-pink-light {
  color: #f69ebd
}

.txt-pink-medium {
  color: #f16696
}

.txt-pink-dark {
  color: #ed3c7a
}

.txt-danger-light {
  color: #ffb9c5
}

.txt-danger-medium {
  color: #ff90a3
}

.txt-danger-dark {
  color: #ff7289 !important
}

.font-color-yellow {
  color: #ff7700 !important;
}

#consignment-overdue-component {
  padding: 17px;
}

.nav-tabs .nav-link {
  color: #333;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  font-weight: 700;
}

.ainfo {
  color: #4099ff !important;
}

.binfo {
  color: #00c292 !important;
}

.cinfo {
  color: #f7516f !important;
}

.dinfo {
  color: #26c6da !important;
}

.tabpad {
  padding: 10px;
  background: #e4e4e4;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}

.tabhigh {
  background: #e4e4e4 !important;
  border-color: #e4e4e4 !important;
  border: 1px solid #e4e4e4 !important;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu {
  padding: 40px 15px !important;
}

.darkorange {
  color: #d3a337 !important;
}

.darkblue {
  color: #3300c2 !important;
}

.mildgreen {
  color: #7ad337 !important;
}

.cursorPointer {
  cursor: pointer;
}

.page-wrapper .page-body-wrapper .page-sidebar {
  position: fixed !important;
  height: 100% !important;
  width: 290px !important;
  top: 0px !important;
}
.cstm-und{
  color:#dc3545 !important;
}
.cst-dsbled{
  color:#adb5bd !important;
}
.cst-delivered{
  color: #17a2b8 !important;
}
.cst-ontime{
  color:#60EF48D9 !important;
  /* color:#20c997 !important */

}
.cst-delayed{
  color:#ff1a40 !important;
}
.cst-pending{
  color:#ffc107 !important;
}
.page-main-header .main-header-left {
  position: fixed;
  left: 0;
  top: 0;
  height: auto;
  padding: 0px;
  height: 40px;
}

.page-main-header .main-header-left .logo-wrapper {
  height: 40px;
}

.page-main-header .main-header-left .logo-wrapper img {
  margin-top: 0px;
  width: 90%;
  height: 100%;
}

.page-wrapper .page-body-wrapper .page-sidebar~.page-body {
  /* margin-left: 280px; */
}
.btn-disabled{
  background-color: #ccc;
  color: #666;
  border-color: #ccc;
  cursor: not-allowed;
  
}
.customStyle{
  margin: 0 !important;
}
.customStyle1{
  margin-left: 15px !important;
}
.sidebaricon {
  position: fixed;
  top: 30px;
  left: 0px;
  z-index: 8;
}

.sidebar-close .page-sidebar {
  left: -33px
}

.sidebar-blueicon {
  right: 0px;
  position: absolute;
  top: 47px;
}

.sidebaropen-icon {
  position: absolute;
  top: 22px;
  right: 0px;
  z-index: 11;
}

.page-main-header .main-header-right .nav-right>ul {
  height: 50px;
}

.counterset {
  font-size: 16px;
  padding-left: 0px;
}

.maroon {
  color: #a34518 !important;
}

.darkgreen {
  color: #069518;
}

.purple {
  color: #9f08b2;
}

.blue i.icofont.icofont-map-pins.f25 {
  color: cornflowerblue;
}

.map-legends img {
  height: 50px;
  width: 50px;
}

.weather-sidebar {
  width: 82%
}

.lightgrey i.icofont.icofont-map-pins.f25 {
  color: #e1d8d8;
}

.grey {
  color: #cccccc;
}

.white {
  color: #FFFFFF !important;
}

.crm-activity {
  height: 525px !important;
}

.capitlize {
  text-transform: capitalize;
}

.se-ico:hover {
  color: #bebebe;
}

.fright {
  float: right !important;
}

.ch300 {
  min-height: 100px !important;
  max-height: 230px !important;
}

.brd-top {
  border-top: 1px solid #ececec;
}

#dashboardCounterCardBody {
  padding: 10px;
}

.email-wrap .email-right-aside .email-body .inbox {
  max-height: 570px;
}

.ck-editor__editable {
  min-height: 350px !important;
}

.email-wrap .email-right-aside .email-body .email-compose .cke_contents.cke_reset {
  max-height: 400px !important;
}

.email-wrap .email-right-aside {
  overflow-y: auto;
  overflow-x: hidden;
}

#profileDropdown {
  width: 250px;
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#loginButton {
  padding: 0.475rem 2.75rem;
  text-align: center;
}

.textAlignCenter {
  text-align: center;
}

.textAlignLeft {
  text-align: left;
}

#counterCardBody {
  padding: 15px;
}

.rdtPicker table {
  width: 100% !important;
}

.rdtOpen .rdtPicker {
  border: 1px solid #ccc;
}

.andriomap-pos {
  position: fixed;
  bottom: -1%;
  left: 47%;
  width: 40px;
  height: 40px;
  z-index: 999;
  cursor: pointer;
}

.andriomap-pos2 {
  position: absolute;
  left: 47%;
  top: -2%;
  width: 40px;
  height: 40px;
  z-index: 999999;
  cursor: pointer;
}

.ico-color {
  color: #ffffff;
  font-size: 32px;
  background: #333333;
  padding: 5px;
}

.zindex999 {
  z-index: 999;
}

.divpos {
  position: fixed;
  bottom: -15px;
  right: 0;
  background: #fff;
  width: 100%;
  height: 0;
  overflow-y: auto;
  z-index: 9999;
  box-shadow: 0.5rem 0.5rem 2rem 1rem rgba(0, 0, 0, 0.2);
  transition: 0.5s;
  transform: translateY(100%);
  padding: 2%;
}

.slider-translatey {
  height: 400px;
  transform: translateX(-110%);
  width:500px;
}

.prel {
  position: relative;
}

.sweet-alert h2 {
  word-break: break-word;
}



/*Datepicker CSS Start*/
/*! jQuery UI - v1.12.1 - 2016-09-14
* http://jqueryui.com
* Includes: core.css, accordion.css, autocomplete.css, menu.css, button.css, controlgroup.css, checkboxradio.css, datepicker.css, dialog.css, draggable.css, resizable.css, progressbar.css, selectable.css, selectmenu.css, slider.css, sortable.css, spinner.css, tabs.css, tooltip.css, theme.css
* To view and modify this theme, visit http://jqueryui.com/themeroller/?ffDefault=Arial%2CHelvetica%2Csans-serif&fsDefault=1em&fwDefault=normal&cornerRadius=3px&bgColorHeader=e9e9e9&bgTextureHeader=flat&borderColorHeader=dddddd&fcHeader=333333&iconColorHeader=444444&bgColorContent=ffffff&bgTextureContent=flat&borderColorContent=dddddd&fcContent=333333&iconColorContent=444444&bgColorDefault=f6f6f6&bgTextureDefault=flat&borderColorDefault=c5c5c5&fcDefault=454545&iconColorDefault=777777&bgColorHover=ededed&bgTextureHover=flat&borderColorHover=cccccc&fcHover=2b2b2b&iconColorHover=555555&bgColorActive=007fff&bgTextureActive=flat&borderColorActive=003eff&fcActive=ffffff&iconColorActive=ffffff&bgColorHighlight=fffa90&bgTextureHighlight=flat&borderColorHighlight=dad55e&fcHighlight=777620&iconColorHighlight=777620&bgColorError=fddfdf&bgTextureError=flat&borderColorError=f1a899&fcError=5f3f3f&iconColorError=cc0000&bgColorOverlay=aaaaaa&bgTextureOverlay=flat&bgImgOpacityOverlay=0&opacityOverlay=30&bgColorShadow=666666&bgTextureShadow=flat&bgImgOpacityShadow=0&opacityShadow=30&thicknessShadow=5px&offsetTopShadow=0px&offsetLeftShadow=0px&cornerRadiusShadow=8px
* Copyright jQuery Foundation and other contributors; Licensed MIT */

/* Layout helpers
----------------------------------*/
.ui-helper-hidden {
  display: none;
}

.ui-helper-hidden-accessible {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.ui-helper-reset {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  line-height: 1.3;
  text-decoration: none;
  font-size: 100%;
  list-style: none;
}

.ui-helper-clearfix:before,
.ui-helper-clearfix:after {
  content: "";
  display: table;
  border-collapse: collapse;
}

.ui-helper-clearfix:after {
  clear: both;
}

.ui-helper-zfix {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  opacity: 0;
  filter: Alpha(Opacity=0);
  /* support: IE8 */
}

.ui-front {
  z-index: 100;
}


/* Interaction Cues
----------------------------------*/
.ui-state-disabled {
  cursor: default !important;
  pointer-events: none;
}


/* Icons
----------------------------------*/
.ui-icon {
  display: inline-block;
  vertical-align: middle;
  margin-top: -.25em;
  position: relative;
  text-indent: -99999px;
  overflow: hidden;
  background-repeat: no-repeat;
}

.ui-widget-icon-block {
  left: 50%;
  margin-left: -8px;
  display: block;
}

/* Misc visuals
----------------------------------*/

/* Overlays */
.ui-widget-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ui-accordion .ui-accordion-header {
  display: block;
  cursor: pointer;
  position: relative;
  margin: 2px 0 0 0;
  padding: .5em .5em .5em .7em;
  font-size: 100%;
}

.ui-accordion .ui-accordion-content {
  padding: 1em 2.2em;
  border-top: 0;
  overflow: auto;
}

.ui-autocomplete {
  position: absolute;
  top: 0;
  left: 0;
  cursor: default;
}

.ui-menu {
  list-style: none;
  padding: 0;
  margin: 0;
  display: block;
  outline: 0;
}

.ui-menu .ui-menu {
  position: absolute;
}

.ui-menu .ui-menu-item {
  margin: 0;
  cursor: pointer;
  /* support: IE10, see #8844 */
  list-style-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.ui-menu .ui-menu-item-wrapper {
  position: relative;
  padding: 3px 1em 3px .4em;
}

.ui-menu .ui-menu-divider {
  margin: 5px 0;
  height: 0;
  font-size: 0;
  line-height: 0;
  border-width: 1px 0 0 0;
}

.ui-menu .ui-state-focus,
.ui-menu .ui-state-active {
  margin: -1px;
}

/* icon support */
.ui-menu-icons {
  position: relative;
}

.ui-menu-icons .ui-menu-item-wrapper {
  padding-left: 2em;
}

/* left-aligned */
.ui-menu .ui-icon {
  position: absolute;
  top: 0;
  bottom: 0;
  left: .2em;
  margin: auto 0;
}

/* right-aligned */
.ui-menu .ui-menu-icon {
  left: auto;
  right: 0;
}

.ui-button {
  padding: .4em 1em;
  display: inline-block;
  position: relative;
  line-height: normal;
  margin-right: .1em;
  cursor: pointer;
  vertical-align: middle;
  text-align: center;
  -webkit-user-select: none;
  user-select: none;

  /* Support: IE <= 11 */
  overflow: visible;
}

.ui-button,
.ui-button:link,
.ui-button:visited,
.ui-button:hover,
.ui-button:active {
  text-decoration: none;
}

/* to make room for the icon, a width needs to be set here */
.ui-button-icon-only {
  width: 2em;
  box-sizing: border-box;
  text-indent: -9999px;
  white-space: nowrap;
}

/* no icon support for input elements */
input.ui-button.ui-button-icon-only {
  text-indent: 0;
}

/* button icon element(s) */
.ui-button-icon-only .ui-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -8px;
  margin-left: -8px;
}

.ui-button.ui-icon-notext .ui-icon {
  padding: 0;
  width: 2.1em;
  height: 2.1em;
  text-indent: -9999px;
  white-space: nowrap;

}

input.ui-button.ui-icon-notext .ui-icon {
  width: auto;
  height: auto;
  text-indent: 0;
  white-space: normal;
  padding: .4em 1em;
}

/* workarounds */
/* Support: Firefox 5 - 40 */
input.ui-button::-moz-focus-inner,
button.ui-button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

.ui-controlgroup {
  vertical-align: middle;
  display: inline-block;
}

.ui-controlgroup>.ui-controlgroup-item {
  float: left;
  margin-left: 0;
  margin-right: 0;
}

.ui-controlgroup>.ui-controlgroup-item:focus,
.ui-controlgroup>.ui-controlgroup-item.ui-visual-focus {
  z-index: 9999;
}

.ui-controlgroup-vertical>.ui-controlgroup-item {
  display: block;
  float: none;
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
  text-align: left;
}

.ui-controlgroup-vertical .ui-controlgroup-item {
  box-sizing: border-box;
}

.ui-controlgroup .ui-controlgroup-label {
  padding: .4em 1em;
}

.ui-controlgroup .ui-controlgroup-label span {
  font-size: 80%;
}

.ui-controlgroup-horizontal .ui-controlgroup-label+.ui-controlgroup-item {
  border-left: none;
}

.ui-controlgroup-vertical .ui-controlgroup-label+.ui-controlgroup-item {
  border-top: none;
}

.ui-controlgroup-horizontal .ui-controlgroup-label.ui-widget-content {
  border-right: none;
}

.ui-controlgroup-vertical .ui-controlgroup-label.ui-widget-content {
  border-bottom: none;
}

/* Spinner specific style fixes */
.ui-controlgroup-vertical .ui-spinner-input {

  /* Support: IE8 only, Android < 4.4 only */
  width: 75%;
  width: calc(100% - 2.4em);
}

.ui-controlgroup-vertical .ui-spinner .ui-spinner-up {
  border-top-style: solid;
}

.ui-checkboxradio-label .ui-icon-background {
  box-shadow: inset 1px 1px 1px #ccc;
  border-radius: .12em;
  border: none;
}

.ui-checkboxradio-radio-label .ui-icon-background {
  width: 16px;
  height: 16px;
  border-radius: 1em;
  overflow: visible;
  border: none;
}

.ui-checkboxradio-radio-label.ui-checkboxradio-checked .ui-icon,
.ui-checkboxradio-radio-label.ui-checkboxradio-checked:hover .ui-icon {
  background-image: none;
  width: 8px;
  height: 8px;
  border-width: 4px;
  border-style: solid;
}

.ui-checkboxradio-disabled {
  pointer-events: none;
}

.datepick-filter {
  background-color: #171c8f;
  border-color: #171c8f;
  color: #ffffff;
  /* Optionally set the text color to white */
}

.ui-datepicker {
  width: 17em;
  padding: .2em .2em 0;
  display: none;
}

.ui-datepicker .ui-datepicker-header {
  position: relative;
  padding: .2em 0;
}

.ui-datepicker .ui-datepicker-prev,
.ui-datepicker .ui-datepicker-next {
  position: absolute;
  top: 2px;
  width: 1.8em;
  height: 1.8em;
}

.ui-datepicker .ui-datepicker-prev-hover,
.ui-datepicker .ui-datepicker-next-hover {
  top: 1px;
}

.ui-datepicker .ui-datepicker-prev {
  left: 2px;
}

.ui-datepicker .ui-datepicker-next {
  right: 2px;
}

.ui-datepicker .ui-datepicker-prev-hover {
  left: 1px;
}

.ui-datepicker .ui-datepicker-next-hover {
  right: 1px;
}

.ui-datepicker .ui-datepicker-prev span,
.ui-datepicker .ui-datepicker-next span {
  display: block;
  position: absolute;
  left: 50%;
  margin-left: -8px;
  top: 50%;
  margin-top: -8px;
}

.ui-datepicker .ui-datepicker-title {
  margin: 0 2.3em;
  line-height: 1.8em;
  text-align: center;
}

.ui-datepicker .ui-datepicker-title select {
  font-size: 1em;
  margin: 1px 0;
}

.ui-datepicker select.ui-datepicker-month,
.ui-datepicker select.ui-datepicker-year {
  width: 45%;
}

.ui-datepicker table {
  width: 100%;
  font-size: .9em;
  border-collapse: collapse;
  margin: 0 0 .4em;
}

.ui-datepicker th {
  padding: .7em .3em;
  text-align: center;
  font-weight: bold;
  border: 0;
}

.ui-datepicker td {
  border: 0;
  padding: 1px;
}

.ui-datepicker td span,
.ui-datepicker td a {
  display: block;
  padding: .2em;
  text-align: right;
  text-decoration: none;
}

.ui-datepicker .ui-datepicker-buttonpane {
  background-image: none;
  margin: .7em 0 0 0;
  padding: 0 .2em;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;
}

.ui-datepicker .ui-datepicker-buttonpane button {
  float: right;
  margin: .5em .2em .4em;
  cursor: pointer;
  padding: .2em .6em .3em .6em;
  width: auto;
  overflow: visible;
}

.ui-datepicker .ui-datepicker-buttonpane button.ui-datepicker-current {
  float: left;
}

/* with multiple calendars */
.ui-datepicker.ui-datepicker-multi {
  width: auto;
}

.ui-datepicker-multi .ui-datepicker-group {
  float: left;
}

.ui-datepicker-multi .ui-datepicker-group table {
  width: 95%;
  margin: 0 auto .4em;
}

.ui-datepicker-multi-2 .ui-datepicker-group {
  width: 50%;
}

.ui-datepicker-multi-3 .ui-datepicker-group {
  width: 33.3%;
}

.ui-datepicker-multi-4 .ui-datepicker-group {
  width: 25%;
}

.ui-datepicker-multi .ui-datepicker-group-last .ui-datepicker-header,
.ui-datepicker-multi .ui-datepicker-group-middle .ui-datepicker-header {
  border-left-width: 0;
}

.ui-datepicker-multi .ui-datepicker-buttonpane {
  clear: left;
}

.ui-datepicker-row-break {
  clear: both;
  width: 100%;
  font-size: 0;
}

/* RTL support */
.ui-datepicker-rtl {
  direction: rtl;
}

.ui-datepicker-rtl .ui-datepicker-prev {
  right: 2px;
  left: auto;
}

.ui-datepicker-rtl .ui-datepicker-next {
  left: 2px;
  right: auto;
}

.ui-datepicker-rtl .ui-datepicker-prev:hover {
  right: 1px;
  left: auto;
}

.ui-datepicker-rtl .ui-datepicker-next:hover {
  left: 1px;
  right: auto;
}

.ui-datepicker-rtl .ui-datepicker-buttonpane {
  clear: right;
}

.ui-datepicker-rtl .ui-datepicker-buttonpane button {
  float: left;
}

.ui-datepicker-rtl .ui-datepicker-buttonpane button.ui-datepicker-current,
.ui-datepicker-rtl .ui-datepicker-group {
  float: right;
}

.ui-datepicker-rtl .ui-datepicker-group-last .ui-datepicker-header,
.ui-datepicker-rtl .ui-datepicker-group-middle .ui-datepicker-header {
  border-right-width: 0;
  border-left-width: 1px;
}

/* Icons */
.ui-datepicker .ui-icon {
  display: block;
  text-indent: -99999px;
  overflow: hidden;
  background-repeat: no-repeat;
  left: .5em;
  top: .3em;
}

.ui-dialog {
  position: absolute;
  top: 0;
  left: 0;
  padding: .2em;
  outline: 0;
}

.ui-dialog .ui-dialog-titlebar {
  padding: .4em 1em;
  position: relative;
}

.ui-dialog .ui-dialog-title {
  float: left;
  margin: .1em 0;
  white-space: nowrap;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ui-dialog .ui-dialog-titlebar-close {
  position: absolute;
  right: .3em;
  top: 50%;
  width: 20px;
  margin: -10px 0 0 0;
  padding: 1px;
  height: 20px;
}

.ui-dialog .ui-dialog-content {
  position: relative;
  border: 0;
  padding: .5em 1em;
  background: none;
  overflow: auto;
}

.ui-dialog .ui-dialog-buttonpane {
  text-align: left;
  border-width: 1px 0 0 0;
  background-image: none;
  margin-top: .5em;
  padding: .3em 1em .5em .4em;
}

.ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {
  float: right;
}

.ui-dialog .ui-dialog-buttonpane button {
  margin: .5em .4em .5em 0;
  cursor: pointer;
}

.ui-dialog .ui-resizable-n {
  height: 2px;
  top: 0;
}

.ui-dialog .ui-resizable-e {
  width: 2px;
  right: 0;
}

.ui-dialog .ui-resizable-s {
  height: 2px;
  bottom: 0;
}

.ui-dialog .ui-resizable-w {
  width: 2px;
  left: 0;
}

.ui-dialog .ui-resizable-se,
.ui-dialog .ui-resizable-sw,
.ui-dialog .ui-resizable-ne,
.ui-dialog .ui-resizable-nw {
  width: 7px;
  height: 7px;
}

.ui-dialog .ui-resizable-se {
  right: 0;
  bottom: 0;
}

.ui-dialog .ui-resizable-sw {
  left: 0;
  bottom: 0;
}

.ui-dialog .ui-resizable-ne {
  right: 0;
  top: 0;
}

.ui-dialog .ui-resizable-nw {
  left: 0;
  top: 0;
}

.ui-draggable .ui-dialog-titlebar {
  cursor: move;
}

.ui-draggable-handle {
  touch-action: none;
}

.ui-resizable {
  position: relative;
}

.ui-resizable-handle {
  position: absolute;
  font-size: 0.1px;
  display: block;
  touch-action: none;
}

.ui-resizable-disabled .ui-resizable-handle,
.ui-resizable-autohide .ui-resizable-handle {
  display: none;
}

.ui-resizable-n {
  cursor: n-resize;
  height: 7px;
  width: 100%;
  top: -5px;
  left: 0;
}

.ui-resizable-s {
  cursor: s-resize;
  height: 7px;
  width: 100%;
  bottom: -5px;
  left: 0;
}

.ui-resizable-e {
  cursor: e-resize;
  width: 7px;
  right: -5px;
  top: 0;
  height: 100%;
}

.ui-resizable-w {
  cursor: w-resize;
  width: 7px;
  left: -5px;
  top: 0;
  height: 100%;
}

.ui-resizable-se {
  cursor: se-resize;
  width: 12px;
  height: 12px;
  right: 1px;
  bottom: 1px;
}

.ui-resizable-sw {
  cursor: sw-resize;
  width: 9px;
  height: 9px;
  left: -5px;
  bottom: -5px;
}

.ui-resizable-nw {
  cursor: nw-resize;
  width: 9px;
  height: 9px;
  left: -5px;
  top: -5px;
}

.ui-resizable-ne {
  cursor: ne-resize;
  width: 9px;
  height: 9px;
  right: -5px;
  top: -5px;
}

.ui-progressbar {
  height: 2em;
  text-align: left;
  overflow: hidden;
}

.ui-progressbar .ui-progressbar-value {
  margin: -1px;
  height: 100%;
}

.ui-progressbar .ui-progressbar-overlay {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  height: 100%;
  filter: alpha(opacity=25);
  /* support: IE8 */
  opacity: 0.25;
}

.ui-progressbar-indeterminate .ui-progressbar-value {
  background-image: none;
}

.ui-selectable {
  touch-action: none;
}

.ui-selectable-helper {
  position: absolute;
  z-index: 100;
  border: 1px dotted black;
}

.ui-selectmenu-menu {
  padding: 0;
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
}

.ui-selectmenu-menu .ui-menu {
  overflow: auto;
  overflow-x: hidden;
  padding-bottom: 1px;
}

.ui-selectmenu-menu .ui-menu .ui-selectmenu-optgroup {
  font-size: 1em;
  font-weight: bold;
  line-height: 1.5;
  padding: 2px 0.4em;
  margin: 0.5em 0 0 0;
  height: auto;
  border: 0;
}

.ui-selectmenu-open {
  display: block;
}

.ui-selectmenu-text {
  display: block;
  margin-right: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ui-selectmenu-button.ui-button {
  text-align: left;
  white-space: nowrap;
  width: 14em;
}

.ui-selectmenu-icon.ui-icon {
  float: right;
  margin-top: 0;
}

.ui-slider {
  position: relative;
  text-align: left;
}

.ui-slider .ui-slider-handle {
  position: absolute;
  z-index: 2;
  width: 1.2em;
  height: 1.2em;
  cursor: default;
  touch-action: none;
}

.ui-slider .ui-slider-range {
  position: absolute;
  z-index: 1;
  font-size: .7em;
  display: block;
  border: 0;
  background-position: 0 0;
}

/* support: IE8 - See #6727 */
.ui-slider.ui-state-disabled .ui-slider-handle,
.ui-slider.ui-state-disabled .ui-slider-range {
  filter: inherit;
}

.ui-slider-horizontal {
  height: .8em;
}

.ui-slider-horizontal .ui-slider-handle {
  top: -.3em;
  margin-left: -.6em;
}

.ui-slider-horizontal .ui-slider-range {
  top: 0;
  height: 100%;
}

.ui-slider-horizontal .ui-slider-range-min {
  left: 0;
}

.ui-slider-horizontal .ui-slider-range-max {
  right: 0;
}

.ui-slider-vertical {
  width: .8em;
  height: 100px;
}

.ui-slider-vertical .ui-slider-handle {
  left: -.3em;
  margin-left: 0;
  margin-bottom: -.6em;
}

.ui-slider-vertical .ui-slider-range {
  left: 0;
  width: 100%;
}

.ui-slider-vertical .ui-slider-range-min {
  bottom: 0;
}

.ui-slider-vertical .ui-slider-range-max {
  top: 0;
}

.ui-sortable-handle {
  touch-action: none;
}

.ui-spinner {
  position: relative;
  display: inline-block;
  overflow: hidden;
  padding: 0;
  vertical-align: middle;
}

.ui-spinner-input {
  border: none;
  background: none;
  color: inherit;
  padding: .222em 0;
  margin: .2em 0;
  vertical-align: middle;
  margin-left: .4em;
  margin-right: 2em;
}

.ui-spinner-button {
  width: 1.6em;
  height: 50%;
  font-size: .5em;
  padding: 0;
  margin: 0;
  text-align: center;
  position: absolute;
  cursor: default;
  display: block;
  overflow: hidden;
  right: 0;
}

/* more specificity required here to override default borders */
.ui-spinner a.ui-spinner-button {
  border-top-style: none;
  border-bottom-style: none;
  border-right-style: none;
}

.ui-spinner-up {
  top: 0;
}

.ui-spinner-down {
  bottom: 0;
}

.ui-tabs {
  position: relative;
  /* position: relative prevents IE scroll bug (element with position: relative inside container with overflow: auto appear as "fixed") */
  padding: .2em;
}

.ui-tabs .ui-tabs-nav {
  margin: 0;
  padding: .2em .2em 0;
}

.ui-tabs .ui-tabs-nav li {
  list-style: none;
  float: left;
  position: relative;
  top: 0;
  margin: 1px .2em 0 0;
  border-bottom-width: 0;
  padding: 0;
  white-space: nowrap;
}

.ui-tabs .ui-tabs-nav .ui-tabs-anchor {
  float: left;
  padding: .5em 1em;
  text-decoration: none;
}

.ui-tabs .ui-tabs-nav li.ui-tabs-active {
  margin-bottom: -1px;
  padding-bottom: 1px;
}

.ui-tabs .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor,
.ui-tabs .ui-tabs-nav li.ui-state-disabled .ui-tabs-anchor,
.ui-tabs .ui-tabs-nav li.ui-tabs-loading .ui-tabs-anchor {
  cursor: text;
}

.ui-tabs-collapsible .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor {
  cursor: pointer;
}

.ui-tabs .ui-tabs-panel {
  display: block;
  border-width: 0;
  padding: 1em 1.4em;
  background: none;
}

.ui-tooltip {
  padding: 8px;
  position: absolute;
  z-index: 9999;
  max-width: 300px;
}

body .ui-tooltip {
  border-width: 2px;
}

/* Component containers
----------------------------------*/
.ui-widget {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1em;
}

.ui-widget .ui-widget {
  font-size: 1em;
}

.ui-widget input,
.ui-widget select,
.ui-widget textarea,
.ui-widget button {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1em;
}

.ui-widget.ui-widget-content {
  border: 1px solid #c5c5c5;
}

.ui-widget-content {
  border: 1px solid #dddddd;
  background: #ffffff;
  color: #333333;
}

.ui-widget-content a {
  color: #333333;
}

.ui-widget-header {
  border: 1px solid #dddddd;
  background: #e9e9e9;
  color: #333333;
  font-weight: bold;
}

.ui-widget-header a {
  color: #333333;
}

/* Interaction states
----------------------------------*/
.ui-state-default,
.ui-widget-content .ui-state-default,
.ui-widget-header .ui-state-default,
.ui-button,

/* We use html here because we need a greater specificity to make sure disabled
works properly when clicked or hovered */
html .ui-button.ui-state-disabled:hover,
html .ui-button.ui-state-disabled:active {
  border: 1px solid #c5c5c5;
  background: #f6f6f6;
  font-weight: normal;
  color: #454545;
}

.ui-state-default a,
.ui-state-default a:link,
.ui-state-default a:visited,
a.ui-button,
a:link.ui-button,
a:visited.ui-button,
.ui-button {
  color: #454545;
  text-decoration: none;
}

.ui-state-hover,
.ui-widget-content .ui-state-hover,
.ui-widget-header .ui-state-hover,
.ui-state-focus,
.ui-widget-content .ui-state-focus,
.ui-widget-header .ui-state-focus,
.ui-button:hover,
.ui-button:focus {
  border: 1px solid #cccccc;
  background: #ededed;
  font-weight: normal;
  color: #2b2b2b;
}

.ui-state-hover a,
.ui-state-hover a:hover,
.ui-state-hover a:link,
.ui-state-hover a:visited,
.ui-state-focus a,
.ui-state-focus a:hover,
.ui-state-focus a:link,
.ui-state-focus a:visited,
a.ui-button:hover,
a.ui-button:focus {
  color: #2b2b2b;
  text-decoration: none;
}

.ui-visual-focus {
  box-shadow: 0 0 3px 1px rgb(94, 158, 214);
}

.ui-state-active,
.ui-widget-content .ui-state-active,
.ui-widget-header .ui-state-active,
a.ui-button:active,
.ui-button:active,
.ui-button.ui-state-active:hover {
  border: 1px solid #003eff;
  background: #007fff;
  font-weight: normal;
  color: #ffffff;
}

.ui-icon-background,
.ui-state-active .ui-icon-background {
  border: #003eff;
  background-color: #ffffff;
}

.ui-state-active a,
.ui-state-active a:link,
.ui-state-active a:visited {
  color: #ffffff;
  text-decoration: none;
}

/* Interaction Cues
----------------------------------*/
.ui-state-highlight,
.ui-widget-content .ui-state-highlight,
.ui-widget-header .ui-state-highlight {
  border: 1px solid #dad55e;
  background: #fffa90;
  color: #777620;
}

.ui-state-checked {
  border: 1px solid #dad55e;
  background: #fffa90;
}

.ui-state-highlight a,
.ui-widget-content .ui-state-highlight a,
.ui-widget-header .ui-state-highlight a {
  color: #777620;
}

.ui-state-error,
.ui-widget-content .ui-state-error,
.ui-widget-header .ui-state-error {
  border: 1px solid #f1a899;
  background: #fddfdf;
  color: #5f3f3f;
}

.ui-state-error a,
.ui-widget-content .ui-state-error a,
.ui-widget-header .ui-state-error a {
  color: #5f3f3f;
}

.ui-state-error-text,
.ui-widget-content .ui-state-error-text,
.ui-widget-header .ui-state-error-text {
  color: #5f3f3f;
}

.ui-priority-primary,
.ui-widget-content .ui-priority-primary,
.ui-widget-header .ui-priority-primary {
  font-weight: bold;
}

.ui-priority-secondary,
.ui-widget-content .ui-priority-secondary,
.ui-widget-header .ui-priority-secondary {
  opacity: .7;
  filter: Alpha(Opacity=70);
  /* support: IE8 */
  font-weight: normal;
}

.ui-state-disabled,
.ui-widget-content .ui-state-disabled,
.ui-widget-header .ui-state-disabled {
  opacity: .35;
  filter: Alpha(Opacity=35);
  /* support: IE8 */
  background-image: none;
}

.ui-state-disabled .ui-icon {
  filter: Alpha(Opacity=35);
  /* support: IE8 - See #6059 */
}

/* Icons
----------------------------------*/

/* states and images */
.ui-icon {
  width: 16px;
  height: 16px;
}

.ui-icon,
.ui-widget-content .ui-icon {
  /* background-image: url("../images/ui-icons_444444_256x240.png"); */
}

.ui-widget-header .ui-icon {
  /* background-image: url("../images/ui-icons_444444_256x240.png"); */
}

.ui-state-hover .ui-icon,
.ui-state-focus .ui-icon,
.ui-button:hover .ui-icon,
.ui-button:focus .ui-icon {
  /* background-image: url("../images/ui-icons_555555_256x240.png"); */
}

.ui-state-active .ui-icon,
.ui-button:active .ui-icon {
  /* background-image: url("../images/ui-icons_ffffff_256x240.png"); */
}

.ui-state-highlight .ui-icon,
.ui-button .ui-state-highlight.ui-icon {
  /* background-image: url("../images/ui-icons_777620_256x240.png"); */
}

.ui-state-error .ui-icon,
.ui-state-error-text .ui-icon {
  /* background-image: url("../images/ui-icons_cc0000_256x240.png"); */
}

.ui-button .ui-icon {
  /* background-image: url("../images/ui-icons_777777_256x240.png"); */
}

/* positioning */
.ui-icon-blank {
  background-position: 16px 16px;
}

.ui-icon-caret-1-n {
  background-position: 0 0;
}

.ui-icon-caret-1-ne {
  background-position: -16px 0;
}

.ui-icon-caret-1-e {
  background-position: -32px 0;
}

.ui-icon-caret-1-se {
  background-position: -48px 0;
}

.ui-icon-caret-1-s {
  background-position: -65px 0;
}

.ui-icon-caret-1-sw {
  background-position: -80px 0;
}

.ui-icon-caret-1-w {
  background-position: -96px 0;
}

.ui-icon-caret-1-nw {
  background-position: -112px 0;
}

.ui-icon-caret-2-n-s {
  background-position: -128px 0;
}

.ui-icon-caret-2-e-w {
  background-position: -144px 0;
}

.ui-icon-triangle-1-n {
  background-position: 0 -16px;
}

.ui-icon-triangle-1-ne {
  background-position: -16px -16px;
}

.ui-icon-triangle-1-e {
  background-position: -32px -16px;
}

.ui-icon-triangle-1-se {
  background-position: -48px -16px;
}

.ui-icon-triangle-1-s {
  background-position: -65px -16px;
}

.ui-icon-triangle-1-sw {
  background-position: -80px -16px;
}

.ui-icon-triangle-1-w {
  background-position: -96px -16px;
}

.ui-icon-triangle-1-nw {
  background-position: -112px -16px;
}

.ui-icon-triangle-2-n-s {
  background-position: -128px -16px;
}

.ui-icon-triangle-2-e-w {
  background-position: -144px -16px;
}

.ui-icon-arrow-1-n {
  background-position: 0 -32px;
}

.ui-icon-arrow-1-ne {
  background-position: -16px -32px;
}

.ui-icon-arrow-1-e {
  background-position: -32px -32px;
}

.ui-icon-arrow-1-se {
  background-position: -48px -32px;
}

.ui-icon-arrow-1-s {
  background-position: -65px -32px;
}

.ui-icon-arrow-1-sw {
  background-position: -80px -32px;
}

.ui-icon-arrow-1-w {
  background-position: -96px -32px;
}

.ui-icon-arrow-1-nw {
  background-position: -112px -32px;
}

.ui-icon-arrow-2-n-s {
  background-position: -128px -32px;
}

.ui-icon-arrow-2-ne-sw {
  background-position: -144px -32px;
}

.ui-icon-arrow-2-e-w {
  background-position: -160px -32px;
}

.ui-icon-arrow-2-se-nw {
  background-position: -176px -32px;
}

.ui-icon-arrowstop-1-n {
  background-position: -192px -32px;
}

.ui-icon-arrowstop-1-e {
  background-position: -208px -32px;
}

.ui-icon-arrowstop-1-s {
  background-position: -224px -32px;
}

.ui-icon-arrowstop-1-w {
  background-position: -240px -32px;
}

.ui-icon-arrowthick-1-n {
  background-position: 1px -48px;
}

.ui-icon-arrowthick-1-ne {
  background-position: -16px -48px;
}

.ui-icon-arrowthick-1-e {
  background-position: -32px -48px;
}

.ui-icon-arrowthick-1-se {
  background-position: -48px -48px;
}

.ui-icon-arrowthick-1-s {
  background-position: -64px -48px;
}

.ui-icon-arrowthick-1-sw {
  background-position: -80px -48px;
}

.ui-icon-arrowthick-1-w {
  background-position: -96px -48px;
}

.ui-icon-arrowthick-1-nw {
  background-position: -112px -48px;
}

.ui-icon-arrowthick-2-n-s {
  background-position: -128px -48px;
}

.ui-icon-arrowthick-2-ne-sw {
  background-position: -144px -48px;
}

.ui-icon-arrowthick-2-e-w {
  background-position: -160px -48px;
}

.ui-icon-arrowthick-2-se-nw {
  background-position: -176px -48px;
}

.ui-icon-arrowthickstop-1-n {
  background-position: -192px -48px;
}

.ui-icon-arrowthickstop-1-e {
  background-position: -208px -48px;
}

.ui-icon-arrowthickstop-1-s {
  background-position: -224px -48px;
}

.ui-icon-arrowthickstop-1-w {
  background-position: -240px -48px;
}

.ui-icon-arrowreturnthick-1-w {
  background-position: 0 -64px;
}

.ui-icon-arrowreturnthick-1-n {
  background-position: -16px -64px;
}

.ui-icon-arrowreturnthick-1-e {
  background-position: -32px -64px;
}

.ui-icon-arrowreturnthick-1-s {
  background-position: -48px -64px;
}

.ui-icon-arrowreturn-1-w {
  background-position: -64px -64px;
}

.ui-icon-arrowreturn-1-n {
  background-position: -80px -64px;
}

.ui-icon-arrowreturn-1-e {
  background-position: -96px -64px;
}

.ui-icon-arrowreturn-1-s {
  background-position: -112px -64px;
}

.ui-icon-arrowrefresh-1-w {
  background-position: -128px -64px;
}

.ui-icon-arrowrefresh-1-n {
  background-position: -144px -64px;
}

.ui-icon-arrowrefresh-1-e {
  background-position: -160px -64px;
}

.ui-icon-arrowrefresh-1-s {
  background-position: -176px -64px;
}

.ui-icon-arrow-4 {
  background-position: 0 -80px;
}

.ui-icon-arrow-4-diag {
  background-position: -16px -80px;
}

.ui-icon-extlink {
  background-position: -32px -80px;
}

.ui-icon-newwin {
  background-position: -48px -80px;
}

.ui-icon-refresh {
  background-position: -64px -80px;
}

.ui-icon-shuffle {
  background-position: -80px -80px;
}

.ui-icon-transfer-e-w {
  background-position: -96px -80px;
}

.ui-icon-transferthick-e-w {
  background-position: -112px -80px;
}

.ui-icon-folder-collapsed {
  background-position: 0 -96px;
}

.ui-icon-folder-open {
  background-position: -16px -96px;
}

.ui-icon-document {
  background-position: -32px -96px;
}

.ui-icon-document-b {
  background-position: -48px -96px;
}

.ui-icon-note {
  background-position: -64px -96px;
}

.ui-icon-mail-closed {
  background-position: -80px -96px;
}

.ui-icon-mail-open {
  background-position: -96px -96px;
}

.ui-icon-suitcase {
  background-position: -112px -96px;
}

.ui-icon-comment {
  background-position: -128px -96px;
}

.ui-icon-person {
  background-position: -144px -96px;
}

.ui-icon-print {
  background-position: -160px -96px;
}

.ui-icon-trash {
  background-position: -176px -96px;
}

.ui-icon-locked {
  background-position: -192px -96px;
}

.ui-icon-unlocked {
  background-position: -208px -96px;
}

.ui-icon-bookmark {
  background-position: -224px -96px;
}

.ui-icon-tag {
  background-position: -240px -96px;
}

.ui-icon-home {
  background-position: 0 -112px;
}

.ui-icon-flag {
  background-position: -16px -112px;
}

.ui-icon-calendar {
  background-position: -32px -112px;
}

.ui-icon-cart {
  background-position: -48px -112px;
}

.ui-icon-pencil {
  background-position: -64px -112px;
}

.ui-icon-clock {
  background-position: -80px -112px;
}

.ui-icon-disk {
  background-position: -96px -112px;
}

.ui-icon-calculator {
  background-position: -112px -112px;
}

.ui-icon-zoomin {
  background-position: -128px -112px;
}

.ui-icon-zoomout {
  background-position: -144px -112px;
}

.ui-icon-search {
  background-position: -160px -112px;
}

.ui-icon-wrench {
  background-position: -176px -112px;
}

.ui-icon-gear {
  background-position: -192px -112px;
}

.ui-icon-heart {
  background-position: -208px -112px;
}

.ui-icon-star {
  background-position: -224px -112px;
}

.ui-icon-link {
  background-position: -240px -112px;
}

.ui-icon-cancel {
  background-position: 0 -128px;
}

.ui-icon-plus {
  background-position: -16px -128px;
}

.ui-icon-plusthick {
  background-position: -32px -128px;
}

.ui-icon-minus {
  background-position: -48px -128px;
}

.ui-icon-minusthick {
  background-position: -64px -128px;
}

.ui-icon-close {
  background-position: -80px -128px;
}

.ui-icon-closethick {
  background-position: -96px -128px;
}

.ui-icon-key {
  background-position: -112px -128px;
}

.ui-icon-lightbulb {
  background-position: -128px -128px;
}

.ui-icon-scissors {
  background-position: -144px -128px;
}

.ui-icon-clipboard {
  background-position: -160px -128px;
}

.ui-icon-copy {
  background-position: -176px -128px;
}

.ui-icon-contact {
  background-position: -192px -128px;
}

.ui-icon-image {
  background-position: -208px -128px;
}

.ui-icon-video {
  background-position: -224px -128px;
}

.ui-icon-script {
  background-position: -240px -128px;
}

.ui-icon-alert {
  background-position: 0 -144px;
}

.ui-icon-info {
  background-position: -16px -144px;
}

.ui-icon-notice {
  background-position: -32px -144px;
}

.ui-icon-help {
  background-position: -48px -144px;
}

.ui-icon-check {
  background-position: -64px -144px;
}

.ui-icon-bullet {
  background-position: -80px -144px;
}

.ui-icon-radio-on {
  background-position: -96px -144px;
}

.ui-icon-radio-off {
  background-position: -112px -144px;
}

.ui-icon-pin-w {
  background-position: -128px -144px;
}

.ui-icon-pin-s {
  background-position: -144px -144px;
}

.ui-icon-play {
  background-position: 0 -160px;
}

.ui-icon-pause {
  background-position: -16px -160px;
}

.ui-icon-seek-next {
  background-position: -32px -160px;
}

.ui-icon-seek-prev {
  background-position: -48px -160px;
}

.ui-icon-seek-end {
  background-position: -64px -160px;
}

.ui-icon-seek-start {
  background-position: -80px -160px;
}

/* ui-icon-seek-first is deprecated, use ui-icon-seek-start instead */
.ui-icon-seek-first {
  background-position: -80px -160px;
}

.ui-icon-stop {
  background-position: -96px -160px;
}

.ui-icon-eject {
  background-position: -112px -160px;
}

.ui-icon-volume-off {
  background-position: -128px -160px;
}

.ui-icon-volume-on {
  background-position: -144px -160px;
}

.ui-icon-power {
  background-position: 0 -176px;
}

.ui-icon-signal-diag {
  background-position: -16px -176px;
}

.ui-icon-signal {
  background-position: -32px -176px;
}

.ui-icon-battery-0 {
  background-position: -48px -176px;
}

.ui-icon-battery-1 {
  background-position: -64px -176px;
}

.ui-icon-battery-2 {
  background-position: -80px -176px;
}

.ui-icon-battery-3 {
  background-position: -96px -176px;
}

.ui-icon-circle-plus {
  background-position: 0 -192px;
}

.ui-icon-circle-minus {
  background-position: -16px -192px;
}

.ui-icon-circle-close {
  background-position: -32px -192px;
}

.ui-icon-circle-triangle-e {
  background-position: -48px -192px;
}

.ui-icon-circle-triangle-s {
  background-position: -64px -192px;
}

.ui-icon-circle-triangle-w {
  background-position: -80px -192px;
}

.ui-icon-circle-triangle-n {
  background-position: -96px -192px;
}

.ui-icon-circle-arrow-e {
  background-position: -112px -192px;
}

.ui-icon-circle-arrow-s {
  background-position: -128px -192px;
}

.ui-icon-circle-arrow-w {
  background-position: -144px -192px;
}

.ui-icon-circle-arrow-n {
  background-position: -160px -192px;
}

.ui-icon-circle-zoomin {
  background-position: -176px -192px;
}

.ui-icon-circle-zoomout {
  background-position: -192px -192px;
}

.ui-icon-circle-check {
  background-position: -208px -192px;
}

.ui-icon-circlesmall-plus {
  background-position: 0 -208px;
}

.ui-icon-circlesmall-minus {
  background-position: -16px -208px;
}

.ui-icon-circlesmall-close {
  background-position: -32px -208px;
}

.ui-icon-squaresmall-plus {
  background-position: -48px -208px;
}

.ui-icon-squaresmall-minus {
  background-position: -64px -208px;
}

.ui-icon-squaresmall-close {
  background-position: -80px -208px;
}

.ui-icon-grip-dotted-vertical {
  background-position: 0 -224px;
}

.ui-icon-grip-dotted-horizontal {
  background-position: -16px -224px;
}

.ui-icon-grip-solid-vertical {
  background-position: -32px -224px;
}

.ui-icon-grip-solid-horizontal {
  background-position: -48px -224px;
}

.ui-icon-gripsmall-diagonal-se {
  background-position: -64px -224px;
}

.ui-icon-grip-diagonal-se {
  background-position: -80px -224px;
}


/* Misc visuals
----------------------------------*/

/* Corner radius */
.ui-corner-all,
.ui-corner-top,
.ui-corner-left,
.ui-corner-tl {
  border-top-left-radius: 3px;
}

.ui-corner-all,
.ui-corner-top,
.ui-corner-right,
.ui-corner-tr {
  border-top-right-radius: 3px;
}

.ui-corner-all,
.ui-corner-bottom,
.ui-corner-left,
.ui-corner-bl {
  border-bottom-left-radius: 3px;
}

.ui-corner-all,
.ui-corner-bottom,
.ui-corner-right,
.ui-corner-br {
  border-bottom-right-radius: 3px;
}

/* Overlays */
.ui-widget-overlay {
  background: #aaaaaa;
  opacity: .3;
  filter: Alpha(Opacity=30);
  /* support: IE8 */
}

.ui-widget-shadow {
  box-shadow: 0px 0px 5px #666666;
}

.styles_modal__gNwvD {
  width: 1200px !important;
}


@keyframes customEnterAnimation {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes customLeaveAnimation {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0);
  }
}

.customModal {
  min-width: 1300px !important;
  width: 1200px !important;
}

.errorStyles {
  border: 1px solid red !important;
}

.logo-caption {
  position: absolute;
  bottom: -4px;
  right: 13%;
  z-index: 9999;
  font-size: 11px;
  color: #000;
}

.ag-header-cell-label .ag-header-cell-text {
  white-space: normal !important;
}

.agrowheight {
  height: 70px;
}

.maileven {
  background: #d7fffa !important;
}

.wraptext {
  white-space: normal !important;
}

.row.col-xl-12.col-lg-12.ml-0p.n-p-0.Transhipment-Edit-Row {
  margin-top: 13px;
}

/* input#replaced_Date {
    width: 72%;
    margin-left: 121px;
} */
.save-btn {
  height: 36px;
  width: 100px;
  margin-top: 35px;
  margin-left: 41px;
}

.rdt.transhipment-datetime input {
  width: 22em;
  height: 40px;
  margin-top: 4px;
  margin-left: 29px;
}

label.replacement-time {
  float: left;
  width: 100%;
  /* margin-left: 9em; */
}

.xdsoft_datetimepicker {
  box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.506);
  background: #fff;
  border-bottom: 1px solid #bbb;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-top: 1px solid #ccc;
  color: #333;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: 8px;
  padding-left: 0;
  padding-top: 2px;
  position: absolute;
  z-index: 9999;
  box-sizing: border-box;
  display: none;
}

.xdsoft_datetimepicker.xdsoft_rtl {
  padding: 8px 0 8px 8px;
}

.xdsoft_datetimepicker iframe {
  position: absolute;
  left: 0;
  top: 0;
  width: 75px;
  height: 210px;
  background: transparent;
  border: none;
}

/*For IE8 or lower*/
.xdsoft_datetimepicker button {
  border: none !important;
}

.xdsoft_noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.xdsoft_noselect::selection {
  background: transparent
}

.xdsoft_noselect::-moz-selection {
  background: transparent
}

.xdsoft_datetimepicker.xdsoft_inline {
  display: inline-block;
  position: static;
  box-shadow: none;
}

.xdsoft_datetimepicker * {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.xdsoft_datetimepicker .xdsoft_datepicker,
.xdsoft_datetimepicker .xdsoft_timepicker {
  display: none;
}

.xdsoft_datetimepicker .xdsoft_datepicker.active,
.xdsoft_datetimepicker .xdsoft_timepicker.active {
  display: block;
}

.xdsoft_datetimepicker .xdsoft_datepicker {
  width: 224px;
  float: left;
  margin-left: 8px;
}

.xdsoft_datetimepicker.xdsoft_rtl .xdsoft_datepicker {
  float: right;
  margin-right: 8px;
  margin-left: 0;
}

.xdsoft_datetimepicker.xdsoft_showweeks .xdsoft_datepicker {
  width: 256px;
}

.xdsoft_datetimepicker .xdsoft_timepicker {
  width: 58px;
  float: left;
  text-align: center;
  margin-left: 8px;
  margin-top: 0;
}

.xdsoft_datetimepicker.xdsoft_rtl .xdsoft_timepicker {
  float: right;
  margin-right: 8px;
  margin-left: 0;
}

.xdsoft_datetimepicker .xdsoft_datepicker.active+.xdsoft_timepicker {
  margin-top: 8px;
  margin-bottom: 3px
}

.xdsoft_datetimepicker .xdsoft_monthpicker {
  position: relative;
  text-align: center;
}

.xdsoft_datetimepicker .xdsoft_label i,
.xdsoft_datetimepicker .xdsoft_prev,
.xdsoft_datetimepicker .xdsoft_next,
.xdsoft_datetimepicker .xdsoft_today_button {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.xdsoft_datetimepicker .xdsoft_label i {
  opacity: 0.5;
  background-position: -92px -19px;
  display: inline-block;
  width: 9px;
  height: 20px;
  vertical-align: middle;
}

.xdsoft_datetimepicker .xdsoft_prev {
  float: left;
  background-position: -20px 0;
}

.xdsoft_datetimepicker .xdsoft_today_button {
  float: left;
  background-position: -70px 0;
  margin-left: 5px;
}

.xdsoft_datetimepicker .xdsoft_next {
  float: right;
  background-position: 0 0;
}

.xdsoft_datetimepicker .xdsoft_next,
.xdsoft_datetimepicker .xdsoft_prev,
.xdsoft_datetimepicker .xdsoft_today_button {
  background-color: transparent;
  background-repeat: no-repeat;
  border: 0 none;
  cursor: pointer;
  display: block;
  height: 30px;
  opacity: 0.5;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=50)";
  outline: medium none;
  overflow: hidden;
  padding: 0;
  position: relative;
  text-indent: 100%;
  white-space: nowrap;
  width: 20px;
  min-width: 0;
}

.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_prev,
.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_next {
  float: none;
  background-position: -40px -15px;
  height: 15px;
  width: 30px;
  display: block;
  margin-left: 14px;
  margin-top: 7px;
}

.xdsoft_datetimepicker.xdsoft_rtl .xdsoft_timepicker .xdsoft_prev,
.xdsoft_datetimepicker.xdsoft_rtl .xdsoft_timepicker .xdsoft_next {
  float: none;
  margin-left: 0;
  margin-right: 14px;
}

.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_prev {
  background-position: -40px 0;
  margin-bottom: 7px;
  margin-top: 0;
}

.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_time_box {
  height: 151px;
  overflow: hidden;
  border-bottom: 1px solid #ddd;
}

.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_time_box>div>div {
  background: #f5f5f5;
  border-top: 1px solid #ddd;
  color: #666;
  font-size: 12px;
  text-align: center;
  border-collapse: collapse;
  cursor: pointer;
  border-bottom-width: 0;
  height: 25px;
  line-height: 25px;
}

.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_time_box>div>div:first-child {
  border-top-width: 0;
}

.xdsoft_datetimepicker .xdsoft_today_button:hover,
.xdsoft_datetimepicker .xdsoft_next:hover,
.xdsoft_datetimepicker .xdsoft_prev:hover {
  opacity: 1;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
}

.xdsoft_datetimepicker .xdsoft_label {
  display: inline;
  position: relative;
  z-index: 9999;
  margin: 0;
  padding: 5px 3px;
  font-size: 14px;
  line-height: 20px;
  font-weight: bold;
  background-color: #fff;
  float: left;
  width: 182px;
  text-align: center;
  cursor: pointer;
}

.xdsoft_datetimepicker .xdsoft_label:hover>span {
  text-decoration: underline;
}

.xdsoft_datetimepicker .xdsoft_label:hover i {
  opacity: 1.0;
}

.xdsoft_datetimepicker .xdsoft_label>.xdsoft_select {
  border: 1px solid #ccc;
  position: absolute;
  right: 0;
  top: 30px;
  z-index: 101;
  display: none;
  background: #fff;
  max-height: 160px;
  overflow-y: hidden;
}

.xdsoft_datetimepicker .xdsoft_label>.xdsoft_select.xdsoft_monthselect {
  right: -7px
}

.xdsoft_datetimepicker .xdsoft_label>.xdsoft_select.xdsoft_yearselect {
  right: 2px
}

.xdsoft_datetimepicker .xdsoft_label>.xdsoft_select>div>.xdsoft_option:hover {
  color: #fff;
  background: #ff8000;
}

.xdsoft_datetimepicker .xdsoft_label>.xdsoft_select>div>.xdsoft_option {
  padding: 2px 10px 2px 5px;
  text-decoration: none !important;
}

.xdsoft_datetimepicker .xdsoft_label>.xdsoft_select>div>.xdsoft_option.xdsoft_current {
  background: #33aaff;
  box-shadow: #178fe5 0 1px 3px 0 inset;
  color: #fff;
  font-weight: 700;
}

.xdsoft_datetimepicker .xdsoft_month {
  width: 100px;
  text-align: right;
}

.xdsoft_datetimepicker .xdsoft_calendar {
  clear: both;
}

.xdsoft_datetimepicker .xdsoft_year {
  width: 48px;
  margin-left: 5px;
}

.xdsoft_datetimepicker .xdsoft_calendar table {
  border-collapse: collapse;
  width: 100%;

}

.xdsoft_datetimepicker .xdsoft_calendar td>div {
  padding-right: 5px;
}

.xdsoft_datetimepicker .xdsoft_calendar th {
  height: 25px;
}

.xdsoft_datetimepicker .xdsoft_calendar td,
.xdsoft_datetimepicker .xdsoft_calendar th {
  width: 14.2857142%;
  background: #f5f5f5;
  border: 1px solid #ddd;
  color: #666;
  font-size: 12px;
  text-align: right;
  vertical-align: middle;
  padding: 0;
  border-collapse: collapse;
  cursor: pointer;
  height: 25px;
}

.xdsoft_datetimepicker.xdsoft_showweeks .xdsoft_calendar td,
.xdsoft_datetimepicker.xdsoft_showweeks .xdsoft_calendar th {
  width: 12.5%;
}

.xdsoft_datetimepicker .xdsoft_calendar th {
  background: #f1f1f1;
}

.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_today {
  color: #33aaff;
}

.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_highlighted_default {
  background: #ffe9d2;
  box-shadow: #ffb871 0 1px 4px 0 inset;
  color: #000;
}

.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_highlighted_mint {
  background: #c1ffc9;
  box-shadow: #00dd1c 0 1px 4px 0 inset;
  color: #000;
}

.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_default,
.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_current,
.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_time_box>div>div.xdsoft_current {
  background: #33aaff;
  box-shadow: #178fe5 0 1px 3px 0 inset;
  color: #fff;
  font-weight: 700;
}

.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_other_month,
.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_disabled,
.xdsoft_datetimepicker .xdsoft_time_box>div>div.xdsoft_disabled {
  opacity: 0.5;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=50)";
  cursor: default;
}

.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_other_month.xdsoft_disabled {
  opacity: 0.2;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=20)";
}

.xdsoft_datetimepicker .xdsoft_calendar td:hover,
.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_time_box>div>div:hover {
  color: #fff !important;
  background: #ff8000 !important;
  box-shadow: none !important;
}

.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_current.xdsoft_disabled:hover,
.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_time_box>div>div.xdsoft_current.xdsoft_disabled:hover {
  background: #33aaff !important;
  box-shadow: #178fe5 0 1px 3px 0 inset !important;
  color: #fff !important;
}

.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_disabled:hover,
.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_time_box>div>div.xdsoft_disabled:hover {
  color: inherit !important;
  background: inherit !important;
  box-shadow: inherit !important;
}

.xdsoft_datetimepicker .xdsoft_calendar th {
  font-weight: 700;
  text-align: center;
  color: #999;
  cursor: default;
}

.xdsoft_datetimepicker .xdsoft_copyright {
  color: #ccc !important;
  font-size: 10px;
  clear: both;
  float: none;
  margin-left: 8px;
}

.xdsoft_datetimepicker .xdsoft_copyright a {
  color: #eee !important
}

.xdsoft_datetimepicker .xdsoft_copyright a:hover {
  color: #aaa !important
}

.xdsoft_time_box {
  position: relative;
  border: 1px solid #ccc;
}

.xdsoft_scrollbar>.xdsoft_scroller {
  background: #ccc !important;
  height: 20px;
  border-radius: 3px;
}

.xdsoft_scrollbar {
  position: absolute;
  width: 7px;
  right: 0;
  top: 0;
  bottom: 0;
  cursor: pointer;
}

.xdsoft_datetimepicker.xdsoft_rtl .xdsoft_scrollbar {
  left: 0;
  right: auto;
}

.xdsoft_scroller_box {
  position: relative;
}

.xdsoft_datetimepicker.xdsoft_dark {
  box-shadow: 0 5px 15px -5px rgba(255, 255, 255, 0.506);
  background: #000;
  border-bottom: 1px solid #444;
  border-left: 1px solid #333;
  border-right: 1px solid #333;
  border-top: 1px solid #333;
  color: #ccc;
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_timepicker .xdsoft_time_box {
  border-bottom: 1px solid #222;
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_timepicker .xdsoft_time_box>div>div {
  background: #0a0a0a;
  border-top: 1px solid #222;
  color: #999;
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_label {
  background-color: #000;
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_label>.xdsoft_select {
  border: 1px solid #333;
  background: #000;
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_label>.xdsoft_select>div>.xdsoft_option:hover {
  color: #000;
  background: #007fff;
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_label>.xdsoft_select>div>.xdsoft_option.xdsoft_current {
  background: #cc5500;
  box-shadow: #b03e00 0 1px 3px 0 inset;
  color: #000;
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_label i,
.xdsoft_datetimepicker.xdsoft_dark .xdsoft_prev,
.xdsoft_datetimepicker.xdsoft_dark .xdsoft_next,
.xdsoft_datetimepicker.xdsoft_dark .xdsoft_today_button {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar td,
.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar th {
  background: #0a0a0a;
  border: 1px solid #222;
  color: #999;
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar th {
  background: #0e0e0e;
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar td.xdsoft_today {
  color: #cc5500;
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar td.xdsoft_highlighted_default {
  background: #ffe9d2;
  box-shadow: #ffb871 0 1px 4px 0 inset;
  color: #000;
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar td.xdsoft_highlighted_mint {
  background: #c1ffc9;
  box-shadow: #00dd1c 0 1px 4px 0 inset;
  color: #000;
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar td.xdsoft_default,
.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar td.xdsoft_current,
.xdsoft_datetimepicker.xdsoft_dark .xdsoft_timepicker .xdsoft_time_box>div>div.xdsoft_current {
  background: #cc5500;
  box-shadow: #b03e00 0 1px 3px 0 inset;
  color: #000;
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar td:hover,
.xdsoft_datetimepicker.xdsoft_dark .xdsoft_timepicker .xdsoft_time_box>div>div:hover {
  color: #000 !important;
  background: #007fff !important;
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar th {
  color: #666;
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_copyright {
  color: #333 !important
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_copyright a {
  color: #111 !important
}

.xdsoft_datetimepicker.xdsoft_dark .xdsoft_copyright a:hover {
  color: #555 !important
}

.xdsoft_dark .xdsoft_time_box {
  border: 1px solid #333;
}

.xdsoft_dark .xdsoft_scrollbar>.xdsoft_scroller {
  background: #333 !important;
}

.xdsoft_datetimepicker .xdsoft_save_selected {
  display: block;
  border: 1px solid #dddddd !important;
  margin-top: 5px;
  width: 100%;
  color: #454551;
  font-size: 13px;
}

.xdsoft_datetimepicker .blue-gradient-button {
  font-family: "museo-sans", "Book Antiqua", sans-serif;
  font-size: 12px;
  font-weight: 300;
  color: #82878c;
  height: 28px;
  position: relative;
  padding: 4px 17px 4px 33px;
  border: 1px solid #d7d8da;
  /* FF3.6+ */
  /* Chrome,Safari4+ */
  /* Chrome10+,Safari5.1+ */
  /* Opera 11.10+ */
  /* IE10+ */
  background: linear-gradient(to bottom, #fff 0%, #f4f8fa 73%);
  /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff', endColorstr='#f4f8fa', GradientType=0);
  /* IE6-9 */
}

.xdsoft_datetimepicker .blue-gradient-button:hover,
.xdsoft_datetimepicker .blue-gradient-button:focus,
.xdsoft_datetimepicker .blue-gradient-button:hover span,
.xdsoft_datetimepicker .blue-gradient-button:focus span {
  color: #454551;
  /* FF3.6+ */
  /* Chrome,Safari4+ */
  /* Chrome10+,Safari5.1+ */
  /* Opera 11.10+ */
  /* IE10+ */
  background: linear-gradient(to bottom, #f4f8fa 0%, #FFF 73%);
  /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f4f8fa', endColorstr='#FFF', GradientType=0);
  /* IE6-9 */
}

.d-none {
  display: none;
}

.summary-title {
  font-size: 18px;
  padding: 10px;
  color: #ffffff;
  background-color: #0abb80;
}

.summary-blue {
  color: #4099ff !important;
}

.summary-green {
  color: #0abb80 !important;
}

.summary-yellow {
  color: #f3d800 !important;
}

.summary-red {
  color: #FF5370 !important;
}

.summary-grid {
  position: absolute;
  top: 0px;
  left: 15px;
  width: 93%;
  height: 98%;
  background: #fff;
  z-index: 9999;
  overflow-y: auto;
}

.summary-back {
  padding: 3px 5px;
  position: absolute;
  right: 22px;
  top: 5px;
}

.summary-span {
  font-size: 18px;
}

.summary-grid-title {
  background: #ff5370;
  color: #fff;
  padding: 10px 5px;
  font-size: 16px;
  font-weight: 600;
}

.summary-body {
  padding: 10px 10px;
}

.bordergray {
  border: 1px solid #ccc;
}

.hcolor {
  color: #f7516f !important;
}

.todo-options ul li {
  margin: 10px;
  color: #000;
  padding: 0px
}

.brd-btm-gray {
  border-bottom: 1px solid #ccc;
}

.z999 {
  z-index: 999;
}

.z9999 {
  z-index: 9999;
}

.oddbg {
  background: #c2edf8
}

.summary-lbl {
  background: #357fa4;
  color: #fff;
  text-align: center;
  padding: 5px 0px;
  font-size: 14px;
  margin: 0px;
}

.brd-right {
  border-right: 1px solid #eee;
}

.txt-dec-none {
  text-decoration: none;
}

.clr333 {
  color: #333333;
}

.clr333:hover {
  color: #1f749c;
}

.cell-wrap {
  white-space: normal !important;
  line-height: 1.5
}

.custom-tooltip {
  position: absolute;
  background: #FFFFFF;
  width: 200px;
  height: 90px;
  border: 1px solid cornflowerblue;
  pointer-events: none;
  transition: opacity 1s;
  word-wrap: break-word;
}

.custom-tooltip.ag-tooltip-hiding {
  opacity: 0;
}

.custom-tooltip p {
  margin: 5px;
  white-space: nowrap;
}

.custom-tooltip p:first-of-type {
  font-weight: bold;
}

.tabc {
  float: left;
  width: 100%;
}

.tabc li {
  float: left;
  margin: 0px 1px 15px 0px;
}

.tabc li a {
  padding: 15px 25px;
  background: #4c5a57;
  border: 1px solid #4c5a57;
  color: #fff;
  text-decoration: none;
  font-size: 16px;
}

.tabc li a.active {
  /*background: #eefaf7;*/
  background: #ffffff;
  color: #00c292;
  border-top: 1px solid #eee;
  border-right: 1px solid #eee;
  border-left: 1px solid #eee;
  border-bottom: 0px solid #eee;
}

.tabc-sm {
  float: left;
  width: 100%;
}

.tabc-sm li {
  float: left;
  margin: 0px 1px 15px 0px;
}

.tabc-sm li a {
  padding: 5px 25px;
  background: #4c5a57;
  border: 1px solid #4c5a57;
  color: #fff;
  text-decoration: none;
  font-size: 16px;
}

.tabc-sm li a.active {
  /*background: #eefaf7;*/
  background: #ffffff;
  color: #00c292;
  border-top: 1px solid #eee;
  border-right: 1px solid #eee;
  border-left: 1px solid #eee;
  border-bottom: 0px solid #eee;
}


.tabc-sbm {
  float: left;
  width: 100%;
}

.tabc-sbm li {
  float: left;
  margin: 0px 1px 15px 0px;
}

.tabc-sbm li a {
  padding: 5px 25px;
  background: #4c5956;
  border: 1px solid #4c5a57;
  color: #fff;
  text-decoration: none;
  font-size: 16px;
}

.tabc-sbm li a.active {
  /*background: #eefaf7;*/
  background: #f3da3c;
  color: #333333;
  border-top: 1px solid #eee;
  border-right: 1px solid #eee;
  border-left: 1px solid #eee;
  border-bottom: 0px solid #eee;
}

.tab-brd {
  border: 1px solid #eee;
}

.optchrt {
  font-size: 18px;
  background: #eee;
  padding: 5px;
  text-align: center;
  margin-bottom: 20px
}

.fixtb {
  position: fixed;
  right: 0;
  top: 30%;

  z-index: 999;
}

.fixtb li {
  margin: 10px;
  background: #fff;
  padding: 10px;
  background: #ccc;
}

.fixtb li a {
  padding: 5px 10px;
  text-decoration: none;
  color: #333
}

.gr-check {
  height: 16px;
  width: 16px;
  background: rgb(245, 245, 245);
  border: 1px solid #7f8c8d;
  border-radius: 3px;
}

/* .styles_modal__gNwvD, .styles_modal__gNwvD>div{
	padding: 0px !important;
    width: 830px !important;
} */
h5.modeltitle {
  width: 100%;
  background: #068cda;
  padding: 10px;
  color: #fff;
}

.dashboard-page {
  position: absolute;
  left: -27px;
  top: 80px;
  background: #ccc;
}

.dashboard-page li {
  border-bottom: 1px solid #ccc;
}

.dashboard-page li.active {
  background: #fff;
}

.dashboard-page li a.active {
  background: #fff;
}

.dashboard-page li:last-child {
  border-bottom: 0px solid #ccc;
}

.dashboard-page li:hover {
  background: #fff;
}

.dashboard-icon {
  width: 48px;
  height: 48px;
  margin: 5px;
  padding: 5px;
}

.dashboard-sub {
  position: absolute;
  right: -220px;
  top: 0;
  background: #fff;
  width: 220px;
  min-height: 60px;
  height: auto;
  z-index: 9;
  font-size: 12px;
  box-shadow: 6px 0px 25px 6px #ccc;
}

.dashboard-sub a {
  color: #333;
  text-decoration: none;
}

.dashboard-sub li {
  width: 100%;
  background: #d4d4d4;
  padding-left: 12px;
  border-bottom: 1px solid #ccc;
  line-height: 40px;
}

.dashboard-sub li:hover {
  background: #fff;
}

.dashboard-sub li a {
  color: #333;
  padding: 12px 0px;
}

.dashboard-sub img {
  width: 24px;
  height: 24px;
}

.dashboard-sub li:last-child {
  border-bottom: 1px solid #ccc;
}

.dashboard-sub li.active {
  background: #fff;
}


.map {
  position: static !important;
  position: initial !important
}

.nav-tooltip {
  position: absolute;
  top: 52px;
  left: 44px;
  background: #343434;
  color: white;
  padding: 9px;
  font-size: 12px;
}

span.nav-left-arrow {
  position: absolute;
  left: 35px;
  top: 54.5px;
  color: #343434;
}

div#pbody {
  padding-top: 48px;
  background-color: #fff;
}

.btn-data {
  height: 35px;
  padding: 6px;
  margin-top: 22px;
}

.close-menu-alert {
  position: absolute;
  top: 52px;
  left: 181px;
  color: white;
  font-size: 13px;
  /* height: 28px; */
  padding: 0px 6px 0px 6px;
  z-index: 1000;
  background: cornflowerblue;
  opacity: 0.9 !important;
}

.card-body.pt-15px .row {
  /* margin-top: 23px; */
}

.hr-dashed {
  margin: 2% 0 2% 0;
  border-bottom: 1px dotted #ccc;
}

.aircargo-form label {
  padding: 0;
  color: #3d6cb7;
  margin-top: 2%;
}

/* .mybtn { */
  /* background: #ded022 !important; */
  /* color: #333;
  font-size: 10px;
  padding: 2px 5px 2px; */
  /* border: 1px solid #ded022 !important; */
/* } */

.mybtn:hover,
.mybtn:visited,
.mybtn:focus,
.mybtn:active {
  /* background: #dead22 !important; */
  color: #333 !important;
  /* border: 1px solid #ded022 !important; */
}


.map-overly {
  background: black;
  opacity: 0.7;
  color: white;
  position: absolute;
  top: 0;
  width: 100%;
  text-align: center;
  padding-top: 15em;
}

.c-pd {
  padding: 5px 0px !important;
}

.w85p {
  width: 85% !important
}

.w90p {
  width: 90% !important
}

.layoutbtns {
  display: block;
}

.display-block {
  display: block;
}

.highcharts-root {
  width: 100% !important;
}

.show-unloading-dashboard {
  display: flex;
}

.m-top-1 {
  margin-top: 1%;
}

.m-top-2 {
  margin-top: 2%;
}

.viewcs li {
  display: inline-block;
}

/*Full Calender*/

/* classes attached to <body> */
.fc-theme-standard {
  width: 100%
}

.fc-not-allowed,
.fc-not-allowed .fc-event {
  /* override events' custom cursors */
  cursor: not-allowed;
}

.fc-unselectable {
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.fc {
  /* layout of immediate children */
  display: flex;
  flex-direction: column;

  font-size: 1em
}

.fc,
.fc *,
.fc *:before,
.fc *:after {
  box-sizing: border-box;
}

.fc table {
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 1em;
  /* normalize cross-browser */
}

.fc th {
  text-align: center;
}

.fc th,
.fc td {
  vertical-align: top;
  padding: 0;
}

.fc a[data-navlink] {
  cursor: pointer;
}

.fc a[data-navlink]:hover {
  text-decoration: underline;
}

.fc-direction-ltr {
  direction: ltr;
  text-align: left;
}

.fc-direction-rtl {
  direction: rtl;
  text-align: right;
}

.fc-theme-standard td,
.fc-theme-standard th {
  border: 1px solid #ddd;
  border: 1px solid var(--fc-border-color, #ddd);
}

/* for FF, which doesn't expand a 100% div within a table cell. use absolute positioning */
/* inner-wrappers are responsible for being absolute */
/* TODO: best place for this? */
.fc-liquid-hack td,
.fc-liquid-hack th {
  position: relative;
}

@font-face {
  font-family: 'fcicons';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

.fc-icon {
  /* added for fc */
  display: inline-block;
  width: 1em;
  height: 1em;
  text-align: center;
  -webkit-user-select: none;
  user-select: none;

  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'fcicons' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.fc-icon-chevron-left:before {
  content: "\\e900";
}

.fc-icon-chevron-right:before {
  content: "\\e901";
}

.fc-icon-chevrons-left:before {
  content: "\\e902";
}

.fc-icon-chevrons-right:before {
  content: "\\e903";
}

.fc-icon-minus-square:before {
  content: "\\e904";
}

.fc-icon-plus-square:before {
  content: "\\e905";
}

.fc-icon-x:before {
  content: "\\e906";
}

/*
Lots taken from Flatly (MIT): https://bootswatch.com/4/flatly/bootstrap.css

These styles only apply when the standard-theme is activated.
When it's NOT activated, the fc-button classes won't even be in the DOM.
*/
.fc {

  /* reset */

}

.fc .fc-button {
  border-radius: 0;
  overflow: visible;
  text-transform: none;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.fc .fc-button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

.fc .fc-button {
  -webkit-appearance: button;
}

.fc .fc-button:not(:disabled) {
  cursor: pointer;
}

.fc .fc-button::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

.fc {

  /* theme */

}

.fc .fc-button {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.4em 0.65em;
  font-size: 1em;
  line-height: 1.5;
  border-radius: 0.25em;
}

.fc .fc-button:hover {
  text-decoration: none;
}

.fc .fc-button:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(44, 62, 80, 0.25);
}

.fc .fc-button:disabled {
  opacity: 0.65;
}

.fc {

  /* "primary" coloring */

}

.fc .fc-button-primary {
  color: #fff;
  color: var(--fc-button-text-color, #fff);
  background-color: #2C3E50;
  background-color: var(--fc-button-bg-color, #2C3E50);
  border-color: #2C3E50;
  border-color: var(--fc-button-border-color, #2C3E50);
}

.fc .fc-button-primary:hover {
  color: #fff;
  color: var(--fc-button-text-color, #fff);
  background-color: #1e2b37;
  background-color: var(--fc-button-hover-bg-color, #1e2b37);
  border-color: #1a252f;
  border-color: var(--fc-button-hover-border-color, #1a252f);
}

.fc .fc-button-primary:disabled {
  /* not DRY */
  color: #fff;
  color: var(--fc-button-text-color, #fff);
  background-color: #2C3E50;
  background-color: var(--fc-button-bg-color, #2C3E50);
  border-color: #2C3E50;
  border-color: var(--fc-button-border-color, #2C3E50);
  /* overrides :hover */
}

.fc .fc-button-primary:focus {
  box-shadow: 0 0 0 0.2rem rgba(76, 91, 106, 0.5);
}

.fc .fc-button-primary:not(:disabled):active,
.fc .fc-button-primary:not(:disabled).fc-button-active {
  color: #fff;
  color: var(--fc-button-text-color, #fff);
  background-color: #1a252f;
  background-color: var(--fc-button-active-bg-color, #1a252f);
  border-color: #151e27;
  border-color: var(--fc-button-active-border-color, #151e27);
}

.fc .fc-button-primary:not(:disabled):active:focus,
.fc .fc-button-primary:not(:disabled).fc-button-active:focus {
  box-shadow: 0 0 0 0.2rem rgba(76, 91, 106, 0.5);
}

.fc {

  /* icons within buttons */

}

.fc .fc-button .fc-icon {
  vertical-align: middle;
  font-size: 1.5em;
  /* bump up the size (but don't make it bigger than line-height of button, which is 1.5em also) */
}

.fc .fc-button-group {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
/* .white{
  color:#fff;
} */
/* .defaultBlue{
  background-color:#F7F7F7 !important;
  color:#fff !important
} */
.bold-text{
  font-weight: bold;
}
.fc .fc-button-group>.fc-button {
  position: relative;
  flex: 1 1 auto;
}

.fc .fc-button-group>.fc-button:hover {
  z-index: 1;
}

.fc .fc-button-group>.fc-button:focus,
.fc .fc-button-group>.fc-button:active,
.fc .fc-button-group>.fc-button.fc-button-active {
  z-index: 1;
}

.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child) {
  margin-right: -1px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.fc .fc-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.fc .fc-toolbar.fc-header-toolbar {
  margin-bottom: 1.5em;
}

.fc .fc-toolbar.fc-footer-toolbar {
  margin-top: 1.5em;
}

.fc .fc-toolbar-title {
  font-size: 1.75em;
  margin: 0;
}

.fc-direction-ltr .fc-toolbar>*> :not(:first-child) {
  margin-left: .75em;
  /* space between */
}

.fc-direction-rtl .fc-toolbar>*> :not(:first-child) {
  margin-right: .75em;
  /* space between */
}

.fc-direction-rtl .fc-toolbar-ltr {
  /* when the toolbar-chunk positioning system is explicitly left-to-right */
  flex-direction: row-reverse;
}

.fc .fc-scroller {
  -webkit-overflow-scrolling: touch;
  position: relative;
  /* for abs-positioned elements within */
}

.fc .fc-scroller-liquid {
  height: 100%;
}

.fc .fc-scroller-liquid-absolute {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}

.fc .fc-scroller-harness {
  position: relative;
  overflow: hidden;
  direction: ltr;
  /* hack for chrome computing the scroller's right/left wrong for rtl. undone below... */
  /* TODO: demonstrate in codepen */
}

.fc .fc-scroller-harness-liquid {
  height: 100%;
}

.fc-direction-rtl .fc-scroller-harness>.fc-scroller {
  /* undo above hack */
  direction: rtl;
}

.fc-theme-standard .fc-scrollgrid {
  border: 1px solid #ddd;
  border: 1px solid var(--fc-border-color, #ddd);
  /* bootstrap does this. match */
}

.fc .fc-scrollgrid,
.fc .fc-scrollgrid table {
  /* all tables (self included) */
  width: 100%;
  /* because tables don't normally do this */
  table-layout: fixed;
}

.fc .fc-scrollgrid table {
  /* inner tables */
  border-top-style: hidden;
  border-left-style: hidden;
  border-right-style: hidden;
}

.fc .fc-scrollgrid {

  border-collapse: separate;
  border-right-width: 0;
  border-bottom-width: 0;

}

.fc .fc-scrollgrid-liquid {
  height: 100%;
}

.fc .fc-scrollgrid-section {
  /* a <tr> */
  height: 1px
    /* better than 0, for firefox */

}

.fc .fc-scrollgrid-section>td {
  height: 1px;
  /* needs a height so inner div within grow. better than 0, for firefox */
}

.fc .fc-scrollgrid-section table {
  height: 1px;
  /* for most browsers, if a height isn't set on the table, can't do liquid-height within cells */
  /* serves as a min-height. harmless */
}

.fc .fc-scrollgrid-section-liquid {
  height: auto
}

.fc .fc-scrollgrid-section-liquid>td {
  height: 100%;
  /* better than \`auto\`, for firefox */
}

.fc .fc-scrollgrid-section>* {
  border-top-width: 0;
  border-left-width: 0;
}

.fc .fc-scrollgrid-section-header>*,
.fc .fc-scrollgrid-section-footer>* {
  border-bottom-width: 0;
}

.fc .fc-scrollgrid-section-body table,
.fc .fc-scrollgrid-section-footer table {
  border-bottom-style: hidden;
  /* head keeps its bottom border tho */
}

.fc {

  /* stickiness */

}

.fc .fc-scrollgrid-section-sticky>* {
  background: #fff;
  background: var(--fc-page-bg-color, #fff);
  position: sticky;
  z-index: 2;
  /* TODO: var */
  /* TODO: box-shadow when sticking */
}

.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>* {
  top: 0;
  /* because border-sharing causes a gap at the top */
  /* TODO: give safari -1. has bug */
}

.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>* {
  bottom: 0;
  /* known bug: bottom-stickiness doesn't work in safari */
}

.fc .fc-scrollgrid-sticky-shim {
  /* for horizontal scrollbar */
  height: 1px;
  /* needs height to create scrollbars */
  margin-bottom: -1px;
}

.fc-sticky {
  /* no .fc wrap because used as child of body */
  position: sticky;
}

.fc .fc-view-harness {
  flex-grow: 1;
  /* because this harness is WITHIN the .fc's flexbox */
  position: relative;
}

.fc {

  /* when the harness controls the height, make the view liquid */

}

.fc .fc-view-harness-active>.fc-view {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.fc .fc-col-header-cell-cushion {
  display: inline-block;
  /* x-browser for when sticky (when multi-tier header) */
  padding: 2px 4px;
}

.fc .fc-bg-event,
.fc .fc-non-business,
.fc .fc-highlight {
  /* will always have a harness with position:relative/absolute, so absolutely expand */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.fc .fc-non-business {
  background: rgba(215, 215, 215, 0.3);
  background: var(--fc-non-business-color, rgba(215, 215, 215, 0.3));
}

.fc .fc-bg-event {
  background: rgb(143, 223, 130);
  background: var(--fc-bg-event-color, rgb(143, 223, 130));
  opacity: 0.3;
  opacity: var(--fc-bg-event-opacity, 0.3)
}

.fc .fc-bg-event .fc-event-title {
  margin: .5em;
  font-size: .85em;
  font-size: var(--fc-small-font-size, .85em);
  font-style: italic;
}

.fc .fc-highlight {
  background: rgba(188, 232, 241, 0.3);
  background: var(--fc-highlight-color, rgba(188, 232, 241, 0.3));
}

.fc .fc-cell-shaded,
.fc .fc-day-disabled {
  background: rgba(208, 208, 208, 0.3);
  background: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));
}

/* link resets */
/* ---------------------------------------------------------------------------------------------------- */
a.fc-event,
a.fc-event:hover {
  text-decoration: none;
}

/* cursor */
.fc-event[href],
.fc-event.fc-event-draggable {
  cursor: pointer;
}

/* event text content */
/* ---------------------------------------------------------------------------------------------------- */
.fc-event .fc-event-main {
  position: relative;
  z-index: 2;
}

/* dragging */
/* ---------------------------------------------------------------------------------------------------- */
.fc-event-dragging:not(.fc-event-selected) {
  /* MOUSE */
  opacity: 0.75;
}

.fc-event-dragging.fc-event-selected {
  /* TOUCH */
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.3);
}

/* resizing */
/* ---------------------------------------------------------------------------------------------------- */
/* (subclasses should hone positioning for touch and non-touch) */
.fc-event .fc-event-resizer {
  display: none;
  position: absolute;
  z-index: 4;
}

.fc-event:hover,
/* MOUSE */
.fc-event-selected {
  /* TOUCH */

}

.fc-event:hover .fc-event-resizer,
.fc-event-selected .fc-event-resizer {
  display: block;
}

.fc-event-selected .fc-event-resizer {
  border-radius: 4px;
  border-radius: calc(8px / 2);
  border-radius: calc(var(--fc-event-resizer-dot-total-width, 8px) / 2);
  border-width: 1px;
  border-width: var(--fc-event-resizer-dot-border-width, 1px);
  width: 8px;
  width: var(--fc-event-resizer-dot-total-width, 8px);
  height: 8px;
  height: var(--fc-event-resizer-dot-total-width, 8px);
  border-style: solid;
  border-color: inherit;
  background: #fff;
  background: var(--fc-page-bg-color, #fff)
    /* expand hit area */

}

.fc-event-selected .fc-event-resizer:before {
  content: '';
  position: absolute;
  top: -20px;
  left: -20px;
  right: -20px;
  bottom: -20px;
}

/* selecting (always TOUCH) */
/* ---------------------------------------------------------------------------------------------------- */
.fc-event-selected {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2)
    /* expand hit area (subclasses should expand) */

}

.fc-event-selected:before {
  content: "";
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.fc-event-selected {

  /* dimmer effect */

}

.fc-event-selected:after {
  content: "";
  background: rgba(0, 0, 0, 0.25);
  background: var(--fc-event-selected-overlay-color, rgba(0, 0, 0, 0.25));
  position: absolute;
  z-index: 1;

  /* assume there's a border on all sides. overcome it. */
  /* sometimes there's NOT a border, in which case the dimmer will go over */
  /* an adjacent border, which looks fine. */
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
}

/*
A HORIZONTAL event
*/
.fc-h-event {
  /* allowed to be top-level */
  display: block;
  border: 1px solid #3788d8;
  border: 1px solid var(--fc-event-border-color, #3788d8);
  background-color: #3788d8;
  background-color: var(--fc-event-bg-color, #3788d8)
}

.fc-h-event .fc-event-main {
  color: #fff;
  color: var(--fc-event-text-color, #fff);
}

.fc-h-event .fc-event-main-frame {
  display: flex;
  /* for make fc-event-title-container expand */
}

.fc-h-event .fc-event-time {
  max-width: 100%;
  /* clip overflow on this element */
  overflow: hidden;
}

.fc-h-event .fc-event-title-container {
  /* serves as a container for the sticky cushion */
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
  /* important for allowing to shrink all the way */
}

.fc-h-event .fc-event-title {
  display: inline-block;
  /* need this to be sticky cross-browser */
  vertical-align: top;
  /* for not messing up line-height */
  left: 0;
  /* for sticky */
  right: 0;
  /* for sticky */
  max-width: 100%;
  /* clip overflow on this element */
  overflow: hidden;
}

.fc-h-event.fc-event-selected:before {
  /* expand hit area */
  top: -10px;
  bottom: -10px;
}

/* adjust border and border-radius (if there is any) for non-start/end */
.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),
.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left-width: 0;
}

.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),
.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right-width: 0;
}

/* resizers */
.fc-h-event:not(.fc-event-selected) .fc-event-resizer {
  top: 0;
  bottom: 0;
  width: 8px;
  width: var(--fc-event-resizer-thickness, 8px);
}

.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,
.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end {
  cursor: w-resize;
  left: -4px;
  left: calc(8px / -2);
  left: calc(var(--fc-event-resizer-thickness, 8px) / -2);
}

.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,
.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start {
  cursor: e-resize;
  right: -4px;
  right: calc(8px / -2);
  right: calc(var(--fc-event-resizer-thickness, 8px) / -2);
}

/* resizers for TOUCH */
.fc-h-event.fc-event-selected .fc-event-resizer {
  top: 50%;
  margin-top: -4px;
  margin-top: calc(8px / -2);
  margin-top: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}

.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,
.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end {
  left: -4px;
  left: calc(8px / -2);
  left: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}

.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,
.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start {
  right: -4px;
  right: calc(8px / -2);
  right: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}


:root {
  --fc-daygrid-event-dot-width: 8px;
}

.fc .fc-popover {
  position: fixed;
  top: 0;
  /* for when not positioned yet */
  box-shadow: 0 2px 6px rgba(0, 0, 0, .15);
}

.fc .fc-popover-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 3px 4px;
}

.fc .fc-popover-title {
  margin: 0 2px;
}

.fc .fc-popover-close {
  cursor: pointer;
  opacity: 0.65;
  font-size: 1.1em;
}

.fc-theme-standard .fc-popover {
  border: 1px solid #ddd;
  border: 1px solid var(--fc-border-color, #ddd);
  background: #fff;
  background: var(--fc-page-bg-color, #fff);
}

.fc-theme-standard .fc-popover-header {
  background: rgba(208, 208, 208, 0.3);
  background: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));
}

/* help things clear margins of inner content */
.fc-daygrid-day-frame,
.fc-daygrid-day-events,
.fc-daygrid-event-harness {
  /* for event top/bottom margins */
}

.fc-daygrid-day-frame:before,
.fc-daygrid-day-events:before,
.fc-daygrid-event-harness:before {
  content: "";
  clear: both;
  display: table;
}

.fc-daygrid-day-frame:after,
.fc-daygrid-day-events:after,
.fc-daygrid-event-harness:after {
  content: "";
  clear: both;
  display: table;
}

.fc .fc-daygrid-body {
  /* a <div> that wraps the table */
  position: relative;
  z-index: 1;
  /* container inner z-index's because <tr>s can't do it */
}

.fc .fc-daygrid-day.fc-day-today {
  background-color: rgba(255, 220, 40, 0.15);
  background-color: var(--fc-today-bg-color, rgba(255, 220, 40, 0.15));
}

.fc .fc-daygrid-day-frame {
  position: relative;
  min-height: 100%;
  /* seems to work better than \`height\` because sets height after rows/cells naturally do it */
}

.fc {

  /* cell top */

}

.fc .fc-daygrid-day-top {
  display: flex;
  flex-direction: row-reverse;
}

.fc .fc-day-other .fc-daygrid-day-top {
  opacity: 0.3;
}

.fc {

  /* day number (within cell top) */

}

.fc .fc-daygrid-day-number {
  position: relative;
  z-index: 4;
  padding: 4px;
}

.fc {

  /* event container */

}

.fc .fc-daygrid-day-events {
  margin-top: 1px;
  /* needs to be margin, not padding, so that available cell height can be computed */
}

.fc {

  /* positioning for balanced vs natural */

}

.fc .fc-daygrid-body-balanced .fc-daygrid-day-events {
  position: absolute;
  left: 0;
  right: 0;
}

.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events {
  position: relative;
  /* for containing abs positioned event harnesses */
  min-height: 2em;
  /* in addition to being a min-height during natural height, equalizes the heights a little bit */
}

.fc .fc-daygrid-body-natural {
  /* can coexist with -unbalanced */
}

.fc .fc-daygrid-body-natural .fc-daygrid-day-events {
  margin-bottom: 1em;
}

.fc {

  /* event harness */

}

.fc .fc-daygrid-event-harness {
  position: relative;
}

.fc .fc-daygrid-event-harness-abs {
  position: absolute;
  top: 0;
  /* fallback coords for when cannot yet be computed */
  left: 0;
  /* */
  right: 0;
  /* */
}

.fc .fc-daygrid-bg-harness {
  position: absolute;
  top: 0;
  bottom: 0;
}

.fc {

  /* bg content */

}

.fc .fc-daygrid-day-bg .fc-non-business {
  z-index: 1
}

.fc .fc-daygrid-day-bg .fc-bg-event {
  z-index: 2
}

.fc .fc-daygrid-day-bg .fc-highlight {
  z-index: 3
}

.fc {

  /* events */

}

.fc .fc-daygrid-event {
  z-index: 6;
  margin-top: 1px;
}

.fc .fc-daygrid-event.fc-event-mirror {
  z-index: 7;
}

.fc {

  /* cell bottom (within day-events) */

}

.fc .fc-daygrid-day-bottom {
  font-size: .85em;
  margin: 2px 3px 0;
}

.fc .fc-daygrid-more-link {
  position: relative;
  z-index: 4;
  cursor: pointer;
}

.fc {

  /* week number (within frame) */

}

.fc .fc-daygrid-week-number {
  position: absolute;
  z-index: 5;
  top: 0;
  padding: 2px;
  min-width: 1.5em;
  text-align: center;
  background-color: rgba(208, 208, 208, 0.3);
  background-color: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));
  color: #808080;
  color: var(--fc-neutral-text-color, #808080);
}

.fc {

  /* popover */

}

.fc .fc-more-popover {
  z-index: 8;
}

.fc .fc-more-popover .fc-popover-body {
  min-width: 220px;
  padding: 10px;
}

.fc-direction-ltr .fc-daygrid-event.fc-event-start,
.fc-direction-rtl .fc-daygrid-event.fc-event-end {
  margin-left: 2px;
}

.fc-direction-ltr .fc-daygrid-event.fc-event-end,
.fc-direction-rtl .fc-daygrid-event.fc-event-start {
  margin-right: 2px;
}

.fc-direction-ltr .fc-daygrid-week-number {
  left: 0;
  border-radius: 0 0 3px 0;
}

.fc-direction-rtl .fc-daygrid-week-number {
  right: 0;
  border-radius: 0 0 0 3px;
}

.fc-liquid-hack .fc-daygrid-day-frame {
  position: static;
  /* will cause inner absolute stuff to expand to <td> */
}

.fc-daygrid-event {
  /* make root-level, because will be dragged-and-dropped outside of a component root */
  position: relative;
  /* for z-indexes assigned later */
  white-space: nowrap;
  border-radius: 3px;
  /* dot event needs this to when selected */
  font-size: .85em;
  font-size: var(--fc-small-font-size, .85em);
}

/* --- the rectangle ("block") style of event --- */
.fc-daygrid-block-event .fc-event-time {
  font-weight: bold;
}

.fc-daygrid-block-event .fc-event-time,
.fc-daygrid-block-event .fc-event-title {
  padding: 1px;
}

/* --- the dot style of event --- */
.fc-daygrid-dot-event {
  display: flex;
  align-items: center;
  padding: 2px 0
}

.fc-daygrid-dot-event .fc-event-title {
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
  /* important for allowing to shrink all the way */
  overflow: hidden;
  font-weight: bold;
}

.fc-daygrid-dot-event:hover,
.fc-daygrid-dot-event.fc-event-mirror {
  background: rgba(0, 0, 0, 0.1);
}

.fc-daygrid-dot-event.fc-event-selected:before {
  /* expand hit area */
  top: -10px;
  bottom: -10px;
}

.fc-daygrid-event-dot {
  /* the actual dot */
  margin: 0 4px;
  box-sizing: content-box;
  width: 0;
  height: 0;
  border: 4px solid #3788d8;
  border: calc(8px / 2) solid #3788d8;
  border: calc(var(--fc-daygrid-event-dot-width, 8px) / 2) solid var(--fc-event-border-color, #3788d8);
  border-radius: 4px;
  border-radius: calc(8px / 2);
  border-radius: calc(var(--fc-daygrid-event-dot-width, 8px) / 2);
}

/* --- spacing between time and title --- */
.fc-direction-ltr .fc-daygrid-event .fc-event-time {
  margin-right: 3px;
}

.fc-direction-rtl .fc-daygrid-event .fc-event-time {
  margin-left: 3px;
}


/*
A VERTICAL event
*/

.fc-v-event {
  /* allowed to be top-level */
  display: block;
  border: 1px solid #3788d8;
  border: 1px solid var(--fc-event-border-color, #3788d8);
  background-color: #3788d8;
  background-color: var(--fc-event-bg-color, #3788d8)
}

.fc-v-event .fc-event-main {
  color: #fff;
  color: var(--fc-event-text-color, #fff);
  height: 100%;
}

.fc-v-event .fc-event-main-frame {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.fc-v-event .fc-event-time {
  flex-grow: 0;
  flex-shrink: 0;
  max-height: 100%;
  overflow: hidden;
}

.fc-v-event .fc-event-title-container {
  /* a container for the sticky cushion */
  flex-grow: 1;
  flex-shrink: 1;
  min-height: 0;
  /* important for allowing to shrink all the way */
}

.fc-v-event .fc-event-title {
  /* will have fc-sticky on it */
  top: 0;
  bottom: 0;
  max-height: 100%;
  /* clip overflow */
  overflow: hidden;
}

.fc-v-event:not(.fc-event-start) {
  border-top-width: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.fc-v-event:not(.fc-event-end) {
  border-bottom-width: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.fc-v-event.fc-event-selected:before {
  /* expand hit area */
  left: -10px;
  right: -10px;
}

.fc-v-event {

  /* resizer (mouse AND touch) */

}

.fc-v-event .fc-event-resizer-start {
  cursor: n-resize;
}

.fc-v-event .fc-event-resizer-end {
  cursor: s-resize;
}

.fc-v-event {

  /* resizer for MOUSE */

}

.fc-v-event:not(.fc-event-selected) .fc-event-resizer {
  height: 8px;
  height: var(--fc-event-resizer-thickness, 8px);
  left: 0;
  right: 0;
}

.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start {
  top: -4px;
  top: calc(8px / -2);
  top: calc(var(--fc-event-resizer-thickness, 8px) / -2);
}

.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end {
  bottom: -4px;
  bottom: calc(8px / -2);
  bottom: calc(var(--fc-event-resizer-thickness, 8px) / -2);
}

.fc-v-event {

  /* resizer for TOUCH (when event is "selected") */

}

.fc-v-event.fc-event-selected .fc-event-resizer {
  left: 50%;
  margin-left: -4px;
  margin-left: calc(8px / -2);
  margin-left: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}

.fc-v-event.fc-event-selected .fc-event-resizer-start {
  top: -4px;
  top: calc(8px / -2);
  top: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}

.fc-v-event.fc-event-selected .fc-event-resizer-end {
  bottom: -4px;
  bottom: calc(8px / -2);
  bottom: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}

.fc .fc-timegrid .fc-daygrid-body {
  /* the all-day daygrid within the timegrid view */
  z-index: 2;
  /* put above the timegrid-body so that more-popover is above everything. TODO: better solution */
}

.fc .fc-timegrid-divider {
  padding: 0 0 2px;
  /* browsers get confused when you set height. use padding instead */
}

.fc .fc-timegrid-body {
  position: relative;
  z-index: 1;
  /* scope the z-indexes of slots and cols */
  min-height: 100%;
  /* fill height always, even when slat table doesn't grow */
}

.fc .fc-timegrid-axis-chunk {
  /* for advanced ScrollGrid */
  position: relative
    /* offset parent for now-indicator-container */

}

.fc .fc-timegrid-axis-chunk>table {
  position: relative;
  z-index: 1;
  /* above the now-indicator-container */
}

.fc .fc-timegrid-slots {
  position: relative;
  z-index: 1;
}

.fc .fc-timegrid-slot {
  /* a <td> */
  height: 1.5em;
  border-bottom: 0
    /* each cell owns its top border */
}

.fc .fc-timegrid-slot:empty:before {
  content: '\\00a0';
  /* make sure there's at least an empty space to create height for height syncing */
}

.fc .fc-timegrid-slot-minor {
  border-top-style: dotted;
}

.fc .fc-timegrid-slot-label-cushion {
  display: inline-block;
  white-space: nowrap;
}

.fc .fc-timegrid-slot-label {
  vertical-align: middle;
  /* vertical align the slots */
}

.fc {


  /* slots AND axis cells (top-left corner of view including the "all-day" text) */

}

.fc .fc-timegrid-axis-cushion,
.fc .fc-timegrid-slot-label-cushion {
  padding: 0 4px;
}

.fc {


  /* axis cells (top-left corner of view including the "all-day" text) */
  /* vertical align is more complicated, uses flexbox */

}

.fc .fc-timegrid-axis-frame-liquid {
  height: 100%;
  /* will need liquid-hack in FF */
}

.fc .fc-timegrid-axis-frame {
  overflow: hidden;
  display: flex;
  align-items: center;
  /* vertical align */
  justify-content: flex-end;
  /* horizontal align. matches text-align below */
}

.fc .fc-timegrid-axis-cushion {
  max-width: 60px;
  /* limits the width of the "all-day" text */
  flex-shrink: 0;
  /* allows text to expand how it normally would, regardless of constrained width */
}

.fc-direction-ltr .fc-timegrid-slot-label-frame {
  text-align: right;
}

.fc-direction-rtl .fc-timegrid-slot-label-frame {
  text-align: left;
}

.fc-liquid-hack .fc-timegrid-axis-frame-liquid {
  height: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.fc .fc-timegrid-col.fc-day-today {
  background-color: rgba(255, 220, 40, 0.15);
  background-color: var(--fc-today-bg-color, rgba(255, 220, 40, 0.15));
}

.fc .fc-timegrid-col-frame {
  min-height: 100%;
  /* liquid-hack is below */
  position: relative;
}

.fc-liquid-hack .fc-timegrid-col-frame {
  height: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.fc-media-screen .fc-timegrid-cols {
  position: absolute;
  /* no z-index. children will decide and go above slots */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0
}

.fc-media-screen .fc-timegrid-cols>table {
  height: 100%;
}

.fc-media-screen .fc-timegrid-col-bg,
.fc-media-screen .fc-timegrid-col-events,
.fc-media-screen .fc-timegrid-now-indicator-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.fc-media-screen .fc-timegrid-event-harness {
  position: absolute;
  /* top/left/right/bottom will all be set by JS */
}

.fc {

  /* bg */

}

.fc .fc-timegrid-col-bg {
  z-index: 2;
  /* TODO: kill */
}

.fc .fc-timegrid-col-bg .fc-non-business {
  z-index: 1
}

.fc .fc-timegrid-col-bg .fc-bg-event {
  z-index: 2
}

.fc .fc-timegrid-col-bg .fc-highlight {
  z-index: 3
}

.fc .fc-timegrid-bg-harness {
  position: absolute;
  /* top/bottom will be set by JS */
  left: 0;
  right: 0;
}

.fc {

  /* fg events */
  /* (the mirror segs are put into a separate container with same classname, */
  /* and they must be after the normal seg container to appear at a higher z-index) */

}

.fc .fc-timegrid-col-events {
  z-index: 3;
  /* child event segs have z-indexes that are scoped within this div */
}

.fc {

  /* now indicator */

}

.fc .fc-timegrid-now-indicator-container {
  bottom: 0;
  overflow: hidden;
  /* don't let overflow of lines/arrows cause unnecessary scrolling */
  /* z-index is set on the individual elements */
}

.fc-direction-ltr .fc-timegrid-col-events {
  margin: 0 2.5% 0 2px;
}

.fc-direction-rtl .fc-timegrid-col-events {
  margin: 0 2px 0 2.5%;
}

.fc-timegrid-event-harness-inset .fc-timegrid-event,
.fc-timegrid-event.fc-event-mirror {
  box-shadow: 0px 0px 0px 1px #fff;
  box-shadow: 0px 0px 0px 1px var(--fc-page-bg-color, #fff);
}

.fc-timegrid-event {
  /* events need to be root */

  font-size: .85em;

  font-size: var(--fc-small-font-size, .85em);
  border-radius: 3px
}

.fc-timegrid-event .fc-event-main {
  padding: 1px 1px 0;
}

.fc-timegrid-event .fc-event-time {
  white-space: nowrap;
  font-size: .85em;
  font-size: var(--fc-small-font-size, .85em);
  margin-bottom: 1px;
}

.fc-timegrid-event-condensed .fc-event-main-frame {
  flex-direction: row;
  overflow: hidden;
}

.fc-timegrid-event-condensed .fc-event-time:after {
  content: '\\00a0-\\00a0';
  /* dash surrounded by non-breaking spaces */
}

.fc-timegrid-event-condensed .fc-event-title {
  font-size: .85em;
  font-size: var(--fc-small-font-size, .85em)
}

.fc-media-screen .fc-timegrid-event {
  position: absolute;
  /* absolute WITHIN the harness */
  top: 0;
  bottom: 1px;
  /* stay away from bottom slot line */
  left: 0;
  right: 0;
}

.fc {

  /* line */

}

.fc .fc-timegrid-now-indicator-line {
  position: absolute;
  z-index: 4;
  left: 0;
  right: 0;
  border-style: solid;
  border-color: red;
  border-color: var(--fc-now-indicator-color, red);
  border-width: 1px 0 0;
}

.fc {

  /* arrow */

}

.fc .fc-timegrid-now-indicator-arrow {
  position: absolute;
  z-index: 4;
  margin-top: -5px;
  /* vertically center on top coordinate */
  border-style: solid;
  border-color: red;
  border-color: var(--fc-now-indicator-color, red);
}

.fc-direction-ltr .fc-timegrid-now-indicator-arrow {
  left: 0;

  /* triangle pointing right. TODO: mixin */
  border-width: 5px 0 5px 6px;
  border-top-color: transparent;
  border-bottom-color: transparent;
}

.fc-direction-rtl .fc-timegrid-now-indicator-arrow {
  right: 0;

  /* triangle pointing left. TODO: mixin */
  border-width: 5px 6px 5px 0;
  border-top-color: transparent;
  border-bottom-color: transparent;
}


:root {
  --fc-list-event-dot-width: 10px;
  --fc-list-event-hover-bg-color: #f5f5f5;
}

.fc-theme-standard .fc-list {
  border: 1px solid #ddd;
  border: 1px solid var(--fc-border-color, #ddd);
}

.fc {

  /* message when no events */

}

.fc .fc-list-empty {
  background-color: rgba(208, 208, 208, 0.3);
  background-color: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* vertically aligns fc-list-empty-inner */
}

.fc .fc-list-empty-cushion {
  margin: 5em 0;
}

.fc {

  /* table within the scroller */
  /* ---------------------------------------------------------------------------------------------------- */

}

.fc .fc-list-table {
  width: 100%;
  border-style: hidden;
  /* kill outer border on theme */
}

.fc .fc-list-table tr>* {
  border-left: 0;
  border-right: 0;
}

.fc .fc-list-sticky .fc-list-day>* {
  /* the cells */
  position: sticky;
  top: 0;
  background: #fff;
  background: var(--fc-page-bg-color, #fff);
  /* for when headers are styled to be transparent and sticky */
}

.fc .fc-list-table th {
  padding: 0;
  /* uses an inner-wrapper instead... */
}

.fc .fc-list-table td,
.fc .fc-list-day-cushion {
  padding: 8px 14px;
}

.fc {


  /* date heading rows */
  /* ---------------------------------------------------------------------------------------------------- */

}

.fc .fc-list-day-cushion:after {
  content: "";
  clear: both;
  display: table;
  /* clear floating */
}

.fc-theme-standard .fc-list-day-cushion {
  background-color: rgba(208, 208, 208, 0.3);
  background-color: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));
}

.fc-direction-ltr .fc-list-day-text,
.fc-direction-rtl .fc-list-day-side-text {
  float: left;
}

.fc-direction-ltr .fc-list-day-side-text,
.fc-direction-rtl .fc-list-day-text {
  float: right;
}

/* make the dot closer to the event title */
.fc-direction-ltr .fc-list-table .fc-list-event-graphic {
  padding-right: 0
}

.fc-direction-rtl .fc-list-table .fc-list-event-graphic {
  padding-left: 0
}

.fc .fc-list-event.fc-event-forced-url {
  cursor: pointer;
  /* whole row will seem clickable */
}

.fc .fc-list-event:hover td {
  background-color: #f5f5f5;
  background-color: var(--fc-list-event-hover-bg-color, #f5f5f5);
}

.fc {

  /* shrink certain cols */

}

.fc .fc-list-event-graphic,
.fc .fc-list-event-time {
  white-space: nowrap;
  width: 1px;
}

.fc .fc-list-event-dot {
  display: inline-block;
  box-sizing: content-box;
  width: 0;
  height: 0;
  border: 5px solid #3788d8;
  border: calc(10px / 2) solid #3788d8;
  border: calc(var(--fc-list-event-dot-width, 10px) / 2) solid var(--fc-event-border-color, #3788d8);
  border-radius: 5px;
  border-radius: calc(10px / 2);
  border-radius: calc(var(--fc-list-event-dot-width, 10px) / 2);
}

.fc {

  /* reset <a> styling */

}

.fc .fc-list-event-title a {
  color: inherit;
  text-decoration: none;
}

.fc {

  /* underline link when hovering over any part of row */

}

.fc .fc-list-event.fc-event-forced-url:hover a {
  text-decoration: underline;
}



.fc-theme-bootstrap a:not([href]) {
  color: inherit;
  /* natural color for navlinks */
}

.fc-event-time {
  display: none;
}

a.fc-event,
a.fc-event:hover {
  font-size: 11px !important;
}

.d-tabs li {
  display: inline;
  border: 1px solid #fff;
}

.d-tabs-li li {
  display: inline;
  border-right: 1px solid black !important;
}

.activet {
  background: #de2222 !important;
  color: #fff !important;
  margin: 0px;
}

.activetpt {
  background: #562cc9 !important;
  color: #fff !important;
  margin: 0px;
}

.bt {
  border-top: 1px solid #ccc;
}

.br {
  border-right: 1px solid #ccc;
}

.bb {
  border-bottom: 1px solid #ccc;
}

.bl {
  border-left: 1px solid #ccc;
}

.egcolor {
  color: #378006 !important;
}

.ebcolor {
  color: #A0522D !important;
}

.eblcolor {
  color: #0004FF !important;
}

.evt-htitle {
  background: #de2222;
  width: 100%;
  text-align: center;
  font-size: 16px;
  color: #fff;
  padding: 8px;
}

.evt-label {
  background: #5d5d65 !important;
  color: #ffffff;
  padding: 5px 10px;
  font-size: 12px;
}

.evt-strng {
  font-size: 17px !important;
  text-align: center !important;
  margin: 0px 0px 5px 0px;
}

.circle {
  width: 12px;
  height: 12px;
  padding: 0px 8px;
  border-radius: 100%;
}

.cgreen {
  background: #378006 !important;
}

.cbrown {
  background: #A0522D !important;
}

.cblue {
  background: #0004FF !important;
}

.carousel-root {
  width: 100% !important;
}

.carousel .slide {
  background: #FFFFFF !important;
}

.carousel .control-dots .dot.selected,
.carousel .control-dots .dot:hover {
  background: #f90000 !important;
}

.carousel .control-dots .dot {
  background: #757575 !important;
  border: 1px solid #757575 !important;
}

.ttabs {
  background: #ccc;
  padding: 5px 10px;
  color: #333;
}

.ttabs button {
  background: transparent;
  color: #333;
}

.ttabs.activet button {
  color: #fff;
}

.lttabs {
  background: #ccc;
  padding: 5px 2px;
  color: #333;
}

.lttabs button {
  background: transparent;
  color: #333;
}

.lttabs.activet button {
  color: #fff;
}

.lttab {
  background: #ccc;
  color: #333;
}

.lttab button {
  background: transparent;
  color: #333;
}

.lttab.activet button {
  color: #fff;
}

.fs-body {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  text-align: center;
  background: rgba(255, 255, 255, 0.5);
}

.fs-content {
  z-index: 999999;
  position: absolute;
  left: 45%;
  top: 40%;
}

.fs-content button {
  background: #f7bb12;
  font-size: 24px;
  border: 1px solid #f7bb12;
}

/* .ui-datepicker-calendar div : has(.dispatch_dashboard_date)
{
    display: none;
} */
.ag-theme-balham .ag-row {
  font-weight: 'Poppins-Regular' !important;
}

.greengridbg {
  background: #058b05;
  color: #FFF;
  font-weight: 'Poppins-Regular';
}

.bluegridbg {
  background: #0723c2;
  color: #FFF;
  font-weight: 'Poppins-Regular';
}

.redgridbg {
  background: #ce0909;
  color: #FFF;
  font-weight: 'Poppins-Regular';
}

.graygridbg {
  background: #5f5f5f;
  color: #FFF;
  font-weight: 'Poppins-Regular';
}

.yellowbg {
  background: #ded022
}

.yellowlitebg {
  background: #f3eb7b
}

.uppercase {
  text-transform: uppercase;
}

.blue {
  background: #0a59b3;
  color: #FFFFFF;
}

.literedbg {
  background: #f16969
}

.litebluebg {
  background: #4099ff
}

.litepinkbg {
  background: #ffbbbb
}

.greenbg {
  background: #28a852
}

.loadSummaryMap .gm-style-iw {
  padding: 8px !important;
}

.loadSummaryMap th,
.loadSummaryMap td {
  padding-right: 8px !important;
}

.bglightblue {
  background-color: #faf5fae0;
  color: black
}

.cellstylegridO {
  background: #ffd0bb;
  color: #333
}

.cellstylegridLG {
  background: #d6ffbb;
  color: #333
}

.cellstylegridBG {
  background: #bbf7ff;
  color: #333
}

.cellstylegridMG {
  background: #f8c5d0;
  color: #333
}

.cellstylegridBLG {
  background: #d7c5f8;
  color: #333
}

.cellstylegridCLG {
  background: #c5ecf8;
  color: #333
}

.cellstylegridGLG {
  background: #c7f8c5;
  color: #333
}

.usermanual {
  position: fixed;
  right: 0px;
  top: 20%;
  width: 30px;
  height: 32px;
  background: #ded022;
  color: #333;
  padding: 0px 5px;
  cursor: pointer;
}

.model-title {
  position: absolute;
  width: 100%;
  top: 0;
  background: #cc1919;
  color: #fff;
  left: 0;
  padding: 5px;
  text-align: center;
}

.cust-tbl {
  width: 100%;
  border: 1px solid #BDC3C7;
}

.cust-tbl th {
  color: #000;
}

.cust-tbl td,
.cust-tbl th {
  border-color: #BDC3C7 !important;
}

.cust-td td:first-child {
  width: 40%;
  text-align: center;
}

.cust-td:last-child {
  text-align: center;
}

#safetygrid .ag-header.ag-pivot-off {
  background: #ffe4bb;
  color: #333;
  font-weight: bolder;
}

.cust-tbl {
  width: 100%;
  border: 1px solid #BDC3C7;
}

.cust-tbl td,
.cust-tbl th {
  border-color: #BDC3C7 !important;
}

.cust-td td:first-child {
  width: 40%;
  text-align: center;
}

.cust-td:last-child {
  text-align: center;
}

.cust-tbl {
  width: 100%;
  border: 1px solid #BDC3C7;
}

.cust-tbl td,
.cust-tbl th {
  border-color: #BDC3C7 !important;
}

.cust-td td:first-child {
  width: 40%;
  text-align: center;
  color: #000;
  font-weight: 600;
  font-size: 16px;
}

.cust-td:last-child {
  text-align: center;
  color: #000;
  font-weight: 600;
  font-size: 16px;
}

.cust-tbl td {
  font-weight: 600;
  font-size: 16px;
}

.fbold {
  font-weight: bold;
}
.blackColor{
  color:#000 !important;
}

.csgpsBg {
  background: #ffe4bb;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold
}

.cellBorder {
  border-right: 1px solid #ccc !important;
}

.cellstylegridY {
  background: #ffffc9;
  color: #000
}

.pstBg {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-right: 1px solid #ccc !important
}

.cellTopSubHeader {
  font-size: 20px;
}

.cellRvrt {
  text-align: center;
  font-weight: bold;
  cursor: pointer;
}

@media screen and (max-width: 800px) {
  .wdiv {
    display: flex;
    flex-flow: column;
  }

  .one {
    order: 1;
    width: 100% !important;
  }

  .two {
    order: 2;
    width: 100% !important;
  }

  .three {
    order: 3;
  }

  .four {
    order: 4;
  }

  .five {
    order: 5
  }
}

@media screen and (max-width: 1025px) {
  .wdiv {
    display: flex;
    flex-flow: column;
  }

  .one {
    order: 1;
    width: 100% !important;
  }

  .two {
    order: 2;
    width: 100% !important;
  }

  .three {
    order: 3;
  }

  .four {
    order: 4;
  }

  .five {
    order: 5
  }
}

.cellstylegridORG {
  background: #ffb657;
  color: #333
}

.tss-tl {
  color: #000
}

.tss-tl span {
  font-size: 18px;
}

.mselect {
  max-height: 200px;
  min-height: 100px;
  border: 1px solid #ccc;
  overflow-y: auto;
  margin-top: 50px;
  padding: 5px 10px 10px 10px;
}

.scolumn-l {
  float: left;
  width: 49%;
  margin: 5px 0px;
  text-align: left;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

.scolumn-m {
  float: left;
  width: 28%;
  margin: 5px 0px;
  text-align: center;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

.scolumn-s {
  float: left;
  width: 20%;
  margin: 5px 0px;
  text-align: center;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

.listhd {
  position: absolute;
  top: 0px;
  left: 0px;
  background: #ffffff;
  width: 100%;
}

.scolumn-pos-1 {
  padding-left: 10px;
  width: 47.2%;
  font-weight: bold;
  background-color: #ffffff;
}

.scolumn-pos-2 {
  width: 25.7%;
  font-weight: bold;
  background-color: #ffffff;
}

.scolumn-pos-3 {
  width: 18.2%;
  font-weight: bold;
  background-color: #ffffff;
}

.w34 {
  width: 34% !important;
}

.noborder {
  border: 0px !important;
}

.mllcustom-btn {
  padding: 5px 5px
}

/* .sideMenuCls{background-color: #3d6db7 !important;}
.sideTitlecls{color:#000 !important}
.sideHeadercls{color:#fff !important} */
.map-bx {
  box-shadow: 0 1px 10px 0 rgb(0 0 0 / 30%);
  border: 1px solid #ccc;
}

.map-h {
  font-size: 16px;
  background: #ff2046;
  padding: 5px;
  color: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.map-tbl {
  font-size: 13px;
}

.map-htxt {
  font-weight: 600;
}

.blc-1 {
  padding: 0px;
  background: #fdead8;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  box-shadow: 0 1px 10px 0 rgb(0 0 0 / 30%);

}

.blc-2 {
  padding: 0px;
  background: #e4ffde;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  box-shadow: 0 1px 10px 0 rgb(0 0 0 / 30%);
}

.blc-3 {
  padding: 0px;
  background: #fdead8;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  box-shadow: 0 1px 10px 0 rgb(0 0 0 / 30%);
}

.blc-4 {
  padding: 0px;
  background: #e4ffde;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  box-shadow: 0 1px 10px 0 rgb(0 0 0 / 30%);
}

.nav-tabs .nav-item {
  cursor: pointer;
}

@media screen and (max-width: 800px) {
  .wdiv {
    display: flex;
    flex-flow: column;
  }

  .one {
    order: 1;
    width: 100% !important;
  }

  .two {
    order: 2;
    width: 100% !important;
  }

  .three {
    order: 3;
  }

  .four {
    order: 4;
  }

  .five {
    order: 5
  }
}

@media screen and (min-width: 360px) and (max-width: 640px) {
  .brm-chart .highcharts-title {
    font-size: 14px !important;
  }
}

.trucks-dropdown-srch {
  background: white;
  height: 18em;
  width: 22.3em;
  position: absolute;
  overflow-y: scroll;
  left: 32px;
  z-index: 1000;
  top: 36px;
  border-radius: 5px;
  border: 0.1px solid cornflowerblue;
}

.trucks-dropdown-srch>ul>li {
  padding: 10px;
  padding-left: 13px;
}

.trucks-dropdown-srch>ul>li:hover {
  background: #e4e4e4;
}

.styles_modal__gNwvD {
  max-width: 1200px !important
}

.styles_modal__gNwvD {
  max-width: 1200px !important
}

.nav-tabs .nav-link {
  background: #E4E4E5;
  color: #333;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  background: #FFFFFF;
  color: #333333;
}

.styles_modal__gNwvD {
  max-width: 1200px !important
}

.nav-tabs .nav-link {
  background: #E4E4E5;
  color: #333;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  background: #FFFFFF;
  color: #333333;
}

.mapic {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 999999999;
  height: 40px;

}

.mapici {
  color: #FFFFFF;
  position: absolute;
  left: 44%;
  bottom: 30px;
  background-color: #e01111;
  font-size: 40px;
}

.mapdt {
  background-color: #ff1212;
  color: #ffffff;
  font-size: 20px;
  padding: 5px
}

.sbox {
  height: 200px;
  width: 300px;
  overflow: hidden;
  border: 1px solid red;
  background: #ff0;
}

.shid-box {
  top: 100%;
  position: relative;
  transition: all .3s ease-out;
  background: #428bca;
  height: 100%;
}

.sbox:hover>.shid-box {
  top: 0;
}

.mapics {
  position: fixed;
  bottom: 0px;
  background: #fff;
  width: 100%;
}

.mapcls {
  background: rgb(255, 255, 255);
  width: 32px;
  height: 32px;
  position: absolute;
  right: 25px;
  top: 0px;
  cursor: pointer;
  z-index: 9;
  text-align: center;
  padding: 5px;
  font-weight: bold;
}

.route-h5 {
  background: #FF5722;
  color: #fff;
  padding: 5px;
  font-size: 16px
}

.tptinfo th {
  background: #ffffc9 !important
}

.tptinfo td,
.tptinfo th {
  border-color: #ccc;
}

.txt-center {
  text-align: center;
}

.tr-tabs .btn {
  padding: 0.375rem 0.3rem;
}

.tr-tabs .btn {
  padding: 0.375rem 0.3rem;
}

.tr-tabs .btn {
  padding: 0.375rem 0.3rem;
}

.btn-defaultc {
  background: #cccccc !important;
  color: #333 !important;
}

.rotate-dispatch-loader.dashed.colored {
  animation-timing-function: linear;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-name: rotate;
  border: 3px dashed #ab8ce4;
  width: 15px;
  height: 15px;
  border-radius: 50px;
  display: block;
  margin: 1em;
  float: left;
}

.load-exit-status-total-row {
  background: skyblue !important;
  font-weight: bold;
  font-size: 15px;
}

.sub-cntrs {
  font-family: Open Sans;
  padding-top: 7px;
  font-weight: 600;
  margin-bottom: 0;
}
.ag-theme-balham .ag-cell{
  font-size:14px;
}
.ag-theme-balham .ag-header-cell{
  font-size:14px;
}

.ag-vertical-header .ag-cell-label-container {
  /*Necessary to allow for text to grow vertically*/
  height: 100%;
}

.ag-vertical-header .ag-header-cell-label {
  /*Necessary to allow for text to grow vertically*/
  height: 100%;
  padding: 0 !important;
}

.ag-vertical-header .ag-header-cell-label .ag-header-cell-text {
  /*Force the width corresponding at how much width
    we need once the text is laid out vertically*/
  width: 55px;
  writing-mode: vertical-lr;
  -ms-writing-mode: tb-lr;
  line-height: 2em;
}

.ag-vertical-header .ag-pivot-off .ag-header-group-cell {
  font-size: 50px;
}

.ag-vertical-header .ag-pivot-on .ag-header-group-cell {
  font-size: 10px;
  color: green;
}

.ag-vertical-header .ag-pivot-off .ag-header-cell-label {
  color: #3d6db7;
  font-weight: bold;
}

.ag-vertical-header .ag-pivot-on .ag-header-cell-label {
  font-size: 10px;
  height: 90px;
  padding-top: 36px;
  margin-left: 0px;
  color: #1b6d85;
  font-weight: bold;
}

.ag-vertical-header .ag-pivot-on .ag-header-cell-label .ag-header-cell-text {
  /*There is empty space left at the top from the menu and sort
    icons not used*/
  margin-top: 25px;
}

/*Floating filters*/
.ag-vertical-header .ag-floating-filter-body {
  height: 50px;
}

.ag-vertical-header .ag-floating-filter-body input {
  height: 49px;
}

.ag-vertical-header .ag-floating-filter-button {
  margin-top: -49px;
}

.ag-vertical-header .ag-floating-filter-button button {
  height: 49px;
}

.ag-vertical-header .ag-floating-filter-body input {
  font-size: 15px;
  font-weight: bold;
}

.ag-vertical-header .ag-header-cell {
  padding: 5px;
}

.ag-vertical-header .ag-header-cell::after,
.ag-theme-balham .ag-header-group-cell::after {
  height: 150px;
  margin-top: 0;
}

.fontBold {
  font-weight: bold
}

.danger-ico {
  font-weight: bold;
  color: red;
  cursor: pointer;
}

.info-ico {
  font-weight: bold;
  color: blueviolet;
  cursor: pointer;
}

.warning-ico {
  font-weight: bold;
  color: orange;
  cursor: pointer;
}

.primary-ico {
  font-weight: bold;
  color: blue;
  cursor: pointer;
}

.cms-tabs li button {
  padding: 0 20px;
}

.float-right {
  float: right;
}

.btn-default {
  color: #333;
  background-color: #ffffff;
  border-color: #cccccc;
}

.border-none {
  border: none;
}

.rail-stage-tbl tr th,
.rail-stage-tbl tr td {
  width: 30%;
}

.rail-stage-tbl-20 tr th,
.rail-stage-tbl-20 tr td {
  width: 30%;
}

.rail-stage-tbl th {
  border-color: #ccc
}

.rail-stage-tbl td {
  border-color: #ccc
}

#fleetDeployedGrid .ag-header-group-cell-label {
  justify-content: center;
  font-weight: bolder;
}

.semicircle-container {
  text-align: center;
}

.trowColor {
  background-color: #171C8F;
  color: white;

}

.totalHead {
  background-color: #ffffc9;
}

#buttonStyle1 {
  font-weight: 470;
  text-align: center;
  display: flex;
  /* Use flexbox to center content */
  justify-content: center;
  /* Center horizontally */
  align-items: center;
  /* Center vertically */
  margin: 5px;
  border-radius: 5px;
  height: 150px;
  width: 360px;
  color: #000000;
  background: rgb(221, 219, 219);
  font-size: 20px;
  cursor: pointer;
  height: 100px;
}

#buttonStyle1:hover {
  /*opacity: 0.3;*/

  color: white;
  background: #005ce6;
  transform: scale(1);
  /* Equal to scaleX(2) scaleY(2) */
  transition-duration: 0.5s;
  /*transform: scale(0.6);*/
}

#buttonStyle2 {
  font-weight: 470;
  padding: 50px;
  text-align: center;
  display: block;
  margin: 5px;
  border-radius: 5px;

  /* font-size: 12px; */
  color: #000000;
  /* width: 300px; */
  background: rgb(221, 219, 219);
  font-size: 20px;
  /* margin: 100px auto;
  padding: 10px; */
  cursor: pointer;
}

#buttonStyle2:hover {
  /*opacity: 0.3;*/

  /* color: white; */
  background: #005ce6;
  transform: scale(1);
  /* Equal to scaleX(2) scaleY(2) */
  transition-duration: 0.5s;
  /*transform: scale(0.6);*/
}

#buttonStyle3 {
  font-weight: 380;
  padding: 20px;
  text-align: center;
  display: flex;
  /* margin:5px; */
  border-radius: 5px;
  color: #000000;
  background: rgb(221, 219, 219);
  font-size: 20px;
  cursor: pointer;
  justify-content: center;
  /* Center horizontally */
  align-items: center;
  /* Center vertically */
  height: 104px;
  width: 200px;

}

#buttonStyle3:hover {
  /*opacity: 0.3;*/
  color: white;
  background: #005ce6;
  transform: scale(1);
  /* Equal to scaleX(2) scaleY(2) */
  transition-duration: 0.5s;
  /*transform: scale(0.6);*/
}

#buttonStyle {
  font-weight: 470;
  text-align: center;
  display: flex;
  /* Use flexbox to center content */
  justify-content: center;
  /* Center horizontally */
  align-items: center;
  /* Center vertically */
  margin: 5px;
  border-radius: 5px;
  height: 150px;
  width: 360px;
  color: #000000;
  background: rgb(221, 219, 219);
  font-size: 20px;


}

#buttonStyle:hover {
  /*opacity: 0.3;*/

  color: white;
  background: #005ce6;
  transform: scale(1);
  /* Equal to scaleX(2) scaleY(2) */
  transition-duration: 0.5s;
  /*transform: scale(0.6);*/
}

.ag-theme-balham .status-rejected {
  background-color: #F5B7B1 !important;
}

.ag-theme-balham .status-approved {
  background-color: #ABEBC6 !important;
}

.ag-theme-balham .status-empty {
  background-color: #FCF3CF !important;
}

.button-disable {
  padding-top: 0px;
  background-color: "lightgrey" !important;
}


.light-bg {
  background-color: #ccfddd;
}

.light-err-bg {
  background-color: #FFCCCC;
}

#hub-consignments-grid>div>div>div.ag-theme-balham.ag-popup>div>div>div.ag-tab-body {
  height: 200px;
}

.top-header-led1 {
  border: 1px solid #ccc;
  padding: 1%;
  display: flex !important;
  justify-content: space-between !important;
}

.font-color {
  color: #171C8F;
  font-weight: bold;
  font-size: 20px;
}

.main-title {
  font-weight: bold;
  font-size: 20px;
}

.railway_dispatches_header {
  font-size: 18px
}

.intransit_rake_status_header {
  font-size: 18px;
}

.led_table_header th {
  font-size: 18px
}

.led_table_header td {
  font-size: 18px;
  /* font-weight: bold; */
}

.progress_bar_led>div>div>span {
  font-size: 18px !important;
}

.led1_table1 {
  padding: 10px 25px 10px 10px
}

.led1_table2 {
  padding: 15px 25px 10px 25px;
  margin-top: 20px
}

.led1_pirchart {
  text-align: center;
  padding-top: 18px
}

.led1_piechart {
  height: 250px
}

.highcharts_led_screen {
  width: 100%;
  height: 100%
}

.counter-led1_header {
  font-size: 20px;
}

.counter-led1_header2 {
  font-size: 19px;
}

.counter-text {
  color: #000000;
  font-size: 15px;
  font-weight: bold;
  /* margin-bottom: 50px */
}

/* @media screen and (min-width: 2160px) {
  .ledscreen_main_title{
    text-align:center;
    font-size:20px;
  }
  .update_on_time{
    position:relative;
    left:-23%;
    font-size:20px;
    color:#171C8F
  }
  .from_date_right{
    position:relative ;
    left:22%;
    font-size:20px;
    color:#171C8F
  }
  .to_date_right{
    position:relative;
    left:23%;
    font-size:20px;
    color:#171C8F
  }
  .railway_dispatches_header{
    font-size: 16px
  }
  .intransit_rake_status_header{
    font-size: 16px;
  }
  .led_table_header th{
    font-size:16px
  }
  .led_table_header td{
    font-size:16px
  }
  .progress_bar_led>div>div>span{
    font-size:12px !important;
  }
} */
/* @media screen and (min-width: 3840px) {
  .ledscreen_main_title{
    text-align:"center";
    font-size:36px;
  } 
  .update_on_time{
    position:relative;
    left:-23%;
    font-size:32px;
    color:#171C8F
  }
  .from_date_right{
    position:relative ;
    left:22%;
    font-size:32px;
    color:#171C8F
  }
  .to_date_right{
    position:relative;
    left:23%;
    font-size:32px;
    color:#171C8F
  }
  .railway_dispatches_header{
    font-size: 30px;
    margin-bottom: 10px !important;
  }
  .intransit_rake_status_header{
    font-size: 30px;
    margin-bottom: 10px !important;
  }
  .led_table_header th{
    font-size:26px !important;
    padding: 25px !important;
  }
  .led_table_header td{
    font-size:26px !important;
    padding: 25px !important;
  }
  .progress_bar_led>div>div>span{
    font-size:26px !important;
  }
  .led1_table1{
    padding :10px 25px 10px 10px
  }
  .led1_table2{
    padding :15px 25px 10px 25px;
    margin-top:20px
  }
  .led1_piechart{
    height:350px !important
  }
  .highcharts_led_screen{
    width: 100%;
    height: 100%
  }
} */

.disabled-anchor-edit {
  color: #D3D3D3;
}

.sustainability_icons {
  width: 25px;
}

.emission_image {
  width: 60px;
  margin-bottom: -15px;
}

.ltxtcenter {
  text-align: center;
}

.lspceo {
  float: right;
  width: 265px;
  margin-right: 10px;
}

.lspceo .css-2b097c-container {
  font-size: 13px;
  font-weight: normal !important;
}

.lspceo_blk {
  background: #f5f5f5;
  padding: 5px 10px 30px;
}

.ltxtcenterD .blk_lco {
  height: 120px;
  margin-bottom: 10px;
  padding: 30px 10px;
}

.hvr {
  border-radius: 5px;
}

.hvr:hover {
  background-color: #171c8f;
  color: #fff
}

.h6fnt {
  font-size: 0.9rem;
}

.h115 {
  height: 115px;
}

.dcursr {
  cursor: pointer;
  color: #000
}

.hvr:hover h6.txt-dark {
  color: #fff !important;
}

.pd20 {
  padding: 0 20px;
}

.custom-datetime-input {
  opacity: 1;
  border: 1px solid #b5b5b5;
  font-size: 0.9rem;
  border-radius: 0px;
  width: 100%;
  height: 36px;
  padding: 6px 12px;
}


/* Container Tracking CSS */

.eachCard+div.react-tooltip {
  top: -38.875px !important;
}

.tilebl {
  width: 30%;
  position: relative;
  height: 9px;
}

.portpos {
  position: absolute;
  width: 27%;
  left: -20%;
  top: -32px;
  word-wrap: break-word;
}

.portdes {
  position: absolute;
  width: 35%;
  right: -28px;
  top: -33px
}

.my-svg {
  display: flex;
  flex-direction: row;

}

.flag_class {
  width: 16px;
  height: 16px;
  position: relative;
}

.portind {
  width: 20px;
  /* position: absolute;left: 30%; */
}

.portsimg {
  /* width:24px;height:24px; */
  position: absolute !important;
  top: 30px;
  left: 2px;
  border: 1px solid #ccc;
}

.portxt {
  font-size: 11px;
  font-weight: 600;
  margin-top: 0px;
}

.portTxtpos {
  margin: 0px 10px;
}

.desflg {
  width: 16px;
}

.current-activity {
  position: absolute;
  top: -30px;
  /* left: 29.1vw; */
  /* width: 17.99vw; */
  width: 27vw;
  text-align: center;
}

.tracking-background-progress {
  /* width: 260px;
  height: 2px; */
  /* background: #dcdcdc; */
  /* position: relative;
  width: 300px; */
  position: absolute;
  /* width: 375px; */
  /* left: 412px; */
  width: 85%;
  left: 0%;
  top: 0px;
  height: 3px;
  background: #b0adad;
}

.tracking-progress-red-line {
  background: linear-gradient(to right, #0d5ed7, #9145c4, #ca149c, #e7006a, #eb1233);
  animation: lineanimation 4s linear forwards;
}

.tracking-progress-green-line {
  background: linear-gradient(to right, #0d5ed7, #0085ed, #009fd2, #00b194, #09bd4c);
  animation: lineanimation 4s linear forwards;
}

.tracking-progress-blue-line {
  background-color: #171c8f;
  animation: lineanimation 4s linear forwards
}

@keyframes lineanimation {
  0% {
    width: 0%;
  }

  100% {
    width: var(--highlight);
  }
}

.early-text {
  color: #217121;
  background: #e4ffed;
}

.ontime-text {
  color: #171c8f;
  background: #e5e5fd;
}

.delay-text {
  color: red;
  background: #fce2e2;
}

.tracking-image-background {
  width: 26px;
  height: 23px;
  background: #cccccc00;
  position: absolute;
  top: -17px;
  text-align: center;
  animation: lineanimation2 4s linear forwards
    /* left: 100px; */
}


@keyframes lineanimation2 {
  0% {
    left: -1%;
  }

  100% {
    left: var(--highlight2);
  }
}

.cursor-class {
  cursor: pointer;
}


.info_card_tracking {
  width: 12px;
  height: 12px;
  margin-top: 9px;
  margin-left: 7px;
}

.info_card_tracking_header {
  width: 14px;
  height: 14px;
  margin-left: 7px;
}


.custom-modal-class-edit {
  width: 85vw !important;
  max-width: 100vw !important;
}

.custom-pagination {
  display: flex;
  padding: 10px;
  justify-content: center;
}

.page-link {
  border: none;
  border-radius: 10px;
}

.visually-hidden {
  display: none;
}

.arwUp {
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 20px solid #EEF3FF;
  position: absolute;
  bottom: -30px;
  left: 33%;
}

.cntrdiv {
  border: 1px solid #171C8F !important;
  position: absolute;
  left: -10px;
  width: 1px;
  height: 70px;
}

.bghighliter {
  background: #EEF3FF;
  border-radius: 20px;
  padding: 10px;
  margin-bottom: 30px;
  height: 90px;
}


.sub_counters_exim {
  display: flex;
  flex-direction: row;
  gap: 10px;
  overflow-x: auto;
}

.sub_counters_exim::-webkit-scrollbar {
  height: 3px !important;
}


.region_card div.css-13cymwt-control {
  height: 38px !important;
}


.mode-type .css-13cymwt-control,
.tilesPageSelector .css-13cymwt-control {
  height: 38px !important;
}

.mode-type .css-1n6sfyn-MenuList,
.tilesPageSelector .css-1q04ie9-MenuList {
  padding-top: 0px !important;
}

.tilesPageSelector .css-13cymwt-control {
  width: 95px !important;
}


.search_icon {
  position: absolute;
  right: 12px;
  width: 24px;
  height: 13px;
  top: 13px;
  padding-left: 5px;
  cursor: pointer;
}

.filter_search_icon {
  position: relative;
  width: 24px;
  height: 13px;
  top: -1px;
  padding-left: 5px;
  cursor: pointer;
  left: -2vw;
}

.product_details {
  font-weight: bold;
  color: black;
}

.product_details_map {
  font-size: 10px !important;
}


.accordion-button {
  border: none;
  background: #fff;
  width: 100%;
  text-align: left;
  color: #007bff;
  font-size: 16px;
  font-weight: bold;
}

button.accordion-button[aria-expanded="true"]::after {
  content: '\\2B9F';
  font-size: 25px;
  float: inline-end;
}

button.accordion-button[aria-expanded="false"]::after {
  content: '\\2B9D';
  font-size: 25px;
  float: inline-end;
}

.accordion-header {
  border-color: #007bff;
}

.accordion {
  padding: 2rem;
}


.subtileborder {
  border: 3px groove #171c8f !important;
}

.legend-overlay {
  position: absolute;
  bottom: 35px;
  right: 57px;
  z-index: 99;
  width: 38%;
  background-color: transparent;
}

.onwardrut {
  background: #0059b3;
  float: right;
  color: #fff;
  font-weight: 600;
  padding: 0px 5px;
}

.baserut {
  background: #a064ba;
  float: right;
  color: #fff;
  font-weight: 600;
  padding: 0px 5px;
}

.nav-item .tab-active {
  border-bottom: 4px solid #c81e27;
}

.tab-active-container {
  border-bottom: 3px solid #171c8f;
  color: #171c8f !important;
  border-bottom-width: 80%;
  display: flex;
  align-items: flex-end !important;

}

.subcounter-modal-size {
  width: 50% !important;
}


.trip-done {
  opacity: 0.5 !important;
  filter: grayscale(1) !important;
  cursor: not-allowed !important;
}


.custom-paginationItem {
  border: 0px;
  text-align: center;
  font-size: 20px;
  border-radius: 10px;
  cursor: pointer;
  padding-left: 14px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 14px;
}

#page-active.custom-paginationItem {
  background-color: #171c8f;
  color: #ffffff;
}

.scrolling-text {
  white-space: nowrap;
  overflow: hidden;
  /* position: fixed; */
  /* top: 0; */
  margin-top: 15px;
  margin-bottom: -15px;
  width: 100%;
  background-color: red;
  /* You can change the background color */
  color: #fff;
  /* Text color */
  /* z-index: 1000; Makes sure the text is above other content */
}

.scrolling-text h5 {
  display: inline-block;
  padding-left: 50%;
  animation: scroll-text 20s linear infinite;
}

@keyframes scroll-text {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-70%);
  }
}

.kpi-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 115px;
  /* Set a fixed height to ensure uniformity */
  margin: 5px;
  padding: 10px;
  border-radius: 5px;
  /* Rounded corners */
  color: #000;
  overflow: hidden;
  /* Hide any overflow */
}

.kpi-box h6 {
  margin: 0;
  font-size: 16px;
  text-align: center;
}

.kpi-box p {
  margin: 0;
  font-size: 14px;
  text-align: center;
}

/* Adjust box background colors based on the context */
.kpi-box.good {
  background-color: #95d5b2;
  /* Light green for good status */
}

.kpi-box.bad {
  background-color: #FF7F7F;
  /* Light red for alerts or bad status */
}

button {
  outline: none;
}

.datepciker-box {
  border: 1px solid #b5b5b5;
  font-size: 0.9rem;
  border-radius: 0px;
  padding: 6px 12px;
  outline: none;
}

.lds-dual-ring,
.lds-dual-ring:after {
  box-sizing: border-box;
}

.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}

.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6.4px solid currentColor;
  border-color: currentColor transparent currentColor transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.custom-calendar{
  width:100% !important;
}
.datepicker-custom {
  width: 290px !important;
  font-size: 1rem;
  padding-block: 5px;
  outline: none;
  border: 1px solid #b5b5b5;

}
.datepicker-custom1 {
  width: 100% !important;
  font-size: 1rem;
  padding-block: 5px;
  outline: none;
  border: 1px solid #b5b5b5;

}
.datepicker-custom2 {
  width: 100% !important;
  font-size: 12px;
  padding-block: 8px;
  outline: none;
  border: 1px solid #b5b5b5;
  border-radius: 4px;
}

.datepicker-custom-ptl {
  width: 220% !important;
  /* font-size: 1rem; */
  padding-block: 5px;
  outline: none;
  border: 1px solid #b5b5b5;
}
.datepicker-custom-ptl2 {
  width: 213% !important;
  /* font-size: 1rem; */
  padding-block: 8px;
  outline: none;
  border: 1px solid #b5b5b5;
}
.datepicker-custom-ptl6 {
  width: 256% !important;
  /* font-size: 1rem; */
  padding-block: 8px;
  outline: none;
  border: 1px solid #b5b5b5;
}
.datepicker-custom-ptl4 {
  width: 245% !important;
  /* font-size: 1rem; */
  padding-block: 8px;
  outline: none;
  border: 1px solid #b5b5b5;
}
.datepicker-custom-ptl3 {
  width: 265% !important;
  /* font-size: 1rem; */
  padding-block: 8px;
  outline: none;
  border: 1px solid #b5b5b5;
}
.datepicker-custom-ptl5 {
  /* width: 265% !important; */
  /* font-size: 1rem; */
  padding-block: 8px;
  outline: none;
  border: 1px solid #b5b5b5;
}

.datepicker-custom-ptl2 {
  width: 203% !important;
  /* font-size: 1rem; */
  padding-block: 8px;
  outline: none;
  border: 1px solid #b5b5b5;
}
#datepicker1 .react-datepicker-popper{
  left:64px !important;
}
#addConsignment-datepicker .react-datepicker-wrapper{
  width:100% !important;
}


.configuration-menu {
  padding: 6px;
  font-size: 17px;
  font-weight: 400;
  margin-top: 6px;
}

.configuration-menu.active {
  background-color: #356cc9;
  color: #ffff;
  border-radius: 13px;
  transition: all 0.2s ease;
}

.icon-config {
  padding: 6px;
  color: #ffff;
}

.icon-config.nightdriving {
  background-color: #6d1fff;
  border-radius: 11px;
}

.icon-config.overspeeding {
  background-color: #f47a16;
  border-radius: 11px;
}

.eye-icon2 {
  position: absolute;
  top: 69%;
  transform: translateY(-50%);
  right: 2rem;
  cursor: pointer;
}

.icon-config.nogpsdata {
  background-color: #38cfae;
  border-radius: 11px;
}

.icon-config.enrouteStoppages {
  background-color: #ff7441;
  border-radius: 11px;
}

.icon-config.loadingDelaySettings {
  background-color: #ff8839;
  border-radius: 11px;
}

.icon-config.unloadingDelaySettings {
  background-color: #DA3E52;
  border-radius: 11px;
}

.icon-config.dealerRadius {
  background-color: #770928;
  border-radius: 11px;
}

.flex-left-center {
  display: flex;
  justify-content: left;
  align-items: center;
}

.configuration-pannel {
  padding-left: 2rem;
  padding-top: 2rem;
}

.configuration-menu:hover {
  .icon-config {
    background-color: #356cc9;
  }

  background-color: #356cc9;
  color: #ffff;
  border-radius: 13px;
}

button:focus {
  outline: none;
}

.ewayBill-mandatory {
  font-size: 8px;
  position: absolute;
}

@keyframes expands {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }

  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}

.filter-in {
  animation: expands 0.5s;
  -webkit-animation: expands 0.5s;
}

#webpack-dev-server-client-overlay-div {
  display: none !important;
}

#webpack-dev-server-client-overlay {
  display: none !important;
}

.poweredByLogo {
  position: fixed;
  bottom: 0px;
  right: 22px;
}
.slider-translate{
  width:25%;
  transform: translateX(0%);
}
.slide30{width:30% !important;transform: translateX(0%);right:0px;}
/* .nav-tabs {
  background-color: \$sidebar-dark-hover-bg;
  border-bottom: 0;
  margin-bottom: 5px;

  .nav-item {
    margin: 0;
  }

  .nav-link {
    border-radius: 0;
    padding: 10px 20px;
    position: relative;
    text-align: center;

    &,
    &:hover,
    &:active,
    &:focus,
    &.active {
      border: 0;
    }

    &:hover,
    &:active,
    &:focus,
    &.active {
      border-bottom-color: transparent;
      border-left-color: transparent;
      border-top-color: transparent;
      color: \$sidebar-dark-hover-color;
    }

    &.active {
      background-color: \$sidebar-dark-bg;
    }
  }
} */
.nav-tabs .nav-link {
  font-weight: bold;
  color: #555;
  border-radius: 0;
  border-bottom: 2px solid transparent;
  padding: 10px 20px;
  transition: color 0.3s, border-bottom-color 0.3s;
}

.nav-tabs .nav-link.active {
  color: #007bff;
  border-bottom-color: #007bff;
}

.nav-tabs .nav-link:hover {
  color: #0056b3;
}

.nav-pills .nav-link {
  font-weight: normal;
  color: #666;
  padding: 8px 15px;
  border-radius: 5px;
  transition: background-color 0.3s, color 0.3s;
}

.nav-pills .nav-link.active {
  background-color: #007bff;
  color: white;
}

.nav-pills .nav-link:hover {
  background-color: #0056b3;
  color: white;
}
.dashboard1{
  width:130px;
  height:40px;
  text-align: center;
  border-radius:10px;
  background-color: transparent;
  /* box-shadow: 0 1px 11px 0 rgb(0 0 0 / 10%); */
  padding-top:10px;
  cursor:pointer;
  font-family: "Public Sans";
}
.activetab{
  background-color: #c81e27;
  color:white;
  /* font-family: 'inter'; */
  font-weight:14px;
  
}
.inactivetab{
  background-color: transparent;
  color: #c81e27;
  /* font-family: 'inter'; */
  font-weight:14px;
 
}
.filter-styling {
  height: 33px;
  width: 34px;
  cursor: pointer;
  float: right;
  background-color: #f5f5f5;
  margin-right: 15px;
  vertical-align: middle;
  line-height: 16px;
  font-size: 14px;
  padding: 8px;
  border: 2px solid transparent; 
  transition: all 0.3s ease; 
  border-radius:4px;
}

.filter-styling:hover {
  border-color: #ff0000; 
  background-color: #e0e0e0; 
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  transform: scale(1.05); 
}
.close-btn-container {
  position: absolute;
  top: 10px; /* Adjust this value to move the button up or down */
  right: 10px; /* Adjust this value to move the button left or right */
  z-index: 1051; /* Ensure the button is above other content */
}

.close-button {
  background: transparent; /* Optional: Set background to transparent */
  border: none; /* Remove border */
}
 .card-header2 {
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    background-color:white !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    height:350px;
  }
  .scrollable-table-container table  {
    max-height: 235px;
    overflow-y: auto;
   }
   .scrollable-table-container th,
   .scrollable-table-container td {
       padding: 4px 8px !important;/* Adjust padding to control row height */
       text-align: left;
       vertical-align: middle;
   }
   
.scrollable-table-container th {
       height: 30px; /* Adjust height for header */
       font-size: 14px; /* Adjust font size for header */
   }
   
.scrollable-table-container td {
       height: 25px; /* Adjust height for rows */
       font-size: 12px; /* Adjust font size for rows */
   }
.scrollable-table-container1 table  {
     max-height: 240px;
     overflow-y: auto;
     width:"97%" !important;
    }
.table-outlookvsorders{
      background-color:#c81e27;
      color:#ffffff !important;
      width:160px;
      height:10px;
    }
.heading3{
  font-family:"Public Sans" !important;
      /* color:#0664AE; */
      color:black;
      font-weight: 600;
      font-size:15px;
    }
.dateStyling{
  font-size: 10px;
} 
.smaller-datetime input {
  width: 80px;  /* Adjust width as needed */
  height: 25px;  /* Adjust height as needed */
  font-size:9px; 
  font-weight:bold;
  margin-right: 15px;
  background-color: #fff !important;
}
.table-small-rows td {
  height:10px;
  padding: 7px !important;
  font-size: 12px;  /* Optionally reduce the font size for better fit */
}
.custom-btn1{padding:8px 5px;background:#1cc88a;color:#fff;border:#1cc88a;border-radius:10px; cursor:pointer}
.legendlist button:last-child{
  border-right: none !important;
}
.mybtn {
  background: none !important;
  color: #333;
  font-size: 12px;
  padding: 1px 5px;
  border-right: 1px solid #ccc !important;
  border-left: 0px solid #ccc !important;
  border-top: 0px solid #ccc !important;
  border-bottom: 0px solid #ccc !important;
}
.sliderBlock3 {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 35%;
  height: 30%;
  background: #fff;
  box-shadow: 0.5rem 0.5rem 2rem 1rem rgba(0, 0, 0, 0.2);
  border-radius: 30px;
  z-index: 1000;
  overflow-y: hidden;
  overflow-x: hidden;
  transition: 0.5s ease-in-out;
}
.sliderBlockForConsCreation {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 30%;
  height: 40%;
  background: #fff;
  box-shadow: 0.5rem 0.5rem 2rem 1rem rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  z-index: 1000;
  overflow-y: hidden;
  overflow-x: hidden;
  transition: 0.5s ease-in-out;
  padding:20px;
}

.slide95 {
  transform: translate(-50%, -50%) scale(1);
}

.ffclosebtn1 {
  cursor: pointer;
  margin-top: -43px;
  color: #717171;
}

.closeIcon {
  height: 14px;
  width: 14px;
  color:black;
}

.confirm-heading {
  font-family: "Public Sans" !important;
  font-weight: 500;
  font-size: 16px;
  color: #585757;
  text-align: center;
}

.btn_confirm_cancel {
  width: 195px;
  height: 33px;
  border: 0.76px solid #565555;
  color: #565555;
  border-radius: 7.57px;
  background-color: transparent;
  transition: #565555 0.3s ease;
}

.btn_confirm_cancel:hover {
  border-color: #426cf5;
  color: #426cf5;
}

.btn_hover7 {
  background-color: green;
  border-radius: 7.57px;
  font-weight: bold;
  color: white;
  font-size: 15px;
  height: 33px;
  width: 195px;
  border: none;
}
.btn_hover8 {
  background-color: #d12828;
  border-radius: 7.57px;
  font-weight: bold;
  color: white;
  font-size: 15px;
  height: 33px;
  width: 195px;
  border: none;
}
.viewButton{
  padding: 3px 3px 0px 2px;
  /* background-color: #d6d3d3; */
  background-color: white;
  color: #000;
  font-size: 12px;
  border-radius: 5px;
  border:0px;
  font-weight: bold;
  height:20px;
  width:20px;
  }
  .viewButton1{
    padding: 0px;
    background-color: #d6d3d3;
    color: #000;
    font-size: 12px;
    }
    
.title-heading{
  /* font-family: "roboto"; */
  font-size:20px !important;
  color:black;
}  
.custom-field-width{
  max-width: 385px !important;
}
.custom-field-width1{
  max-width: 450px !important;
}
.plantstyle{
  margin-top: 20px !important;
}
.toggle-container {
  margin: 10px 0;
  display: flex;
  justify-content: center;
}

.btn1 {
  padding: 5px 5px;
  border-radius: 5px;
  margin: 0 10px;
  cursor: pointer;
  border: none;
  font-size: 12px;
}

.btn-active {
  background-color: #1cc88a;
  color: white;
}

.btn-inactive {
  background-color: #ddd;
  color: black;
}

.ag-header-cell-text{
  font-weight: bold;
  color:black;
}
.btn-h {
  background-color: #5FC19C !important;
  border-color: #5FC19C !important;
  color:#fff !important;
}

.btn-h.disabled {
  background-color: #5FC19C !important;
  border-color: #5FC19C !important;
}

.btn-h:disabled {
  background-color: #5FC19C !important;
  border-color: #5FC19C !important;
}

.btn-h:hover,
.btn-h:focus,
.btn-h:active,
.btn-h.active {
  background-color: #359b74 !important;
  border-color: #359b74 !important;
  color:#fff !important;
}

.btn-h:focus {
  box-shadow: 0 0 0 0.2rem #d9ebff;
}

.pgtab {
  border-right: 2px solid #fff;
  background: #4c99ff2b;
}
.pgtab:first-child {
  border-top-left-radius: 5px;
}
.pgtab:last-child {
  border-top-right-radius: 5px;
}
.pgtab:last-child {
  border-right: 0px;
}
.pgtab{border-right:2px solid #fff;background:#E0FAF0;}
.bgColorDangerDark{ background-color: #ff7289 !important;}
.disabled-checkbox {
  opacity: 0.5;
  pointer-events: none;
}

.disabled-cell {
  background-color: #f0f0f0; /* Light grey */
}
.andriomap-pos{position:fixed;bottom:-1%;left:47%;width:40px;height:40px;z-index:999;cursor:pointer;}
.andriomap-pos2{position: absolute;left:47%;top:-2%; width:40px;height:40px;z-index:999999;cursor:pointer;}


.zindex999{z-index:999;}
.ico-color{color:#ffffff;font-size:32px;background:#333333;padding:5px;}
.textAlignCenter {
  text-align: center;
}
.route-block{margin-bottom: 15px;border-bottom: 1px solid #ccc;padding-bottom: 10px;}
.sidebar-label{font-weight: 600;}
.prel{ position:relative;}
.remark-text {
  color: black;
  font-size: 0.9rem; /* Slightly larger font size */
  margin-top: 5px;
  text-decoration: underline; /* Adds underline */
  font-weight: bold; /* Optional: makes the text bold */
}
/* Card styling */
.document-card {
  display: flex;
  flex-direction: column;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
}

/* Attachment icon */
.attachment-icon {
  font-size: 1.2rem;
  margin-right: 10px;
  color: #6c757d; /* Neutral color for the icon */
}

/* Document section */
.document-section {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.document-details {
  display: flex;
  align-items: center;
  width: 100%;
}

.file-input {
  flex-grow: 1;
  margin-right: 10px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
}

/* Remarks section */
.remarks-section {
  margin-top: 5px;
}

.remark-text {
  color: black;
  font-size: 0.9rem;
  font-weight: bold;
  text-decoration: underline;
}

/* Cool color palette */
:root {
  --primary-color: #3498db; /* Cool blue */
  --secondary-color: #2ecc71; /* Fresh green */
  --accent-color: #9b59b6; /* Purple accent */
  --background-color: #f3f4f7; /* Light background */
  --text-color: #333; /* Dark text for contrast */
}

/* Container for the tab buttons */
.tab-buttons {
  display: flex;
  justify-content: left;
  margin-bottom: 20px;
}

/* Common styles for the tab buttons */
.tab-button {
  flex: 1 1;
  padding: 12px;
  text-align: center;
  background-color: #f3f4f7;
  background-color: var(--background-color);
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  color: #333;
  color: var(--text-color);
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  position: relative;
}

/* Hover effect for tab buttons */
.tab-button:hover {
  background-color: #3498db;
  background-color: var(--primary-color);
  color: white;
}

/* Active state styling for the tab with animation */
@keyframes loadingAnimation {
  0% {
      transform: scale(1);
      opacity: 1;
      background-color: #3498db;
      background-color: var(--primary-color);
  }
  50% {
      transform: scale(1.1);
      opacity: 0.8;
      background-color: #2ecc71;
      background-color: var(--secondary-color);
  }
  100% {
      transform: scale(1);
      opacity: 1;
      background-color: #3498db;
      background-color: var(--primary-color);
  }
}

.tab-button.active {
  animation: loadingAnimation 1s ease-in-out infinite;
  color: white;
  font-weight: 700;
}

/* Disabled tab button styling */
.tab-button:disabled {
  background-color: #f5f5f5;
  color: #aaa;
  cursor: not-allowed;
}

/* Optional: Hover effect when the tab is active */
.tab-button.active:hover {
  background-color: #2ecc71;
  background-color: var(--secondary-color);
}

/* Loading button with small bouncing balls animation */
/* Loading button with small bouncing balls animation */
.loading-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  background-color: #3498db;
  background-color: var(--primary-color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  transition: background-color 0.3s ease;
}
.loading-button1 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  background-color: #2ecc71;
  background-color: var(--secondary-color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  transition: background-color 0.3s ease;
}

.loading-button:hover {
  background-color: #2ecc71;
  background-color: var(--secondary-color);
}

/* Disabled button styling (grey color and no dots animation) */
.loading-button:disabled {
  background-color: #d3d3d3; /* Grey background */
  color: #aaa;  /* Grey color for text */
  cursor: not-allowed;
}

.loading-button:disabled .loading-dots {
  display: none; /* Hide the dots animation when the button is disabled */
}

/* Style for the dots */
.loading-dots {
  display: inline-block;
  margin-left: 10px;
}

/* Reduced size of dots and making them colorful */
.dot {
  display: inline-block;
  width: 8px;  /* Smaller size */
  height: 8px;  /* Smaller size */
  margin-right: 5px;
  border-radius: 50%;
  opacity: 0;
  animation: dot-blink 1.5s infinite step-start;
}

/* Sequential dot appearance with delays */
.dot:nth-child(1) {
  animation-delay: 0s;
  background-color: #ff5733;  /* Red */
}

.dot:nth-child(2) {
  animation-delay: 0.3s;
  background-color: #33ff57;  /* Green */
}

.dot:nth-child(3) {
  animation-delay: 0.6s;
  background-color: #3357ff;  /* Blue */
}

/* Keyframes for dot blink effect */
@keyframes dot-blink {
  0% {
      opacity: 0;
  }
  50% {
      opacity: 1;
  }
  100% {
      opacity: 0;
  }
}
/* Container for the tab section */
.tabs-section {
  margin-bottom: 20px;
  padding: 10px;
  border-bottom: 2px solid #ddd; /* Light border under tabs */
  background-color: #f9f9f9; /* Light background for the tabs section */
}

/* Style the tab list */
.tabs1 {
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0;
  margin: 0;
}
.tabs {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
}

/* Style individual tab items */
.tab-item {
  padding: 10px 20px;
  cursor: pointer;
  font-weight: bold;
  color: #555; /* Default text color */
  background-color: #fff; /* Background color of inactive tabs */
  border: 1px solid #ccc; /* Border for each tab */
  border-radius: 5px 5px 0 0; /* Rounded top corners */
  margin-right: 10px; /* Space between tabs */
  transition: background-color 0.3s, color 0.3s, border-color 0.3s; /* Smooth transition for hover/active states */
}

/* Hover effect for tabs */
.tab-item:hover {
  background-color: #f0f0f0; /* Slightly darker background on hover */
  color: #007bff; /* Blue text color on hover */
}

/* Active tab styles */
.tab-item.active {
  background-color: #007bff; /* Blue background for active tab */
  color: white; /* White text for active tab */
  border-color: #007bff; /* Same blue border color */
}

/* Optionally, you can add some customizations for focus, etc., for accessibility */
.tab-item:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.5); /* Blue outline on focus */
}
.tab-item.active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}
.custom-label {
  font-size: 14px;
}

.custom-input {
  width: 105%;
  /* padding: 10px; */
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  /* margin-bottom: 10px; */
  transition: border-color 0.3s ease;
}

.custom-input:focus {
  border-color: #007bff;
  outline: none;
}
.doc-style{
  font-size: 14px;
  color:#000;
  font-weight:bold;
}

input:disabled {
  background-color: #e9ecef;
  cursor: not-allowed;
}
.margin-left-extended {
  margin-left: 1165px; /* Adjust the value as needed */
}
.margin-top-default {
  margin-top: 0px;
}
.margin-top-tablet {
  margin-top: 0px;
}


/* Larger screen sizes (tablet and above) */
@media (min-width: 768px) {
  .margin-top-tablet {
      margin-top: 25px;
  }
}

/* Extra large screens (desktop and above) */
@media (min-width: 1200px) {
  .margin-top-default {
      margin-top: 25px; /* Or any value you want for larger screens */
  }
}
/* General styles for counters */
.counters-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 0.5rem;
  margin: 0 auto;
}



/* Adjust font sizes for smaller screens */
.counter-card {
  flex: 1 1;
  text-align: center;
  padding: 10px 0;
  border-left: 1px solid #ddd; /* Vertical separator */
  font-family: "Public Sans";
}

/* Remove the first vertical line */
.counter-card:first-child {
  border-left: none;
}

/* Adjust font sizes for counters */
.counter-card span {
  font-size: 30px;
  /* color: #333; */
}

.counter-card h4 {
  font-size: 24px;
  margin-top: 20px;
  /* color: #555; */
  font-weight: bold;
}
.counter-card h6 {
  font-size: 24px;
  /* margin-top: 20px; */
  /* color: #555; */
  font-weight: bold;
}
.counter-card h5 {
  font-size: 24px;
  margin-top: 5px;
  /* color: #555; */
  font-weight: 600px;
}

/* Responsive breakpoints */
@media (max-width: 1024px) {
  .counter-card {
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis: calc(33.33% - 1rem); /* Adjust for smaller screens */
  }
}

@media (max-width: 768px) {
  .counter-card {
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis: calc(50% - 1rem); /* Two items per row */
  }
}

@media (max-width: 480px) {
  .counter-card {
      flex: 1 1 100%; /* One item per row */
      border-left: none;
      border-bottom: 1px solid #ddd;
  }

  .counter-card:last-child {
      border-bottom: none;
  }
}

.btn-bulkupload{
  border-radius: 4px;
  border-color: #0664AE;
  background-color:#ffffff;
}
.radio-buttons{
  margin-left:10px;
}
.search-label {
  position: relative;
  margin-left: 20px;
  font-size: 13px;
}

.filter-label {
  position: relative;
  margin-left: 10px;
  font-size: 13px;
}
.search_icon{
  position: absolute;
  right: 12px;
  width: 24px;
  height: 13px;
  top: 13px;
  padding-left: 5px;
  cursor: pointer;
}

.gm-ui-hover-effect {
  opacity: 1 !important;
  background: #b6b5b5 !important;
  padding: 0px !important;
  top: 0px !important;
  right: 0px !important;
  height: 34px !important;
  width: 19px !important;
  filter: invert(1);
}
.modal-header-custom {
  background-color: #6c5ce7; /* Purple Header */
  color: white;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.modal-title-custom {
  font-size: 16px;
  font-weight: bold;
}

.modal-body-custom {
  padding: 20px;
  font-size: 16px;
  color: #333;
}

.otp-label {
  font-weight: bold;
  font-size: 15px;
}

.otp-input {
  border: 2px solid #6c5ce7;
  border-radius: 5px;
  font-size: 16px;
  padding: 10px;
}

.modal-footer-custom {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  background-color: #f1f1f1;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.cancel-btn {
  background-color: #d6d5d2 !important;
  color: black !important;
  border-radius: 5px;
  /* padding: 8px 16px; */
  font-size: 14px;
}

.submit-btn {
  background-color: green !important;
  color: white;
  border-radius: 5px;
  /* padding: 8px 16px; */
  font-size: 14px;
}

.cancel-btn:hover {
  background-color: #b82b2b;
}

.submit-btn:hover {
  background-color: #0875d3;
}
.pagination-controls {
  display: flex;
  justify-content: center;  /* ✅ Center align */
  align-items: center;
  margin-top: 15px;  /* ✅ Add spacing above */
  gap: 10px;  /* ✅ Space between elements */
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.pagination-controls button {
  background-color: #007bff;  /* ✅ Blue background */
  color: white;
  border: none;
  padding: 8px 15px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 5px;
  transition: background 0.3s ease-in-out;
}

.pagination-controls button:hover {
  background-color: #0056b3;  /* ✅ Darker blue on hover */
}

.pagination-controls button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination-controls span {
  font-size: 16px;
  font-weight: bold;
  color: #555;
}
.track-button {
  background-color: #28a745; /* Green */
  color: white;
  border: 2px solid #218838;
  padding: 4px 12px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.track-button:hover {
  background-color: #218838; /* Darker Green */
  border-color: #1e7e34;
  color: white;
}
.border-radius1{
  border-radius: 4px;
}
.defectIcon1{
  height:30px;
}
.login-style{
  background-color: #a064ba !important;
  color:#fff;
  border-radius: 4px;
}
.bulk-invalid-text{
  margin-top: -15px;
  margin-right: -18px;
}
.tms-legend-style{
  font-size: 15px;
  font-weight: 400;
  font-size: 13px;
}
.resetgrid-border-radius{
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.savegrid-border-radius{
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.date-container .react-datepicker-wrapper{
  width: 100%;
}
.display-flex-center-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-page-button {
  font-size: 14px;
  border-radius:4px;
  
  /* padding: 4px; */
}
.txt-black-light {
  color: #534949
}
.txt-total {
  color: #4a4a4a; /* Neutral gray for total */
}

.txt-open {
  color: #007bff; /* Blue for open */
}

.txt-assigned {
  color: #ff8c00; /* Orange for assigned */
}

.txt-in-progress {
  color: #ffc107; /* Yellow for in-progress */
}

.txt-resolved {
  color: #28a745; /* Green for resolved */
}

.txt-reopened {
  color: #dc3545; /* Red for reopened */
}

.txt-onhold {
  color: #6c757d; /* Muted gray for on-hold */
}

.txt-need-info {
  color: #e83e8c; /* Pink for need info */
}

.txt-closed {
  color: #28a745; /* Dark green for closed */
}
.back-button {
    background-color: #fff;
    border: 1px solid #ccc;
    padding: 5px 14px;
    border-radius: 20px; /* Rounded corners */
    display: flex;
    align-items: center;
    font-size: 12px;
    cursor: pointer;
}

.back-button::before {
    content: "<"; /* Left arrow */
    margin-right: 8px;
}

.back-button:hover {
    background-color: #e0e0e0;
    border-color: #bbb;
}

.back-button:focus {
    outline: none;
}
.form-input{
  border-radius:3px;
  border: 1px solid #D3D3D3;
  height:38px;
}
.form-label{
  font-size:13px;
  color:grey;
}
.logoheader{
  height:100px !important;
}
.create-ticket{
  padding:0px;
}
.editItem1{
  padding:0px;
  width:46px;
  height:21px;
}
.editticket-input{
  width:100%;
  padding:10px;
  border-radius: 4px;
  border:1px solid #ccc;
}
.down-arrow{
  font-size: 30px;
}
.cancel-button {
  background-color: whitesmoke;
  color: #ff4d79; /* soft red/pink */
  border: 2px solid #ff4d79;
  padding: 5px 16px;
  border-radius: 6px;
  font-size: 14px;
  height:38px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.cancel-button:hover {
  background-color: #ff4d79;
  color: white;
}
.save-add-new-button {
  color: #00c896; /* soft green */
  border: 2px solid #00c896;
  padding: 5px 16px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  height: 38px;
  width: auto; /* ADD THIS */
  align-self: center; /* ADD THIS to center it inside flex column */
}


.save-add-new-button:hover {
  background-color: #00c896;
  color: white;
}
.save-consignment-button {
  background-color: #00c896; /* same green as the others */
  color: white;
  border: none;
  padding: 5px 16px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  height:38px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.save-consignment-button:hover {
  background-color: #00b287; /* slightly darker green on hover */
}
.consignment-del{
  font-size: 25px;
}
.cons-creation-head{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.proceed-text {
  color: red; /* Same red color as your button */
  text-decoration: underline; /* Underline */
  font-size: 14px;
  margin: 10px 0px 30px 0px;
  cursor: pointer; /* So user knows it's clickable */
  font-weight: 500;
}
.success-icon {
  width: 100px; /* Size of tick */
  height: 70px;
  margin-bottom: 10px;
}
.cons-creation-card-title-header {
  padding: 12px 20px;
  margin-bottom: 0;
  background-color:#e7f2f9;
  border-bottom: 1px solid #e7f2f9;
}

.cons-creation-card-title-header:first-child {
  border-radius: 3px 3px 0 0;
}

.cons-creation-card-title-header+.list-group .list-group-item:first-child {
  border-top: 0;
}
.tpt-dropdown-style{
  margin-top: 6px;
  padding: 4px;
  width: 100%;
  font-size: 13px;
  border: 1px solid #ccc;
}
.tpt-alloc-label{
  display: block;
  margin-bottom: 5px;
}
.tpt-alloc-input{ 
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.disabled-btn {
  background-color: #cccccc !important;
  border-color: #aaaaaa !important;
  color: #666666 !important;
  cursor: not-allowed !important;
  opacity: 0.6;
  pointer-events: none; /* prevents click or hover */
}
.master-title{
  font-weight: bold;
}
/* 
.toggle-button {
  position: relative;
  width: 60px;
  height: 30px;
  background-color: #ccc;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
}

.toggle-button::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 24px;
  height: 24px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.3s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,0.3);
}

.toggle-button.active {
  background-color: #4caf50;
  justify-content: flex-end;
}

.toggle-button.active::after {
  transform: translateX(-3px); 
}

.toggle-button .off,
.toggle-button .on {
  display: none;
} */

.toggle-button {
  position: relative;
  width: 60px;
  height: 30px;
  background-color: #ccc;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  padding: 0;
  overflow: hidden;
}

/* The knob */
.toggle-button::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 24px;
  height: 24px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

/* When active: background turns green */
.toggle-button.active {
  background-color: #4caf50;
}

/* When active: move the knob right */
.toggle-button.active::after {
  transform: translateX(30px); /* 60px container - knob width - margin */
}

/* Hide icons */
.toggle-button .on,
.toggle-button .off {
  display: none;
}

.btn-sea {
  background-color: #2CA6A4 !important;  
  border-color: #2CA6A4 !important;
  color: #ffffff !important;
}

.btn-sea.disabled,
.btn-sea:disabled {
  background-color: #2CA6A4 !important;
  border-color: #2CA6A4 !important;
}

.btn-sea:hover,
.btn-sea:focus,
.btn-sea:active,
.btn-sea.active {
  background-color: #218c8a !important;  
  border-color: #218c8a !important;
  color: #ffffff !important;
}

.btn-sea:focus {
  box-shadow: 0 0 0 0.2rem #c8f4f3;
  -webkit-box-shadow: 0 0 0 0.2rem #c8f4f3;
}

.sea-tab {
  border-right: 2px solid #fff;
  background: #e0fafa;
}

.sea-tab:first-child {
  border-top-left-radius: 5px;
}

.sea-tab:last-child {
  border-top-right-radius: 5px;
  border-right: 0px;
}

.timeline-stripe1 {
  position: relative;
  width: 12px;
  background-color: #1e90ff; /* default blue */
  margin: 0px 30px;
}

.timeline-stripe1::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: green;
  transition: height 0.3s ease;
  border-radius: 2px;
}

.timeline-event1 {
  transition: transform 0.3s ease, opacity 0.3s ease;
  transform-origin: top;
}

.timeline-stripe1.expanding .timeline-event1 {
  animation: fadeSlideIn 0.4s ease forwards;
}

@keyframes fadeSlideIn {
  from {
    transform: translateY(-10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.timeline-event1.newly-shown {
  animation: popIn 0.3s ease-in;
  background-color: #e8f5e9; /* light green highlight */
  border-radius: 6px;
}

@keyframes popIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.truck-image1.expanded {
  animation: pulseTruck 0.4s ease-in-out;
  box-shadow: 0 0 10px 3px rgba(0, 255, 0, 0.4);
  border-radius: 50%; /* optional: smooth rounded highlight */
}

@keyframes pulseTruck {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.timeline-content1.in-transit-bg {
  background-color: #e8f5e9;  /* light green background */
  border-radius: 8px;
  padding: 10px 14px;
  box-shadow: 0 1px 4px rgba(76, 175, 80, 0.2); /* subtle green shadow */
  transition: background-color 0.3s ease;
}

.blue-dot1 {
  width: 20px;
  height: 20px;
  background-color: #2196f3; /* blue */
  border-radius: 50%;
  position: relative;
  z-index: 2;
}

.green-dot1 {
  width: 20px;
  height: 20px;
  background-color: green;
  border-radius: 50%;
  position: relative;
  z-index: 2;
}

.arrow-toggle {
  font-size: 20px;
  font-weight: bold;
  color: #4caf50; 
  background-color: transparent !important; 
  border: none;
  outline: none;
  box-shadow: none;
  padding: 0;
  margin-right: 6px;
  display: inline-block;
  line-height: 1;
}

.arrow-toggle:hover {
  transform: scale(1.2);
  transition: transform 0.2s ease;
}

.truck-wrapper {
  position: relative;
  width: 36px;
  height: 36px;
  background-color: #e0f2f1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.truck-image-icon1 {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.arrow-toggle {
  position: absolute;
  font-size: 20px;
  font-weight: bold;
  color: #e8f5e9;;
  background: transparent;
  pointer-events: none;
  margin-right: 45px;
  margin-bottom: 10px;
  margin-left: -27px;
}

.collapsed-arrow .arrow-toggle {
  top: 50%;
  right: -6px;
  transform: translateY(-50%);
}

.expanded-arrow .arrow-toggle {
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
}

.pod-eye-icon button {
  padding: 2px 8px;
  font-size: 13px;
}

.legs-container {
  background-color: #e6f9f6;
  padding: 10px 15px;
  border-left: 3px solid #28a745;
  margin-top: 8px;
  border-radius: 4px;
  max-width: 300px;
}

.leg-details {
  font-size: 12px;
  color: #333;
  padding: 8px 10px;
  border-radius: 4px;
  box-shadow: 0 4px 2px rgba(0, 0, 0, 0.05);
}

.expand-legs-icon {
  font-size: 13px;
}

.legs-scroll-wrapper {
  min-height: 100px;
  max-height: 230px;
  overflow-y: auto;
  padding-right: 8px;
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: #888 transparent;
}

.legs-scroll-wrapper::-webkit-scrollbar {
  width: 6px;
}

.legs-scroll-wrapper::-webkit-scrollbar-track {
  background: transparent; 
}

.legs-scroll-wrapper::-webkit-scrollbar-thumb {
  background-color: #888;  
  border-radius: 10px;
}

.legs-scroll-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
.logo-header-tracking{
  height: 200px !important;
}
.reset-btn-rawcourier {
  border-radius: 4px; 
  padding: 0.375rem 0.75rem;
}

.rightModal {
    position: fixed;
    top: 0;
    right: 0;
    width: 450px;
    height: 100%;
    background: #fff;
    z-index: 9999;
    box-shadow: -2px 0 8px rgba(0,0,0,0.2);
    animation: slideIn 0.3s ease-out;
    padding: 20px;
}

@keyframes slideIn {
    from { right: -500px; }
    to { right: 0; }
}

.modalOverlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.3);
    z-index: 9998;
}
.duplicate-row {
    background-color: #ffcccc !important;
}
.modalOverlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.4);
    z-index: 9998;
}

.rightModal {
    position: fixed;
    top: 0;
    right: 0;
    width: 420px;       /* or whatever width you want */
    height: 100vh;      /* full screen height */
    background: #fff;
    z-index: 9999;
    padding: 20px;
    overflow-y: auto;   /* <-- ENABLE SCROLL */
    box-shadow: -3px 0 10px rgba(0,0,0,0.2);
}
.grid-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 3000;
}

.grid-modal {
    background: #fff;
    width: 90%;
    max-width: 1300px;
    padding: 20px;
    border-radius: 10px;
}

.grid-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.close-btn {
    background: #dc3545;
    color: #fff;
    padding: 6px 15px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
}

.trip-tabs {
    display: flex;
    gap: 10px;
    margin-bottom: 12px;
}

.tab, .active-tab {
    padding: 6px 14px;
    border-radius: 6px;
    background: #fff;
    border: 1px solid #007bff;
    cursor: pointer;
}

.active-tab {
    background: #007bff;
    color: #fff;
    font-weight: bold;
}
.excel-btn {
    background: linear-gradient(135deg, #28a745, #218838);
    color: #fff;
    padding: 8px 18px;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
    transition: all 0.25s ease-in-out;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.excel-btn:hover {
    background: linear-gradient(135deg, #1e7e34, #1c7430);
    transform: translateY(-1px);
    box-shadow: 0 5px 12px rgba(0, 0, 0, 0.25);
}

.excel-btn:active {
    transform: scale(0.98);
    box-shadow: none;
}
.bulk-error-row {
    background-color: #f8d7da !important;
    color: #721c24;
    font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/encss.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,gCAAgC;EAChC,QAAQ;EACR,eAAe;EACf,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yDAAyC;EACzC,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa,EAAE,qCAAqC;EACpD,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,2BAA2B,EAAE,0BAA0B;EACvD,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB;AACF;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,uBAAuB;EACvB,iCAAiC;EACjC,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;;AAEA;EAKE,wBAAwB;EACxB,6BAA6B;EAC7B,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAElB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EAKE,wBAAwB;EACxB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAElB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,SAAS;EACT,mBAAmB;EAEnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,QAAQ;EACR,mBAAmB;EAEnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,0CAA0C;EAC5C;;EAEA;IACE,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,wCAAwC;EAC1C;AACF;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAsCA;EACE,eAAe;EACf,UAAU;EACV,MAAM;EACN,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,iDAAiD;EACjD,gBAAgB;EAEhB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,sDAAsD;EACtD,gBAAgB;EAEhB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;AACA,sBAAsB,0BAA0B,CAAC,UAAU,CAAC;AAC5D;EACE,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;;AAEpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAEhB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,0BAA0B;EAE1B,gBAAgB;EAChB,8BAA8B;EAE9B,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAUA;EACE;IACE,QAAQ;EACV;AACF;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,MAAM;EACN,gBAAgB;EAChB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,sDAAsD;EACtD,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAEhB,wEAAwE;AAC1E;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;;AAEjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,uBAAuB;EACvB;AACF;;AAEA;;EAEE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB;AACF;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,MAAM;EACN;AACF;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,SAAS;EACT;AACF;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;AACF;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,0GAA0G;;AAE5G;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mDAAmD;EACnD,uBAAuB;AACzB;;AAEA;EACE,kDAAkD;EAClD,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,iCAAiC;EACjC,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA,uEAAuE;AACvE;EACE,qDAAqD;EACrD,kBAAkB;EAClB,WAAW;EACX;;OAEK;EACL,OAAO;AACT;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,iCAAiC;EACjC,6BAA6B;EAC7B,mEAAmE;EACnE,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,kCAAkC;EAClC,mCAAmC;EACnC;;mBAEiB;AACnB;;AAEA,sEAAsE;AACtE;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,sBAAsB;EACtB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,8BAA8B;EAC9B;AACF;;AAEA;EACE,8BAA8B;EAC9B;AACF;;AAEA;EACE,8BAA8B;EAC9B;AACF;;AAEA;EACE,8BAA8B;EAC9B;AACF;;AAEA;EACE,yCAAyC;EACzC;AACF;;AAEA;EACE,8BAA8B;EAC9B;AACF;;AAEA;EACE,8BAA8B;EAC9B;AACF;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE;EACF;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;AACF;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB;mDACiD;EACjD,UAAU;EACV,6CAA6C;;AAE/C;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,6FAA6F;AAC/F;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,4BAA4B;EAC5B,6FAA6F;AAC/F;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2FAA2F;AAC7F;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;;AAE/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;;AAErB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,sDAAsD;EACtD,gBAAgB;EAEhB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;;;AAIA,uBAAuB;AACvB;;;;oEAIoE;;AAEpE;mCACmC;AACnC;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;;AAGA;mCACmC;AACnC;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;;AAGA;mCACmC;AACnC;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;mCACmC;;AAEnC,aAAa;AACb;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,yDAAuG;AACzG;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EAGzB,iBAAiB;;EAEjB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA,4DAA4D;AAC5D;EACE,UAAU;EACV,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,mBAAmB;;AAErB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB,4BAA4B;AAC5B;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;;EAEE,0CAA0C;EAC1C,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;EAC5B,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,MAAM;AACR;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,UAAU;EACV,OAAO;AACT;;AAEA;;;;EAIE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,OAAO;EACP,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,OAAO;EACP,MAAM;AACR;;AAEA;EACE,YAAY;AACd;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EAEd,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,SAAS;EACT,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,MAAM;EACN,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV,MAAM;EACN,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mDAAyzE;EACzzE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,eAAe;EAEf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,cAAc;EACd,SAAS;EACT,wBAAwB;AAC1B;;AAEA,6BAA6B;AAC7B;;EAEE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,MAAM;AACR;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,QAAQ;AACV;;AAEA,+DAA+D;AAC/D;EACE,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,uIAAuI;EACvI,aAAa;AACf;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,oBAAoB;EACpB,sBAAsB;EACtB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;mCACmC;AACnC;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;mCACmC;AACnC;;;;;;;;;EASE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;EAOE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;;;;EAQE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;;;EAUE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;;;;;EAME,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;;AAEA;mCACmC;AACnC;;;EAGE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;mCACmC;;AAEnC,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,oEAAoE;AACtE;;AAEA;EACE,oEAAoE;AACtE;;AAEA;;;;EAIE,oEAAoE;AACtE;;AAEA;;EAEE,oEAAoE;AACtE;;AAEA;;EAEE,oEAAoE;AACtE;;AAEA;;EAEE,oEAAoE;AACtE;;AAEA;EACE,oEAAoE;AACtE;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,qEAAqE;AACrE;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;;AAGA;mCACmC;;AAEnC,kBAAkB;AAClB;;;;EAIE,2BAA2B;AAC7B;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;GAGG;AACH;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,WAAW;EACX,2DAA2D;EAC3D,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EAEb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EAIzB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EAEE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;EAIE,yDAAq6D;AACv6D;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;;;EAGE,6BAA6B;EAC7B,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,iEAAiE;EACjE,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,UAAU;EACV,kEAAkE;AACpE;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;;AAEb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,UAAU;EACV,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;EACZ,iEAAiE;EACjE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iEAAiE;AACnE;;AAEA;;EAEE,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;EAEE,8BAA8B;EAC9B,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,MAAM;EACN,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;EACtD,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;AACb;;AAEA;;;;EAIE,yDAAq5D;AACv5D;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EAEzB,WAAW;EAEX,oBAAoB;EAEpB,yBAAyB;EAEzB,iBAAiB;EAEjB,UAAU;EACV,4DAA4D;EAC5D,QAAQ;EACR,+GAA+G;EAC/G,UAAU;AACZ;;AAEA;;;;EAIE,cAAc;EAEd,WAAW;EAEX,oBAAoB;EAEpB,yBAAyB;EAEzB,iBAAiB;EAEjB,UAAU;EACV,4DAA4D;EAC5D,QAAQ;EACR,+GAA+G;EAC/G,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gCAAgC;EAChC,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;AAC/B;;;AAGA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,QAAQ;;EAER,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;GAGG;AACH;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,MAAM;EACN,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,2BAA2B;EAA3B;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,cAAc;EACd,cAAc;AAChB;;AAEA,aAAa;EACX,oCAAoC;EACpC;;yBAEuB;EACvB,0CAA0C;AAC5C,MAAM;;AAEN;;;;EAIE,oCAAoC;EACpC,sBAAsB;EACtB,0CAA0C;AAC5C;;;AAGA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gBAAgB;;AAEhB,+BAA+B;AAC/B;EACE;AACF;;AAEA;;EAEE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EAGzB,iBAAiB;EACjB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,sBAAsB;;EAEtB;AACF;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA,0FAA0F;AAC1F,sDAAsD;AACtD,+BAA+B;AAC/B;;EAEE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAA4mG;EAC5mG,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EAGzB,iBAAiB;;EAEjB,+EAA+E;EAC/E,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6BAAoB;EAApB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;CAKC;AACD;;EAEE,UAAU;;AAEZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;;AAEZ;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EAGzB,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,uBAAuB;;AAEzB;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,yBAAyB;EACzB,oDAAoD;EACpD,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,yBAAyB;EACzB,0DAA0D;EAC1D,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wCAAwC;EACxC,yBAAyB;EACzB,oDAAoD;EACpD,qBAAqB;EACrB,oDAAoD;EACpD,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;EAEE,WAAW;EACX,wCAAwC;EACxC,yBAAyB;EACzB,2DAA2D;EAC3D,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;;EAEE,yBAAyB;;AAE3B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gGAAgG;AAClG;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;;GAEG;AACH;;;GAGG;AACH;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0EAA0E;EAC1E,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uFAAuF;EACvF,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;EAC/B,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;;AAExB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;IACR,+BAA+B;;AAEnC;;AAEA;EACE,WAAW;EACX,wEAAwE;AAC1E;;AAEA;EACE,WAAW;EACX,+FAA+F;EAC/F,qCAAqC;AACvC;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EAEzC,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,MAAM;EACN,mDAAmD;EACnD,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,wDAAwD;AAC1D;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAE9C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;;EAEE,+DAA+D;;AAEjE;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,uDAAuD;EACvD,gBAAgB;AAClB;;AAEA;;;EAGE,qFAAqF;EACrF,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,kEAAkE;AACpE;;AAEA;EACE,8BAA8B;EAC9B,wDAAwD;EACxD,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,+DAA+D;AACjE;;AAEA;;EAEE,oCAAoC;EACpC,gEAAgE;AAClE;;AAEA,gBAAgB;AAChB,yGAAyG;AACzG;;EAEE,qBAAqB;AACvB;;AAEA,WAAW;AACX;;EAEE,eAAe;AACjB;;AAEA,uBAAuB;AACvB,yGAAyG;AACzG;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,aAAa;AACb,yGAAyG;AACzG;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,UAAU;EACV,wCAAwC;AAC1C;;AAEA,aAAa;AACb,yGAAyG;AACzG,iEAAiE;AACjE;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;EAGE,UAAU;;AAEZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,4BAAqE;EAArE,qEAAqE;EACrE,iBAAiB;EACjB,2DAA2D;EAC3D,UAAU;EACV,mDAAmD;EACnD,WAAW;EACX,oDAAoD;EACpD,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,wCAAwC;IACtC,oBAAoB;;AAExB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA,6BAA6B;AAC7B,yGAAyG;AACzG;EACE,uCAAuC;IACrC,+CAA+C;;AAEnD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;;EAEE,kBAAkB;;AAEpB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,uEAAuE;EACvE,kBAAkB;EAClB,UAAU;;EAEV,uDAAuD;EACvD,0EAA0E;EAC1E,0CAA0C;EAC1C,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;;CAEC;AACD;EACE,4BAA4B;EAC5B,cAAc;EACd,yBAAyB;EACzB,uDAAuD;EACvD,yBAAyB;EACzB;AACF;;AAEA;EACE,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;EACzC,mBAAmB;EACnB,mCAAmC;EACnC,OAAO;EACP,eAAe;EACf,QAAQ;EACR,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,aAAa;AACf;;AAEA,wEAAwE;AACxE;;EAEE,yBAAyB;EACzB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,MAAM;EACN,SAAS;EACT,UAAU;EACV,6CAA6C;AAC/C;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,oBAAuD;EAAvD,uDAAuD;AACzD;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,qBAAwD;EAAxD,wDAAwD;AAC1D;;AAEA,uBAAuB;AACvB;EACE,QAAQ;EACR,gBAAgB;EAChB,0BAAmE;EAAnE,mEAAmE;AACrE;;AAEA;;EAEE,UAAU;EACV,oBAA6D;EAA7D,6DAA6D;AAC/D;;AAEA;;EAEE,WAAW;EACX,qBAA8D;EAA9D,8DAA8D;AAChE;;;AAGA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;EAC9C,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,gEAAgE;AAClE;;AAEA,+CAA+C;AAC/C;;;EAGE,iCAAiC;AACnC;;AAEA;;;EAGE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,UAAU;EACV,wDAAwD;AAC1D;;AAEA;EACE,0CAA0C;EAC1C,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4FAA4F;AAC9F;;AAEA;;EAEE,aAAa;;AAEf;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,iCAAiC;;AAEnC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;;EAEE,oBAAoB;;AAEtB;;AAEA;EACE,eAAe;EACf,mFAAmF;AACrF;;AAEA;;EAEE,wCAAwC;;AAE1C;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,eAAe;EACf,gGAAgG;AAClG;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;;AAEpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,oDAAoD;EACpD,OAAO;EACP,IAAI;EACJ,QAAQ;EACR,IAAI;AACN;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;AACX;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,WAAW;;AAEb;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,oCAAoC;;AAEtC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;;EAEE,+BAA+B;;AAEjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,sEAAsE;EACtE,cAAc;EACd,4CAA4C;AAC9C;;AAEA;;EAEE,YAAY;;AAEd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,wBAAwB;AAC1B;;AAEA;EACE,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,qFAAqF;EACrF,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,mDAAmD;AACnD;EACE,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,iDAAiD;EACjD,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,mCAAoG;EAApG,oGAAoG;EACpG,kBAAkB;EAClB,4BAA+D;EAA/D,+DAA+D;AACjE;;AAEA,2CAA2C;AAC3C;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;;CAEC;;AAED;EACE,4BAA4B;EAC5B,cAAc;EACd,yBAAyB;EACzB,uDAAuD;EACvD,yBAAyB;EACzB;AACF;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,cAAc;EACd,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,8BAA8B;EAC9B,MAAM;EACN,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,8BAA8B;;AAEhC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;;AAExB;;AAEA;EACE,WAAW;EACX,8CAA8C;EAC9C,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,mBAAsD;EAAtD,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,sBAAyD;EAAzD,yDAAyD;AAC3D;;AAEA;;EAEE,iDAAiD;;AAEnD;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,2BAAoE;EAApE,oEAAoE;AACtE;;AAEA;EACE,SAAS;EACT,mBAA4D;EAA5D,4DAA4D;AAC9D;;AAEA;EACE,YAAY;EACZ,sBAA+D;EAA/D,+DAA+D;AACjE;;AAEA;EACE,iDAAiD;EACjD,UAAU;EACV,gGAAgG;AAClG;;AAEA;EACE,gBAAgB;EAChB,mEAAmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,0CAA0C;EAC1C,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;IACf,8CAA8C;;AAElD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;IACb,kCAAkC;AACtC;;AAEA;EACE,gBAAgB;EAChB,kFAAkF;AACpF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;;EAGE,gFAAgF;;AAElF;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,sEAAsE;EACtE,qDAAqD;;AAEvD;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,0CAA0C;EAC1C,oEAAoE;AACtE;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;EACxD,MAAM;EACN,OAAO;EACP,QAAQ;EACR;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;;EAEE,OAAO;;AAET;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,OAAO;EACP,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,4EAA4E;EAC5E,mFAAmF;;AAErF;;AAEA;EACE,UAAU;EACV,oEAAoE;AACtE;;AAEA;;EAEE,kBAAkB;;AAEpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,mEAAmE;EACnE,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;;EAE3B,gBAAgB;;EAEhB,2CAA2C;EAC3C;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,MAAM;EACN,WAAW;EACX,oCAAoC;EACpC,OAAO;EACP,QAAQ;AACV;;AAEA;;EAEE,SAAS;;AAEX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,gDAAgD;EAChD,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;;AAEZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,OAAO;;EAEP,yCAAyC;EACzC,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,QAAQ;;EAER,wCAAwC;EACxC,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;AAClC;;;AAGA;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;;EAEE,2BAA2B;;AAE7B;;AAEA;EACE,0CAA0C;EAC1C,sEAAsE;EACtE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,8BAA8B;EAC9B,yGAAyG;;AAE3G;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EAEd,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,yCAAyC;EACzC,6DAA6D;AAC/D;;AAEA;EACE,UAAU;EACV,qCAAqC;AACvC;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;;EAGE,sBAAsB;EACtB,yGAAyG;;AAE3G;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,sEAAsE;AACxE;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,8DAA8D;AAChE;;AAEA;;EAEE,wBAAwB;;AAE1B;;AAEA;;EAEE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,oCAAkG;EAAlG,kGAAkG;EAClG,kBAAkB;EAClB,6BAA6D;EAA7D,6DAA6D;AAC/D;;AAEA;;EAEE,sBAAsB;;AAExB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,sDAAsD;;AAExD;;AAEA;EACE,0BAA0B;AAC5B;;;;AAIA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;;GAGG;AACH;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,sBAAsB;EACxB;;EAEA;IACE,QAAQ;IACR,sBAAsB;EACxB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,sBAAsB;EACxB;;EAEA;IACE,QAAQ;IACR,sBAAsB;EACxB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;AACF;;AAEA;;uCAEuC;AACvC;EACE,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;EAC7B,yCAAyC;;AAE3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,sBAAsB;EACxB;;EAEA;IACE,QAAQ;IACR,sBAAsB;EACxB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,YAAY;;AAEd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EAEE,iCAAiC;EAEjC,sBAAsB;EAEtB,mCAAmC;EAEnC,sBAAsB;EACtB,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,iDAAiD;EACjD,YAAY;AACd;;AAEA;EACE,iDAAiD;EACjD,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE;iDAC+C;EAC/C,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;mBACiB;EACjB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,aAAa;AACf;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;;AAEd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,kCAAkC;EAClC,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;;EAEhB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;;EAElB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf;kBACgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;;EAEhB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,YAAY;;AAEd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,kCAAkC;EAClC,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,eAAe;;;AAGjB;;AAEA;EACE,gBAAgB;;EAEhB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;AACF;;AAEA;EACE,4BAA4B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAsCG;AACH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAwDG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;;AAGA,2BAA2B;;AAE3B;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;;AAErB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,SAAS;EACT,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;gBACc;EACd,yBAAyB;EACzB;iBACe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kFAAkF;EAClF,2CAA2C;AAC7C;;AAEA;EACE,kFAAkF;EAClF,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,2CAA2C;IACzC,iBAAiB;AACrB;;;AAGA;EACE;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,uBAAuB;AACzB;;;AAGA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;EACb,gCAAgC;;AAElC;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;AAChC;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,qBAAqB;EACrB,wCAAwC;EACxC,WAAW;EACX,eAAe;EACf,8DAA8D;AAChE;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,4CAA4C;EAC5C,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA,sDAAsD;AACtD;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,+DAA+D;EAC/D,6CAA6C;AAC/C;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,yBAAyB;;AAE3B;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,yBAAyB;;AAE3B;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;;;AAGA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,UAAU;EACZ;AACF;;AAcA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;AACb;AACA;EACE,SAAS;EACT,yBAAyB;AAC3B;AACA,SAAS,oBAAoB,CAAC,yBAAyB,CAAC,SAAS,CAAC;AAClE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAqCG;AACH;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,+CAA+C;EAC/C,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;;AAElB;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;;AAElB;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,0CAA0C;EAC1C,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,SAAS,EAAE,oDAAoD;EAC/D,WAAW,EAAE,uDAAuD;EACpE,aAAa,EAAE,6CAA6C;AAC9D;;AAEA;EACE,uBAAuB,EAAE,4CAA4C;EACrE,YAAY,EAAE,kBAAkB;AAClC;CACC;IACG,wBAAwB;IACxB,gBAAgB;IAChB,iCAAiC;IACjC,6CAA6C;IAC7C,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,gBAAgB;GACjB;GACA;;OAEI,2BAA2B,CAAC,yCAAyC;OACrE,gBAAgB;OAChB,sBAAsB;GAC1B;;AAEH;OACO,YAAY,EAAE,6BAA6B;OAC3C,eAAe,EAAE,gCAAgC;GACrD;;AAEH;OACO,YAAY,EAAE,2BAA2B;OACzC,eAAe,EAAE,8BAA8B;GACnD;AACH;KACK,iBAAiB;KACjB,gBAAgB;KAChB,sBAAsB;IACvB;AACJ;MACM,wBAAwB;MACxB,wBAAwB;MACxB,WAAW;MACX,WAAW;IACb;AACJ;EACE,oCAAoC;MAChC,mBAAmB;MACnB,WAAW;MACX,gBAAgB;MAChB,cAAc;IAChB;AACJ;EACE,eAAe;AACjB;AACA;EACE,WAAW,GAAG,2BAA2B;EACzC,YAAY,GAAG,4BAA4B;EAC3C,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe,GAAG,mDAAmD;AACvE;AACA,aAAa,eAAe,CAAC,kBAAkB,CAAC,UAAU,CAAC,cAAc,CAAC,kBAAkB,EAAE,cAAc;AAC5G;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,sCAAsC;EACtC,qCAAqC;EACrC,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,sDAAsD;EACtD,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,sDAAsD;EACtD,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,cAAc;EACd,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV;EACA;IACE,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf;;AAEJ;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;;EAIE,oCAAoC;EACpC,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;AACnB;AACA,OAAO,2BAA2B,CAAC,kBAAkB,CAAC;AACtD,oBAAoB,oCAAoC,CAAC;AACzD;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,yBAAyB,EAAE,eAAe;AAC5C;AACA,eAAe,cAAc,CAAC,UAAU,CAAC,QAAQ,CAAC,UAAU,CAAC,WAAW,CAAC,WAAW,CAAC,cAAc,CAAC;AACpG,gBAAgB,kBAAkB,CAAC,QAAQ,CAAC,OAAO,EAAE,UAAU,CAAC,WAAW,CAAC,cAAc,CAAC,cAAc,CAAC;;;AAG1G,WAAW,WAAW,CAAC;AACvB,WAAW,aAAa,CAAC,cAAc,CAAC,kBAAkB,CAAC,WAAW,CAAC;AACvE;EACE,kBAAkB;AACpB;AACA,aAAa,mBAAmB,CAAC,6BAA6B,CAAC,oBAAoB,CAAC;AACpF,eAAe,gBAAgB,CAAC;AAChC,OAAO,iBAAiB,CAAC;AACzB;EACE,YAAY;EACZ,iBAAiB,EAAE,8BAA8B;EACjD,eAAe;EACf,0BAA0B,EAAE,mBAAmB;EAC/C,iBAAiB,EAAE,kCAAkC;AACvD;AACA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc,EAAE,+BAA+B;AACjD;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,wBAAwB,EAAE,cAAc;EACxC,0BAA0B,EAAE,gBAAgB;EAC5C,uBAAuB,EAAE,kBAAkB;EAC3C,2BAA2B,EAAE,qBAAqB;EAClD,kBAAkB,EAAE,2BAA2B;AACjD;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,yBAAyC;EAAzC,yCAAyC;EACzC,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAwB;EAAxB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,yBAAsC;EAAtC,sCAAsC;EACtC,YAAY;AACd;;AAEA,oDAAoD;AACpD;EACE;MACI,mBAAmB;MACnB,UAAU;MACV,yBAAsC;MAAtC,sCAAsC;EAC1C;EACA;MACI,qBAAqB;MACrB,YAAY;MACZ,yBAAwC;MAAxC,wCAAwC;EAC5C;EACA;MACI,mBAAmB;MACnB,UAAU;MACV,yBAAsC;MAAtC,sCAAsC;EAC1C;AACF;;AAEA;EACE,mDAAmD;EACnD,YAAY;EACZ,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,yBAAwC;EAAxC,wCAAwC;AAC1C;;AAEA,uDAAuD;AACvD,uDAAuD;AACvD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAsC;EAAtC,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAwC;EAAxC,wCAAwC;EACxC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,yBAAwC;EAAxC,wCAAwC;AAC1C;;AAEA,+DAA+D;AAC/D;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,WAAW,GAAG,wBAAwB;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa,EAAE,wDAAwD;AACzE;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,kDAAkD;AAClD;EACE,qBAAqB;EACrB,UAAU,GAAG,iBAAiB;EAC9B,WAAW,GAAG,iBAAiB;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,6CAA6C;AAC/C;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,yBAAyB,GAAG,QAAQ;AACtC;;AAEA;EACE,qBAAqB;EACrB,yBAAyB,GAAG,UAAU;AACxC;;AAEA;EACE,qBAAqB;EACrB,yBAAyB,GAAG,SAAS;AACvC;;AAEA,mCAAmC;AACnC;EACE;MACI,UAAU;EACd;EACA;MACI,UAAU;EACd;EACA;MACI,UAAU;EACd;AACF;AACA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,aAAa;EACb,6BAA6B,EAAE,4BAA4B;EAC3D,yBAAyB,EAAE,0CAA0C;AACvE;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW,EAAE,uBAAuB;EACpC,sBAAsB,EAAE,sCAAsC;EAC9D,sBAAsB,EAAE,wBAAwB;EAChD,0BAA0B,EAAE,wBAAwB;EACpD,kBAAkB,EAAE,uBAAuB;EAC3C,gEAAgE,EAAE,8CAA8C;AAClH;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB,EAAE,wCAAwC;EACnE,cAAc,EAAE,6BAA6B;AAC/C;;AAEA,sBAAsB;AACtB;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,YAAY,EAAE,8BAA8B;EAC5C,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA,mFAAmF;AACnF;EACE,aAAa;EACb,4CAA4C,EAAE,0BAA0B;AAC1E;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,mBAAmB,EAAE,+BAA+B;AACtD;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;;AAGA,2CAA2C;AAC3C;EACE;MACI,gBAAgB;EACpB;AACF;;AAEA,4CAA4C;AAC5C;EACE;MACI,gBAAgB,EAAE,6CAA6C;EACnE;AACF;AACA,gCAAgC;AAChC;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,WAAW;EACX,cAAc;AAChB;;;;AAIA,0CAA0C;AAC1C;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,2BAA2B,EAAE,uBAAuB;EACpD,0BAA0B;AAC5B;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;MACI,YAA6B;MAA7B,cAA6B;MAA7B,+BAA6B,EAAE,+BAA+B;EAClE;AACF;;AAEA;EACE;MACI,YAA0B;MAA1B,cAA0B;MAA1B,4BAA0B,EAAE,sBAAsB;EACtD;AACF;;AAEA;EACE;MACI,cAAc,EAAE,qBAAqB;MACrC,iBAAiB;MACjB,6BAA6B;EACjC;;EAEA;MACI,mBAAmB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,YAAY;EACZ,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,uBAAuB,GAAG,mBAAmB;EAC7C,mBAAmB;EACnB,gBAAgB,GAAG,wBAAwB;EAC3C,SAAS,GAAG,6BAA6B;EACzC,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB,GAAG,sBAAsB;EAClD,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB,GAAG,2BAA2B;AACzD;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,yBAAyB,EAAE,UAAU;EACrC,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,iBAAiB;;EAEjB,kBAAkB;AACpB;AACA;EACE;AACF;AACA;EACE,cAAc,EAAE,2BAA2B;AAC7C;;AAEA;EACE,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE,cAAc,EAAE,wBAAwB;AAC1C;;AAEA;EACE,cAAc,EAAE,2BAA2B;AAC7C;;AAEA;EACE,cAAc,EAAE,uBAAuB;AACzC;;AAEA;EACE,cAAc,EAAE,qBAAqB;AACvC;;AAEA;EACE,cAAc,EAAE,2BAA2B;AAC7C;;AAEA;EACE,cAAc,EAAE,uBAAuB;AACzC;;AAEA;EACE,cAAc,EAAE,0BAA0B;AAC5C;AACA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB,EAAE,oBAAoB;IACzC,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY,EAAE,eAAe;IAC7B,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,cAAc,EAAE,kBAAkB;EAClC,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,cAAc,EAAE,eAAe;EAC/B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,WAAW,EAAE,aAAa;EAC1B,kBAAkB,EAAE,6CAA6C;AACnE;;;AAGA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB,EAAE,6BAA6B;EACxD,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;AAChE;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,UAAU,EAAE,kCAAkC;EAC9C,0BAA0B,EAAE,cAAc;EAC1C,eAAe;EACf,yBAAyB;EACzB,eAAe,EAAE,iCAAiC;EAClD,gBAAgB;AAClB;AACA;EACE,YAAY,EAAE,iBAAiB;EAC/B,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB,EAAE,4BAA4B;AACpD;AACA;EACE,iBAAiB;AACnB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA0CG;;AAEH;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,UAAU;EACV,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,2BAA2B,EAAE,yCAAyC;AACxE;;AAEA,eAAe;AACf;;EAEE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;;EAIE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB,EAAE,iBAAiB;EAC5C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;EAClD,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB,EAAE,0BAA0B;EACrD,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;EAC7C,kBAAkB,EAAE,uCAAuC;AAC7D;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,yBAAyB,GAAG,2BAA2B;EACvD,kBAAkB;EAClB,kBAAkB;EAClB,4CAA4C,EAAE,wBAAwB;EACtE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB,EAAE,SAAS;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,wCAAwC;EACxC,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sCAAsC;IACtC,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,OAAO,aAAa,EAAE;IACtB,KAAK,QAAQ,EAAE;AACnB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,aAAa;AACjB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,YAAY,QAAQ,+BAA+B;IACnD,aAAa,OAAO,uBAAuB;IAC3C,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,gBAAgB,IAAI,sBAAsB;IAC1C,uCAAuC;AAC3C;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,qDAAqD;IACrD,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yCAAyC;IACzC,iCAAiC;IACjC,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,qDAAqD;IACrD,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,oCAAoC;IACpC,cAAc;IACd,gBAAgB;AACpB","sourcesContent":["body {\n  font-family: \"Public Sans\" !important;\n  background-color: #e4e4e4;\n}\n\n.login-button {\n  margin-block: 2rem;\n}\n\n@keyframes login-slide {\n  0% {\n    width: 0rem;\n  }\n\n  100% {\n    width: 27rem;\n  }\n}\n\n.login-form {\n  border-radius: 17px 0px 0px 17px;\n  width: 0;\n  position: fixed;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n  opacity: 0.9;\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n  animation: login-slide 0.8s forwards;\n}\n\n.login-textbox {\n  width: 20rem;\n  height:37px;\n  background-color: #fff;\n}\n\n.login-custom {\n  margin-inline: 3rem;\n}\n\n.login-bg {\n  background-image: url(\"../images/bg.svg\");\n  background-size: cover;\n  background-position: center;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  animation: opac 3s forwards;\n}\n\n.eye-icon {\n  position: absolute;\n  top: 54%;\n  transform: translateY(-50%);\n  right: 5rem;\n  cursor: pointer;\n}\n\n.primary-button {\n  background-color: #00C292;\n  border: 0px;\n  color: #ffff;\n  padding-block: 5.2px;\n  padding-inline: 1rem;\n  display: flex;\n  cursor: pointer;\n}\n\n.cus-main-header {\n  position: fixed !important;\n}\n\n.page-main-header .main-header-left .logo-wrapper img {\n  height: auto;\n}\n\n.page-wrapper .page-main-header {\n  height: 45px;\n}\n\n.page-main-header .main-header-left .logo-wrapper {\n  height: 62px;\n}\n\n.sidemenu {\n  position: absolute;\n  left: -5px;\n  z-index: 11;\n  top: 25px;\n  background: #e4e4e4;\n  padding: 5px 10px;\n  border-radius: 100%;\n}\n.anchor-down {\n  position: absolute;\n  content: \"\";\n  left: 50%;\n  bottom: -24px; /* Adjust this based on your layout */\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-top: 10px solid #fff; /* Color of the triangle */\n  transform: translateX(-50%);\n}\n.anchor-down1 {\n  position: absolute;\n  content: \"\";\n  left: 50%;\n  bottom: -38px;\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-top: 10px solid #fff;\n  transform: translateX(-50%);\n}\n.page-wrapper .page-body-wrapper .page-body {\n  min-height: calc(100vh - 80px);\n  margin-top: 40px;\n  padding-top: 40px;\n  padding-left: 45px;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar {\n  top: 40px;\n  position: absolute;\n}\n.bold-header{\n  font-weight: 700;\n  color:#000\n}\n.page-wrapper .page-body-wrapper .page-body {\n  background: #f7f7f7 !important;\n}\n.rm-br{\n  border-right: 0px !important;\n}\n.topmenu {\n  position: absolute;\n  top: 8px;\n  z-index: 8;\n  right: 35px;\n  background: #e4e4e4;\n  padding: 5px 5px 5px 5px;\n  border-radius: 100%;\n}\n\n.emptyli {\n  width: 45px;\n}\n\n.onhover-show-div {\n  top: 60px;\n}\n.custom-LR-btn{\n  min-width: 210px;\n}\n.topbar-close {\n  transform: translateY(-40px);\n  transition: 0.5s;\n}\n\n.movetp {\n  top: 37px;\n  transition: 0.5s;\n  border-radius: 0;\n  right: 42px;\n  background: #fff;\n}\n\n.pbdy {\n  margin-top: 0px !important;\n  transition: 0.5s;\n}\n\n.whgb {\n  background-color: #fff !important;\n  padding: 10px 10px;\n}\n\n.whbg-bg {\n  width: 57px;\n  position: absolute;\n  height: 57px;\n  border-radius: 15px;\n  left: -30px;\n  z-index: 11;\n  top: 15px;\n  background: #fff;\n  transform: rotate(45deg);\n}\n\n.map-legends.row.col-xl-12.col-lg-12 img {\n  height: 24px;\n  width: 24px;\n}\n\n#mapweather button.gm-ui-hover-effect {\n  display: none !important;\n}\n\n.weather-marker-tooltip {\n  padding: 9px;\n  color: #6e3c7e;\n}\n\n.weather-marker-tooltip .forecast-labels {\n  font-weight: bold;\n}\n\n.weather-marker-tooltip .forecast-date,\n.address,\n.weather-desc,\n.last-updated {\n  font-weight: 400;\n}\n\n#mapweather .gm-style .gm-style-iw-c {\n  position: absolute;\n  box-sizing: border-box;\n  overflow: hidden;\n  top: 0;\n  left: 0;\n  height: 13em !important;\n  transform: translate(-50%, -100%);\n  background-color: white;\n  border-radius: 0px !important;\n  padding: 12px;\n  box-shadow: 0 2px 7px 1px rgba(0, 0, 0, 0.3);\n}\n\n.bluebg {\n  background: #fff !important;\n  top: 60px;\n  left: -18px;\n  padding: 0;\n}\n\n.vline {\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 11;\n  background: #fff;\n  width: 4px;\n  height: 100%;\n}\n\n#inner {\n  -ms-transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n  -o-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  transform: rotate(45deg);\n  /*background-color: #e4e4e4;*/\n  background: transparent;\n  width: 75px;\n  height: 75px;\n  top: 50px;\n  left: 33px;\n  position: relative;\n  -moz-border-radius: 20px;\n  border-radius: 20px;\n}\n\n#outer {\n  width: 88px;\n  /* height: 115px; */\n  top: 10px;\n  left: 10px;\n  overflow: hidden;\n  border: 0px solid red;\n}\n\n#outer1 {\n  width: 125px;\n  height: 115px;\n  top: 10px;\n  left: 10px;\n  overflow: hidden;\n  border: 0px solid red;\n}\n\n#sinner {\n  -ms-transform: rotate(135deg);\n  -webkit-transform: rotate(135deg);\n  -o-transform: rotate(135deg);\n  -moz-transform: rotate(135deg);\n  transform: rotate(45deg);\n  background-color: #fff;\n  width: 75px;\n  height: 75px;\n  top: 23px;\n  left: 33px;\n  position: relative;\n  -moz-border-radius: 20px;\n  border-radius: 20px;\n  transition: 0.5s;\n}\n\n#souter {\n  width: 125px;\n  height: 115px;\n  top: 10px;\n  left: 10px;\n  overflow: hidden;\n  border: 0px solid red;\n}\n\n#ssinner {\n  width: 57px;\n  position: absolute;\n  height: 57px;\n  border-radius: 15px;\n  left: -20px;\n  z-index: 11;\n  top: 46px;\n  background: #e4e4e4;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n#ssinnerOpen {\n  width: 70px;\n  position: absolute;\n  height: 70px;\n  border-radius: 15px;\n  left: -30px;\n  z-index: 11;\n  top: 0px;\n  background: #e4e4e4;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.row.col-xl-12.col-lg-12.ml-0p.n-p-0.mt-20p.road-pick-up-grid {\n  margin-top: -1%;\n  padding-left: 68% !important;\n}\n\n.flitrblock {\n  width: 230px;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 12;\n  background: #fff;\n}\n\n.trucks-dropdown {\n  background: white;\n  /* height: 18em; */\n  width: 17em;\n  position: absolute;\n  overflow-y: scroll;\n  left: 32px;\n  z-index: 1000;\n  top: 36px;\n  border-radius: 5px;\n  border: 0.1px solid cornflowerblue;\n}\n\n.trucks-dropdown>ul>li {\n  padding: 10px;\n  padding-left: 13px;\n}\n\n.trucks-dropdown>ul>li:hover {\n  background: #e4e4e4;\n}\n\n.transporter-dropdown {\n  background: white;\n  height: 18em;\n  width: 22.3em;\n  position: absolute;\n  overflow-y: scroll;\n  left: 32px;\n  z-index: 1000;\n  top: 36px;\n  border-radius: 5px;\n  border: 0.1px solid cornflowerblue;\n}\n\n.transporter-dropdown>ul>li {\n  padding: 10px;\n  padding-left: 13px;\n}\n\n.transporter-dropdown>ul>li:hover {\n  background: #e4e4e4;\n}\n\n.cellStyleRed {\n  background: #ff90a3\n}\n\n.cellStyleGridHeader {\n  background: #FEFFC9 !important\n}\n\n.shwfilt {\n  display: none;\n}\n\n.brd {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 7px;\n  height: 100%;\n}\n\n.brd-gry {\n  background: #ccc;\n}\n\n.brd-gb {\n  background: #22aade;\n}\n\n.brd-gb1 {\n  background: #22debb;\n}\n\n.brd-gb2 {\n  background: #ded022;\n}\n\n.brd-gb3 {\n  background: #dead22;\n}\n\n.brd-gb4 {\n  background: #de7922;\n}\n\n.brd-txt1 {\n  background: #ab8ce4\n}\n\n.brd-txt2 {\n  background: #26c6da\n}\n\n.brd-txt3 {\n  background: #00c292\n}\n\n.brd-txt4 {\n  background: #4099ff\n}\n\n.brd-txt5 {\n  background: #ff7700\n}\n\n.fnt3 {\n  font-size: 3rem;\n}\n\n.stat-widget-dashboard .media img {\n  width: 50px;\n}\n\n.card-header {\n  padding: 10px !important;\n}\n\n.n-p-0 {\n  padding: 0 !important;\n}\n\n.f10 {\n  font-size: 10px;\n}\n\n.f13 {\n  font-size: 13px;\n}\n\n.f14 {\n  font-size: 14px;\n}\n\n.f15 {\n  font-size: 15px;\n}\n\n.card .card-header h5 {\n  text-transform: none !important;\n  font-size: 13px;\n}\n\n.cust-btn {\n  border-radius: 0px;\n  height: 38px;\n}\n\n.pb-0 {\n  padding-bottom: 0px !important;\n}\n\n.p-r0 {\n  padding-right: 0px;\n}\n\n.p-l0 {\n  padding-left: 0px;\n}\n\n.border-radius-0 {\n  border-radius: 0px;\n}\n\n.tmenus {\n  margin: 0 0 20px 0;\n  padding: 0\n}\n\n.tmenus li {\n  display: inline;\n  padding: 10px;\n}\n\n.tmenus li a {\n  text-decoration: none;\n  color: #333;\n  font-size: 14px;\n  padding: 10px;\n  background: #daebfd;\n}\n\n.tmenus li a:hover {\n  background: #e6ddf7;\n}\n\n.h-title {\n  font-size: 1.1rem;\n  margin-bottom: 30px;\n}\n\n.h-title span {\n  margin-top: 2px;\n  margin-left: 10px;\n}\n\n.cus-i {\n  font-size: 1.5rem;\n}\n\n.cs-btn {\n  padding: 0.375rem 0.75rem;\n  margin: 0px 10px 0 0px;\n}\n\n.white-bg {\n  background: #fff;\n  padding: 10px;\n}\n\n.form-control {\n  border: 1px solid #b5b5b5;\n  font-size: 0.8rem;\n  border-radius: 5px;\n}\n\nlabel.c-lbl {\n  margin-top: 5px;\n  font-size: 0.8rem;\n  display: flex;\n  align-items: center;\n}\n\n.cs-radio {\n  margin: 4px 5px 0 0;\n}\n\n.mt-5p {\n  margin-top: 5px;\n}\n\n.mt-8p {\n  margin-top: 8px;\n}\n\n.mt-9p {\n  margin-top: 9px;\n}\n\n.mt-10p {\n  margin-top: 10px;\n}\n\n.mt-15p {\n  margin-top: 15px;\n}\n\n.mt-20p {\n  margin-top: 20px;\n}\n\n.mt-21p {\n  margin-top: 21px;\n}\n\n.mt-22p {\n  margin-top: 22px;\n}\n\n.mt-23p {\n  margin-top: 23px;\n}\n\n.mt-24p {\n  margin-top: 24px;\n}\n\n.mt-25p {\n  margin-top: 25px;\n}\n\n.mt-26p {\n  margin-top: 26px;\n}\n\n.mt-27p {\n  margin-top: 27px;\n}\n\n.mt-28p {\n  margin-top: 28px;\n}\n\n.mt-29p {\n  margin-top: 29px;\n}\n\n.mt-30p {\n  margin-top: 30px;\n}\n\n.mt-35p {\n  margin-top: 35px;\n}\n\n.mt-40p {\n  margin-top: 40px;\n}\n\n.mt-50p {\n  margin-top: 50px;\n}\n\n.mt-60p {\n  margin-top: 60px;\n}\n\n.mt-70p {\n  margin-top: 70px;\n}\n\n.mt-80p {\n  margin-top: 80px;\n}\n\n\n.ml-0p {\n  margin-left: 0px;\n}\n\n.ml-5p {\n  margin-left: 5px;\n}\n\n.ml-8p {\n  margin-left: 8px;\n}\n\n.ml-10p {\n  margin-left: 10px;\n}\n\n.ml-15p {\n  margin-left: 15px;\n}\n\n.ml-18p {\n  margin-left: 18px;\n}\n\n.ml-20p {\n  margin-left: 20px;\n}\n\n.ml-30p {\n  margin-left: 30px;\n}\n\n.ml-40p {\n  margin-left: 40px;\n}\n\n.ml-50p {\n  margin-left: 50px;\n}\n\n.ml-60p {\n  margin-left: 60px;\n}\n\n.ml-70p {\n  margin-left: 70px;\n}\n\n.ml-80p {\n  margin-left: 80px;\n}\n\n\n.mr-5p {\n  margin-right: 5px !important;\n}\n\n.mr-8p {\n  margin-right: 8px !important;\n}\n\n.mr-10p {\n  margin-right: 10px !important;\n}\n\n.mr-20p {\n  margin-right: 20px !important;\n}\n\n.mr-30p {\n  margin-right: 30px !important;\n}\n\n.mr-40p {\n  margin-right: 40px !important;\n}\n\n.mr-50p {\n  margin-right: 50px !important;\n}\n\n.mr-60p {\n  margin-right: 60px !important;\n}\n\n.mr-70p {\n  margin-right: 70px !important;\n}\n\n.mr-80p {\n  margin-right: 80px !important;\n}\n\n.rd-text {\n  margin-right: 10px !important;\n}\n\n.mb-0p {\n  margin-bottom: 0px !important;\n}\n\n.mb-5p {\n  margin-bottom: 5px !important;\n}\n\n.mb-10p {\n  margin-bottom: 10px !important;\n}\n\n.mb-15p {\n  margin-bottom: 15px !important;\n}\n\n.mb-20p {\n  margin-bottom: 20px !important;\n}\n\n.mb-25p {\n  margin-bottom: 25px !important;\n}\n\n.mb-30p {\n  margin-bottom: 30px !important;\n}\n\n.mb-40p {\n  margin-bottom: 40px !important;\n}\n\n.mb-50p {\n  margin-bottom: 50px !important;\n}\n\n.mb-60p {\n  margin-bottom: 60px !important;\n}\n\n.mb-70p {\n  margin-bottom: 70px !important;\n}\n\n.pl-0px {\n  padding-left: 0px !important;\n}\n\n.pl-10px {\n  padding-left: 10px !important;\n}\n\n.pl-15px {\n  padding-left: 15px !important;\n}\n\n.pl-20px {\n  padding-left: 20px !important;\n}\n\n.pl-25px {\n  padding-left: 25px !important;\n}\n\n.pl-26px {\n  padding-left: 26px !important;\n}\n\n.pr-0px {\n  padding-right: 0px !important;\n}\n\n.pr-10px {\n  padding-right: 10px !important;\n}\n\n.pr-15px {\n  padding-right: 15px !important;\n}\n\n.pr-20px {\n  padding-right: 20px !important;\n}\n\n.pr-25px {\n  padding-right: 25px !important;\n}\n\n.pr-26px {\n  padding-right: 26px !important;\n}\n\n.pt-0px {\n  padding-top: 0px !important;\n}\n\n.pt-10px {\n  padding-top: 10px !important;\n}\n\n.pt-15px {\n  padding-top: 15px !important;\n}\n\n.pt-20px {\n  padding-top: 20px !important;\n}\n\n.pt-25px {\n  padding-top: 25px !important;\n}\n\n.pt-26px {\n  padding-top: 26px !important;\n}\n\n.pb-0px {\n  padding-bottom: 0px !important;\n}\n\n.pb-5px {\n  padding-bottom: 5px !important;\n}\n\n.pb-10px {\n  padding-bottom: 10px !important;\n}\n\n.p-0px {\n  padding: 0px !important;\n}\n\n.p-2px {\n  padding: 2px !important;\n}\n\n.p-4px {\n  padding: 4px !important;\n}\n\n.p-5px {\n  padding: 5px !important;\n}\n\n.p-6px {\n  padding: 6px !important;\n}\n\n.p-7px {\n  padding: 7px !important;\n}\n\n.p-8px {\n  padding: 8px !important;\n}\n\n.p-9px {\n  padding: 9px !important;\n}\n\n.p-10px {\n  padding: 10px !important;\n}\n\n.p-11px {\n  padding: 11px !important;\n}\n\n.p-12px {\n  padding: 12px !important;\n}\n\n.p-13px {\n  padding: 13px !important;\n}\n\n.p-14px {\n  padding: 14px !important;\n}\n\n.p-15px {\n  padding: 15px !important;\n}\n\n.p-16px {\n  padding: 16px !important;\n}\n\n.p-17px {\n  padding: 17px !important;\n}\n\n.p-18px {\n  padding: 18px !important;\n}\n\n.p-19px {\n  padding: 19px !important;\n}\n\n.p-20px {\n  padding: 20px !important;\n}\n\n.p-21px {\n  padding: 21px !important;\n}\n\n.p-22px {\n  padding: 22px !important;\n}\n\n.p-23px {\n  padding: 23px !important;\n}\n\n.p-24px {\n  padding: 24px !important;\n}\n\n.p-25px {\n  padding: 25px !important;\n}\n\n.p-26px {\n  padding: 26px !important;\n}\n\n.p-271px {\n  padding: 27px !important;\n}\n\n.p-28px {\n  padding: 28px !important;\n}\n\n.p-29px {\n  padding: 29px !important;\n}\n\n.p-30px {\n  padding: 30px !important;\n}\n\n.btn {\n  border-radius: 0px;\n}\n\n#map_canvas {\n  box-shadow: 0px 0px 10px #ccc;\n  border: 1px solid #ccc;\n  margin-left: 20px;\n}\n\n.custom-btn {\n  padding: 3px 5px;\n  background: transparent;\n  color: #333;\n  border: 0px;\n}\n\n.icolor-green {\n  color: #00c292\n}\n\n.icolor-red {\n  color: #FF5722\n}\n\n.ag-theme-balham .ag-menu {\n  transition: all 3s fade-in !important;\n}\n\n.show-m {\n  display: block;\n}\n\n.show-n {\n  display: none;\n}\n\n.tp40 {\n  top: 40px !important;\n}\n\n.tp0 {\n  top: 0px !important;\n}\n\n.tp10 {\n  top: 10px !important;\n}\n\n.r42 {\n  right: 42px !important;\n}\n\n.l20n {\n  left: -20px !important;\n}\n\n.beffect {\n  opacity: 0;\n  animation-name: bounceIn;\n  animation-duration: 450ms;\n  animation-timing-function: linear;\n  animation-fill-mode: forwards;\n}\n\n.beffect:nth-child(2) {\n  animation-delay: 0.3s;\n}\n\n.beffect:nth-child(3) {\n  animation-delay: 0.6s;\n}\n\n.beffect:nth-child(4) {\n  animation-delay: 0.9s;\n}\n\n@keyframes bounceIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.3) translate3d(0, 0, 0);\n  }\n\n  50% {\n    opacity: 0.9;\n    transform: scale(1.1);\n  }\n\n  80% {\n    opacity: 1;\n    transform: scale(0.89);\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1) translate3d(0, 0, 0);\n  }\n}\n\n.beffectFade {\n  opacity: 0;\n  animation: fadein 0.1s;\n  -moz-animation: fadein 0.1s;\n  /* Firefox */\n  -webkit-animation: fadein 0.1s;\n  /* Safari and Chrome */\n  -o-animation: fadein 0.1s;\n  /* Opera */\n}\n\n@keyframes fadein {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@-moz-keyframes fadein {\n\n  /* Firefox */\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes fadein {\n\n  /* Safari and Chrome */\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@-o-keyframes fadein {\n\n  /* Opera */\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.slide-r {\n  position: fixed;\n  right: 0px;\n  top: 0;\n  background: #fff;\n  width: 0;\n  overflow-y: auto;\n  height: 100%;\n  z-index: 11;\n  box-shadow: 0.5rem 0.5rem 2rem rgba(0, 0, 0, 0.2);\n  transition: 0.5s;\n  -webkit-transform: translateX(100%);\n  transform: translateX(100%);\n}\n\n.slide1-r {\n  position: absolute;\n  right: -15px;\n  top: -38px;\n  background: #fff;\n  width: 0;\n  overflow-y: auto;\n  height: 150%;\n  z-index: 10;\n  box-shadow: 0.5rem 0.5rem 2rem 1rem rgba(0, 0, 0, 0.2);\n  transition: 0.5s;\n  -webkit-transform: translateX(100%);\n  transform: translateX(100%);\n}\n\n.custom {\n  width: 30%;\n  transform: translateX(0%);\n}\n\n.slider-translate {\n  width: 25%;\n  transform: translateX(0%);\n}\n\n.slider-translate-30p {\n  width: 34%;\n  transform: translateX(0%);\n}\n.slider-translate-35p {\n  width: 35%;\n  transform: translateX(0%);\n}\n.slider-translate-40p {\n  width: 40%;\n  transform: translateX(0%);\n}\n\n.slider-translate-50p {\n  width: 50%;\n  transform: translateX(0%);\n}\n\n.slider-translate-60p {\n  width: 60%;\n  transform: translateX(0%);\n}\n\n.slider-translate-65p {\n  width: 65%;\n  transform: translateX(0%);\n}\n\n.slider-translate-75p {\n  width: 75%;\n  transform: translateX(0%);\n}\n\n.slider-translate-84p {\n  width: 84%;\n  transform: translateX(0%);\n}\n\n.slider-translate-90p {\n  width: 90%;\n  transform: translateX(0%);\n}\n\n.slider-translate-95p {\n  width: 95%;\n  transform: translateX(0%);\n}\n\n.slider-translate-98p {\n  width: 98%;\n  transform: translateX(0%);\n}\n\n.slider-translate-100p {\n  width: 100%;\n  transform: translateX(0%);\n}\n.slider-header{\n  background: blue;\n  color: #fff;\n  /* padding: 1px 15px; */\n  font-size: 16px;\n  margin: 0;\n}\n.slider-header button{padding:0px 8px !important;color:#fff;}\n.slide-r-title {\n  font-size: 14px;\n  color: #fff;\n  border-bottom: 1px solid #ccc;\n  position: relative;\n\n}\nh4.slide-r-title {\n  font-size: 16px;\n  position: relative;\n  text-align: center;\n  background: #21759D;\n  padding: 8px 5px;\n  margin: 0;\n}\n\n.slider-translate-101p{\n  width:101%;\n  transform: translateX(0%);\n  box-shadow:0.5rem 0.5rem 2rem 1rem rgba(0, 0, 0, 0.2);\n}\n\n.slide-r-body {\n  font-size: 14px;\n  padding: 10px;\n}\n\n.fslide-r {\n  position: absolute;\n  right: 1.8%;\n  top: 7.6%;\n  background: #fff;\n  width: 0px;\n  overflow: hidden;\n  height: 80.3%;\n  z-index: 10;\n  border: 1px solid #ccc;\n  transition: 0.5s;\n  -webkit-transform: translateX(100%);\n  transform: translateX(100%);\n}\n\n.fslider-translate-40p {\n  width: 40%;\n  transform: translateX(0%);\n}\n\n.fslide-r-title {\n  font-size: 14px;\n  color: #333;\n  border-bottom: 1px solid #ccc;\n  position: relative;\n\n}\n\n.fslide-r-title h4 {\n  font-size: 14px;\n  position: relative;\n  text-align: left;\n  background: #e9f5fa;\n  padding: 5px 10px;\n  margin: 0;\n}\n\n.fslide-r-body {\n  font-size: 14px;\n  padding: 10px;\n}\n\n.fclose {\n  padding: 5px 8px;\n  border: 1px solid #ccc;\n  margin-top: -6px;\n  margin-right: -12px;\n  cursor: pointer;\n}\n\n.posrel {\n  position: relative;\n}\n\n.fcslide-r {\n  position: absolute;\n  right: 0;\n  top: 0%;\n  width: 0px;\n  overflow: hidden;\n  background: #fff;\n  height: 100%;\n  z-index: 10;\n  border-left: 1px solid #ccc;\n  border-top: 1px solid #eee;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  box-shadow: -1px 0px 16px #ccc;\n  -webkit-transform: translateX(100%);\n  transform: translateX(100%);\n}\n\n.fcslide-translate-25p {\n  width: 25%;\n  transform: translateX(0%);\n}\n\n.fcslide-translate-40p {\n  width: 40%;\n  transform: translateX(0%);\n}\n\n.fcslide-r-title {\n  font-size: 14px;\n  color: #333;\n  border-bottom: 1px solid #ccc;\n  position: relative;\n\n}\n\n.fcslide-r-title h4 {\n  font-size: 14px;\n  position: relative;\n  text-align: left;\n  background: #e9f5fa;\n  padding: 5px 10px;\n  margin: 0;\n}\n\n.fcslide-r-body {\n  font-size: 14px;\n  padding: 10px;\n}\n\n\n\n@-webkit-keyframes slide {\n  100% {\n    right: 0;\n  }\n}\n\n@keyframes slide {\n  100% {\n    right: 0;\n  }\n}\n\n.c-btn {\n  background: #e44343 !important;\n  border: 0px !important;\n  color: #fff;\n  cursor: pointer;\n  font-size: 14px;\n  position: absolute;\n  right: 0;\n  top: 0px;\n  width: auto;\n  text-align: center;\n  height: 35px;\n}\n\n.dataLoad {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #fff;\n  z-index: 10;\n}\n\n.dataLoad img {\n  position: absolute;\n  top: 50%;\n  left: 40%;\n  z-index: 99999;\n}\n\n.dataLoadpage {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #fff;\n  z-index: 10;\n  opacity: 0.5;\n}\n\n.dataLoadpageimg {\n  position: absolute;\n  top: 40%;\n  left: 45%;\n  z-index: 99999;\n}\n\n.sweet-alert h2 {\n  font-size: 14px !important;\n  line-height: 25px;\n}\n\n.accordion__button {\n  padding: 10px 10px;\n  background: #0b9ce1;\n  color: #fff;\n  margin-bottom: 5px;\n}\n\n.grid-h5 {\n  width: 75%;\n}\n\n.actions-list {\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  right: 5px;\n  top: 10px;\n}\n\n.actions-list li {\n  display: inline;\n}\n\n.actions-list li a {\n  color: #6e6d6d;\n  padding: 0px 5px;\n  width: 24px;\n  height: 24px;\n  border: 0px solid #ccc;\n  margin: 1px;\n}\n\n.grid-mx:hover {\n  color: #333\n}\n\n.ly {\n  font-size: 31px;\n  margin-right: 4%;\n  background: #fff;\n  padding: 0px 2px;\n  cursor: pointer;\n  line-height: 1;\n  color: #4ac292;\n}\n\n.viewport-r {\n  position: fixed;\n  right: -15px;\n  top: 0;\n  background: #fff;\n  width: 0;\n  height: 100%;\n  overflow-y: auto;\n  z-index: 10;\n  box-shadow: 0.5rem 0.5rem 2rem 1rem rgba(0, 0, 0, 0.2);\n  transition: 0.5s;\n  transform: translateX(100%);\n}\n\n.viewport-r h4 {\n  font-size: 16px;\n  position: relative;\n  text-align: center;\n  background: #21759d;\n  padding: 8px 5px;\n  margin: 0;\n  color: #fff;\n}\n\n.vwTranslate {\n  width: 30%;\n  transform: translateX(0%);\n}\n\n.inner-srcn {\n  max-height: 600px;\n  overflow: auto;\n}\n\n.f10 {\n  font-size: 10px !important;\n}\n\n.f11 {\n  font-size: 11px !important;\n}\n\n.f12 {\n  font-size: 12px !important;\n}\n\n.f13 {\n  font-size: 13px !important;\n}\n\n.f14 {\n  font-size: 14px !important;\n}\n\n.f15 {\n  font-size: 15px !important;\n}\n\n.f16 {\n  font-size: 16px !important;\n}\n\n.f17 {\n  font-size: 17px !important;\n}\n\n.f18 {\n  font-size: 18px !important;\n}\n\n.f19 {\n  font-size: 19px !important;\n}\n\n.f20 {\n  font-size: 20px !important;\n}\n\n.f21 {\n  font-size: 21px !important;\n}\n\n.f22 {\n  font-size: 22px !important;\n}\n\n.f24 {\n  font-size: 24px !important;\n}\n\n.f25 {\n  font-size: 25px !important;\n}\n\n.f26 {\n  font-size: 26px !important;\n}\n\n.f27 {\n  font-size: 27px !important;\n}\n\n.f28 {\n  font-size: 28px !important;\n}\n\n.f29 {\n  font-size: 29px !important;\n}\n\n.f30 {\n  font-size: 30px !important;\n}\n\n.f31 {\n  font-size: 31px !important;\n}\n\n.f32 {\n  font-size: 32px !important;\n}\n\n.f33 {\n  font-size: 33px !important;\n}\n\n.f34 {\n  font-size: 34px !important;\n}\n\n.f35 {\n  font-size: 35px !important;\n}\n\n.f36 {\n  font-size: 36px !important;\n}\n\n.f37 {\n  font-size: 37px !important;\n}\n\n.f38 {\n  font-size: 38px !important;\n}\n\n.f39 {\n  font-size: 39px !important;\n}\n\n.f40 {\n  font-size: 40px !important;\n}\n\n.f41 {\n  font-size: 41px !important;\n}\n\n.f42 {\n  font-size: 42px !important;\n}\n\n.f43 {\n  font-size: 43px !important;\n}\n\n.f44 {\n  font-size: 44px !important;\n}\n\n.f45 {\n  font-size: 45px !important;\n}\n\n.f46 {\n  font-size: 46px !important;\n}\n\n.f47 {\n  font-size: 47px !important;\n}\n\n.f48 {\n  font-size: 48px !important;\n}\n\n.f49 {\n  font-size: 49px !important;\n}\n\n.f50 {\n  font-size: 50px !important;\n}\n\n.react-autosuggest__container {\n  position: relative;\n}\n\n.react-autosuggest__input {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0;\n  -webkit-transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.react-autosuggest__input--focused {\n  outline: none;\n}\n\n.react-autosuggest__input--open {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.react-autosuggest__suggestions-container {\n  display: none;\n}\n\n.react-autosuggest__suggestions-container--open {\n  display: block;\n  position: absolute;\n  top: 40px;\n  width: 100%;\n  border: 1px solid #d2d1d1;\n  background-color: #fff;\n  font-family: Helvetica, sans-serif;\n  font-weight: 300;\n  font-size: 16px;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  max-height: 100px;\n  overflow-y: auto;\n  z-index: 2;\n}\n\n.react-autosuggest__suggestions-list {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\n\n.react-autosuggest__suggestion {\n  cursor: pointer;\n  padding: 8px 15px;\n  font-size: 12px;\n  ;\n}\n\n.react-autosuggest__suggestion--highlighted {\n  background-color: #ddd;\n}\n\n.tree li {\n  list-style-type: none;\n  margin: 0;\n  padding: 10px 5px 0 5px;\n  position: relative\n}\n\n.tree li::before,\n.tree li::after {\n  content: '';\n  left: 20px;\n  position: absolute;\n  right: auto\n}\n\n.tree li::before {\n  border-left: 2px solid #000;\n  bottom: 50px;\n  height: 100%;\n  top: 0;\n  width: 1px\n}\n\n.tree li::after {\n  border-top: 2px solid #000;\n  height: 20px;\n  top: 25px;\n  width: 25px\n}\n\n.tree li span {\n  -moz-border-radius: 5px;\n  -webkit-border-radius: 5px;\n  color: #333;\n  border: 1px solid #000;\n  border-radius: 3px;\n  display: inline-block;\n  padding: 3px 8px;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.tree li span a {\n  color: #333;\n}\n\n.tree>ul>li::before,\n.tree>ul>li::after {\n  border: 0\n}\n\n.tree li:last-child::before {\n  height: 27px\n}\n\n.tree li span:hover {\n  background: rgb(6, 194, 138);\n  border: 1px solid #94a0b4;\n  color: #333;\n}\n\n.tree li span:hover a {\n  color: #333;\n}\n\n.tree li ul li {\n  padding: 10px 5px 0 45px\n}\n\n[aria-expanded=\"false\"]>.expanded,\n[aria-expanded=\"true\"]>.collapsed {\n  display: none;\n}\n\n.tree li span.active {\n  background: rgb(6, 194, 138);\n  border: 1px solid #94a0b4;\n  color: #333;\n}\n\n.sidediv {\n  max-height: 500px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.closebtn {\n  cursor: pointer;\n  background: rgba(0, 0, 0, 0.5);\n  padding: 5px 9px;\n  margin-top: -5px;\n  border-radius: 100%;\n}\n\n.vertical-timeline::before {\n  background: #e3dbdb !important;\n}\n\n.vertical-timeline--two-columns .vertical-timeline-element-icon {\n  width: 25px !important;\n  height: 25px !important;\n  left: 53% !important;\n  margin-left: -28px !important;\n  top: 9% !important;\n}\n\n.vertical-timeline-element-icon {\n  box-shadow: 0 0 0 4px #d7d7d7, inset 0 2px 0 rgba(0, 0, 0, .08), 0 3px 0 4px rgba(0, 0, 0, .05) !important;\n\n}\n\n.vertical-timeline-element-title {\n  font-size: 15px !important;\n}\n\n.vertical-timeline-element-content p {\n  font-size: 0.8rem !important;\n}\n\n.vertical-timeline--two-columns .vertical-timeline-element-content .vertical-timeline-element-date {\n  color: #333 !important;\n}\n\n.vertical-timeline-element-subtitle {\n  font-size: 16px !important;\n  margin-bottom: 10px !important;\n}\n\n.vertical-timeline--two-columns .vertical-timeline-element-content .vertical-timeline-element-date {\n  color: #333;\n}\n\n.mb30np {\n  margin-bottom: -30px;\n}\n\n.fc-input {\n  border: 1px solid #BDC3C7;\n  font-size: 12px !important;\n  color: #333 !important;\n  padding: 5px 10px;\n}\n\n.highlitRow {\n  background: #f1cdcd !important;\n}\n\n.whiteRow {\n  background: #ffffff;\n}\n\n.tbmap {\n  font-size: 15px;\n  font-weight: 400;\n}\n\n.tdmapsp {\n  color: #4c7eb7;\n  font-size: 13px;\n  font-weight: 500;\n}\n\ntd.custb {\n  padding: 6px 5px !important;\n  background-image: linear-gradient(#efefef, #ffffff);\n}\n\n.maptitle {\n  color: #ff1212;\n  margin-bottom: 0px;\n  font-size: 17px;\n}\n\n.gm-style-iw .gm-style-iw-c {\n  box-shadow: rgb(51, 51, 51) 0px 5px 15px !important;\n  height: 13em !important;\n}\n\n.popup-bubble {\n  /* Position the bubble centred-above its parent. */\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: translate(-50%, -100%);\n  /* Style the bubble. */\n  background-color: white;\n  padding: 5px;\n  border-radius: 5px;\n  font-family: sans-serif;\n  overflow-y: auto;\n  max-height: 60px;\n  box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.5);\n}\n\n/* The parent of the bubble. A zero-height div at the top of the tip. */\n.popup-bubble-anchor {\n  /* Position the div a fixed distance above the tip. */\n  position: absolute;\n  width: 100%;\n  bottom:\n    /* TIP_HEIGHT= */\n    8px;\n  left: 0;\n}\n\n/* This element draws the tip. */\n.popup-bubble-anchor::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  /* Center the tip horizontally. */\n  transform: translate(-50%, 0);\n  /* The tip is a https://css-tricks.com/snippets/css/css-triangle/ */\n  width: 0;\n  height: 0;\n  /* The tip is 8px high, and 12px wide. */\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top:\n    /* TIP_HEIGHT= */\n    8px solid white;\n}\n\n/* JavaScript will position this div at the bottom of the popup tip. */\n.popup-container {\n  cursor: auto;\n  height: 0;\n  position: absolute;\n  /* The max width of the info window. */\n  width: 200px;\n}\n\n.forecast-warning {\n  position: absolute;\n  top: 317px;\n  left: 19em;\n  display: none;\n}\n\n.rselect {\n  border-radius: 0px;\n  margin-bottom: 20px;\n}\n\n.mapico {\n  width: 32px;\n  height: 32px;\n  margin-top: -5px;\n  margin-right: 5px;\n}\n\n.mapico1 {\n  width: 24px;\n  height: 24px;\n  margin-right: 5px;\n}\n\n.mapico2 {\n  width: 42px;\n  height: 42px;\n  margin-top: -8px;\n  margin-right: 5px;\n}\n\n.cellstylegrid {\n  background: rgb(241, 251, 255);\n  color: #333;\n}\n\n.cellstylegridB {\n  background: #fff0ef;\n  color: #333\n}\n\n.cellTopHeader {\n  font-size: 25px;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n}\n\n.cellTopHeaderTemplate {\n  font-size: 16px;\n  text-transform: uppercase;\n  vertical-align: middle;\n  padding: 20px 10px !important;\n}\n\n.cellTopHeaderTemplateH {\n  font-size: 14px;\n  text-transform: uppercase;\n  vertical-align: middle;\n  padding: 20px 10px !important;\n}\n\n.cellTopHeaderTemplate16 {\n  padding-top: 10px;\n  font-family: Arial, Helvetica, sans-serif;\n  vertical-align: middle;\n  font-size: 16px;\n  text-align: center !important;\n  font-weight: 400;\n  justify-content: center;\n}\n\n.cellTopHeaderTemplate14 {\n  font-family: Arial, Helvetica, sans-serif;\n  vertical-align: middle;\n  font-weight: bold;\n  text-align: center !important;\n}\n\n.cellTopHeaderTemplatenb {\n  font-family: Arial, Helvetica, sans-serif;\n  vertical-align: middle;\n  font-size: 14px;\n  text-align: center !important;\n}\n\n.green {\n  background: #bfffc1 !important;\n}\n\n.red {\n  background: #ff0000;\n  color: #ffffff;\n}\n\n.redclr {\n  background: #f9bebe;\n  color: #ffffff;\n}\n\n.yellow {\n  background: #f1ffb4 !important;\n}\n\n.lightred {\n  background: #ffa2a2;\n  color: #333;\n}\n\n.defaultclr {\n  color: #000\n}\n\n.cellstylegridG {\n  background: #ffe4bb;\n  color: #333;\n  border-bottom: \"2px solid black\";\n}\n\n.cellstylegridG2 {\n  background: #FEF0DA;\n  color: #333\n}\n\n.cellstylegridGBg {\n  background: #29c21b;\n  color: #333\n}\n\n.cellstylegridTPFM {\n  background: rgb(191, 195, 237);\n  color: #333\n}\n\n.cellstylegridTPSMG {\n  background: rgb(196, 240, 207);\n  color: #333\n}\n\n.cellstylegridTPBNG {\n  background: rgb(244, 196, 196);\n  color: #333\n}\n\n.cellstylegridY {\n  background: rgb(255, 251, 216);\n  color: #333\n}\n\n.cellstylegridDY {\n  background: rgb(255, 244, 147) !important;\n  color: #333\n}\n\n.cellstylegridM {\n  background: rgb(255, 225, 225);\n  color: #333\n}\n\n.cellstylegridSk {\n  background: rgb(195, 253, 255);\n  color: #333\n}\n\n.subtotalrow {\n  background: skyblue !important;\n  /* font-size: 16px !important; */\n}\n\n.subtotalrow .cellstylegridB,\n.subtotalrow .cellstylegridG {\n  background: skyblue !important;\n}\n\n.cellstylegridW {\n  background: rgb(255, 255, 255);\n  color: #333\n}\n\n.cellstylegridR {\n  background: #ff0000;\n  color: #FFF\n}\n\n.mobile-search {\n  outline: none;\n  position: absolute;\n  right: 0;\n  background: #fff;\n  border-right: 0px solid #ddd;\n  border-top: 0px solid #ddd;\n  border-bottom: 1px solid #ddd;\n  border-left: 0px solid #ddd;\n  height: 31px;\n  border-radius: 3px;\n}\n\n@media print {\n  .searchConsSegRoute {\n    display: none;\n  }\n\n  .col-xl-4 {\n    font-size: 10px !important;\n  }\n\n  .consignment-info .row {\n    float: left;\n    width: 30%\n  }\n\n  .slide-r-title {\n    display: none;\n  }\n\n  .table {\n    margin: 30px;\n    float: left;\n    width: 50%;\n  }\n\n  #mygrid {\n    display: none;\n  }\n\n  #mapweather {\n    width: 50%\n  }\n}\n\n.mobile-search:focus {\n  outline: none;\n}\n\n.form-control-plaintext:focus {\n  outline: none;\n}\n\n.search-form input {\n  font-size: 14px !important\n}\n\n.MuiAutocomplete-popper {\n  max-height: 300px !important;\n  overflow-y: auto !important;\n}\n\n.MuiTypography-root {\n  max-height: 300px !important;\n  overflow-y: auto !important;\n}\n\n.redfont {\n  color: #ff0000;\n}\n\n.grayfont {\n  color: #ccc;\n}\n\n.greenfont {\n  color: rgb(10, 153, 34);\n}\n\n.yellowfont {\n  color: rgba(255, 200, 0, 1);\n}\n\n.bluefont {\n  color: rgb(57, 113, 235);\n}\n\n.darkgrayfont {\n  color: #333;\n}\n\n.drpselect {\n  width: 300px;\n}\n\n.gm-style-iw {\n  padding: 0px !important;\n  /* border-radius: 50px !important;\n      border-bottom-right-radius: 50px !important;*/\n  z-index: 9;\n  box-shadow: 10px 0px 45px 0px #333 !important;\n\n}\n\n.subH {\n  background: rgb(3, 145, 79);\n  font-size: 18px;\n  color: #fff;\n  padding: 5px\n}\n\n.g-header {\n  background: #4d4d4d;\n  color: #ffffff;\n  font-size: 16px;\n  padding: 5px;\n}\n\n.gm-style-iw-chr {\n  position: absolute;\n  right: 0px;\n  z-index: 2;\n}\n\n.gm-ui-hover-effect>span {\n  width: 18px !important;\n  height: 19px !important;\n  margin: 0 !important;\n}\n\n.gm-ui-hover-effect img {\n  filter: invert(150%) !important;\n}\n\n.c-google {\n  margin-bottom: 10px;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.fw400 {\n  font-weight: 400 !important;\n}\n\n.c-google-img {\n  width: 24px;\n  height: 24px;\n  border-radius: 100%;\n  padding: 3px;\n  background: #ffffff;\n}\n\n.route-block {\n  margin-bottom: 15px;\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 10px;\n}\n\n.sidebar-label {\n  font-weight: 600;\n}\n\n.overlay {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 7;\n  background: #fff;\n  opacity: 0.5;\n}\n\n.overlay-part {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 7;\n  background: #fff;\n  opacity: 0.5;\n}\n\n.ul-tabs {\n  padding: 5px 0 0 0;\n  margin: 0;\n  background-image: linear-gradient(rgb(223, 223, 223), rgb(245, 245, 245), rgb(223, 223, 223));\n}\n\n.ul-tabs li {\n  display: inline;\n  padding: 8px 0px;\n}\n\n.ul-tabs li a {\n  padding: 10px 10px;\n  color: #333;\n  text-decoration: none;\n  line-height: 30px;\n  border-right: 1px solid #aaa;\n  background-image: linear-gradient(rgb(223, 223, 223), rgb(245, 245, 245), rgb(223, 223, 223));\n}\n\n.ul-tabs li:last-child a {\n  border-right: 0px;\n}\n\n.cpointer {\n  cursor: pointer;\n}\n\n.ul-tabs li a.active {\n  background-image: linear-gradient(rgb(61, 180, 130), rgb(245, 245, 245), rgb(61, 180, 130));\n}\n\n.d-none {\n  display: none;\n}\n\n.fnt2 {\n  font-size: 2rem;\n}\n\n.fnt1 {\n  font-size: 1rem;\n}\n\n.boxbgblue {\n  background-color: #d5e9f0 !important;\n}\n\n.boxbgblue2 {\n  background-color: #efefef !important;\n}\n\n.boxbgblue3 {\n  background-color: #d5daf0 !important;\n}\n\n.boxbgblue4 {\n  background-color: #ece2b1 !important;\n}\n\n.boxbgblue5 {\n  background-color: #ebcaab !important;\n}\n\n.bgColorDangerLight {\n  background-color: #ffb9c5 !important;\n}\n\n.bgColorAshLight {\n  background-color: #e0dddd !important;\n}\n\n.bgColorDangerMedium {\n  background-color: #ff90a3 !important;\n}\n\n.bgColorDangerDark {\n  background-color: #ff7289 !important;\n}\n\n.bgColorSuccessLight {\n  background-color: #00f0b5 !important;\n}\n\n.bgColorSuccessMedium {\n  background-color: #00dea7 !important;\n}\n\n.bgColorSuccessDark {\n  background-color: #00d09c !important;\n}\n\n.colorWhite {\n  color: #ffffff !important;\n  padding-left: 5px\n}\n\n.colorForDangerLight {\n  background-color: #a5d1ef !important;\n  font-weight: bold;\n}\n\n.colorForDangerMedium {\n  background-color: #ff90a3 !important;\n}\n\n.colorForDangerDark {\n  background-color: #ff7289 !important;\n}\n\n.txt-black {\n  color: #000000\n}\n\n.txt-success-light {\n  color: #00f0b5\n}\n\n.txt-success-medium {\n  color: #00dea7\n}\n\n.txt-success-dark {\n  color: #00d09c\n}\n\n.txt-primary-light {\n  color: #d8caf3\n}\n\n.txt-primary-medium {\n  color: #c6b1ed\n}\n\n.txt-primary-dark {\n  color: #b99fe8\n}\n\n.txt-secondary-light {\n  color: #a9e8f0\n}\n\n.txt-secondary-medium {\n  color: #67d7ef\n}\n\n.txt-secondary-dark {\n  color: #4dd0e1\n}\n\n.txt-info-light {\n  color: #c0ddff\n}\n\n.txt-info-medium {\n  color: #8dc2ff\n}\n\n.txt-info-dark {\n  color: #66adff\n}\n\n.txt-warning-light {\n  color: #fff28d\n}\n\n.txt-warning-medium {\n  color: #ffec50\n}\n\n.txt-warning-dark {\n  color: #ffe622\n}\n\n.txt-grey-light {\n  color: #bebebe\n}\n\n.txt-grey-medium {\n  color: #9f9f9f\n}\n\n.txt-grey-dark {\n  color: #888888\n}\n\n.txt-pink-light {\n  color: #f69ebd\n}\n\n.txt-pink-medium {\n  color: #f16696\n}\n\n.txt-pink-dark {\n  color: #ed3c7a\n}\n\n.txt-danger-light {\n  color: #ffb9c5\n}\n\n.txt-danger-medium {\n  color: #ff90a3\n}\n\n.txt-danger-dark {\n  color: #ff7289 !important\n}\n\n.font-color-yellow {\n  color: #ff7700 !important;\n}\n\n#consignment-overdue-component {\n  padding: 17px;\n}\n\n.nav-tabs .nav-link {\n  color: #333;\n}\n\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  font-weight: 700;\n}\n\n.ainfo {\n  color: #4099ff !important;\n}\n\n.binfo {\n  color: #00c292 !important;\n}\n\n.cinfo {\n  color: #f7516f !important;\n}\n\n.dinfo {\n  color: #26c6da !important;\n}\n\n.tabpad {\n  padding: 10px;\n  background: #e4e4e4;\n  border-left: 1px solid #dee2e6;\n  border-right: 1px solid #dee2e6;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.tabhigh {\n  background: #e4e4e4 !important;\n  border-color: #e4e4e4 !important;\n  border: 1px solid #e4e4e4 !important;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu {\n  padding: 40px 15px !important;\n}\n\n.darkorange {\n  color: #d3a337 !important;\n}\n\n.darkblue {\n  color: #3300c2 !important;\n}\n\n.mildgreen {\n  color: #7ad337 !important;\n}\n\n.cursorPointer {\n  cursor: pointer;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar {\n  position: fixed !important;\n  height: 100% !important;\n  width: 290px !important;\n  top: 0px !important;\n}\n.cstm-und{\n  color:#dc3545 !important;\n}\n.cst-dsbled{\n  color:#adb5bd !important;\n}\n.cst-delivered{\n  color: #17a2b8 !important;\n}\n.cst-ontime{\n  color:#60EF48D9 !important;\n  /* color:#20c997 !important */\n\n}\n.cst-delayed{\n  color:#ff1a40 !important;\n}\n.cst-pending{\n  color:#ffc107 !important;\n}\n.page-main-header .main-header-left {\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: auto;\n  padding: 0px;\n  height: 40px;\n}\n\n.page-main-header .main-header-left .logo-wrapper {\n  height: 40px;\n}\n\n.page-main-header .main-header-left .logo-wrapper img {\n  margin-top: 0px;\n  width: 90%;\n  height: 100%;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar~.page-body {\n  /* margin-left: 280px; */\n}\n.btn-disabled{\n  background-color: #ccc;\n  color: #666;\n  border-color: #ccc;\n  cursor: not-allowed;\n  \n}\n.customStyle{\n  margin: 0 !important;\n}\n.customStyle1{\n  margin-left: 15px !important;\n}\n.sidebaricon {\n  position: fixed;\n  top: 30px;\n  left: 0px;\n  z-index: 8;\n}\n\n.sidebar-close .page-sidebar {\n  left: -33px\n}\n\n.sidebar-blueicon {\n  right: 0px;\n  position: absolute;\n  top: 47px;\n}\n\n.sidebaropen-icon {\n  position: absolute;\n  top: 22px;\n  right: 0px;\n  z-index: 11;\n}\n\n.page-main-header .main-header-right .nav-right>ul {\n  height: 50px;\n}\n\n.counterset {\n  font-size: 16px;\n  padding-left: 0px;\n}\n\n.maroon {\n  color: #a34518 !important;\n}\n\n.darkgreen {\n  color: #069518;\n}\n\n.purple {\n  color: #9f08b2;\n}\n\n.blue i.icofont.icofont-map-pins.f25 {\n  color: cornflowerblue;\n}\n\n.map-legends img {\n  height: 50px;\n  width: 50px;\n}\n\n.weather-sidebar {\n  width: 82%\n}\n\n.lightgrey i.icofont.icofont-map-pins.f25 {\n  color: #e1d8d8;\n}\n\n.grey {\n  color: #cccccc;\n}\n\n.white {\n  color: #FFFFFF !important;\n}\n\n.crm-activity {\n  height: 525px !important;\n}\n\n.capitlize {\n  text-transform: capitalize;\n}\n\n.se-ico:hover {\n  color: #bebebe;\n}\n\n.fright {\n  float: right !important;\n}\n\n.ch300 {\n  min-height: 100px !important;\n  max-height: 230px !important;\n}\n\n.brd-top {\n  border-top: 1px solid #ececec;\n}\n\n#dashboardCounterCardBody {\n  padding: 10px;\n}\n\n.email-wrap .email-right-aside .email-body .inbox {\n  max-height: 570px;\n}\n\n.ck-editor__editable {\n  min-height: 350px !important;\n}\n\n.email-wrap .email-right-aside .email-body .email-compose .cke_contents.cke_reset {\n  max-height: 400px !important;\n}\n\n.email-wrap .email-right-aside {\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n#profileDropdown {\n  width: 250px;\n}\n\n.ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#loginButton {\n  padding: 0.475rem 2.75rem;\n  text-align: center;\n}\n\n.textAlignCenter {\n  text-align: center;\n}\n\n.textAlignLeft {\n  text-align: left;\n}\n\n#counterCardBody {\n  padding: 15px;\n}\n\n.rdtPicker table {\n  width: 100% !important;\n}\n\n.rdtOpen .rdtPicker {\n  border: 1px solid #ccc;\n}\n\n.andriomap-pos {\n  position: fixed;\n  bottom: -1%;\n  left: 47%;\n  width: 40px;\n  height: 40px;\n  z-index: 999;\n  cursor: pointer;\n}\n\n.andriomap-pos2 {\n  position: absolute;\n  left: 47%;\n  top: -2%;\n  width: 40px;\n  height: 40px;\n  z-index: 999999;\n  cursor: pointer;\n}\n\n.ico-color {\n  color: #ffffff;\n  font-size: 32px;\n  background: #333333;\n  padding: 5px;\n}\n\n.zindex999 {\n  z-index: 999;\n}\n\n.divpos {\n  position: fixed;\n  bottom: -15px;\n  right: 0;\n  background: #fff;\n  width: 100%;\n  height: 0;\n  overflow-y: auto;\n  z-index: 9999;\n  box-shadow: 0.5rem 0.5rem 2rem 1rem rgba(0, 0, 0, 0.2);\n  transition: 0.5s;\n  -webkit-transform: translateY(100%);\n  transform: translateY(100%);\n  padding: 2%;\n}\n\n.slider-translatey {\n  height: 400px;\n  transform: translateX(-110%);\n  width:500px;\n}\n\n.prel {\n  position: relative;\n}\n\n.sweet-alert h2 {\n  word-break: break-word;\n}\n\n\n\n/*Datepicker CSS Start*/\n/*! jQuery UI - v1.12.1 - 2016-09-14\n* http://jqueryui.com\n* Includes: core.css, accordion.css, autocomplete.css, menu.css, button.css, controlgroup.css, checkboxradio.css, datepicker.css, dialog.css, draggable.css, resizable.css, progressbar.css, selectable.css, selectmenu.css, slider.css, sortable.css, spinner.css, tabs.css, tooltip.css, theme.css\n* To view and modify this theme, visit http://jqueryui.com/themeroller/?ffDefault=Arial%2CHelvetica%2Csans-serif&fsDefault=1em&fwDefault=normal&cornerRadius=3px&bgColorHeader=e9e9e9&bgTextureHeader=flat&borderColorHeader=dddddd&fcHeader=333333&iconColorHeader=444444&bgColorContent=ffffff&bgTextureContent=flat&borderColorContent=dddddd&fcContent=333333&iconColorContent=444444&bgColorDefault=f6f6f6&bgTextureDefault=flat&borderColorDefault=c5c5c5&fcDefault=454545&iconColorDefault=777777&bgColorHover=ededed&bgTextureHover=flat&borderColorHover=cccccc&fcHover=2b2b2b&iconColorHover=555555&bgColorActive=007fff&bgTextureActive=flat&borderColorActive=003eff&fcActive=ffffff&iconColorActive=ffffff&bgColorHighlight=fffa90&bgTextureHighlight=flat&borderColorHighlight=dad55e&fcHighlight=777620&iconColorHighlight=777620&bgColorError=fddfdf&bgTextureError=flat&borderColorError=f1a899&fcError=5f3f3f&iconColorError=cc0000&bgColorOverlay=aaaaaa&bgTextureOverlay=flat&bgImgOpacityOverlay=0&opacityOverlay=30&bgColorShadow=666666&bgTextureShadow=flat&bgImgOpacityShadow=0&opacityShadow=30&thicknessShadow=5px&offsetTopShadow=0px&offsetLeftShadow=0px&cornerRadiusShadow=8px\n* Copyright jQuery Foundation and other contributors; Licensed MIT */\n\n/* Layout helpers\n----------------------------------*/\n.ui-helper-hidden {\n  display: none;\n}\n\n.ui-helper-hidden-accessible {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.ui-helper-reset {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  line-height: 1.3;\n  text-decoration: none;\n  font-size: 100%;\n  list-style: none;\n}\n\n.ui-helper-clearfix:before,\n.ui-helper-clearfix:after {\n  content: \"\";\n  display: table;\n  border-collapse: collapse;\n}\n\n.ui-helper-clearfix:after {\n  clear: both;\n}\n\n.ui-helper-zfix {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  position: absolute;\n  opacity: 0;\n  filter: Alpha(Opacity=0);\n  /* support: IE8 */\n}\n\n.ui-front {\n  z-index: 100;\n}\n\n\n/* Interaction Cues\n----------------------------------*/\n.ui-state-disabled {\n  cursor: default !important;\n  pointer-events: none;\n}\n\n\n/* Icons\n----------------------------------*/\n.ui-icon {\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: -.25em;\n  position: relative;\n  text-indent: -99999px;\n  overflow: hidden;\n  background-repeat: no-repeat;\n}\n\n.ui-widget-icon-block {\n  left: 50%;\n  margin-left: -8px;\n  display: block;\n}\n\n/* Misc visuals\n----------------------------------*/\n\n/* Overlays */\n.ui-widget-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ui-accordion .ui-accordion-header {\n  display: block;\n  cursor: pointer;\n  position: relative;\n  margin: 2px 0 0 0;\n  padding: .5em .5em .5em .7em;\n  font-size: 100%;\n}\n\n.ui-accordion .ui-accordion-content {\n  padding: 1em 2.2em;\n  border-top: 0;\n  overflow: auto;\n}\n\n.ui-autocomplete {\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: default;\n}\n\n.ui-menu {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: block;\n  outline: 0;\n}\n\n.ui-menu .ui-menu {\n  position: absolute;\n}\n\n.ui-menu .ui-menu-item {\n  margin: 0;\n  cursor: pointer;\n  /* support: IE10, see #8844 */\n  list-style-image: url(\"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7\");\n}\n\n.ui-menu .ui-menu-item-wrapper {\n  position: relative;\n  padding: 3px 1em 3px .4em;\n}\n\n.ui-menu .ui-menu-divider {\n  margin: 5px 0;\n  height: 0;\n  font-size: 0;\n  line-height: 0;\n  border-width: 1px 0 0 0;\n}\n\n.ui-menu .ui-state-focus,\n.ui-menu .ui-state-active {\n  margin: -1px;\n}\n\n/* icon support */\n.ui-menu-icons {\n  position: relative;\n}\n\n.ui-menu-icons .ui-menu-item-wrapper {\n  padding-left: 2em;\n}\n\n/* left-aligned */\n.ui-menu .ui-icon {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: .2em;\n  margin: auto 0;\n}\n\n/* right-aligned */\n.ui-menu .ui-menu-icon {\n  left: auto;\n  right: 0;\n}\n\n.ui-button {\n  padding: .4em 1em;\n  display: inline-block;\n  position: relative;\n  line-height: normal;\n  margin-right: .1em;\n  cursor: pointer;\n  vertical-align: middle;\n  text-align: center;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  /* Support: IE <= 11 */\n  overflow: visible;\n}\n\n.ui-button,\n.ui-button:link,\n.ui-button:visited,\n.ui-button:hover,\n.ui-button:active {\n  text-decoration: none;\n}\n\n/* to make room for the icon, a width needs to be set here */\n.ui-button-icon-only {\n  width: 2em;\n  box-sizing: border-box;\n  text-indent: -9999px;\n  white-space: nowrap;\n}\n\n/* no icon support for input elements */\ninput.ui-button.ui-button-icon-only {\n  text-indent: 0;\n}\n\n/* button icon element(s) */\n.ui-button-icon-only .ui-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -8px;\n  margin-left: -8px;\n}\n\n.ui-button.ui-icon-notext .ui-icon {\n  padding: 0;\n  width: 2.1em;\n  height: 2.1em;\n  text-indent: -9999px;\n  white-space: nowrap;\n\n}\n\ninput.ui-button.ui-icon-notext .ui-icon {\n  width: auto;\n  height: auto;\n  text-indent: 0;\n  white-space: normal;\n  padding: .4em 1em;\n}\n\n/* workarounds */\n/* Support: Firefox 5 - 40 */\ninput.ui-button::-moz-focus-inner,\nbutton.ui-button::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n.ui-controlgroup {\n  vertical-align: middle;\n  display: inline-block;\n}\n\n.ui-controlgroup>.ui-controlgroup-item {\n  float: left;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.ui-controlgroup>.ui-controlgroup-item:focus,\n.ui-controlgroup>.ui-controlgroup-item.ui-visual-focus {\n  z-index: 9999;\n}\n\n.ui-controlgroup-vertical>.ui-controlgroup-item {\n  display: block;\n  float: none;\n  width: 100%;\n  margin-top: 0;\n  margin-bottom: 0;\n  text-align: left;\n}\n\n.ui-controlgroup-vertical .ui-controlgroup-item {\n  box-sizing: border-box;\n}\n\n.ui-controlgroup .ui-controlgroup-label {\n  padding: .4em 1em;\n}\n\n.ui-controlgroup .ui-controlgroup-label span {\n  font-size: 80%;\n}\n\n.ui-controlgroup-horizontal .ui-controlgroup-label+.ui-controlgroup-item {\n  border-left: none;\n}\n\n.ui-controlgroup-vertical .ui-controlgroup-label+.ui-controlgroup-item {\n  border-top: none;\n}\n\n.ui-controlgroup-horizontal .ui-controlgroup-label.ui-widget-content {\n  border-right: none;\n}\n\n.ui-controlgroup-vertical .ui-controlgroup-label.ui-widget-content {\n  border-bottom: none;\n}\n\n/* Spinner specific style fixes */\n.ui-controlgroup-vertical .ui-spinner-input {\n\n  /* Support: IE8 only, Android < 4.4 only */\n  width: 75%;\n  width: calc(100% - 2.4em);\n}\n\n.ui-controlgroup-vertical .ui-spinner .ui-spinner-up {\n  border-top-style: solid;\n}\n\n.ui-checkboxradio-label .ui-icon-background {\n  box-shadow: inset 1px 1px 1px #ccc;\n  border-radius: .12em;\n  border: none;\n}\n\n.ui-checkboxradio-radio-label .ui-icon-background {\n  width: 16px;\n  height: 16px;\n  border-radius: 1em;\n  overflow: visible;\n  border: none;\n}\n\n.ui-checkboxradio-radio-label.ui-checkboxradio-checked .ui-icon,\n.ui-checkboxradio-radio-label.ui-checkboxradio-checked:hover .ui-icon {\n  background-image: none;\n  width: 8px;\n  height: 8px;\n  border-width: 4px;\n  border-style: solid;\n}\n\n.ui-checkboxradio-disabled {\n  pointer-events: none;\n}\n\n.datepick-filter {\n  background-color: #171c8f;\n  border-color: #171c8f;\n  color: #ffffff;\n  /* Optionally set the text color to white */\n}\n\n.ui-datepicker {\n  width: 17em;\n  padding: .2em .2em 0;\n  display: none;\n}\n\n.ui-datepicker .ui-datepicker-header {\n  position: relative;\n  padding: .2em 0;\n}\n\n.ui-datepicker .ui-datepicker-prev,\n.ui-datepicker .ui-datepicker-next {\n  position: absolute;\n  top: 2px;\n  width: 1.8em;\n  height: 1.8em;\n}\n\n.ui-datepicker .ui-datepicker-prev-hover,\n.ui-datepicker .ui-datepicker-next-hover {\n  top: 1px;\n}\n\n.ui-datepicker .ui-datepicker-prev {\n  left: 2px;\n}\n\n.ui-datepicker .ui-datepicker-next {\n  right: 2px;\n}\n\n.ui-datepicker .ui-datepicker-prev-hover {\n  left: 1px;\n}\n\n.ui-datepicker .ui-datepicker-next-hover {\n  right: 1px;\n}\n\n.ui-datepicker .ui-datepicker-prev span,\n.ui-datepicker .ui-datepicker-next span {\n  display: block;\n  position: absolute;\n  left: 50%;\n  margin-left: -8px;\n  top: 50%;\n  margin-top: -8px;\n}\n\n.ui-datepicker .ui-datepicker-title {\n  margin: 0 2.3em;\n  line-height: 1.8em;\n  text-align: center;\n}\n\n.ui-datepicker .ui-datepicker-title select {\n  font-size: 1em;\n  margin: 1px 0;\n}\n\n.ui-datepicker select.ui-datepicker-month,\n.ui-datepicker select.ui-datepicker-year {\n  width: 45%;\n}\n\n.ui-datepicker table {\n  width: 100%;\n  font-size: .9em;\n  border-collapse: collapse;\n  margin: 0 0 .4em;\n}\n\n.ui-datepicker th {\n  padding: .7em .3em;\n  text-align: center;\n  font-weight: bold;\n  border: 0;\n}\n\n.ui-datepicker td {\n  border: 0;\n  padding: 1px;\n}\n\n.ui-datepicker td span,\n.ui-datepicker td a {\n  display: block;\n  padding: .2em;\n  text-align: right;\n  text-decoration: none;\n}\n\n.ui-datepicker .ui-datepicker-buttonpane {\n  background-image: none;\n  margin: .7em 0 0 0;\n  padding: 0 .2em;\n  border-left: 0;\n  border-right: 0;\n  border-bottom: 0;\n}\n\n.ui-datepicker .ui-datepicker-buttonpane button {\n  float: right;\n  margin: .5em .2em .4em;\n  cursor: pointer;\n  padding: .2em .6em .3em .6em;\n  width: auto;\n  overflow: visible;\n}\n\n.ui-datepicker .ui-datepicker-buttonpane button.ui-datepicker-current {\n  float: left;\n}\n\n/* with multiple calendars */\n.ui-datepicker.ui-datepicker-multi {\n  width: auto;\n}\n\n.ui-datepicker-multi .ui-datepicker-group {\n  float: left;\n}\n\n.ui-datepicker-multi .ui-datepicker-group table {\n  width: 95%;\n  margin: 0 auto .4em;\n}\n\n.ui-datepicker-multi-2 .ui-datepicker-group {\n  width: 50%;\n}\n\n.ui-datepicker-multi-3 .ui-datepicker-group {\n  width: 33.3%;\n}\n\n.ui-datepicker-multi-4 .ui-datepicker-group {\n  width: 25%;\n}\n\n.ui-datepicker-multi .ui-datepicker-group-last .ui-datepicker-header,\n.ui-datepicker-multi .ui-datepicker-group-middle .ui-datepicker-header {\n  border-left-width: 0;\n}\n\n.ui-datepicker-multi .ui-datepicker-buttonpane {\n  clear: left;\n}\n\n.ui-datepicker-row-break {\n  clear: both;\n  width: 100%;\n  font-size: 0;\n}\n\n/* RTL support */\n.ui-datepicker-rtl {\n  direction: rtl;\n}\n\n.ui-datepicker-rtl .ui-datepicker-prev {\n  right: 2px;\n  left: auto;\n}\n\n.ui-datepicker-rtl .ui-datepicker-next {\n  left: 2px;\n  right: auto;\n}\n\n.ui-datepicker-rtl .ui-datepicker-prev:hover {\n  right: 1px;\n  left: auto;\n}\n\n.ui-datepicker-rtl .ui-datepicker-next:hover {\n  left: 1px;\n  right: auto;\n}\n\n.ui-datepicker-rtl .ui-datepicker-buttonpane {\n  clear: right;\n}\n\n.ui-datepicker-rtl .ui-datepicker-buttonpane button {\n  float: left;\n}\n\n.ui-datepicker-rtl .ui-datepicker-buttonpane button.ui-datepicker-current,\n.ui-datepicker-rtl .ui-datepicker-group {\n  float: right;\n}\n\n.ui-datepicker-rtl .ui-datepicker-group-last .ui-datepicker-header,\n.ui-datepicker-rtl .ui-datepicker-group-middle .ui-datepicker-header {\n  border-right-width: 0;\n  border-left-width: 1px;\n}\n\n/* Icons */\n.ui-datepicker .ui-icon {\n  display: block;\n  text-indent: -99999px;\n  overflow: hidden;\n  background-repeat: no-repeat;\n  left: .5em;\n  top: .3em;\n}\n\n.ui-dialog {\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding: .2em;\n  outline: 0;\n}\n\n.ui-dialog .ui-dialog-titlebar {\n  padding: .4em 1em;\n  position: relative;\n}\n\n.ui-dialog .ui-dialog-title {\n  float: left;\n  margin: .1em 0;\n  white-space: nowrap;\n  width: 90%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ui-dialog .ui-dialog-titlebar-close {\n  position: absolute;\n  right: .3em;\n  top: 50%;\n  width: 20px;\n  margin: -10px 0 0 0;\n  padding: 1px;\n  height: 20px;\n}\n\n.ui-dialog .ui-dialog-content {\n  position: relative;\n  border: 0;\n  padding: .5em 1em;\n  background: none;\n  overflow: auto;\n}\n\n.ui-dialog .ui-dialog-buttonpane {\n  text-align: left;\n  border-width: 1px 0 0 0;\n  background-image: none;\n  margin-top: .5em;\n  padding: .3em 1em .5em .4em;\n}\n\n.ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {\n  float: right;\n}\n\n.ui-dialog .ui-dialog-buttonpane button {\n  margin: .5em .4em .5em 0;\n  cursor: pointer;\n}\n\n.ui-dialog .ui-resizable-n {\n  height: 2px;\n  top: 0;\n}\n\n.ui-dialog .ui-resizable-e {\n  width: 2px;\n  right: 0;\n}\n\n.ui-dialog .ui-resizable-s {\n  height: 2px;\n  bottom: 0;\n}\n\n.ui-dialog .ui-resizable-w {\n  width: 2px;\n  left: 0;\n}\n\n.ui-dialog .ui-resizable-se,\n.ui-dialog .ui-resizable-sw,\n.ui-dialog .ui-resizable-ne,\n.ui-dialog .ui-resizable-nw {\n  width: 7px;\n  height: 7px;\n}\n\n.ui-dialog .ui-resizable-se {\n  right: 0;\n  bottom: 0;\n}\n\n.ui-dialog .ui-resizable-sw {\n  left: 0;\n  bottom: 0;\n}\n\n.ui-dialog .ui-resizable-ne {\n  right: 0;\n  top: 0;\n}\n\n.ui-dialog .ui-resizable-nw {\n  left: 0;\n  top: 0;\n}\n\n.ui-draggable .ui-dialog-titlebar {\n  cursor: move;\n}\n\n.ui-draggable-handle {\n  -ms-touch-action: none;\n  touch-action: none;\n}\n\n.ui-resizable {\n  position: relative;\n}\n\n.ui-resizable-handle {\n  position: absolute;\n  font-size: 0.1px;\n  display: block;\n  -ms-touch-action: none;\n  touch-action: none;\n}\n\n.ui-resizable-disabled .ui-resizable-handle,\n.ui-resizable-autohide .ui-resizable-handle {\n  display: none;\n}\n\n.ui-resizable-n {\n  cursor: n-resize;\n  height: 7px;\n  width: 100%;\n  top: -5px;\n  left: 0;\n}\n\n.ui-resizable-s {\n  cursor: s-resize;\n  height: 7px;\n  width: 100%;\n  bottom: -5px;\n  left: 0;\n}\n\n.ui-resizable-e {\n  cursor: e-resize;\n  width: 7px;\n  right: -5px;\n  top: 0;\n  height: 100%;\n}\n\n.ui-resizable-w {\n  cursor: w-resize;\n  width: 7px;\n  left: -5px;\n  top: 0;\n  height: 100%;\n}\n\n.ui-resizable-se {\n  cursor: se-resize;\n  width: 12px;\n  height: 12px;\n  right: 1px;\n  bottom: 1px;\n}\n\n.ui-resizable-sw {\n  cursor: sw-resize;\n  width: 9px;\n  height: 9px;\n  left: -5px;\n  bottom: -5px;\n}\n\n.ui-resizable-nw {\n  cursor: nw-resize;\n  width: 9px;\n  height: 9px;\n  left: -5px;\n  top: -5px;\n}\n\n.ui-resizable-ne {\n  cursor: ne-resize;\n  width: 9px;\n  height: 9px;\n  right: -5px;\n  top: -5px;\n}\n\n.ui-progressbar {\n  height: 2em;\n  text-align: left;\n  overflow: hidden;\n}\n\n.ui-progressbar .ui-progressbar-value {\n  margin: -1px;\n  height: 100%;\n}\n\n.ui-progressbar .ui-progressbar-overlay {\n  background: url(\"data:image/gif;base64,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\");\n  height: 100%;\n  filter: alpha(opacity=25);\n  /* support: IE8 */\n  opacity: 0.25;\n}\n\n.ui-progressbar-indeterminate .ui-progressbar-value {\n  background-image: none;\n}\n\n.ui-selectable {\n  -ms-touch-action: none;\n  touch-action: none;\n}\n\n.ui-selectable-helper {\n  position: absolute;\n  z-index: 100;\n  border: 1px dotted black;\n}\n\n.ui-selectmenu-menu {\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: none;\n}\n\n.ui-selectmenu-menu .ui-menu {\n  overflow: auto;\n  overflow-x: hidden;\n  padding-bottom: 1px;\n}\n\n.ui-selectmenu-menu .ui-menu .ui-selectmenu-optgroup {\n  font-size: 1em;\n  font-weight: bold;\n  line-height: 1.5;\n  padding: 2px 0.4em;\n  margin: 0.5em 0 0 0;\n  height: auto;\n  border: 0;\n}\n\n.ui-selectmenu-open {\n  display: block;\n}\n\n.ui-selectmenu-text {\n  display: block;\n  margin-right: 20px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ui-selectmenu-button.ui-button {\n  text-align: left;\n  white-space: nowrap;\n  width: 14em;\n}\n\n.ui-selectmenu-icon.ui-icon {\n  float: right;\n  margin-top: 0;\n}\n\n.ui-slider {\n  position: relative;\n  text-align: left;\n}\n\n.ui-slider .ui-slider-handle {\n  position: absolute;\n  z-index: 2;\n  width: 1.2em;\n  height: 1.2em;\n  cursor: default;\n  -ms-touch-action: none;\n  touch-action: none;\n}\n\n.ui-slider .ui-slider-range {\n  position: absolute;\n  z-index: 1;\n  font-size: .7em;\n  display: block;\n  border: 0;\n  background-position: 0 0;\n}\n\n/* support: IE8 - See #6727 */\n.ui-slider.ui-state-disabled .ui-slider-handle,\n.ui-slider.ui-state-disabled .ui-slider-range {\n  filter: inherit;\n}\n\n.ui-slider-horizontal {\n  height: .8em;\n}\n\n.ui-slider-horizontal .ui-slider-handle {\n  top: -.3em;\n  margin-left: -.6em;\n}\n\n.ui-slider-horizontal .ui-slider-range {\n  top: 0;\n  height: 100%;\n}\n\n.ui-slider-horizontal .ui-slider-range-min {\n  left: 0;\n}\n\n.ui-slider-horizontal .ui-slider-range-max {\n  right: 0;\n}\n\n.ui-slider-vertical {\n  width: .8em;\n  height: 100px;\n}\n\n.ui-slider-vertical .ui-slider-handle {\n  left: -.3em;\n  margin-left: 0;\n  margin-bottom: -.6em;\n}\n\n.ui-slider-vertical .ui-slider-range {\n  left: 0;\n  width: 100%;\n}\n\n.ui-slider-vertical .ui-slider-range-min {\n  bottom: 0;\n}\n\n.ui-slider-vertical .ui-slider-range-max {\n  top: 0;\n}\n\n.ui-sortable-handle {\n  -ms-touch-action: none;\n  touch-action: none;\n}\n\n.ui-spinner {\n  position: relative;\n  display: inline-block;\n  overflow: hidden;\n  padding: 0;\n  vertical-align: middle;\n}\n\n.ui-spinner-input {\n  border: none;\n  background: none;\n  color: inherit;\n  padding: .222em 0;\n  margin: .2em 0;\n  vertical-align: middle;\n  margin-left: .4em;\n  margin-right: 2em;\n}\n\n.ui-spinner-button {\n  width: 1.6em;\n  height: 50%;\n  font-size: .5em;\n  padding: 0;\n  margin: 0;\n  text-align: center;\n  position: absolute;\n  cursor: default;\n  display: block;\n  overflow: hidden;\n  right: 0;\n}\n\n/* more specificity required here to override default borders */\n.ui-spinner a.ui-spinner-button {\n  border-top-style: none;\n  border-bottom-style: none;\n  border-right-style: none;\n}\n\n.ui-spinner-up {\n  top: 0;\n}\n\n.ui-spinner-down {\n  bottom: 0;\n}\n\n.ui-tabs {\n  position: relative;\n  /* position: relative prevents IE scroll bug (element with position: relative inside container with overflow: auto appear as \"fixed\") */\n  padding: .2em;\n}\n\n.ui-tabs .ui-tabs-nav {\n  margin: 0;\n  padding: .2em .2em 0;\n}\n\n.ui-tabs .ui-tabs-nav li {\n  list-style: none;\n  float: left;\n  position: relative;\n  top: 0;\n  margin: 1px .2em 0 0;\n  border-bottom-width: 0;\n  padding: 0;\n  white-space: nowrap;\n}\n\n.ui-tabs .ui-tabs-nav .ui-tabs-anchor {\n  float: left;\n  padding: .5em 1em;\n  text-decoration: none;\n}\n\n.ui-tabs .ui-tabs-nav li.ui-tabs-active {\n  margin-bottom: -1px;\n  padding-bottom: 1px;\n}\n\n.ui-tabs .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor,\n.ui-tabs .ui-tabs-nav li.ui-state-disabled .ui-tabs-anchor,\n.ui-tabs .ui-tabs-nav li.ui-tabs-loading .ui-tabs-anchor {\n  cursor: text;\n}\n\n.ui-tabs-collapsible .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor {\n  cursor: pointer;\n}\n\n.ui-tabs .ui-tabs-panel {\n  display: block;\n  border-width: 0;\n  padding: 1em 1.4em;\n  background: none;\n}\n\n.ui-tooltip {\n  padding: 8px;\n  position: absolute;\n  z-index: 9999;\n  max-width: 300px;\n}\n\nbody .ui-tooltip {\n  border-width: 2px;\n}\n\n/* Component containers\n----------------------------------*/\n.ui-widget {\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 1em;\n}\n\n.ui-widget .ui-widget {\n  font-size: 1em;\n}\n\n.ui-widget input,\n.ui-widget select,\n.ui-widget textarea,\n.ui-widget button {\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 1em;\n}\n\n.ui-widget.ui-widget-content {\n  border: 1px solid #c5c5c5;\n}\n\n.ui-widget-content {\n  border: 1px solid #dddddd;\n  background: #ffffff;\n  color: #333333;\n}\n\n.ui-widget-content a {\n  color: #333333;\n}\n\n.ui-widget-header {\n  border: 1px solid #dddddd;\n  background: #e9e9e9;\n  color: #333333;\n  font-weight: bold;\n}\n\n.ui-widget-header a {\n  color: #333333;\n}\n\n/* Interaction states\n----------------------------------*/\n.ui-state-default,\n.ui-widget-content .ui-state-default,\n.ui-widget-header .ui-state-default,\n.ui-button,\n\n/* We use html here because we need a greater specificity to make sure disabled\nworks properly when clicked or hovered */\nhtml .ui-button.ui-state-disabled:hover,\nhtml .ui-button.ui-state-disabled:active {\n  border: 1px solid #c5c5c5;\n  background: #f6f6f6;\n  font-weight: normal;\n  color: #454545;\n}\n\n.ui-state-default a,\n.ui-state-default a:link,\n.ui-state-default a:visited,\na.ui-button,\na:link.ui-button,\na:visited.ui-button,\n.ui-button {\n  color: #454545;\n  text-decoration: none;\n}\n\n.ui-state-hover,\n.ui-widget-content .ui-state-hover,\n.ui-widget-header .ui-state-hover,\n.ui-state-focus,\n.ui-widget-content .ui-state-focus,\n.ui-widget-header .ui-state-focus,\n.ui-button:hover,\n.ui-button:focus {\n  border: 1px solid #cccccc;\n  background: #ededed;\n  font-weight: normal;\n  color: #2b2b2b;\n}\n\n.ui-state-hover a,\n.ui-state-hover a:hover,\n.ui-state-hover a:link,\n.ui-state-hover a:visited,\n.ui-state-focus a,\n.ui-state-focus a:hover,\n.ui-state-focus a:link,\n.ui-state-focus a:visited,\na.ui-button:hover,\na.ui-button:focus {\n  color: #2b2b2b;\n  text-decoration: none;\n}\n\n.ui-visual-focus {\n  box-shadow: 0 0 3px 1px rgb(94, 158, 214);\n}\n\n.ui-state-active,\n.ui-widget-content .ui-state-active,\n.ui-widget-header .ui-state-active,\na.ui-button:active,\n.ui-button:active,\n.ui-button.ui-state-active:hover {\n  border: 1px solid #003eff;\n  background: #007fff;\n  font-weight: normal;\n  color: #ffffff;\n}\n\n.ui-icon-background,\n.ui-state-active .ui-icon-background {\n  border: #003eff;\n  background-color: #ffffff;\n}\n\n.ui-state-active a,\n.ui-state-active a:link,\n.ui-state-active a:visited {\n  color: #ffffff;\n  text-decoration: none;\n}\n\n/* Interaction Cues\n----------------------------------*/\n.ui-state-highlight,\n.ui-widget-content .ui-state-highlight,\n.ui-widget-header .ui-state-highlight {\n  border: 1px solid #dad55e;\n  background: #fffa90;\n  color: #777620;\n}\n\n.ui-state-checked {\n  border: 1px solid #dad55e;\n  background: #fffa90;\n}\n\n.ui-state-highlight a,\n.ui-widget-content .ui-state-highlight a,\n.ui-widget-header .ui-state-highlight a {\n  color: #777620;\n}\n\n.ui-state-error,\n.ui-widget-content .ui-state-error,\n.ui-widget-header .ui-state-error {\n  border: 1px solid #f1a899;\n  background: #fddfdf;\n  color: #5f3f3f;\n}\n\n.ui-state-error a,\n.ui-widget-content .ui-state-error a,\n.ui-widget-header .ui-state-error a {\n  color: #5f3f3f;\n}\n\n.ui-state-error-text,\n.ui-widget-content .ui-state-error-text,\n.ui-widget-header .ui-state-error-text {\n  color: #5f3f3f;\n}\n\n.ui-priority-primary,\n.ui-widget-content .ui-priority-primary,\n.ui-widget-header .ui-priority-primary {\n  font-weight: bold;\n}\n\n.ui-priority-secondary,\n.ui-widget-content .ui-priority-secondary,\n.ui-widget-header .ui-priority-secondary {\n  opacity: .7;\n  filter: Alpha(Opacity=70);\n  /* support: IE8 */\n  font-weight: normal;\n}\n\n.ui-state-disabled,\n.ui-widget-content .ui-state-disabled,\n.ui-widget-header .ui-state-disabled {\n  opacity: .35;\n  filter: Alpha(Opacity=35);\n  /* support: IE8 */\n  background-image: none;\n}\n\n.ui-state-disabled .ui-icon {\n  filter: Alpha(Opacity=35);\n  /* support: IE8 - See #6059 */\n}\n\n/* Icons\n----------------------------------*/\n\n/* states and images */\n.ui-icon {\n  width: 16px;\n  height: 16px;\n}\n\n.ui-icon,\n.ui-widget-content .ui-icon {\n  /* background-image: url(\"../images/ui-icons_444444_256x240.png\"); */\n}\n\n.ui-widget-header .ui-icon {\n  /* background-image: url(\"../images/ui-icons_444444_256x240.png\"); */\n}\n\n.ui-state-hover .ui-icon,\n.ui-state-focus .ui-icon,\n.ui-button:hover .ui-icon,\n.ui-button:focus .ui-icon {\n  /* background-image: url(\"../images/ui-icons_555555_256x240.png\"); */\n}\n\n.ui-state-active .ui-icon,\n.ui-button:active .ui-icon {\n  /* background-image: url(\"../images/ui-icons_ffffff_256x240.png\"); */\n}\n\n.ui-state-highlight .ui-icon,\n.ui-button .ui-state-highlight.ui-icon {\n  /* background-image: url(\"../images/ui-icons_777620_256x240.png\"); */\n}\n\n.ui-state-error .ui-icon,\n.ui-state-error-text .ui-icon {\n  /* background-image: url(\"../images/ui-icons_cc0000_256x240.png\"); */\n}\n\n.ui-button .ui-icon {\n  /* background-image: url(\"../images/ui-icons_777777_256x240.png\"); */\n}\n\n/* positioning */\n.ui-icon-blank {\n  background-position: 16px 16px;\n}\n\n.ui-icon-caret-1-n {\n  background-position: 0 0;\n}\n\n.ui-icon-caret-1-ne {\n  background-position: -16px 0;\n}\n\n.ui-icon-caret-1-e {\n  background-position: -32px 0;\n}\n\n.ui-icon-caret-1-se {\n  background-position: -48px 0;\n}\n\n.ui-icon-caret-1-s {\n  background-position: -65px 0;\n}\n\n.ui-icon-caret-1-sw {\n  background-position: -80px 0;\n}\n\n.ui-icon-caret-1-w {\n  background-position: -96px 0;\n}\n\n.ui-icon-caret-1-nw {\n  background-position: -112px 0;\n}\n\n.ui-icon-caret-2-n-s {\n  background-position: -128px 0;\n}\n\n.ui-icon-caret-2-e-w {\n  background-position: -144px 0;\n}\n\n.ui-icon-triangle-1-n {\n  background-position: 0 -16px;\n}\n\n.ui-icon-triangle-1-ne {\n  background-position: -16px -16px;\n}\n\n.ui-icon-triangle-1-e {\n  background-position: -32px -16px;\n}\n\n.ui-icon-triangle-1-se {\n  background-position: -48px -16px;\n}\n\n.ui-icon-triangle-1-s {\n  background-position: -65px -16px;\n}\n\n.ui-icon-triangle-1-sw {\n  background-position: -80px -16px;\n}\n\n.ui-icon-triangle-1-w {\n  background-position: -96px -16px;\n}\n\n.ui-icon-triangle-1-nw {\n  background-position: -112px -16px;\n}\n\n.ui-icon-triangle-2-n-s {\n  background-position: -128px -16px;\n}\n\n.ui-icon-triangle-2-e-w {\n  background-position: -144px -16px;\n}\n\n.ui-icon-arrow-1-n {\n  background-position: 0 -32px;\n}\n\n.ui-icon-arrow-1-ne {\n  background-position: -16px -32px;\n}\n\n.ui-icon-arrow-1-e {\n  background-position: -32px -32px;\n}\n\n.ui-icon-arrow-1-se {\n  background-position: -48px -32px;\n}\n\n.ui-icon-arrow-1-s {\n  background-position: -65px -32px;\n}\n\n.ui-icon-arrow-1-sw {\n  background-position: -80px -32px;\n}\n\n.ui-icon-arrow-1-w {\n  background-position: -96px -32px;\n}\n\n.ui-icon-arrow-1-nw {\n  background-position: -112px -32px;\n}\n\n.ui-icon-arrow-2-n-s {\n  background-position: -128px -32px;\n}\n\n.ui-icon-arrow-2-ne-sw {\n  background-position: -144px -32px;\n}\n\n.ui-icon-arrow-2-e-w {\n  background-position: -160px -32px;\n}\n\n.ui-icon-arrow-2-se-nw {\n  background-position: -176px -32px;\n}\n\n.ui-icon-arrowstop-1-n {\n  background-position: -192px -32px;\n}\n\n.ui-icon-arrowstop-1-e {\n  background-position: -208px -32px;\n}\n\n.ui-icon-arrowstop-1-s {\n  background-position: -224px -32px;\n}\n\n.ui-icon-arrowstop-1-w {\n  background-position: -240px -32px;\n}\n\n.ui-icon-arrowthick-1-n {\n  background-position: 1px -48px;\n}\n\n.ui-icon-arrowthick-1-ne {\n  background-position: -16px -48px;\n}\n\n.ui-icon-arrowthick-1-e {\n  background-position: -32px -48px;\n}\n\n.ui-icon-arrowthick-1-se {\n  background-position: -48px -48px;\n}\n\n.ui-icon-arrowthick-1-s {\n  background-position: -64px -48px;\n}\n\n.ui-icon-arrowthick-1-sw {\n  background-position: -80px -48px;\n}\n\n.ui-icon-arrowthick-1-w {\n  background-position: -96px -48px;\n}\n\n.ui-icon-arrowthick-1-nw {\n  background-position: -112px -48px;\n}\n\n.ui-icon-arrowthick-2-n-s {\n  background-position: -128px -48px;\n}\n\n.ui-icon-arrowthick-2-ne-sw {\n  background-position: -144px -48px;\n}\n\n.ui-icon-arrowthick-2-e-w {\n  background-position: -160px -48px;\n}\n\n.ui-icon-arrowthick-2-se-nw {\n  background-position: -176px -48px;\n}\n\n.ui-icon-arrowthickstop-1-n {\n  background-position: -192px -48px;\n}\n\n.ui-icon-arrowthickstop-1-e {\n  background-position: -208px -48px;\n}\n\n.ui-icon-arrowthickstop-1-s {\n  background-position: -224px -48px;\n}\n\n.ui-icon-arrowthickstop-1-w {\n  background-position: -240px -48px;\n}\n\n.ui-icon-arrowreturnthick-1-w {\n  background-position: 0 -64px;\n}\n\n.ui-icon-arrowreturnthick-1-n {\n  background-position: -16px -64px;\n}\n\n.ui-icon-arrowreturnthick-1-e {\n  background-position: -32px -64px;\n}\n\n.ui-icon-arrowreturnthick-1-s {\n  background-position: -48px -64px;\n}\n\n.ui-icon-arrowreturn-1-w {\n  background-position: -64px -64px;\n}\n\n.ui-icon-arrowreturn-1-n {\n  background-position: -80px -64px;\n}\n\n.ui-icon-arrowreturn-1-e {\n  background-position: -96px -64px;\n}\n\n.ui-icon-arrowreturn-1-s {\n  background-position: -112px -64px;\n}\n\n.ui-icon-arrowrefresh-1-w {\n  background-position: -128px -64px;\n}\n\n.ui-icon-arrowrefresh-1-n {\n  background-position: -144px -64px;\n}\n\n.ui-icon-arrowrefresh-1-e {\n  background-position: -160px -64px;\n}\n\n.ui-icon-arrowrefresh-1-s {\n  background-position: -176px -64px;\n}\n\n.ui-icon-arrow-4 {\n  background-position: 0 -80px;\n}\n\n.ui-icon-arrow-4-diag {\n  background-position: -16px -80px;\n}\n\n.ui-icon-extlink {\n  background-position: -32px -80px;\n}\n\n.ui-icon-newwin {\n  background-position: -48px -80px;\n}\n\n.ui-icon-refresh {\n  background-position: -64px -80px;\n}\n\n.ui-icon-shuffle {\n  background-position: -80px -80px;\n}\n\n.ui-icon-transfer-e-w {\n  background-position: -96px -80px;\n}\n\n.ui-icon-transferthick-e-w {\n  background-position: -112px -80px;\n}\n\n.ui-icon-folder-collapsed {\n  background-position: 0 -96px;\n}\n\n.ui-icon-folder-open {\n  background-position: -16px -96px;\n}\n\n.ui-icon-document {\n  background-position: -32px -96px;\n}\n\n.ui-icon-document-b {\n  background-position: -48px -96px;\n}\n\n.ui-icon-note {\n  background-position: -64px -96px;\n}\n\n.ui-icon-mail-closed {\n  background-position: -80px -96px;\n}\n\n.ui-icon-mail-open {\n  background-position: -96px -96px;\n}\n\n.ui-icon-suitcase {\n  background-position: -112px -96px;\n}\n\n.ui-icon-comment {\n  background-position: -128px -96px;\n}\n\n.ui-icon-person {\n  background-position: -144px -96px;\n}\n\n.ui-icon-print {\n  background-position: -160px -96px;\n}\n\n.ui-icon-trash {\n  background-position: -176px -96px;\n}\n\n.ui-icon-locked {\n  background-position: -192px -96px;\n}\n\n.ui-icon-unlocked {\n  background-position: -208px -96px;\n}\n\n.ui-icon-bookmark {\n  background-position: -224px -96px;\n}\n\n.ui-icon-tag {\n  background-position: -240px -96px;\n}\n\n.ui-icon-home {\n  background-position: 0 -112px;\n}\n\n.ui-icon-flag {\n  background-position: -16px -112px;\n}\n\n.ui-icon-calendar {\n  background-position: -32px -112px;\n}\n\n.ui-icon-cart {\n  background-position: -48px -112px;\n}\n\n.ui-icon-pencil {\n  background-position: -64px -112px;\n}\n\n.ui-icon-clock {\n  background-position: -80px -112px;\n}\n\n.ui-icon-disk {\n  background-position: -96px -112px;\n}\n\n.ui-icon-calculator {\n  background-position: -112px -112px;\n}\n\n.ui-icon-zoomin {\n  background-position: -128px -112px;\n}\n\n.ui-icon-zoomout {\n  background-position: -144px -112px;\n}\n\n.ui-icon-search {\n  background-position: -160px -112px;\n}\n\n.ui-icon-wrench {\n  background-position: -176px -112px;\n}\n\n.ui-icon-gear {\n  background-position: -192px -112px;\n}\n\n.ui-icon-heart {\n  background-position: -208px -112px;\n}\n\n.ui-icon-star {\n  background-position: -224px -112px;\n}\n\n.ui-icon-link {\n  background-position: -240px -112px;\n}\n\n.ui-icon-cancel {\n  background-position: 0 -128px;\n}\n\n.ui-icon-plus {\n  background-position: -16px -128px;\n}\n\n.ui-icon-plusthick {\n  background-position: -32px -128px;\n}\n\n.ui-icon-minus {\n  background-position: -48px -128px;\n}\n\n.ui-icon-minusthick {\n  background-position: -64px -128px;\n}\n\n.ui-icon-close {\n  background-position: -80px -128px;\n}\n\n.ui-icon-closethick {\n  background-position: -96px -128px;\n}\n\n.ui-icon-key {\n  background-position: -112px -128px;\n}\n\n.ui-icon-lightbulb {\n  background-position: -128px -128px;\n}\n\n.ui-icon-scissors {\n  background-position: -144px -128px;\n}\n\n.ui-icon-clipboard {\n  background-position: -160px -128px;\n}\n\n.ui-icon-copy {\n  background-position: -176px -128px;\n}\n\n.ui-icon-contact {\n  background-position: -192px -128px;\n}\n\n.ui-icon-image {\n  background-position: -208px -128px;\n}\n\n.ui-icon-video {\n  background-position: -224px -128px;\n}\n\n.ui-icon-script {\n  background-position: -240px -128px;\n}\n\n.ui-icon-alert {\n  background-position: 0 -144px;\n}\n\n.ui-icon-info {\n  background-position: -16px -144px;\n}\n\n.ui-icon-notice {\n  background-position: -32px -144px;\n}\n\n.ui-icon-help {\n  background-position: -48px -144px;\n}\n\n.ui-icon-check {\n  background-position: -64px -144px;\n}\n\n.ui-icon-bullet {\n  background-position: -80px -144px;\n}\n\n.ui-icon-radio-on {\n  background-position: -96px -144px;\n}\n\n.ui-icon-radio-off {\n  background-position: -112px -144px;\n}\n\n.ui-icon-pin-w {\n  background-position: -128px -144px;\n}\n\n.ui-icon-pin-s {\n  background-position: -144px -144px;\n}\n\n.ui-icon-play {\n  background-position: 0 -160px;\n}\n\n.ui-icon-pause {\n  background-position: -16px -160px;\n}\n\n.ui-icon-seek-next {\n  background-position: -32px -160px;\n}\n\n.ui-icon-seek-prev {\n  background-position: -48px -160px;\n}\n\n.ui-icon-seek-end {\n  background-position: -64px -160px;\n}\n\n.ui-icon-seek-start {\n  background-position: -80px -160px;\n}\n\n/* ui-icon-seek-first is deprecated, use ui-icon-seek-start instead */\n.ui-icon-seek-first {\n  background-position: -80px -160px;\n}\n\n.ui-icon-stop {\n  background-position: -96px -160px;\n}\n\n.ui-icon-eject {\n  background-position: -112px -160px;\n}\n\n.ui-icon-volume-off {\n  background-position: -128px -160px;\n}\n\n.ui-icon-volume-on {\n  background-position: -144px -160px;\n}\n\n.ui-icon-power {\n  background-position: 0 -176px;\n}\n\n.ui-icon-signal-diag {\n  background-position: -16px -176px;\n}\n\n.ui-icon-signal {\n  background-position: -32px -176px;\n}\n\n.ui-icon-battery-0 {\n  background-position: -48px -176px;\n}\n\n.ui-icon-battery-1 {\n  background-position: -64px -176px;\n}\n\n.ui-icon-battery-2 {\n  background-position: -80px -176px;\n}\n\n.ui-icon-battery-3 {\n  background-position: -96px -176px;\n}\n\n.ui-icon-circle-plus {\n  background-position: 0 -192px;\n}\n\n.ui-icon-circle-minus {\n  background-position: -16px -192px;\n}\n\n.ui-icon-circle-close {\n  background-position: -32px -192px;\n}\n\n.ui-icon-circle-triangle-e {\n  background-position: -48px -192px;\n}\n\n.ui-icon-circle-triangle-s {\n  background-position: -64px -192px;\n}\n\n.ui-icon-circle-triangle-w {\n  background-position: -80px -192px;\n}\n\n.ui-icon-circle-triangle-n {\n  background-position: -96px -192px;\n}\n\n.ui-icon-circle-arrow-e {\n  background-position: -112px -192px;\n}\n\n.ui-icon-circle-arrow-s {\n  background-position: -128px -192px;\n}\n\n.ui-icon-circle-arrow-w {\n  background-position: -144px -192px;\n}\n\n.ui-icon-circle-arrow-n {\n  background-position: -160px -192px;\n}\n\n.ui-icon-circle-zoomin {\n  background-position: -176px -192px;\n}\n\n.ui-icon-circle-zoomout {\n  background-position: -192px -192px;\n}\n\n.ui-icon-circle-check {\n  background-position: -208px -192px;\n}\n\n.ui-icon-circlesmall-plus {\n  background-position: 0 -208px;\n}\n\n.ui-icon-circlesmall-minus {\n  background-position: -16px -208px;\n}\n\n.ui-icon-circlesmall-close {\n  background-position: -32px -208px;\n}\n\n.ui-icon-squaresmall-plus {\n  background-position: -48px -208px;\n}\n\n.ui-icon-squaresmall-minus {\n  background-position: -64px -208px;\n}\n\n.ui-icon-squaresmall-close {\n  background-position: -80px -208px;\n}\n\n.ui-icon-grip-dotted-vertical {\n  background-position: 0 -224px;\n}\n\n.ui-icon-grip-dotted-horizontal {\n  background-position: -16px -224px;\n}\n\n.ui-icon-grip-solid-vertical {\n  background-position: -32px -224px;\n}\n\n.ui-icon-grip-solid-horizontal {\n  background-position: -48px -224px;\n}\n\n.ui-icon-gripsmall-diagonal-se {\n  background-position: -64px -224px;\n}\n\n.ui-icon-grip-diagonal-se {\n  background-position: -80px -224px;\n}\n\n\n/* Misc visuals\n----------------------------------*/\n\n/* Corner radius */\n.ui-corner-all,\n.ui-corner-top,\n.ui-corner-left,\n.ui-corner-tl {\n  border-top-left-radius: 3px;\n}\n\n.ui-corner-all,\n.ui-corner-top,\n.ui-corner-right,\n.ui-corner-tr {\n  border-top-right-radius: 3px;\n}\n\n.ui-corner-all,\n.ui-corner-bottom,\n.ui-corner-left,\n.ui-corner-bl {\n  border-bottom-left-radius: 3px;\n}\n\n.ui-corner-all,\n.ui-corner-bottom,\n.ui-corner-right,\n.ui-corner-br {\n  border-bottom-right-radius: 3px;\n}\n\n/* Overlays */\n.ui-widget-overlay {\n  background: #aaaaaa;\n  opacity: .3;\n  filter: Alpha(Opacity=30);\n  /* support: IE8 */\n}\n\n.ui-widget-shadow {\n  -webkit-box-shadow: 0px 0px 5px #666666;\n  box-shadow: 0px 0px 5px #666666;\n}\n\n.styles_modal__gNwvD {\n  width: 1200px !important;\n}\n\n\n@keyframes customEnterAnimation {\n  0% {\n    transform: scale(0);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes customLeaveAnimation {\n  0% {\n    transform: scale(1);\n  }\n\n  100% {\n    transform: scale(0);\n  }\n}\n\n.customModal {\n  min-width: 1300px !important;\n  width: 1200px !important;\n}\n\n.errorStyles {\n  border: 1px solid red !important;\n}\n\n.logo-caption {\n  position: absolute;\n  bottom: -4px;\n  right: 13%;\n  z-index: 9999;\n  font-size: 11px;\n  color: #000;\n}\n\n.ag-header-cell-label .ag-header-cell-text {\n  white-space: normal !important;\n}\n\n.agrowheight {\n  height: 70px;\n}\n\n.maileven {\n  background: #d7fffa !important;\n}\n\n.wraptext {\n  white-space: normal !important;\n}\n\n.row.col-xl-12.col-lg-12.ml-0p.n-p-0.Transhipment-Edit-Row {\n  margin-top: 13px;\n}\n\n/* input#replaced_Date {\n    width: 72%;\n    margin-left: 121px;\n} */\n.save-btn {\n  height: 36px;\n  width: 100px;\n  margin-top: 35px;\n  margin-left: 41px;\n}\n\n.rdt.transhipment-datetime input {\n  width: 22em;\n  height: 40px;\n  margin-top: 4px;\n  margin-left: 29px;\n}\n\nlabel.replacement-time {\n  float: left;\n  width: 100%;\n  /* margin-left: 9em; */\n}\n\n.xdsoft_datetimepicker {\n  box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.506);\n  background: #fff;\n  border-bottom: 1px solid #bbb;\n  border-left: 1px solid #ccc;\n  border-right: 1px solid #ccc;\n  border-top: 1px solid #ccc;\n  color: #333;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  padding: 8px;\n  padding-left: 0;\n  padding-top: 2px;\n  position: absolute;\n  z-index: 9999;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  display: none;\n}\n\n.xdsoft_datetimepicker.xdsoft_rtl {\n  padding: 8px 0 8px 8px;\n}\n\n.xdsoft_datetimepicker iframe {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 75px;\n  height: 210px;\n  background: transparent;\n  border: none;\n}\n\n/*For IE8 or lower*/\n.xdsoft_datetimepicker button {\n  border: none !important;\n}\n\n.xdsoft_noselect {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n}\n\n.xdsoft_noselect::selection {\n  background: transparent\n}\n\n.xdsoft_noselect::-moz-selection {\n  background: transparent\n}\n\n.xdsoft_datetimepicker.xdsoft_inline {\n  display: inline-block;\n  position: static;\n  box-shadow: none;\n}\n\n.xdsoft_datetimepicker * {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n\n.xdsoft_datetimepicker .xdsoft_datepicker,\n.xdsoft_datetimepicker .xdsoft_timepicker {\n  display: none;\n}\n\n.xdsoft_datetimepicker .xdsoft_datepicker.active,\n.xdsoft_datetimepicker .xdsoft_timepicker.active {\n  display: block;\n}\n\n.xdsoft_datetimepicker .xdsoft_datepicker {\n  width: 224px;\n  float: left;\n  margin-left: 8px;\n}\n\n.xdsoft_datetimepicker.xdsoft_rtl .xdsoft_datepicker {\n  float: right;\n  margin-right: 8px;\n  margin-left: 0;\n}\n\n.xdsoft_datetimepicker.xdsoft_showweeks .xdsoft_datepicker {\n  width: 256px;\n}\n\n.xdsoft_datetimepicker .xdsoft_timepicker {\n  width: 58px;\n  float: left;\n  text-align: center;\n  margin-left: 8px;\n  margin-top: 0;\n}\n\n.xdsoft_datetimepicker.xdsoft_rtl .xdsoft_timepicker {\n  float: right;\n  margin-right: 8px;\n  margin-left: 0;\n}\n\n.xdsoft_datetimepicker .xdsoft_datepicker.active+.xdsoft_timepicker {\n  margin-top: 8px;\n  margin-bottom: 3px\n}\n\n.xdsoft_datetimepicker .xdsoft_monthpicker {\n  position: relative;\n  text-align: center;\n}\n\n.xdsoft_datetimepicker .xdsoft_label i,\n.xdsoft_datetimepicker .xdsoft_prev,\n.xdsoft_datetimepicker .xdsoft_next,\n.xdsoft_datetimepicker .xdsoft_today_button {\n  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAeCAYAAADaW7vzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Q0NBRjI1NjM0M0UwMTFFNDk4NkFGMzJFQkQzQjEwRUIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Q0NBRjI1NjQ0M0UwMTFFNDk4NkFGMzJFQkQzQjEwRUIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpDQ0FGMjU2MTQzRTAxMUU0OTg2QUYzMkVCRDNCMTBFQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDQ0FGMjU2MjQzRTAxMUU0OTg2QUYzMkVCRDNCMTBFQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PoNEP54AAAIOSURBVHja7Jq9TsMwEMcxrZD4WpBYeKUCe+kTMCACHZh4BFfHO/AAIHZGFhYkBBsSEqxsLCAgXKhbXYOTxh9pfJVP+qutnZ5s/5Lz2Y5I03QhWji2GIcgAokWgfCxNvcOCCGKqiSqhUp0laHOne05vdEyGMfkdxJDVjgwDlEQgYQBgx+ULJaWSXXS6r/ER5FBVR8VfGftTKcITNs+a1XpcFoExREIDF14AVIFxgQUS+h520cdud6wNkC0UBw6BCO/HoCYwBhD8QCkQ/x1mwDyD4plh4D6DDV0TAGyo4HcawLIBBSLDkHeH0Mg2yVP3l4TQMZQDDsEOl/MgHQqhMNuE0D+oBh0CIr8MAKyazBH9WyBuKxDWgbXfjNf32TZ1KWm/Ap1oSk/R53UtQ5xTh3LUlMmT8gt6g51Q9p+SobxgJQ/qmsfZhWywGFSl0yBjCLJCMgXail3b7+rumdVJ2YRss4cN+r6qAHDkPWjPjdJCF4n9RmAD/V9A/Wp4NQassDjwlB6XBiCxcJQWmZZb8THFilfy/lfrTvLghq2TqTHrRMTKNJ0sIhdo15RT+RpyWwFdY96UZ/LdQKBGjcXpcc1AlSFEfLmouD+1knuxBDUVrvOBmoOC/rEcN7OQxKVeJTCiAdUzUJhA2Oez9QTkp72OTVcxDcXY8iKNkxGAJXmJCOQwOa6dhyXsOa6XwEGAKdeb5ET3rQdAAAAAElFTkSuQmCC);\n}\n\n.xdsoft_datetimepicker .xdsoft_label i {\n  opacity: 0.5;\n  background-position: -92px -19px;\n  display: inline-block;\n  width: 9px;\n  height: 20px;\n  vertical-align: middle;\n}\n\n.xdsoft_datetimepicker .xdsoft_prev {\n  float: left;\n  background-position: -20px 0;\n}\n\n.xdsoft_datetimepicker .xdsoft_today_button {\n  float: left;\n  background-position: -70px 0;\n  margin-left: 5px;\n}\n\n.xdsoft_datetimepicker .xdsoft_next {\n  float: right;\n  background-position: 0 0;\n}\n\n.xdsoft_datetimepicker .xdsoft_next,\n.xdsoft_datetimepicker .xdsoft_prev,\n.xdsoft_datetimepicker .xdsoft_today_button {\n  background-color: transparent;\n  background-repeat: no-repeat;\n  border: 0 none;\n  cursor: pointer;\n  display: block;\n  height: 30px;\n  opacity: 0.5;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";\n  outline: medium none;\n  overflow: hidden;\n  padding: 0;\n  position: relative;\n  text-indent: 100%;\n  white-space: nowrap;\n  width: 20px;\n  min-width: 0;\n}\n\n.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_prev,\n.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_next {\n  float: none;\n  background-position: -40px -15px;\n  height: 15px;\n  width: 30px;\n  display: block;\n  margin-left: 14px;\n  margin-top: 7px;\n}\n\n.xdsoft_datetimepicker.xdsoft_rtl .xdsoft_timepicker .xdsoft_prev,\n.xdsoft_datetimepicker.xdsoft_rtl .xdsoft_timepicker .xdsoft_next {\n  float: none;\n  margin-left: 0;\n  margin-right: 14px;\n}\n\n.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_prev {\n  background-position: -40px 0;\n  margin-bottom: 7px;\n  margin-top: 0;\n}\n\n.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_time_box {\n  height: 151px;\n  overflow: hidden;\n  border-bottom: 1px solid #ddd;\n}\n\n.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_time_box>div>div {\n  background: #f5f5f5;\n  border-top: 1px solid #ddd;\n  color: #666;\n  font-size: 12px;\n  text-align: center;\n  border-collapse: collapse;\n  cursor: pointer;\n  border-bottom-width: 0;\n  height: 25px;\n  line-height: 25px;\n}\n\n.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_time_box>div>div:first-child {\n  border-top-width: 0;\n}\n\n.xdsoft_datetimepicker .xdsoft_today_button:hover,\n.xdsoft_datetimepicker .xdsoft_next:hover,\n.xdsoft_datetimepicker .xdsoft_prev:hover {\n  opacity: 1;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n}\n\n.xdsoft_datetimepicker .xdsoft_label {\n  display: inline;\n  position: relative;\n  z-index: 9999;\n  margin: 0;\n  padding: 5px 3px;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: bold;\n  background-color: #fff;\n  float: left;\n  width: 182px;\n  text-align: center;\n  cursor: pointer;\n}\n\n.xdsoft_datetimepicker .xdsoft_label:hover>span {\n  text-decoration: underline;\n}\n\n.xdsoft_datetimepicker .xdsoft_label:hover i {\n  opacity: 1.0;\n}\n\n.xdsoft_datetimepicker .xdsoft_label>.xdsoft_select {\n  border: 1px solid #ccc;\n  position: absolute;\n  right: 0;\n  top: 30px;\n  z-index: 101;\n  display: none;\n  background: #fff;\n  max-height: 160px;\n  overflow-y: hidden;\n}\n\n.xdsoft_datetimepicker .xdsoft_label>.xdsoft_select.xdsoft_monthselect {\n  right: -7px\n}\n\n.xdsoft_datetimepicker .xdsoft_label>.xdsoft_select.xdsoft_yearselect {\n  right: 2px\n}\n\n.xdsoft_datetimepicker .xdsoft_label>.xdsoft_select>div>.xdsoft_option:hover {\n  color: #fff;\n  background: #ff8000;\n}\n\n.xdsoft_datetimepicker .xdsoft_label>.xdsoft_select>div>.xdsoft_option {\n  padding: 2px 10px 2px 5px;\n  text-decoration: none !important;\n}\n\n.xdsoft_datetimepicker .xdsoft_label>.xdsoft_select>div>.xdsoft_option.xdsoft_current {\n  background: #33aaff;\n  box-shadow: #178fe5 0 1px 3px 0 inset;\n  color: #fff;\n  font-weight: 700;\n}\n\n.xdsoft_datetimepicker .xdsoft_month {\n  width: 100px;\n  text-align: right;\n}\n\n.xdsoft_datetimepicker .xdsoft_calendar {\n  clear: both;\n}\n\n.xdsoft_datetimepicker .xdsoft_year {\n  width: 48px;\n  margin-left: 5px;\n}\n\n.xdsoft_datetimepicker .xdsoft_calendar table {\n  border-collapse: collapse;\n  width: 100%;\n\n}\n\n.xdsoft_datetimepicker .xdsoft_calendar td>div {\n  padding-right: 5px;\n}\n\n.xdsoft_datetimepicker .xdsoft_calendar th {\n  height: 25px;\n}\n\n.xdsoft_datetimepicker .xdsoft_calendar td,\n.xdsoft_datetimepicker .xdsoft_calendar th {\n  width: 14.2857142%;\n  background: #f5f5f5;\n  border: 1px solid #ddd;\n  color: #666;\n  font-size: 12px;\n  text-align: right;\n  vertical-align: middle;\n  padding: 0;\n  border-collapse: collapse;\n  cursor: pointer;\n  height: 25px;\n}\n\n.xdsoft_datetimepicker.xdsoft_showweeks .xdsoft_calendar td,\n.xdsoft_datetimepicker.xdsoft_showweeks .xdsoft_calendar th {\n  width: 12.5%;\n}\n\n.xdsoft_datetimepicker .xdsoft_calendar th {\n  background: #f1f1f1;\n}\n\n.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_today {\n  color: #33aaff;\n}\n\n.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_highlighted_default {\n  background: #ffe9d2;\n  box-shadow: #ffb871 0 1px 4px 0 inset;\n  color: #000;\n}\n\n.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_highlighted_mint {\n  background: #c1ffc9;\n  box-shadow: #00dd1c 0 1px 4px 0 inset;\n  color: #000;\n}\n\n.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_default,\n.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_current,\n.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_time_box>div>div.xdsoft_current {\n  background: #33aaff;\n  box-shadow: #178fe5 0 1px 3px 0 inset;\n  color: #fff;\n  font-weight: 700;\n}\n\n.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_other_month,\n.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_disabled,\n.xdsoft_datetimepicker .xdsoft_time_box>div>div.xdsoft_disabled {\n  opacity: 0.5;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";\n  cursor: default;\n}\n\n.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_other_month.xdsoft_disabled {\n  opacity: 0.2;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=20)\";\n}\n\n.xdsoft_datetimepicker .xdsoft_calendar td:hover,\n.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_time_box>div>div:hover {\n  color: #fff !important;\n  background: #ff8000 !important;\n  box-shadow: none !important;\n}\n\n.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_current.xdsoft_disabled:hover,\n.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_time_box>div>div.xdsoft_current.xdsoft_disabled:hover {\n  background: #33aaff !important;\n  box-shadow: #178fe5 0 1px 3px 0 inset !important;\n  color: #fff !important;\n}\n\n.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_disabled:hover,\n.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_time_box>div>div.xdsoft_disabled:hover {\n  color: inherit !important;\n  background: inherit !important;\n  box-shadow: inherit !important;\n}\n\n.xdsoft_datetimepicker .xdsoft_calendar th {\n  font-weight: 700;\n  text-align: center;\n  color: #999;\n  cursor: default;\n}\n\n.xdsoft_datetimepicker .xdsoft_copyright {\n  color: #ccc !important;\n  font-size: 10px;\n  clear: both;\n  float: none;\n  margin-left: 8px;\n}\n\n.xdsoft_datetimepicker .xdsoft_copyright a {\n  color: #eee !important\n}\n\n.xdsoft_datetimepicker .xdsoft_copyright a:hover {\n  color: #aaa !important\n}\n\n.xdsoft_time_box {\n  position: relative;\n  border: 1px solid #ccc;\n}\n\n.xdsoft_scrollbar>.xdsoft_scroller {\n  background: #ccc !important;\n  height: 20px;\n  border-radius: 3px;\n}\n\n.xdsoft_scrollbar {\n  position: absolute;\n  width: 7px;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  cursor: pointer;\n}\n\n.xdsoft_datetimepicker.xdsoft_rtl .xdsoft_scrollbar {\n  left: 0;\n  right: auto;\n}\n\n.xdsoft_scroller_box {\n  position: relative;\n}\n\n.xdsoft_datetimepicker.xdsoft_dark {\n  box-shadow: 0 5px 15px -5px rgba(255, 255, 255, 0.506);\n  background: #000;\n  border-bottom: 1px solid #444;\n  border-left: 1px solid #333;\n  border-right: 1px solid #333;\n  border-top: 1px solid #333;\n  color: #ccc;\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_timepicker .xdsoft_time_box {\n  border-bottom: 1px solid #222;\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_timepicker .xdsoft_time_box>div>div {\n  background: #0a0a0a;\n  border-top: 1px solid #222;\n  color: #999;\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_label {\n  background-color: #000;\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_label>.xdsoft_select {\n  border: 1px solid #333;\n  background: #000;\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_label>.xdsoft_select>div>.xdsoft_option:hover {\n  color: #000;\n  background: #007fff;\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_label>.xdsoft_select>div>.xdsoft_option.xdsoft_current {\n  background: #cc5500;\n  box-shadow: #b03e00 0 1px 3px 0 inset;\n  color: #000;\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_label i,\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_prev,\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_next,\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_today_button {\n  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAeCAYAAADaW7vzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QUExQUUzOTA0M0UyMTFFNDlBM0FFQTJENTExRDVBODYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QUExQUUzOTE0M0UyMTFFNDlBM0FFQTJENTExRDVBODYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpBQTFBRTM4RTQzRTIxMUU0OUEzQUVBMkQ1MTFENUE4NiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBQTFBRTM4RjQzRTIxMUU0OUEzQUVBMkQ1MTFENUE4NiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pp0VxGEAAAIASURBVHja7JrNSgMxEMebtgh+3MSLr1T1Xn2CHoSKB08+QmR8Bx9A8e7RixdB9CKCoNdexIugxFlJa7rNZneTbLIpM/CnNLsdMvNjM8l0mRCiQ9Ye61IKCAgZAUnH+mU3MMZaHYChBnJUDzWOFZdVfc5+ZFLbrWDeXPwbxIqrLLfaeS0hEBVGIRQCEiZoHQwtlGSByCCdYBl8g8egTTAWoKQMRBRBcZxYlhzhKegqMOageErsCHVkk3hXIFooDgHB1KkHIHVgzKB4ADJQ/A1jAFmAYhkQqA5TOBtocrKrgXwQA8gcFIuAIO8sQSA7hidvPwaQGZSaAYHOUWJABhWWw2EMIH9QagQERU4SArJXo0ZZL18uvaxejXt/Em8xjVBXmvFr1KVm/AJ10tRe2XnraNqaJvKE3KHuUbfK1E+VHB0q40/y3sdQSxY4FHWeKJCunP8UyDdqJZenT3ntVV5jIYCAh20vT7ioP8tpf6E2lfEMwERe+whV1MHjwZB7PBiCxcGQWwKZKD62lfGNnP/1poFAA60T7rF1UgcKd2id3KDeUS+oLWV8DfWAepOfq00CgQabi9zjcgJVYVD7PVzQUAUGAQkbNJTBICDhgwYTjDYD6XeW08ZKh+A4pYkzenOxXUbvZcWz7E8ykRMnIHGX1XPl+1m2vPYpL+2qdb8CDAARlKFEz/ZVkAAAAABJRU5ErkJggg==);\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar td,\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar th {\n  background: #0a0a0a;\n  border: 1px solid #222;\n  color: #999;\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar th {\n  background: #0e0e0e;\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar td.xdsoft_today {\n  color: #cc5500;\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar td.xdsoft_highlighted_default {\n  background: #ffe9d2;\n  box-shadow: #ffb871 0 1px 4px 0 inset;\n  color: #000;\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar td.xdsoft_highlighted_mint {\n  background: #c1ffc9;\n  box-shadow: #00dd1c 0 1px 4px 0 inset;\n  color: #000;\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar td.xdsoft_default,\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar td.xdsoft_current,\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_timepicker .xdsoft_time_box>div>div.xdsoft_current {\n  background: #cc5500;\n  box-shadow: #b03e00 0 1px 3px 0 inset;\n  color: #000;\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar td:hover,\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_timepicker .xdsoft_time_box>div>div:hover {\n  color: #000 !important;\n  background: #007fff !important;\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_calendar th {\n  color: #666;\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_copyright {\n  color: #333 !important\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_copyright a {\n  color: #111 !important\n}\n\n.xdsoft_datetimepicker.xdsoft_dark .xdsoft_copyright a:hover {\n  color: #555 !important\n}\n\n.xdsoft_dark .xdsoft_time_box {\n  border: 1px solid #333;\n}\n\n.xdsoft_dark .xdsoft_scrollbar>.xdsoft_scroller {\n  background: #333 !important;\n}\n\n.xdsoft_datetimepicker .xdsoft_save_selected {\n  display: block;\n  border: 1px solid #dddddd !important;\n  margin-top: 5px;\n  width: 100%;\n  color: #454551;\n  font-size: 13px;\n}\n\n.xdsoft_datetimepicker .blue-gradient-button {\n  font-family: \"museo-sans\", \"Book Antiqua\", sans-serif;\n  font-size: 12px;\n  font-weight: 300;\n  color: #82878c;\n  height: 28px;\n  position: relative;\n  padding: 4px 17px 4px 33px;\n  border: 1px solid #d7d8da;\n  background: -moz-linear-gradient(top, #fff 0%, #f4f8fa 73%);\n  /* FF3.6+ */\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #fff), color-stop(73%, #f4f8fa));\n  /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(top, #fff 0%, #f4f8fa 73%);\n  /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(top, #fff 0%, #f4f8fa 73%);\n  /* Opera 11.10+ */\n  background: -ms-linear-gradient(top, #fff 0%, #f4f8fa 73%);\n  /* IE10+ */\n  background: linear-gradient(to bottom, #fff 0%, #f4f8fa 73%);\n  /* W3C */\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff', endColorstr='#f4f8fa', GradientType=0);\n  /* IE6-9 */\n}\n\n.xdsoft_datetimepicker .blue-gradient-button:hover,\n.xdsoft_datetimepicker .blue-gradient-button:focus,\n.xdsoft_datetimepicker .blue-gradient-button:hover span,\n.xdsoft_datetimepicker .blue-gradient-button:focus span {\n  color: #454551;\n  background: -moz-linear-gradient(top, #f4f8fa 0%, #FFF 73%);\n  /* FF3.6+ */\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #f4f8fa), color-stop(73%, #FFF));\n  /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(top, #f4f8fa 0%, #FFF 73%);\n  /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(top, #f4f8fa 0%, #FFF 73%);\n  /* Opera 11.10+ */\n  background: -ms-linear-gradient(top, #f4f8fa 0%, #FFF 73%);\n  /* IE10+ */\n  background: linear-gradient(to bottom, #f4f8fa 0%, #FFF 73%);\n  /* W3C */\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f4f8fa', endColorstr='#FFF', GradientType=0);\n  /* IE6-9 */\n}\n\n.d-none {\n  display: none;\n}\n\n.summary-title {\n  font-size: 18px;\n  padding: 10px;\n  color: #ffffff;\n  background-color: #0abb80;\n}\n\n.summary-blue {\n  color: #4099ff !important;\n}\n\n.summary-green {\n  color: #0abb80 !important;\n}\n\n.summary-yellow {\n  color: #f3d800 !important;\n}\n\n.summary-red {\n  color: #FF5370 !important;\n}\n\n.summary-grid {\n  position: absolute;\n  top: 0px;\n  left: 15px;\n  width: 93%;\n  height: 98%;\n  background: #fff;\n  z-index: 9999;\n  overflow-y: auto;\n}\n\n.summary-back {\n  padding: 3px 5px;\n  position: absolute;\n  right: 22px;\n  top: 5px;\n}\n\n.summary-span {\n  font-size: 18px;\n}\n\n.summary-grid-title {\n  background: #ff5370;\n  color: #fff;\n  padding: 10px 5px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.summary-body {\n  padding: 10px 10px;\n}\n\n.bordergray {\n  border: 1px solid #ccc;\n}\n\n.hcolor {\n  color: #f7516f !important;\n}\n\n.todo-options ul li {\n  margin: 10px;\n  color: #000;\n  padding: 0px\n}\n\n.brd-btm-gray {\n  border-bottom: 1px solid #ccc;\n}\n\n.z999 {\n  z-index: 999;\n}\n\n.z9999 {\n  z-index: 9999;\n}\n\n.oddbg {\n  background: #c2edf8\n}\n\n.summary-lbl {\n  background: #357fa4;\n  color: #fff;\n  text-align: center;\n  padding: 5px 0px;\n  font-size: 14px;\n  margin: 0px;\n}\n\n.brd-right {\n  border-right: 1px solid #eee;\n}\n\n.txt-dec-none {\n  text-decoration: none;\n}\n\n.clr333 {\n  color: #333333;\n}\n\n.clr333:hover {\n  color: #1f749c;\n}\n\n.cell-wrap {\n  white-space: normal !important;\n  line-height: 1.5\n}\n\n.custom-tooltip {\n  position: absolute;\n  background: #FFFFFF;\n  width: 200px;\n  height: 90px;\n  border: 1px solid cornflowerblue;\n  pointer-events: none;\n  transition: opacity 1s;\n  word-wrap: break-word;\n}\n\n.custom-tooltip.ag-tooltip-hiding {\n  opacity: 0;\n}\n\n.custom-tooltip p {\n  margin: 5px;\n  white-space: nowrap;\n}\n\n.custom-tooltip p:first-of-type {\n  font-weight: bold;\n}\n\n.tabc {\n  float: left;\n  width: 100%;\n}\n\n.tabc li {\n  float: left;\n  margin: 0px 1px 15px 0px;\n}\n\n.tabc li a {\n  padding: 15px 25px;\n  background: #4c5a57;\n  border: 1px solid #4c5a57;\n  color: #fff;\n  text-decoration: none;\n  font-size: 16px;\n}\n\n.tabc li a.active {\n  /*background: #eefaf7;*/\n  background: #ffffff;\n  color: #00c292;\n  border-top: 1px solid #eee;\n  border-right: 1px solid #eee;\n  border-left: 1px solid #eee;\n  border-bottom: 0px solid #eee;\n}\n\n.tabc-sm {\n  float: left;\n  width: 100%;\n}\n\n.tabc-sm li {\n  float: left;\n  margin: 0px 1px 15px 0px;\n}\n\n.tabc-sm li a {\n  padding: 5px 25px;\n  background: #4c5a57;\n  border: 1px solid #4c5a57;\n  color: #fff;\n  text-decoration: none;\n  font-size: 16px;\n}\n\n.tabc-sm li a.active {\n  /*background: #eefaf7;*/\n  background: #ffffff;\n  color: #00c292;\n  border-top: 1px solid #eee;\n  border-right: 1px solid #eee;\n  border-left: 1px solid #eee;\n  border-bottom: 0px solid #eee;\n}\n\n\n.tabc-sbm {\n  float: left;\n  width: 100%;\n}\n\n.tabc-sbm li {\n  float: left;\n  margin: 0px 1px 15px 0px;\n}\n\n.tabc-sbm li a {\n  padding: 5px 25px;\n  background: #4c5956;\n  border: 1px solid #4c5a57;\n  color: #fff;\n  text-decoration: none;\n  font-size: 16px;\n}\n\n.tabc-sbm li a.active {\n  /*background: #eefaf7;*/\n  background: #f3da3c;\n  color: #333333;\n  border-top: 1px solid #eee;\n  border-right: 1px solid #eee;\n  border-left: 1px solid #eee;\n  border-bottom: 0px solid #eee;\n}\n\n.tab-brd {\n  border: 1px solid #eee;\n}\n\n.optchrt {\n  font-size: 18px;\n  background: #eee;\n  padding: 5px;\n  text-align: center;\n  margin-bottom: 20px\n}\n\n.fixtb {\n  position: fixed;\n  right: 0;\n  top: 30%;\n\n  z-index: 999;\n}\n\n.fixtb li {\n  margin: 10px;\n  background: #fff;\n  padding: 10px;\n  background: #ccc;\n}\n\n.fixtb li a {\n  padding: 5px 10px;\n  text-decoration: none;\n  color: #333\n}\n\n.gr-check {\n  height: 16px;\n  width: 16px;\n  background: rgb(245, 245, 245);\n  border: 1px solid #7f8c8d;\n  border-radius: 3px;\n}\n\n/* .styles_modal__gNwvD, .styles_modal__gNwvD>div{\n\tpadding: 0px !important;\n    width: 830px !important;\n} */\nh5.modeltitle {\n  width: 100%;\n  background: #068cda;\n  padding: 10px;\n  color: #fff;\n}\n\n.dashboard-page {\n  position: absolute;\n  left: -27px;\n  top: 80px;\n  background: #ccc;\n}\n\n.dashboard-page li {\n  border-bottom: 1px solid #ccc;\n}\n\n.dashboard-page li.active {\n  background: #fff;\n}\n\n.dashboard-page li a.active {\n  background: #fff;\n}\n\n.dashboard-page li:last-child {\n  border-bottom: 0px solid #ccc;\n}\n\n.dashboard-page li:hover {\n  background: #fff;\n}\n\n.dashboard-icon {\n  width: 48px;\n  height: 48px;\n  margin: 5px;\n  padding: 5px;\n}\n\n.dashboard-sub {\n  position: absolute;\n  right: -220px;\n  top: 0;\n  background: #fff;\n  width: 220px;\n  min-height: 60px;\n  height: auto;\n  z-index: 9;\n  font-size: 12px;\n  box-shadow: 6px 0px 25px 6px #ccc;\n}\n\n.dashboard-sub a {\n  color: #333;\n  text-decoration: none;\n}\n\n.dashboard-sub li {\n  width: 100%;\n  background: #d4d4d4;\n  padding-left: 12px;\n  border-bottom: 1px solid #ccc;\n  line-height: 40px;\n}\n\n.dashboard-sub li:hover {\n  background: #fff;\n}\n\n.dashboard-sub li a {\n  color: #333;\n  padding: 12px 0px;\n}\n\n.dashboard-sub img {\n  width: 24px;\n  height: 24px;\n}\n\n.dashboard-sub li:last-child {\n  border-bottom: 1px solid #ccc;\n}\n\n.dashboard-sub li.active {\n  background: #fff;\n}\n\n\n.map {\n  position: initial !important\n}\n\n.nav-tooltip {\n  position: absolute;\n  top: 52px;\n  left: 44px;\n  background: #343434;\n  color: white;\n  padding: 9px;\n  font-size: 12px;\n}\n\nspan.nav-left-arrow {\n  position: absolute;\n  left: 35px;\n  top: 54.5px;\n  color: #343434;\n}\n\ndiv#pbody {\n  padding-top: 48px;\n  background-color: #fff;\n}\n\n.btn-data {\n  height: 35px;\n  padding: 6px;\n  margin-top: 22px;\n}\n\n.close-menu-alert {\n  position: absolute;\n  top: 52px;\n  left: 181px;\n  color: white;\n  font-size: 13px;\n  /* height: 28px; */\n  padding: 0px 6px 0px 6px;\n  z-index: 1000;\n  background: cornflowerblue;\n  opacity: 0.9 !important;\n}\n\n.card-body.pt-15px .row {\n  /* margin-top: 23px; */\n}\n\n.hr-dashed {\n  margin: 2% 0 2% 0;\n  border-bottom: 1px dotted #ccc;\n}\n\n.aircargo-form label {\n  padding: 0;\n  color: #3d6cb7;\n  margin-top: 2%;\n}\n\n/* .mybtn { */\n  /* background: #ded022 !important; */\n  /* color: #333;\n  font-size: 10px;\n  padding: 2px 5px 2px; */\n  /* border: 1px solid #ded022 !important; */\n/* } */\n\n.mybtn:hover,\n.mybtn:visited,\n.mybtn:focus,\n.mybtn:active {\n  /* background: #dead22 !important; */\n  color: #333 !important;\n  /* border: 1px solid #ded022 !important; */\n}\n\n\n.map-overly {\n  background: black;\n  opacity: 0.7;\n  color: white;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  text-align: center;\n  padding-top: 15em;\n}\n\n.c-pd {\n  padding: 5px 0px !important;\n}\n\n.w85p {\n  width: 85% !important\n}\n\n.w90p {\n  width: 90% !important\n}\n\n.layoutbtns {\n  display: block;\n}\n\n.display-block {\n  display: block;\n}\n\n.highcharts-root {\n  width: 100% !important;\n}\n\n.show-unloading-dashboard {\n  display: flex;\n}\n\n.m-top-1 {\n  margin-top: 1%;\n}\n\n.m-top-2 {\n  margin-top: 2%;\n}\n\n.viewcs li {\n  display: inline-block;\n}\n\n/*Full Calender*/\n\n/* classes attached to <body> */\n.fc-theme-standard {\n  width: 100%\n}\n\n.fc-not-allowed,\n.fc-not-allowed .fc-event {\n  /* override events' custom cursors */\n  cursor: not-allowed;\n}\n\n.fc-unselectable {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.fc {\n  /* layout of immediate children */\n  display: flex;\n  flex-direction: column;\n\n  font-size: 1em\n}\n\n.fc,\n.fc *,\n.fc *:before,\n.fc *:after {\n  box-sizing: border-box;\n}\n\n.fc table {\n  border-collapse: collapse;\n  border-spacing: 0;\n  font-size: 1em;\n  /* normalize cross-browser */\n}\n\n.fc th {\n  text-align: center;\n}\n\n.fc th,\n.fc td {\n  vertical-align: top;\n  padding: 0;\n}\n\n.fc a[data-navlink] {\n  cursor: pointer;\n}\n\n.fc a[data-navlink]:hover {\n  text-decoration: underline;\n}\n\n.fc-direction-ltr {\n  direction: ltr;\n  text-align: left;\n}\n\n.fc-direction-rtl {\n  direction: rtl;\n  text-align: right;\n}\n\n.fc-theme-standard td,\n.fc-theme-standard th {\n  border: 1px solid #ddd;\n  border: 1px solid var(--fc-border-color, #ddd);\n}\n\n/* for FF, which doesn't expand a 100% div within a table cell. use absolute positioning */\n/* inner-wrappers are responsible for being absolute */\n/* TODO: best place for this? */\n.fc-liquid-hack td,\n.fc-liquid-hack th {\n  position: relative;\n}\n\n@font-face {\n  font-family: 'fcicons';\n  src: url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n.fc-icon {\n  /* added for fc */\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  text-align: center;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'fcicons' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.fc-icon-chevron-left:before {\n  content: \"\\e900\";\n}\n\n.fc-icon-chevron-right:before {\n  content: \"\\e901\";\n}\n\n.fc-icon-chevrons-left:before {\n  content: \"\\e902\";\n}\n\n.fc-icon-chevrons-right:before {\n  content: \"\\e903\";\n}\n\n.fc-icon-minus-square:before {\n  content: \"\\e904\";\n}\n\n.fc-icon-plus-square:before {\n  content: \"\\e905\";\n}\n\n.fc-icon-x:before {\n  content: \"\\e906\";\n}\n\n/*\nLots taken from Flatly (MIT): https://bootswatch.com/4/flatly/bootstrap.css\n\nThese styles only apply when the standard-theme is activated.\nWhen it's NOT activated, the fc-button classes won't even be in the DOM.\n*/\n.fc {\n\n  /* reset */\n\n}\n\n.fc .fc-button {\n  border-radius: 0;\n  overflow: visible;\n  text-transform: none;\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\n.fc .fc-button:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\n.fc .fc-button {\n  -webkit-appearance: button;\n}\n\n.fc .fc-button:not(:disabled) {\n  cursor: pointer;\n}\n\n.fc .fc-button::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n.fc {\n\n  /* theme */\n\n}\n\n.fc .fc-button {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.4em 0.65em;\n  font-size: 1em;\n  line-height: 1.5;\n  border-radius: 0.25em;\n}\n\n.fc .fc-button:hover {\n  text-decoration: none;\n}\n\n.fc .fc-button:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(44, 62, 80, 0.25);\n}\n\n.fc .fc-button:disabled {\n  opacity: 0.65;\n}\n\n.fc {\n\n  /* \"primary\" coloring */\n\n}\n\n.fc .fc-button-primary {\n  color: #fff;\n  color: var(--fc-button-text-color, #fff);\n  background-color: #2C3E50;\n  background-color: var(--fc-button-bg-color, #2C3E50);\n  border-color: #2C3E50;\n  border-color: var(--fc-button-border-color, #2C3E50);\n}\n\n.fc .fc-button-primary:hover {\n  color: #fff;\n  color: var(--fc-button-text-color, #fff);\n  background-color: #1e2b37;\n  background-color: var(--fc-button-hover-bg-color, #1e2b37);\n  border-color: #1a252f;\n  border-color: var(--fc-button-hover-border-color, #1a252f);\n}\n\n.fc .fc-button-primary:disabled {\n  /* not DRY */\n  color: #fff;\n  color: var(--fc-button-text-color, #fff);\n  background-color: #2C3E50;\n  background-color: var(--fc-button-bg-color, #2C3E50);\n  border-color: #2C3E50;\n  border-color: var(--fc-button-border-color, #2C3E50);\n  /* overrides :hover */\n}\n\n.fc .fc-button-primary:focus {\n  box-shadow: 0 0 0 0.2rem rgba(76, 91, 106, 0.5);\n}\n\n.fc .fc-button-primary:not(:disabled):active,\n.fc .fc-button-primary:not(:disabled).fc-button-active {\n  color: #fff;\n  color: var(--fc-button-text-color, #fff);\n  background-color: #1a252f;\n  background-color: var(--fc-button-active-bg-color, #1a252f);\n  border-color: #151e27;\n  border-color: var(--fc-button-active-border-color, #151e27);\n}\n\n.fc .fc-button-primary:not(:disabled):active:focus,\n.fc .fc-button-primary:not(:disabled).fc-button-active:focus {\n  box-shadow: 0 0 0 0.2rem rgba(76, 91, 106, 0.5);\n}\n\n.fc {\n\n  /* icons within buttons */\n\n}\n\n.fc .fc-button .fc-icon {\n  vertical-align: middle;\n  font-size: 1.5em;\n  /* bump up the size (but don't make it bigger than line-height of button, which is 1.5em also) */\n}\n\n.fc .fc-button-group {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n/* .white{\n  color:#fff;\n} */\n/* .defaultBlue{\n  background-color:#F7F7F7 !important;\n  color:#fff !important\n} */\n.bold-text{\n  font-weight: bold;\n}\n.fc .fc-button-group>.fc-button {\n  position: relative;\n  flex: 1 1 auto;\n}\n\n.fc .fc-button-group>.fc-button:hover {\n  z-index: 1;\n}\n\n.fc .fc-button-group>.fc-button:focus,\n.fc .fc-button-group>.fc-button:active,\n.fc .fc-button-group>.fc-button.fc-button-active {\n  z-index: 1;\n}\n\n.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child) {\n  margin-left: -1px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child) {\n  margin-right: -1px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.fc .fc-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.fc .fc-toolbar.fc-header-toolbar {\n  margin-bottom: 1.5em;\n}\n\n.fc .fc-toolbar.fc-footer-toolbar {\n  margin-top: 1.5em;\n}\n\n.fc .fc-toolbar-title {\n  font-size: 1.75em;\n  margin: 0;\n}\n\n.fc-direction-ltr .fc-toolbar>*> :not(:first-child) {\n  margin-left: .75em;\n  /* space between */\n}\n\n.fc-direction-rtl .fc-toolbar>*> :not(:first-child) {\n  margin-right: .75em;\n  /* space between */\n}\n\n.fc-direction-rtl .fc-toolbar-ltr {\n  /* when the toolbar-chunk positioning system is explicitly left-to-right */\n  flex-direction: row-reverse;\n}\n\n.fc .fc-scroller {\n  -webkit-overflow-scrolling: touch;\n  position: relative;\n  /* for abs-positioned elements within */\n}\n\n.fc .fc-scroller-liquid {\n  height: 100%;\n}\n\n.fc .fc-scroller-liquid-absolute {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n}\n\n.fc .fc-scroller-harness {\n  position: relative;\n  overflow: hidden;\n  direction: ltr;\n  /* hack for chrome computing the scroller's right/left wrong for rtl. undone below... */\n  /* TODO: demonstrate in codepen */\n}\n\n.fc .fc-scroller-harness-liquid {\n  height: 100%;\n}\n\n.fc-direction-rtl .fc-scroller-harness>.fc-scroller {\n  /* undo above hack */\n  direction: rtl;\n}\n\n.fc-theme-standard .fc-scrollgrid {\n  border: 1px solid #ddd;\n  border: 1px solid var(--fc-border-color, #ddd);\n  /* bootstrap does this. match */\n}\n\n.fc .fc-scrollgrid,\n.fc .fc-scrollgrid table {\n  /* all tables (self included) */\n  width: 100%;\n  /* because tables don't normally do this */\n  table-layout: fixed;\n}\n\n.fc .fc-scrollgrid table {\n  /* inner tables */\n  border-top-style: hidden;\n  border-left-style: hidden;\n  border-right-style: hidden;\n}\n\n.fc .fc-scrollgrid {\n\n  border-collapse: separate;\n  border-right-width: 0;\n  border-bottom-width: 0;\n\n}\n\n.fc .fc-scrollgrid-liquid {\n  height: 100%;\n}\n\n.fc .fc-scrollgrid-section {\n  /* a <tr> */\n  height: 1px\n    /* better than 0, for firefox */\n\n}\n\n.fc .fc-scrollgrid-section>td {\n  height: 1px;\n  /* needs a height so inner div within grow. better than 0, for firefox */\n}\n\n.fc .fc-scrollgrid-section table {\n  height: 1px;\n  /* for most browsers, if a height isn't set on the table, can't do liquid-height within cells */\n  /* serves as a min-height. harmless */\n}\n\n.fc .fc-scrollgrid-section-liquid {\n  height: auto\n}\n\n.fc .fc-scrollgrid-section-liquid>td {\n  height: 100%;\n  /* better than `auto`, for firefox */\n}\n\n.fc .fc-scrollgrid-section>* {\n  border-top-width: 0;\n  border-left-width: 0;\n}\n\n.fc .fc-scrollgrid-section-header>*,\n.fc .fc-scrollgrid-section-footer>* {\n  border-bottom-width: 0;\n}\n\n.fc .fc-scrollgrid-section-body table,\n.fc .fc-scrollgrid-section-footer table {\n  border-bottom-style: hidden;\n  /* head keeps its bottom border tho */\n}\n\n.fc {\n\n  /* stickiness */\n\n}\n\n.fc .fc-scrollgrid-section-sticky>* {\n  background: #fff;\n  background: var(--fc-page-bg-color, #fff);\n  position: -webkit-sticky;\n  position: sticky;\n  z-index: 2;\n  /* TODO: var */\n  /* TODO: box-shadow when sticking */\n}\n\n.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>* {\n  top: 0;\n  /* because border-sharing causes a gap at the top */\n  /* TODO: give safari -1. has bug */\n}\n\n.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>* {\n  bottom: 0;\n  /* known bug: bottom-stickiness doesn't work in safari */\n}\n\n.fc .fc-scrollgrid-sticky-shim {\n  /* for horizontal scrollbar */\n  height: 1px;\n  /* needs height to create scrollbars */\n  margin-bottom: -1px;\n}\n\n.fc-sticky {\n  /* no .fc wrap because used as child of body */\n  position: -webkit-sticky;\n  position: sticky;\n}\n\n.fc .fc-view-harness {\n  flex-grow: 1;\n  /* because this harness is WITHIN the .fc's flexbox */\n  position: relative;\n}\n\n.fc {\n\n  /* when the harness controls the height, make the view liquid */\n\n}\n\n.fc .fc-view-harness-active>.fc-view {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.fc .fc-col-header-cell-cushion {\n  display: inline-block;\n  /* x-browser for when sticky (when multi-tier header) */\n  padding: 2px 4px;\n}\n\n.fc .fc-bg-event,\n.fc .fc-non-business,\n.fc .fc-highlight {\n  /* will always have a harness with position:relative/absolute, so absolutely expand */\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.fc .fc-non-business {\n  background: rgba(215, 215, 215, 0.3);\n  background: var(--fc-non-business-color, rgba(215, 215, 215, 0.3));\n}\n\n.fc .fc-bg-event {\n  background: rgb(143, 223, 130);\n  background: var(--fc-bg-event-color, rgb(143, 223, 130));\n  opacity: 0.3;\n  opacity: var(--fc-bg-event-opacity, 0.3)\n}\n\n.fc .fc-bg-event .fc-event-title {\n  margin: .5em;\n  font-size: .85em;\n  font-size: var(--fc-small-font-size, .85em);\n  font-style: italic;\n}\n\n.fc .fc-highlight {\n  background: rgba(188, 232, 241, 0.3);\n  background: var(--fc-highlight-color, rgba(188, 232, 241, 0.3));\n}\n\n.fc .fc-cell-shaded,\n.fc .fc-day-disabled {\n  background: rgba(208, 208, 208, 0.3);\n  background: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));\n}\n\n/* link resets */\n/* ---------------------------------------------------------------------------------------------------- */\na.fc-event,\na.fc-event:hover {\n  text-decoration: none;\n}\n\n/* cursor */\n.fc-event[href],\n.fc-event.fc-event-draggable {\n  cursor: pointer;\n}\n\n/* event text content */\n/* ---------------------------------------------------------------------------------------------------- */\n.fc-event .fc-event-main {\n  position: relative;\n  z-index: 2;\n}\n\n/* dragging */\n/* ---------------------------------------------------------------------------------------------------- */\n.fc-event-dragging:not(.fc-event-selected) {\n  /* MOUSE */\n  opacity: 0.75;\n}\n\n.fc-event-dragging.fc-event-selected {\n  /* TOUCH */\n  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.3);\n}\n\n/* resizing */\n/* ---------------------------------------------------------------------------------------------------- */\n/* (subclasses should hone positioning for touch and non-touch) */\n.fc-event .fc-event-resizer {\n  display: none;\n  position: absolute;\n  z-index: 4;\n}\n\n.fc-event:hover,\n/* MOUSE */\n.fc-event-selected {\n  /* TOUCH */\n\n}\n\n.fc-event:hover .fc-event-resizer,\n.fc-event-selected .fc-event-resizer {\n  display: block;\n}\n\n.fc-event-selected .fc-event-resizer {\n  border-radius: 4px;\n  border-radius: calc(var(--fc-event-resizer-dot-total-width, 8px) / 2);\n  border-width: 1px;\n  border-width: var(--fc-event-resizer-dot-border-width, 1px);\n  width: 8px;\n  width: var(--fc-event-resizer-dot-total-width, 8px);\n  height: 8px;\n  height: var(--fc-event-resizer-dot-total-width, 8px);\n  border-style: solid;\n  border-color: inherit;\n  background: #fff;\n  background: var(--fc-page-bg-color, #fff)\n    /* expand hit area */\n\n}\n\n.fc-event-selected .fc-event-resizer:before {\n  content: '';\n  position: absolute;\n  top: -20px;\n  left: -20px;\n  right: -20px;\n  bottom: -20px;\n}\n\n/* selecting (always TOUCH) */\n/* ---------------------------------------------------------------------------------------------------- */\n.fc-event-selected {\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2)\n    /* expand hit area (subclasses should expand) */\n\n}\n\n.fc-event-selected:before {\n  content: \"\";\n  position: absolute;\n  z-index: 3;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.fc-event-selected {\n\n  /* dimmer effect */\n\n}\n\n.fc-event-selected:after {\n  content: \"\";\n  background: rgba(0, 0, 0, 0.25);\n  background: var(--fc-event-selected-overlay-color, rgba(0, 0, 0, 0.25));\n  position: absolute;\n  z-index: 1;\n\n  /* assume there's a border on all sides. overcome it. */\n  /* sometimes there's NOT a border, in which case the dimmer will go over */\n  /* an adjacent border, which looks fine. */\n  top: -1px;\n  left: -1px;\n  right: -1px;\n  bottom: -1px;\n}\n\n/*\nA HORIZONTAL event\n*/\n.fc-h-event {\n  /* allowed to be top-level */\n  display: block;\n  border: 1px solid #3788d8;\n  border: 1px solid var(--fc-event-border-color, #3788d8);\n  background-color: #3788d8;\n  background-color: var(--fc-event-bg-color, #3788d8)\n}\n\n.fc-h-event .fc-event-main {\n  color: #fff;\n  color: var(--fc-event-text-color, #fff);\n}\n\n.fc-h-event .fc-event-main-frame {\n  display: flex;\n  /* for make fc-event-title-container expand */\n}\n\n.fc-h-event .fc-event-time {\n  max-width: 100%;\n  /* clip overflow on this element */\n  overflow: hidden;\n}\n\n.fc-h-event .fc-event-title-container {\n  /* serves as a container for the sticky cushion */\n  flex-grow: 1;\n  flex-shrink: 1;\n  min-width: 0;\n  /* important for allowing to shrink all the way */\n}\n\n.fc-h-event .fc-event-title {\n  display: inline-block;\n  /* need this to be sticky cross-browser */\n  vertical-align: top;\n  /* for not messing up line-height */\n  left: 0;\n  /* for sticky */\n  right: 0;\n  /* for sticky */\n  max-width: 100%;\n  /* clip overflow on this element */\n  overflow: hidden;\n}\n\n.fc-h-event.fc-event-selected:before {\n  /* expand hit area */\n  top: -10px;\n  bottom: -10px;\n}\n\n/* adjust border and border-radius (if there is any) for non-start/end */\n.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),\n.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-left-width: 0;\n}\n\n.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),\n.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right-width: 0;\n}\n\n/* resizers */\n.fc-h-event:not(.fc-event-selected) .fc-event-resizer {\n  top: 0;\n  bottom: 0;\n  width: 8px;\n  width: var(--fc-event-resizer-thickness, 8px);\n}\n\n.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,\n.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end {\n  cursor: w-resize;\n  left: -4px;\n  left: calc(var(--fc-event-resizer-thickness, 8px) / -2);\n}\n\n.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,\n.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start {\n  cursor: e-resize;\n  right: -4px;\n  right: calc(var(--fc-event-resizer-thickness, 8px) / -2);\n}\n\n/* resizers for TOUCH */\n.fc-h-event.fc-event-selected .fc-event-resizer {\n  top: 50%;\n  margin-top: -4px;\n  margin-top: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n}\n\n.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,\n.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end {\n  left: -4px;\n  left: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n}\n\n.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,\n.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start {\n  right: -4px;\n  right: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n}\n\n\n:root {\n  --fc-daygrid-event-dot-width: 8px;\n}\n\n.fc .fc-popover {\n  position: fixed;\n  top: 0;\n  /* for when not positioned yet */\n  box-shadow: 0 2px 6px rgba(0, 0, 0, .15);\n}\n\n.fc .fc-popover-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 3px 4px;\n}\n\n.fc .fc-popover-title {\n  margin: 0 2px;\n}\n\n.fc .fc-popover-close {\n  cursor: pointer;\n  opacity: 0.65;\n  font-size: 1.1em;\n}\n\n.fc-theme-standard .fc-popover {\n  border: 1px solid #ddd;\n  border: 1px solid var(--fc-border-color, #ddd);\n  background: #fff;\n  background: var(--fc-page-bg-color, #fff);\n}\n\n.fc-theme-standard .fc-popover-header {\n  background: rgba(208, 208, 208, 0.3);\n  background: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));\n}\n\n/* help things clear margins of inner content */\n.fc-daygrid-day-frame,\n.fc-daygrid-day-events,\n.fc-daygrid-event-harness {\n  /* for event top/bottom margins */\n}\n\n.fc-daygrid-day-frame:before,\n.fc-daygrid-day-events:before,\n.fc-daygrid-event-harness:before {\n  content: \"\";\n  clear: both;\n  display: table;\n}\n\n.fc-daygrid-day-frame:after,\n.fc-daygrid-day-events:after,\n.fc-daygrid-event-harness:after {\n  content: \"\";\n  clear: both;\n  display: table;\n}\n\n.fc .fc-daygrid-body {\n  /* a <div> that wraps the table */\n  position: relative;\n  z-index: 1;\n  /* container inner z-index's because <tr>s can't do it */\n}\n\n.fc .fc-daygrid-day.fc-day-today {\n  background-color: rgba(255, 220, 40, 0.15);\n  background-color: var(--fc-today-bg-color, rgba(255, 220, 40, 0.15));\n}\n\n.fc .fc-daygrid-day-frame {\n  position: relative;\n  min-height: 100%;\n  /* seems to work better than `height` because sets height after rows/cells naturally do it */\n}\n\n.fc {\n\n  /* cell top */\n\n}\n\n.fc .fc-daygrid-day-top {\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.fc .fc-day-other .fc-daygrid-day-top {\n  opacity: 0.3;\n}\n\n.fc {\n\n  /* day number (within cell top) */\n\n}\n\n.fc .fc-daygrid-day-number {\n  position: relative;\n  z-index: 4;\n  padding: 4px;\n}\n\n.fc {\n\n  /* event container */\n\n}\n\n.fc .fc-daygrid-day-events {\n  margin-top: 1px;\n  /* needs to be margin, not padding, so that available cell height can be computed */\n}\n\n.fc {\n\n  /* positioning for balanced vs natural */\n\n}\n\n.fc .fc-daygrid-body-balanced .fc-daygrid-day-events {\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n\n.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events {\n  position: relative;\n  /* for containing abs positioned event harnesses */\n  min-height: 2em;\n  /* in addition to being a min-height during natural height, equalizes the heights a little bit */\n}\n\n.fc .fc-daygrid-body-natural {\n  /* can coexist with -unbalanced */\n}\n\n.fc .fc-daygrid-body-natural .fc-daygrid-day-events {\n  margin-bottom: 1em;\n}\n\n.fc {\n\n  /* event harness */\n\n}\n\n.fc .fc-daygrid-event-harness {\n  position: relative;\n}\n\n.fc .fc-daygrid-event-harness-abs {\n  position: absolute;\n  top: 0;\n  /* fallback coords for when cannot yet be computed */\n  left: 0;\n  /* */\n  right: 0;\n  /* */\n}\n\n.fc .fc-daygrid-bg-harness {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n}\n\n.fc {\n\n  /* bg content */\n\n}\n\n.fc .fc-daygrid-day-bg .fc-non-business {\n  z-index: 1\n}\n\n.fc .fc-daygrid-day-bg .fc-bg-event {\n  z-index: 2\n}\n\n.fc .fc-daygrid-day-bg .fc-highlight {\n  z-index: 3\n}\n\n.fc {\n\n  /* events */\n\n}\n\n.fc .fc-daygrid-event {\n  z-index: 6;\n  margin-top: 1px;\n}\n\n.fc .fc-daygrid-event.fc-event-mirror {\n  z-index: 7;\n}\n\n.fc {\n\n  /* cell bottom (within day-events) */\n\n}\n\n.fc .fc-daygrid-day-bottom {\n  font-size: .85em;\n  margin: 2px 3px 0;\n}\n\n.fc .fc-daygrid-more-link {\n  position: relative;\n  z-index: 4;\n  cursor: pointer;\n}\n\n.fc {\n\n  /* week number (within frame) */\n\n}\n\n.fc .fc-daygrid-week-number {\n  position: absolute;\n  z-index: 5;\n  top: 0;\n  padding: 2px;\n  min-width: 1.5em;\n  text-align: center;\n  background-color: rgba(208, 208, 208, 0.3);\n  background-color: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));\n  color: #808080;\n  color: var(--fc-neutral-text-color, #808080);\n}\n\n.fc {\n\n  /* popover */\n\n}\n\n.fc .fc-more-popover {\n  z-index: 8;\n}\n\n.fc .fc-more-popover .fc-popover-body {\n  min-width: 220px;\n  padding: 10px;\n}\n\n.fc-direction-ltr .fc-daygrid-event.fc-event-start,\n.fc-direction-rtl .fc-daygrid-event.fc-event-end {\n  margin-left: 2px;\n}\n\n.fc-direction-ltr .fc-daygrid-event.fc-event-end,\n.fc-direction-rtl .fc-daygrid-event.fc-event-start {\n  margin-right: 2px;\n}\n\n.fc-direction-ltr .fc-daygrid-week-number {\n  left: 0;\n  border-radius: 0 0 3px 0;\n}\n\n.fc-direction-rtl .fc-daygrid-week-number {\n  right: 0;\n  border-radius: 0 0 0 3px;\n}\n\n.fc-liquid-hack .fc-daygrid-day-frame {\n  position: static;\n  /* will cause inner absolute stuff to expand to <td> */\n}\n\n.fc-daygrid-event {\n  /* make root-level, because will be dragged-and-dropped outside of a component root */\n  position: relative;\n  /* for z-indexes assigned later */\n  white-space: nowrap;\n  border-radius: 3px;\n  /* dot event needs this to when selected */\n  font-size: .85em;\n  font-size: var(--fc-small-font-size, .85em);\n}\n\n/* --- the rectangle (\"block\") style of event --- */\n.fc-daygrid-block-event .fc-event-time {\n  font-weight: bold;\n}\n\n.fc-daygrid-block-event .fc-event-time,\n.fc-daygrid-block-event .fc-event-title {\n  padding: 1px;\n}\n\n/* --- the dot style of event --- */\n.fc-daygrid-dot-event {\n  display: flex;\n  align-items: center;\n  padding: 2px 0\n}\n\n.fc-daygrid-dot-event .fc-event-title {\n  flex-grow: 1;\n  flex-shrink: 1;\n  min-width: 0;\n  /* important for allowing to shrink all the way */\n  overflow: hidden;\n  font-weight: bold;\n}\n\n.fc-daygrid-dot-event:hover,\n.fc-daygrid-dot-event.fc-event-mirror {\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.fc-daygrid-dot-event.fc-event-selected:before {\n  /* expand hit area */\n  top: -10px;\n  bottom: -10px;\n}\n\n.fc-daygrid-event-dot {\n  /* the actual dot */\n  margin: 0 4px;\n  box-sizing: content-box;\n  width: 0;\n  height: 0;\n  border: 4px solid #3788d8;\n  border: calc(var(--fc-daygrid-event-dot-width, 8px) / 2) solid var(--fc-event-border-color, #3788d8);\n  border-radius: 4px;\n  border-radius: calc(var(--fc-daygrid-event-dot-width, 8px) / 2);\n}\n\n/* --- spacing between time and title --- */\n.fc-direction-ltr .fc-daygrid-event .fc-event-time {\n  margin-right: 3px;\n}\n\n.fc-direction-rtl .fc-daygrid-event .fc-event-time {\n  margin-left: 3px;\n}\n\n\n/*\nA VERTICAL event\n*/\n\n.fc-v-event {\n  /* allowed to be top-level */\n  display: block;\n  border: 1px solid #3788d8;\n  border: 1px solid var(--fc-event-border-color, #3788d8);\n  background-color: #3788d8;\n  background-color: var(--fc-event-bg-color, #3788d8)\n}\n\n.fc-v-event .fc-event-main {\n  color: #fff;\n  color: var(--fc-event-text-color, #fff);\n  height: 100%;\n}\n\n.fc-v-event .fc-event-main-frame {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.fc-v-event .fc-event-time {\n  flex-grow: 0;\n  flex-shrink: 0;\n  max-height: 100%;\n  overflow: hidden;\n}\n\n.fc-v-event .fc-event-title-container {\n  /* a container for the sticky cushion */\n  flex-grow: 1;\n  flex-shrink: 1;\n  min-height: 0;\n  /* important for allowing to shrink all the way */\n}\n\n.fc-v-event .fc-event-title {\n  /* will have fc-sticky on it */\n  top: 0;\n  bottom: 0;\n  max-height: 100%;\n  /* clip overflow */\n  overflow: hidden;\n}\n\n.fc-v-event:not(.fc-event-start) {\n  border-top-width: 0;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.fc-v-event:not(.fc-event-end) {\n  border-bottom-width: 0;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.fc-v-event.fc-event-selected:before {\n  /* expand hit area */\n  left: -10px;\n  right: -10px;\n}\n\n.fc-v-event {\n\n  /* resizer (mouse AND touch) */\n\n}\n\n.fc-v-event .fc-event-resizer-start {\n  cursor: n-resize;\n}\n\n.fc-v-event .fc-event-resizer-end {\n  cursor: s-resize;\n}\n\n.fc-v-event {\n\n  /* resizer for MOUSE */\n\n}\n\n.fc-v-event:not(.fc-event-selected) .fc-event-resizer {\n  height: 8px;\n  height: var(--fc-event-resizer-thickness, 8px);\n  left: 0;\n  right: 0;\n}\n\n.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start {\n  top: -4px;\n  top: calc(var(--fc-event-resizer-thickness, 8px) / -2);\n}\n\n.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end {\n  bottom: -4px;\n  bottom: calc(var(--fc-event-resizer-thickness, 8px) / -2);\n}\n\n.fc-v-event {\n\n  /* resizer for TOUCH (when event is \"selected\") */\n\n}\n\n.fc-v-event.fc-event-selected .fc-event-resizer {\n  left: 50%;\n  margin-left: -4px;\n  margin-left: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n}\n\n.fc-v-event.fc-event-selected .fc-event-resizer-start {\n  top: -4px;\n  top: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n}\n\n.fc-v-event.fc-event-selected .fc-event-resizer-end {\n  bottom: -4px;\n  bottom: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n}\n\n.fc .fc-timegrid .fc-daygrid-body {\n  /* the all-day daygrid within the timegrid view */\n  z-index: 2;\n  /* put above the timegrid-body so that more-popover is above everything. TODO: better solution */\n}\n\n.fc .fc-timegrid-divider {\n  padding: 0 0 2px;\n  /* browsers get confused when you set height. use padding instead */\n}\n\n.fc .fc-timegrid-body {\n  position: relative;\n  z-index: 1;\n  /* scope the z-indexes of slots and cols */\n  min-height: 100%;\n  /* fill height always, even when slat table doesn't grow */\n}\n\n.fc .fc-timegrid-axis-chunk {\n  /* for advanced ScrollGrid */\n  position: relative\n    /* offset parent for now-indicator-container */\n\n}\n\n.fc .fc-timegrid-axis-chunk>table {\n  position: relative;\n  z-index: 1;\n  /* above the now-indicator-container */\n}\n\n.fc .fc-timegrid-slots {\n  position: relative;\n  z-index: 1;\n}\n\n.fc .fc-timegrid-slot {\n  /* a <td> */\n  height: 1.5em;\n  border-bottom: 0\n    /* each cell owns its top border */\n}\n\n.fc .fc-timegrid-slot:empty:before {\n  content: '\\00a0';\n  /* make sure there's at least an empty space to create height for height syncing */\n}\n\n.fc .fc-timegrid-slot-minor {\n  border-top-style: dotted;\n}\n\n.fc .fc-timegrid-slot-label-cushion {\n  display: inline-block;\n  white-space: nowrap;\n}\n\n.fc .fc-timegrid-slot-label {\n  vertical-align: middle;\n  /* vertical align the slots */\n}\n\n.fc {\n\n\n  /* slots AND axis cells (top-left corner of view including the \"all-day\" text) */\n\n}\n\n.fc .fc-timegrid-axis-cushion,\n.fc .fc-timegrid-slot-label-cushion {\n  padding: 0 4px;\n}\n\n.fc {\n\n\n  /* axis cells (top-left corner of view including the \"all-day\" text) */\n  /* vertical align is more complicated, uses flexbox */\n\n}\n\n.fc .fc-timegrid-axis-frame-liquid {\n  height: 100%;\n  /* will need liquid-hack in FF */\n}\n\n.fc .fc-timegrid-axis-frame {\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  /* vertical align */\n  justify-content: flex-end;\n  /* horizontal align. matches text-align below */\n}\n\n.fc .fc-timegrid-axis-cushion {\n  max-width: 60px;\n  /* limits the width of the \"all-day\" text */\n  flex-shrink: 0;\n  /* allows text to expand how it normally would, regardless of constrained width */\n}\n\n.fc-direction-ltr .fc-timegrid-slot-label-frame {\n  text-align: right;\n}\n\n.fc-direction-rtl .fc-timegrid-slot-label-frame {\n  text-align: left;\n}\n\n.fc-liquid-hack .fc-timegrid-axis-frame-liquid {\n  height: auto;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.fc .fc-timegrid-col.fc-day-today {\n  background-color: rgba(255, 220, 40, 0.15);\n  background-color: var(--fc-today-bg-color, rgba(255, 220, 40, 0.15));\n}\n\n.fc .fc-timegrid-col-frame {\n  min-height: 100%;\n  /* liquid-hack is below */\n  position: relative;\n}\n\n.fc-liquid-hack .fc-timegrid-col-frame {\n  height: auto;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.fc-media-screen .fc-timegrid-cols {\n  position: absolute;\n  /* no z-index. children will decide and go above slots */\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0\n}\n\n.fc-media-screen .fc-timegrid-cols>table {\n  height: 100%;\n}\n\n.fc-media-screen .fc-timegrid-col-bg,\n.fc-media-screen .fc-timegrid-col-events,\n.fc-media-screen .fc-timegrid-now-indicator-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n.fc-media-screen .fc-timegrid-event-harness {\n  position: absolute;\n  /* top/left/right/bottom will all be set by JS */\n}\n\n.fc {\n\n  /* bg */\n\n}\n\n.fc .fc-timegrid-col-bg {\n  z-index: 2;\n  /* TODO: kill */\n}\n\n.fc .fc-timegrid-col-bg .fc-non-business {\n  z-index: 1\n}\n\n.fc .fc-timegrid-col-bg .fc-bg-event {\n  z-index: 2\n}\n\n.fc .fc-timegrid-col-bg .fc-highlight {\n  z-index: 3\n}\n\n.fc .fc-timegrid-bg-harness {\n  position: absolute;\n  /* top/bottom will be set by JS */\n  left: 0;\n  right: 0;\n}\n\n.fc {\n\n  /* fg events */\n  /* (the mirror segs are put into a separate container with same classname, */\n  /* and they must be after the normal seg container to appear at a higher z-index) */\n\n}\n\n.fc .fc-timegrid-col-events {\n  z-index: 3;\n  /* child event segs have z-indexes that are scoped within this div */\n}\n\n.fc {\n\n  /* now indicator */\n\n}\n\n.fc .fc-timegrid-now-indicator-container {\n  bottom: 0;\n  overflow: hidden;\n  /* don't let overflow of lines/arrows cause unnecessary scrolling */\n  /* z-index is set on the individual elements */\n}\n\n.fc-direction-ltr .fc-timegrid-col-events {\n  margin: 0 2.5% 0 2px;\n}\n\n.fc-direction-rtl .fc-timegrid-col-events {\n  margin: 0 2px 0 2.5%;\n}\n\n.fc-timegrid-event-harness-inset .fc-timegrid-event,\n.fc-timegrid-event.fc-event-mirror {\n  box-shadow: 0px 0px 0px 1px #fff;\n  box-shadow: 0px 0px 0px 1px var(--fc-page-bg-color, #fff);\n}\n\n.fc-timegrid-event {\n  /* events need to be root */\n\n  font-size: .85em;\n\n  font-size: var(--fc-small-font-size, .85em);\n  border-radius: 3px\n}\n\n.fc-timegrid-event .fc-event-main {\n  padding: 1px 1px 0;\n}\n\n.fc-timegrid-event .fc-event-time {\n  white-space: nowrap;\n  font-size: .85em;\n  font-size: var(--fc-small-font-size, .85em);\n  margin-bottom: 1px;\n}\n\n.fc-timegrid-event-condensed .fc-event-main-frame {\n  flex-direction: row;\n  overflow: hidden;\n}\n\n.fc-timegrid-event-condensed .fc-event-time:after {\n  content: '\\00a0-\\00a0';\n  /* dash surrounded by non-breaking spaces */\n}\n\n.fc-timegrid-event-condensed .fc-event-title {\n  font-size: .85em;\n  font-size: var(--fc-small-font-size, .85em)\n}\n\n.fc-media-screen .fc-timegrid-event {\n  position: absolute;\n  /* absolute WITHIN the harness */\n  top: 0;\n  bottom: 1px;\n  /* stay away from bottom slot line */\n  left: 0;\n  right: 0;\n}\n\n.fc {\n\n  /* line */\n\n}\n\n.fc .fc-timegrid-now-indicator-line {\n  position: absolute;\n  z-index: 4;\n  left: 0;\n  right: 0;\n  border-style: solid;\n  border-color: red;\n  border-color: var(--fc-now-indicator-color, red);\n  border-width: 1px 0 0;\n}\n\n.fc {\n\n  /* arrow */\n\n}\n\n.fc .fc-timegrid-now-indicator-arrow {\n  position: absolute;\n  z-index: 4;\n  margin-top: -5px;\n  /* vertically center on top coordinate */\n  border-style: solid;\n  border-color: red;\n  border-color: var(--fc-now-indicator-color, red);\n}\n\n.fc-direction-ltr .fc-timegrid-now-indicator-arrow {\n  left: 0;\n\n  /* triangle pointing right. TODO: mixin */\n  border-width: 5px 0 5px 6px;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n}\n\n.fc-direction-rtl .fc-timegrid-now-indicator-arrow {\n  right: 0;\n\n  /* triangle pointing left. TODO: mixin */\n  border-width: 5px 6px 5px 0;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n}\n\n\n:root {\n  --fc-list-event-dot-width: 10px;\n  --fc-list-event-hover-bg-color: #f5f5f5;\n}\n\n.fc-theme-standard .fc-list {\n  border: 1px solid #ddd;\n  border: 1px solid var(--fc-border-color, #ddd);\n}\n\n.fc {\n\n  /* message when no events */\n\n}\n\n.fc .fc-list-empty {\n  background-color: rgba(208, 208, 208, 0.3);\n  background-color: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* vertically aligns fc-list-empty-inner */\n}\n\n.fc .fc-list-empty-cushion {\n  margin: 5em 0;\n}\n\n.fc {\n\n  /* table within the scroller */\n  /* ---------------------------------------------------------------------------------------------------- */\n\n}\n\n.fc .fc-list-table {\n  width: 100%;\n  border-style: hidden;\n  /* kill outer border on theme */\n}\n\n.fc .fc-list-table tr>* {\n  border-left: 0;\n  border-right: 0;\n}\n\n.fc .fc-list-sticky .fc-list-day>* {\n  /* the cells */\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  background: #fff;\n  background: var(--fc-page-bg-color, #fff);\n  /* for when headers are styled to be transparent and sticky */\n}\n\n.fc .fc-list-table th {\n  padding: 0;\n  /* uses an inner-wrapper instead... */\n}\n\n.fc .fc-list-table td,\n.fc .fc-list-day-cushion {\n  padding: 8px 14px;\n}\n\n.fc {\n\n\n  /* date heading rows */\n  /* ---------------------------------------------------------------------------------------------------- */\n\n}\n\n.fc .fc-list-day-cushion:after {\n  content: \"\";\n  clear: both;\n  display: table;\n  /* clear floating */\n}\n\n.fc-theme-standard .fc-list-day-cushion {\n  background-color: rgba(208, 208, 208, 0.3);\n  background-color: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));\n}\n\n.fc-direction-ltr .fc-list-day-text,\n.fc-direction-rtl .fc-list-day-side-text {\n  float: left;\n}\n\n.fc-direction-ltr .fc-list-day-side-text,\n.fc-direction-rtl .fc-list-day-text {\n  float: right;\n}\n\n/* make the dot closer to the event title */\n.fc-direction-ltr .fc-list-table .fc-list-event-graphic {\n  padding-right: 0\n}\n\n.fc-direction-rtl .fc-list-table .fc-list-event-graphic {\n  padding-left: 0\n}\n\n.fc .fc-list-event.fc-event-forced-url {\n  cursor: pointer;\n  /* whole row will seem clickable */\n}\n\n.fc .fc-list-event:hover td {\n  background-color: #f5f5f5;\n  background-color: var(--fc-list-event-hover-bg-color, #f5f5f5);\n}\n\n.fc {\n\n  /* shrink certain cols */\n\n}\n\n.fc .fc-list-event-graphic,\n.fc .fc-list-event-time {\n  white-space: nowrap;\n  width: 1px;\n}\n\n.fc .fc-list-event-dot {\n  display: inline-block;\n  box-sizing: content-box;\n  width: 0;\n  height: 0;\n  border: 5px solid #3788d8;\n  border: calc(var(--fc-list-event-dot-width, 10px) / 2) solid var(--fc-event-border-color, #3788d8);\n  border-radius: 5px;\n  border-radius: calc(var(--fc-list-event-dot-width, 10px) / 2);\n}\n\n.fc {\n\n  /* reset <a> styling */\n\n}\n\n.fc .fc-list-event-title a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.fc {\n\n  /* underline link when hovering over any part of row */\n\n}\n\n.fc .fc-list-event.fc-event-forced-url:hover a {\n  text-decoration: underline;\n}\n\n\n\n.fc-theme-bootstrap a:not([href]) {\n  color: inherit;\n  /* natural color for navlinks */\n}\n\n.fc-event-time {\n  display: none;\n}\n\na.fc-event,\na.fc-event:hover {\n  font-size: 11px !important;\n}\n\n.d-tabs li {\n  display: inline;\n  border: 1px solid #fff;\n}\n\n.d-tabs-li li {\n  display: inline;\n  border-right: 1px solid black !important;\n}\n\n.activet {\n  background: #de2222 !important;\n  color: #fff !important;\n  margin: 0px;\n}\n\n.activetpt {\n  background: #562cc9 !important;\n  color: #fff !important;\n  margin: 0px;\n}\n\n.bt {\n  border-top: 1px solid #ccc;\n}\n\n.br {\n  border-right: 1px solid #ccc;\n}\n\n.bb {\n  border-bottom: 1px solid #ccc;\n}\n\n.bl {\n  border-left: 1px solid #ccc;\n}\n\n.egcolor {\n  color: #378006 !important;\n}\n\n.ebcolor {\n  color: #A0522D !important;\n}\n\n.eblcolor {\n  color: #0004FF !important;\n}\n\n.evt-htitle {\n  background: #de2222;\n  width: 100%;\n  text-align: center;\n  font-size: 16px;\n  color: #fff;\n  padding: 8px;\n}\n\n.evt-label {\n  background: #5d5d65 !important;\n  color: #ffffff;\n  padding: 5px 10px;\n  font-size: 12px;\n}\n\n.evt-strng {\n  font-size: 17px !important;\n  text-align: center !important;\n  margin: 0px 0px 5px 0px;\n}\n\n.circle {\n  width: 12px;\n  height: 12px;\n  padding: 0px 8px;\n  border-radius: 100%;\n}\n\n.cgreen {\n  background: #378006 !important;\n}\n\n.cbrown {\n  background: #A0522D !important;\n}\n\n.cblue {\n  background: #0004FF !important;\n}\n\n.carousel-root {\n  width: 100% !important;\n}\n\n.carousel .slide {\n  background: #FFFFFF !important;\n}\n\n.carousel .control-dots .dot.selected,\n.carousel .control-dots .dot:hover {\n  background: #f90000 !important;\n}\n\n.carousel .control-dots .dot {\n  background: #757575 !important;\n  border: 1px solid #757575 !important;\n}\n\n.ttabs {\n  background: #ccc;\n  padding: 5px 10px;\n  color: #333;\n}\n\n.ttabs button {\n  background: transparent;\n  color: #333;\n}\n\n.ttabs.activet button {\n  color: #fff;\n}\n\n.lttabs {\n  background: #ccc;\n  padding: 5px 2px;\n  color: #333;\n}\n\n.lttabs button {\n  background: transparent;\n  color: #333;\n}\n\n.lttabs.activet button {\n  color: #fff;\n}\n\n.lttab {\n  background: #ccc;\n  color: #333;\n}\n\n.lttab button {\n  background: transparent;\n  color: #333;\n}\n\n.lttab.activet button {\n  color: #fff;\n}\n\n.fs-body {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 99999;\n  text-align: center;\n  background: rgba(255, 255, 255, 0.5);\n}\n\n.fs-content {\n  z-index: 999999;\n  position: absolute;\n  left: 45%;\n  top: 40%;\n}\n\n.fs-content button {\n  background: #f7bb12;\n  font-size: 24px;\n  border: 1px solid #f7bb12;\n}\n\n/* .ui-datepicker-calendar div : has(.dispatch_dashboard_date)\n{\n    display: none;\n} */\n.ag-theme-balham .ag-row {\n  font-weight: 'Poppins-Regular' !important;\n}\n\n.greengridbg {\n  background: #058b05;\n  color: #FFF;\n  font-weight: 'Poppins-Regular';\n}\n\n.bluegridbg {\n  background: #0723c2;\n  color: #FFF;\n  font-weight: 'Poppins-Regular';\n}\n\n.redgridbg {\n  background: #ce0909;\n  color: #FFF;\n  font-weight: 'Poppins-Regular';\n}\n\n.graygridbg {\n  background: #5f5f5f;\n  color: #FFF;\n  font-weight: 'Poppins-Regular';\n}\n\n.yellowbg {\n  background: #ded022\n}\n\n.yellowlitebg {\n  background: #f3eb7b\n}\n\n.uppercase {\n  text-transform: uppercase;\n}\n\n.blue {\n  background: #0a59b3;\n  color: #FFFFFF;\n}\n\n.literedbg {\n  background: #f16969\n}\n\n.litebluebg {\n  background: #4099ff\n}\n\n.litepinkbg {\n  background: #ffbbbb\n}\n\n.greenbg {\n  background: #28a852\n}\n\n.loadSummaryMap .gm-style-iw {\n  padding: 8px !important;\n}\n\n.loadSummaryMap th,\n.loadSummaryMap td {\n  padding-right: 8px !important;\n}\n\n.bglightblue {\n  background-color: #faf5fae0;\n  color: black\n}\n\n.cellstylegridO {\n  background: #ffd0bb;\n  color: #333\n}\n\n.cellstylegridLG {\n  background: #d6ffbb;\n  color: #333\n}\n\n.cellstylegridBG {\n  background: #bbf7ff;\n  color: #333\n}\n\n.cellstylegridMG {\n  background: #f8c5d0;\n  color: #333\n}\n\n.cellstylegridBLG {\n  background: #d7c5f8;\n  color: #333\n}\n\n.cellstylegridCLG {\n  background: #c5ecf8;\n  color: #333\n}\n\n.cellstylegridGLG {\n  background: #c7f8c5;\n  color: #333\n}\n\n.usermanual {\n  position: fixed;\n  right: 0px;\n  top: 20%;\n  width: 30px;\n  height: 32px;\n  background: #ded022;\n  color: #333;\n  padding: 0px 5px;\n  cursor: pointer;\n}\n\n.model-title {\n  position: absolute;\n  width: 100%;\n  top: 0;\n  background: #cc1919;\n  color: #fff;\n  left: 0;\n  padding: 5px;\n  text-align: center;\n}\n\n.cust-tbl {\n  width: 100%;\n  border: 1px solid #BDC3C7;\n}\n\n.cust-tbl th {\n  color: #000;\n}\n\n.cust-tbl td,\n.cust-tbl th {\n  border-color: #BDC3C7 !important;\n}\n\n.cust-td td:first-child {\n  width: 40%;\n  text-align: center;\n}\n\n.cust-td:last-child {\n  text-align: center;\n}\n\n#safetygrid .ag-header.ag-pivot-off {\n  background: #ffe4bb;\n  color: #333;\n  font-weight: bolder;\n}\n\n.cust-tbl {\n  width: 100%;\n  border: 1px solid #BDC3C7;\n}\n\n.cust-tbl td,\n.cust-tbl th {\n  border-color: #BDC3C7 !important;\n}\n\n.cust-td td:first-child {\n  width: 40%;\n  text-align: center;\n}\n\n.cust-td:last-child {\n  text-align: center;\n}\n\n.cust-tbl {\n  width: 100%;\n  border: 1px solid #BDC3C7;\n}\n\n.cust-tbl td,\n.cust-tbl th {\n  border-color: #BDC3C7 !important;\n}\n\n.cust-td td:first-child {\n  width: 40%;\n  text-align: center;\n  color: #000;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.cust-td:last-child {\n  text-align: center;\n  color: #000;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.cust-tbl td {\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.fbold {\n  font-weight: bold;\n}\n.blackColor{\n  color:#000 !important;\n}\n\n.csgpsBg {\n  background: #ffe4bb;\n  color: #333;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold\n}\n\n.cellBorder {\n  border-right: 1px solid #ccc !important;\n}\n\n.cellstylegridY {\n  background: #ffffc9;\n  color: #000\n}\n\n.pstBg {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  border-right: 1px solid #ccc !important\n}\n\n.cellTopSubHeader {\n  font-size: 20px;\n}\n\n.cellRvrt {\n  text-align: center;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n@media screen and (max-width: 800px) {\n  .wdiv {\n    display: flex;\n    flex-flow: column;\n  }\n\n  .one {\n    order: 1;\n    width: 100% !important;\n  }\n\n  .two {\n    order: 2;\n    width: 100% !important;\n  }\n\n  .three {\n    order: 3;\n  }\n\n  .four {\n    order: 4;\n  }\n\n  .five {\n    order: 5\n  }\n}\n\n@media screen and (max-width: 1025px) {\n  .wdiv {\n    display: flex;\n    flex-flow: column;\n  }\n\n  .one {\n    order: 1;\n    width: 100% !important;\n  }\n\n  .two {\n    order: 2;\n    width: 100% !important;\n  }\n\n  .three {\n    order: 3;\n  }\n\n  .four {\n    order: 4;\n  }\n\n  .five {\n    order: 5\n  }\n}\n\n.cellstylegridORG {\n  background: #ffb657;\n  color: #333\n}\n\n.tss-tl {\n  color: #000\n}\n\n.tss-tl span {\n  font-size: 18px;\n}\n\n.mselect {\n  max-height: 200px;\n  min-height: 100px;\n  border: 1px solid #ccc;\n  overflow-y: auto;\n  margin-top: 50px;\n  padding: 5px 10px 10px 10px;\n}\n\n.scolumn-l {\n  float: left;\n  width: 49%;\n  margin: 5px 0px;\n  text-align: left;\n  border-right: 1px solid #ccc;\n  border-bottom: 1px solid #ccc;\n}\n\n.scolumn-m {\n  float: left;\n  width: 28%;\n  margin: 5px 0px;\n  text-align: center;\n  border-right: 1px solid #ccc;\n  border-bottom: 1px solid #ccc;\n}\n\n.scolumn-s {\n  float: left;\n  width: 20%;\n  margin: 5px 0px;\n  text-align: center;\n  border-right: 1px solid #ccc;\n  border-bottom: 1px solid #ccc;\n}\n\n.listhd {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  background: #ffffff;\n  width: 100%;\n}\n\n.scolumn-pos-1 {\n  padding-left: 10px;\n  width: 47.2%;\n  font-weight: bold;\n  background-color: #ffffff;\n}\n\n.scolumn-pos-2 {\n  width: 25.7%;\n  font-weight: bold;\n  background-color: #ffffff;\n}\n\n.scolumn-pos-3 {\n  width: 18.2%;\n  font-weight: bold;\n  background-color: #ffffff;\n}\n\n.w34 {\n  width: 34% !important;\n}\n\n.noborder {\n  border: 0px !important;\n}\n\n.mllcustom-btn {\n  padding: 5px 5px\n}\n\n/* .sideMenuCls{background-color: #3d6db7 !important;}\n.sideTitlecls{color:#000 !important}\n.sideHeadercls{color:#fff !important} */\n.map-bx {\n  box-shadow: 0 1px 10px 0 rgb(0 0 0 / 30%);\n  border: 1px solid #ccc;\n}\n\n.map-h {\n  font-size: 16px;\n  background: #ff2046;\n  padding: 5px;\n  color: #fff;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.map-tbl {\n  font-size: 13px;\n}\n\n.map-htxt {\n  font-weight: 600;\n}\n\n.blc-1 {\n  padding: 0px;\n  background: #fdead8;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  box-shadow: 0 1px 10px 0 rgb(0 0 0 / 30%);\n\n}\n\n.blc-2 {\n  padding: 0px;\n  background: #e4ffde;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  box-shadow: 0 1px 10px 0 rgb(0 0 0 / 30%);\n}\n\n.blc-3 {\n  padding: 0px;\n  background: #fdead8;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  box-shadow: 0 1px 10px 0 rgb(0 0 0 / 30%);\n}\n\n.blc-4 {\n  padding: 0px;\n  background: #e4ffde;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  box-shadow: 0 1px 10px 0 rgb(0 0 0 / 30%);\n}\n\n.nav-tabs .nav-item {\n  cursor: pointer;\n}\n\n@media screen and (max-width: 800px) {\n  .wdiv {\n    display: flex;\n    flex-flow: column;\n  }\n\n  .one {\n    order: 1;\n    width: 100% !important;\n  }\n\n  .two {\n    order: 2;\n    width: 100% !important;\n  }\n\n  .three {\n    order: 3;\n  }\n\n  .four {\n    order: 4;\n  }\n\n  .five {\n    order: 5\n  }\n}\n\n@media screen and (min-width: 360px) and (max-width: 640px) {\n  .brm-chart .highcharts-title {\n    font-size: 14px !important;\n  }\n}\n\n.trucks-dropdown-srch {\n  background: white;\n  height: 18em;\n  width: 22.3em;\n  position: absolute;\n  overflow-y: scroll;\n  left: 32px;\n  z-index: 1000;\n  top: 36px;\n  border-radius: 5px;\n  border: 0.1px solid cornflowerblue;\n}\n\n.trucks-dropdown-srch>ul>li {\n  padding: 10px;\n  padding-left: 13px;\n}\n\n.trucks-dropdown-srch>ul>li:hover {\n  background: #e4e4e4;\n}\n\n.styles_modal__gNwvD {\n  max-width: 1200px !important\n}\n\n.styles_modal__gNwvD {\n  max-width: 1200px !important\n}\n\n.nav-tabs .nav-link {\n  background: #E4E4E5;\n  color: #333;\n}\n\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  background: #FFFFFF;\n  color: #333333;\n}\n\n.styles_modal__gNwvD {\n  max-width: 1200px !important\n}\n\n.nav-tabs .nav-link {\n  background: #E4E4E5;\n  color: #333;\n}\n\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  background: #FFFFFF;\n  color: #333333;\n}\n\n.mapic {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  z-index: 999999999;\n  height: 40px;\n\n}\n\n.mapici {\n  color: #FFFFFF;\n  position: absolute;\n  left: 44%;\n  bottom: 30px;\n  background-color: #e01111;\n  font-size: 40px;\n}\n\n.mapdt {\n  background-color: #ff1212;\n  color: #ffffff;\n  font-size: 20px;\n  padding: 5px\n}\n\n.sbox {\n  height: 200px;\n  width: 300px;\n  overflow: hidden;\n  border: 1px solid red;\n  background: #ff0;\n}\n\n.shid-box {\n  top: 100%;\n  position: relative;\n  transition: all .3s ease-out;\n  background: #428bca;\n  height: 100%;\n}\n\n.sbox:hover>.shid-box {\n  top: 0;\n}\n\n.mapics {\n  position: fixed;\n  bottom: 0px;\n  background: #fff;\n  width: 100%;\n}\n\n.mapcls {\n  background: rgb(255, 255, 255);\n  width: 32px;\n  height: 32px;\n  position: absolute;\n  right: 25px;\n  top: 0px;\n  cursor: pointer;\n  z-index: 9;\n  text-align: center;\n  padding: 5px;\n  font-weight: bold;\n}\n\n.route-h5 {\n  background: #FF5722;\n  color: #fff;\n  padding: 5px;\n  font-size: 16px\n}\n\n.tptinfo th {\n  background: #ffffc9 !important\n}\n\n.tptinfo td,\n.tptinfo th {\n  border-color: #ccc;\n}\n\n.txt-center {\n  text-align: center;\n}\n\n.tr-tabs .btn {\n  padding: 0.375rem 0.3rem;\n}\n\n.tr-tabs .btn {\n  padding: 0.375rem 0.3rem;\n}\n\n.tr-tabs .btn {\n  padding: 0.375rem 0.3rem;\n}\n\n.btn-defaultc {\n  background: #cccccc !important;\n  color: #333 !important;\n}\n\n.rotate-dispatch-loader.dashed.colored {\n  -webkit-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-animation-duration: 3s;\n  animation-duration: 3s;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  -webkit-animation-name: rotate;\n  animation-name: rotate;\n  border: 3px dashed #ab8ce4;\n  width: 15px;\n  height: 15px;\n  border-radius: 50px;\n  display: block;\n  margin: 1em;\n  float: left;\n}\n\n.load-exit-status-total-row {\n  background: skyblue !important;\n  font-weight: bold;\n  font-size: 15px;\n}\n\n.sub-cntrs {\n  font-family: Open Sans;\n  padding-top: 7px;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n.ag-theme-balham .ag-cell{\n  font-size:14px;\n}\n.ag-theme-balham .ag-header-cell{\n  font-size:14px;\n}\n\n.ag-vertical-header .ag-cell-label-container {\n  /*Necessary to allow for text to grow vertically*/\n  height: 100%;\n}\n\n.ag-vertical-header .ag-header-cell-label {\n  /*Necessary to allow for text to grow vertically*/\n  height: 100%;\n  padding: 0 !important;\n}\n\n.ag-vertical-header .ag-header-cell-label .ag-header-cell-text {\n  /*Force the width corresponding at how much width\n    we need once the text is laid out vertically*/\n  width: 55px;\n  writing-mode: vertical-lr;\n  -ms-writing-mode: tb-lr;\n  line-height: 2em;\n}\n\n.ag-vertical-header .ag-pivot-off .ag-header-group-cell {\n  font-size: 50px;\n}\n\n.ag-vertical-header .ag-pivot-on .ag-header-group-cell {\n  font-size: 10px;\n  color: green;\n}\n\n.ag-vertical-header .ag-pivot-off .ag-header-cell-label {\n  color: #3d6db7;\n  font-weight: bold;\n}\n\n.ag-vertical-header .ag-pivot-on .ag-header-cell-label {\n  font-size: 10px;\n  height: 90px;\n  padding-top: 36px;\n  margin-left: 0px;\n  color: #1b6d85;\n  font-weight: bold;\n}\n\n.ag-vertical-header .ag-pivot-on .ag-header-cell-label .ag-header-cell-text {\n  /*There is empty space left at the top from the menu and sort\n    icons not used*/\n  margin-top: 25px;\n}\n\n/*Floating filters*/\n.ag-vertical-header .ag-floating-filter-body {\n  height: 50px;\n}\n\n.ag-vertical-header .ag-floating-filter-body input {\n  height: 49px;\n}\n\n.ag-vertical-header .ag-floating-filter-button {\n  margin-top: -49px;\n}\n\n.ag-vertical-header .ag-floating-filter-button button {\n  height: 49px;\n}\n\n.ag-vertical-header .ag-floating-filter-body input {\n  font-size: 15px;\n  font-weight: bold;\n}\n\n.ag-vertical-header .ag-header-cell {\n  padding: 5px;\n}\n\n.ag-vertical-header .ag-header-cell::after,\n.ag-theme-balham .ag-header-group-cell::after {\n  height: 150px;\n  margin-top: 0;\n}\n\n.fontBold {\n  font-weight: bold\n}\n\n.danger-ico {\n  font-weight: bold;\n  color: red;\n  cursor: pointer;\n}\n\n.info-ico {\n  font-weight: bold;\n  color: blueviolet;\n  cursor: pointer;\n}\n\n.warning-ico {\n  font-weight: bold;\n  color: orange;\n  cursor: pointer;\n}\n\n.primary-ico {\n  font-weight: bold;\n  color: blue;\n  cursor: pointer;\n}\n\n.cms-tabs li button {\n  padding: 0 20px;\n}\n\n.float-right {\n  float: right;\n}\n\n.btn-default {\n  color: #333;\n  background-color: #ffffff;\n  border-color: #cccccc;\n}\n\n.border-none {\n  border: none;\n}\n\n.rail-stage-tbl tr th,\n.rail-stage-tbl tr td {\n  width: 30%;\n}\n\n.rail-stage-tbl-20 tr th,\n.rail-stage-tbl-20 tr td {\n  width: 30%;\n}\n\n.rail-stage-tbl th {\n  border-color: #ccc\n}\n\n.rail-stage-tbl td {\n  border-color: #ccc\n}\n\n#fleetDeployedGrid .ag-header-group-cell-label {\n  justify-content: center;\n  font-weight: bolder;\n}\n\n.semicircle-container {\n  text-align: center;\n}\n\n.trowColor {\n  background-color: #171C8F;\n  color: white;\n\n}\n\n.totalHead {\n  background-color: #ffffc9;\n}\n\n#buttonStyle1 {\n  font-weight: 470;\n  text-align: center;\n  display: flex;\n  /* Use flexbox to center content */\n  justify-content: center;\n  /* Center horizontally */\n  align-items: center;\n  /* Center vertically */\n  margin: 5px;\n  border-radius: 5px;\n  height: 150px;\n  width: 360px;\n  color: #000000;\n  background: rgb(221, 219, 219);\n  font-size: 20px;\n  cursor: pointer;\n  height: 100px;\n}\n\n#buttonStyle1:hover {\n  /*opacity: 0.3;*/\n\n  color: white;\n  background: #005ce6;\n  transform: scale(1);\n  /* Equal to scaleX(2) scaleY(2) */\n  transition-duration: 0.5s;\n  /*transform: scale(0.6);*/\n}\n\n#buttonStyle2 {\n  font-weight: 470;\n  padding: 50px;\n  text-align: center;\n  display: block;\n  margin: 5px;\n  border-radius: 5px;\n\n  /* font-size: 12px; */\n  color: #000000;\n  /* width: 300px; */\n  background: rgb(221, 219, 219);\n  font-size: 20px;\n  /* margin: 100px auto;\n  padding: 10px; */\n  cursor: pointer;\n}\n\n#buttonStyle2:hover {\n  /*opacity: 0.3;*/\n\n  /* color: white; */\n  background: #005ce6;\n  transform: scale(1);\n  /* Equal to scaleX(2) scaleY(2) */\n  transition-duration: 0.5s;\n  /*transform: scale(0.6);*/\n}\n\n#buttonStyle3 {\n  font-weight: 380;\n  padding: 20px;\n  text-align: center;\n  display: flex;\n  /* margin:5px; */\n  border-radius: 5px;\n  color: #000000;\n  background: rgb(221, 219, 219);\n  font-size: 20px;\n  cursor: pointer;\n  justify-content: center;\n  /* Center horizontally */\n  align-items: center;\n  /* Center vertically */\n  height: 104px;\n  width: 200px;\n\n}\n\n#buttonStyle3:hover {\n  /*opacity: 0.3;*/\n  color: white;\n  background: #005ce6;\n  transform: scale(1);\n  /* Equal to scaleX(2) scaleY(2) */\n  transition-duration: 0.5s;\n  /*transform: scale(0.6);*/\n}\n\n#buttonStyle {\n  font-weight: 470;\n  text-align: center;\n  display: flex;\n  /* Use flexbox to center content */\n  justify-content: center;\n  /* Center horizontally */\n  align-items: center;\n  /* Center vertically */\n  margin: 5px;\n  border-radius: 5px;\n  height: 150px;\n  width: 360px;\n  color: #000000;\n  background: rgb(221, 219, 219);\n  font-size: 20px;\n\n\n}\n\n#buttonStyle:hover {\n  /*opacity: 0.3;*/\n\n  color: white;\n  background: #005ce6;\n  transform: scale(1);\n  /* Equal to scaleX(2) scaleY(2) */\n  transition-duration: 0.5s;\n  /*transform: scale(0.6);*/\n}\n\n.ag-theme-balham .status-rejected {\n  background-color: #F5B7B1 !important;\n}\n\n.ag-theme-balham .status-approved {\n  background-color: #ABEBC6 !important;\n}\n\n.ag-theme-balham .status-empty {\n  background-color: #FCF3CF !important;\n}\n\n.button-disable {\n  padding-top: 0px;\n  background-color: \"lightgrey\" !important;\n}\n\n\n.light-bg {\n  background-color: #ccfddd;\n}\n\n.light-err-bg {\n  background-color: #FFCCCC;\n}\n\n#hub-consignments-grid>div>div>div.ag-theme-balham.ag-popup>div>div>div.ag-tab-body {\n  height: 200px;\n}\n\n.top-header-led1 {\n  border: 1px solid #ccc;\n  padding: 1%;\n  display: flex !important;\n  justify-content: space-between !important;\n}\n\n.font-color {\n  color: #171C8F;\n  font-weight: bold;\n  font-size: 20px;\n}\n\n.main-title {\n  font-weight: bold;\n  font-size: 20px;\n}\n\n.railway_dispatches_header {\n  font-size: 18px\n}\n\n.intransit_rake_status_header {\n  font-size: 18px;\n}\n\n.led_table_header th {\n  font-size: 18px\n}\n\n.led_table_header td {\n  font-size: 18px;\n  /* font-weight: bold; */\n}\n\n.progress_bar_led>div>div>span {\n  font-size: 18px !important;\n}\n\n.led1_table1 {\n  padding: 10px 25px 10px 10px\n}\n\n.led1_table2 {\n  padding: 15px 25px 10px 25px;\n  margin-top: 20px\n}\n\n.led1_pirchart {\n  text-align: center;\n  padding-top: 18px\n}\n\n.led1_piechart {\n  height: 250px\n}\n\n.highcharts_led_screen {\n  width: 100%;\n  height: 100%\n}\n\n.counter-led1_header {\n  font-size: 20px;\n}\n\n.counter-led1_header2 {\n  font-size: 19px;\n}\n\n.counter-text {\n  color: #000000;\n  font-size: 15px;\n  font-weight: bold;\n  /* margin-bottom: 50px */\n}\n\n/* @media screen and (min-width: 2160px) {\n  .ledscreen_main_title{\n    text-align:center;\n    font-size:20px;\n  }\n  .update_on_time{\n    position:relative;\n    left:-23%;\n    font-size:20px;\n    color:#171C8F\n  }\n  .from_date_right{\n    position:relative ;\n    left:22%;\n    font-size:20px;\n    color:#171C8F\n  }\n  .to_date_right{\n    position:relative;\n    left:23%;\n    font-size:20px;\n    color:#171C8F\n  }\n  .railway_dispatches_header{\n    font-size: 16px\n  }\n  .intransit_rake_status_header{\n    font-size: 16px;\n  }\n  .led_table_header th{\n    font-size:16px\n  }\n  .led_table_header td{\n    font-size:16px\n  }\n  .progress_bar_led>div>div>span{\n    font-size:12px !important;\n  }\n} */\n/* @media screen and (min-width: 3840px) {\n  .ledscreen_main_title{\n    text-align:\"center\";\n    font-size:36px;\n  } \n  .update_on_time{\n    position:relative;\n    left:-23%;\n    font-size:32px;\n    color:#171C8F\n  }\n  .from_date_right{\n    position:relative ;\n    left:22%;\n    font-size:32px;\n    color:#171C8F\n  }\n  .to_date_right{\n    position:relative;\n    left:23%;\n    font-size:32px;\n    color:#171C8F\n  }\n  .railway_dispatches_header{\n    font-size: 30px;\n    margin-bottom: 10px !important;\n  }\n  .intransit_rake_status_header{\n    font-size: 30px;\n    margin-bottom: 10px !important;\n  }\n  .led_table_header th{\n    font-size:26px !important;\n    padding: 25px !important;\n  }\n  .led_table_header td{\n    font-size:26px !important;\n    padding: 25px !important;\n  }\n  .progress_bar_led>div>div>span{\n    font-size:26px !important;\n  }\n  .led1_table1{\n    padding :10px 25px 10px 10px\n  }\n  .led1_table2{\n    padding :15px 25px 10px 25px;\n    margin-top:20px\n  }\n  .led1_piechart{\n    height:350px !important\n  }\n  .highcharts_led_screen{\n    width: 100%;\n    height: 100%\n  }\n} */\n\n.disabled-anchor-edit {\n  color: #D3D3D3;\n}\n\n.sustainability_icons {\n  width: 25px;\n}\n\n.emission_image {\n  width: 60px;\n  margin-bottom: -15px;\n}\n\n.ltxtcenter {\n  text-align: center;\n}\n\n.lspceo {\n  float: right;\n  width: 265px;\n  margin-right: 10px;\n}\n\n.lspceo .css-2b097c-container {\n  font-size: 13px;\n  font-weight: normal !important;\n}\n\n.lspceo_blk {\n  background: #f5f5f5;\n  padding: 5px 10px 30px;\n}\n\n.ltxtcenterD .blk_lco {\n  height: 120px;\n  margin-bottom: 10px;\n  padding: 30px 10px;\n}\n\n.hvr {\n  border-radius: 5px;\n}\n\n.hvr:hover {\n  background-color: #171c8f;\n  color: #fff\n}\n\n.h6fnt {\n  font-size: 0.9rem;\n}\n\n.h115 {\n  height: 115px;\n}\n\n.dcursr {\n  cursor: pointer;\n  color: #000\n}\n\n.hvr:hover h6.txt-dark {\n  color: #fff !important;\n}\n\n.pd20 {\n  padding: 0 20px;\n}\n\n.custom-datetime-input {\n  opacity: 1;\n  border: 1px solid #b5b5b5;\n  font-size: 0.9rem;\n  border-radius: 0px;\n  width: 100%;\n  height: 36px;\n  padding: 6px 12px;\n}\n\n\n/* Container Tracking CSS */\n\n.eachCard+div.react-tooltip {\n  top: -38.875px !important;\n}\n\n.tilebl {\n  width: 30%;\n  position: relative;\n  height: 9px;\n}\n\n.portpos {\n  position: absolute;\n  width: 27%;\n  left: -20%;\n  top: -32px;\n  word-wrap: break-word;\n}\n\n.portdes {\n  position: absolute;\n  width: 35%;\n  right: -28px;\n  top: -33px\n}\n\n.my-svg {\n  display: flex;\n  flex-direction: row;\n\n}\n\n.flag_class {\n  width: 16px;\n  height: 16px;\n  position: relative;\n}\n\n.portind {\n  width: 20px;\n  /* position: absolute;left: 30%; */\n}\n\n.portsimg {\n  /* width:24px;height:24px; */\n  position: absolute !important;\n  top: 30px;\n  left: 2px;\n  border: 1px solid #ccc;\n}\n\n.portxt {\n  font-size: 11px;\n  font-weight: 600;\n  margin-top: 0px;\n}\n\n.portTxtpos {\n  margin: 0px 10px;\n}\n\n.desflg {\n  width: 16px;\n}\n\n.current-activity {\n  position: absolute;\n  top: -30px;\n  /* left: 29.1vw; */\n  /* width: 17.99vw; */\n  width: 27vw;\n  text-align: center;\n}\n\n.tracking-background-progress {\n  /* width: 260px;\n  height: 2px; */\n  /* background: #dcdcdc; */\n  /* position: relative;\n  width: 300px; */\n  position: absolute;\n  /* width: 375px; */\n  /* left: 412px; */\n  width: 85%;\n  left: 0%;\n  top: 0px;\n  height: 3px;\n  background: #b0adad;\n}\n\n.tracking-progress-red-line {\n  background: linear-gradient(to right, #0d5ed7, #9145c4, #ca149c, #e7006a, #eb1233);\n  animation: lineanimation 4s linear forwards;\n}\n\n.tracking-progress-green-line {\n  background: linear-gradient(to right, #0d5ed7, #0085ed, #009fd2, #00b194, #09bd4c);\n  animation: lineanimation 4s linear forwards;\n}\n\n.tracking-progress-blue-line {\n  background-color: #171c8f;\n  animation: lineanimation 4s linear forwards\n}\n\n@keyframes lineanimation {\n  0% {\n    width: 0%;\n  }\n\n  100% {\n    width: var(--highlight);\n  }\n}\n\n.early-text {\n  color: #217121;\n  background: #e4ffed;\n}\n\n.ontime-text {\n  color: #171c8f;\n  background: #e5e5fd;\n}\n\n.delay-text {\n  color: red;\n  background: #fce2e2;\n}\n\n.tracking-image-background {\n  width: 26px;\n  height: 23px;\n  background: #cccccc00;\n  position: absolute;\n  top: -17px;\n  text-align: center;\n  animation: lineanimation2 4s linear forwards\n    /* left: 100px; */\n}\n\n\n@keyframes lineanimation2 {\n  0% {\n    left: -1%;\n  }\n\n  100% {\n    left: var(--highlight2);\n  }\n}\n\n.cursor-class {\n  cursor: pointer;\n}\n\n\n.info_card_tracking {\n  width: 12px;\n  height: 12px;\n  margin-top: 9px;\n  margin-left: 7px;\n}\n\n.info_card_tracking_header {\n  width: 14px;\n  height: 14px;\n  margin-left: 7px;\n}\n\n\n.custom-modal-class-edit {\n  width: 85vw !important;\n  max-width: 100vw !important;\n}\n\n.custom-pagination {\n  display: flex;\n  padding: 10px;\n  justify-content: center;\n}\n\n.page-link {\n  border: none;\n  border-radius: 10px;\n}\n\n.visually-hidden {\n  display: none;\n}\n\n.arwUp {\n  width: 0;\n  height: 0;\n  border-left: 20px solid transparent;\n  border-right: 20px solid transparent;\n  border-bottom: 20px solid #EEF3FF;\n  position: absolute;\n  bottom: -30px;\n  left: 33%;\n}\n\n.cntrdiv {\n  border: 1px solid #171C8F !important;\n  position: absolute;\n  left: -10px;\n  width: 1px;\n  height: 70px;\n}\n\n.bghighliter {\n  background: #EEF3FF;\n  border-radius: 20px;\n  padding: 10px;\n  margin-bottom: 30px;\n  height: 90px;\n}\n\n\n.sub_counters_exim {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  overflow-x: auto;\n}\n\n.sub_counters_exim::-webkit-scrollbar {\n  height: 3px !important;\n}\n\n\n.region_card div.css-13cymwt-control {\n  height: 38px !important;\n}\n\n\n.mode-type .css-13cymwt-control,\n.tilesPageSelector .css-13cymwt-control {\n  height: 38px !important;\n}\n\n.mode-type .css-1n6sfyn-MenuList,\n.tilesPageSelector .css-1q04ie9-MenuList {\n  padding-top: 0px !important;\n}\n\n.tilesPageSelector .css-13cymwt-control {\n  width: 95px !important;\n}\n\n\n.search_icon {\n  position: absolute;\n  right: 12px;\n  width: 24px;\n  height: 13px;\n  top: 13px;\n  padding-left: 5px;\n  cursor: pointer;\n}\n\n.filter_search_icon {\n  position: relative;\n  width: 24px;\n  height: 13px;\n  top: -1px;\n  padding-left: 5px;\n  cursor: pointer;\n  left: -2vw;\n}\n\n.product_details {\n  font-weight: bold;\n  color: black;\n}\n\n.product_details_map {\n  font-size: 10px !important;\n}\n\n\n.accordion-button {\n  border: none;\n  background: #fff;\n  width: 100%;\n  text-align: left;\n  color: #007bff;\n  font-size: 16px;\n  font-weight: bold;\n}\n\nbutton.accordion-button[aria-expanded=\"true\"]::after {\n  content: '\\2B9F';\n  font-size: 25px;\n  float: inline-end;\n}\n\nbutton.accordion-button[aria-expanded=\"false\"]::after {\n  content: '\\2B9D';\n  font-size: 25px;\n  float: inline-end;\n}\n\n.accordion-header {\n  border-color: #007bff;\n}\n\n.accordion {\n  padding: 2rem;\n}\n\n\n.subtileborder {\n  border: 3px groove #171c8f !important;\n}\n\n.legend-overlay {\n  position: absolute;\n  bottom: 35px;\n  right: 57px;\n  z-index: 99;\n  width: 38%;\n  background-color: transparent;\n}\n\n.onwardrut {\n  background: #0059b3;\n  float: right;\n  color: #fff;\n  font-weight: 600;\n  padding: 0px 5px;\n}\n\n.baserut {\n  background: #a064ba;\n  float: right;\n  color: #fff;\n  font-weight: 600;\n  padding: 0px 5px;\n}\n\n.nav-item .tab-active {\n  border-bottom: 4px solid #c81e27;\n}\n\n.tab-active-container {\n  border-bottom: 3px solid #171c8f;\n  color: #171c8f !important;\n  border-bottom-width: 80%;\n  display: flex;\n  align-items: flex-end !important;\n\n}\n\n.subcounter-modal-size {\n  width: 50% !important;\n}\n\n\n.trip-done {\n  opacity: 0.5 !important;\n  filter: grayscale(1) !important;\n  cursor: not-allowed !important;\n}\n\n\n.custom-paginationItem {\n  border: 0px;\n  text-align: center;\n  font-size: 20px;\n  border-radius: 10px;\n  cursor: pointer;\n  padding-left: 14px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-right: 14px;\n}\n\n#page-active.custom-paginationItem {\n  background-color: #171c8f;\n  color: #ffffff;\n}\n\n.scrolling-text {\n  white-space: nowrap;\n  overflow: hidden;\n  /* position: fixed; */\n  /* top: 0; */\n  margin-top: 15px;\n  margin-bottom: -15px;\n  width: 100%;\n  background-color: red;\n  /* You can change the background color */\n  color: #fff;\n  /* Text color */\n  /* z-index: 1000; Makes sure the text is above other content */\n}\n\n.scrolling-text h5 {\n  display: inline-block;\n  padding-left: 50%;\n  animation: scroll-text 20s linear infinite;\n}\n\n@keyframes scroll-text {\n  from {\n    transform: translateX(0);\n  }\n\n  to {\n    transform: translateX(-70%);\n  }\n}\n\n.kpi-box {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 115px;\n  /* Set a fixed height to ensure uniformity */\n  margin: 5px;\n  padding: 10px;\n  border-radius: 5px;\n  /* Rounded corners */\n  color: #000;\n  overflow: hidden;\n  /* Hide any overflow */\n}\n\n.kpi-box h6 {\n  margin: 0;\n  font-size: 16px;\n  text-align: center;\n}\n\n.kpi-box p {\n  margin: 0;\n  font-size: 14px;\n  text-align: center;\n}\n\n/* Adjust box background colors based on the context */\n.kpi-box.good {\n  background-color: #95d5b2;\n  /* Light green for good status */\n}\n\n.kpi-box.bad {\n  background-color: #FF7F7F;\n  /* Light red for alerts or bad status */\n}\n\nbutton {\n  outline: none;\n}\n\n.datepciker-box {\n  border: 1px solid #b5b5b5;\n  font-size: 0.9rem;\n  border-radius: 0px;\n  padding: 6px 12px;\n  outline: none;\n}\n\n.lds-dual-ring,\n.lds-dual-ring:after {\n  box-sizing: border-box;\n}\n\n.lds-dual-ring {\n  display: inline-block;\n  width: 80px;\n  height: 80px;\n}\n\n.lds-dual-ring:after {\n  content: \" \";\n  display: block;\n  width: 64px;\n  height: 64px;\n  margin: 8px;\n  border-radius: 50%;\n  border: 6.4px solid currentColor;\n  border-color: currentColor transparent currentColor transparent;\n  animation: lds-dual-ring 1.2s linear infinite;\n}\n\n@keyframes lds-dual-ring {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.custom-calendar{\n  width:100% !important;\n}\n.datepicker-custom {\n  width: 290px !important;\n  font-size: 1rem;\n  padding-block: 5px;\n  outline: none;\n  border: 1px solid #b5b5b5;\n\n}\n.datepicker-custom1 {\n  width: 100% !important;\n  font-size: 1rem;\n  padding-block: 5px;\n  outline: none;\n  border: 1px solid #b5b5b5;\n\n}\n.datepicker-custom2 {\n  width: 100% !important;\n  font-size: 12px;\n  padding-block: 8px;\n  outline: none;\n  border: 1px solid #b5b5b5;\n  border-radius: 4px;\n}\n\n.datepicker-custom-ptl {\n  width: 220% !important;\n  /* font-size: 1rem; */\n  padding-block: 5px;\n  outline: none;\n  border: 1px solid #b5b5b5;\n}\n.datepicker-custom-ptl2 {\n  width: 213% !important;\n  /* font-size: 1rem; */\n  padding-block: 8px;\n  outline: none;\n  border: 1px solid #b5b5b5;\n}\n.datepicker-custom-ptl6 {\n  width: 256% !important;\n  /* font-size: 1rem; */\n  padding-block: 8px;\n  outline: none;\n  border: 1px solid #b5b5b5;\n}\n.datepicker-custom-ptl4 {\n  width: 245% !important;\n  /* font-size: 1rem; */\n  padding-block: 8px;\n  outline: none;\n  border: 1px solid #b5b5b5;\n}\n.datepicker-custom-ptl3 {\n  width: 265% !important;\n  /* font-size: 1rem; */\n  padding-block: 8px;\n  outline: none;\n  border: 1px solid #b5b5b5;\n}\n.datepicker-custom-ptl5 {\n  /* width: 265% !important; */\n  /* font-size: 1rem; */\n  padding-block: 8px;\n  outline: none;\n  border: 1px solid #b5b5b5;\n}\n\n.datepicker-custom-ptl2 {\n  width: 203% !important;\n  /* font-size: 1rem; */\n  padding-block: 8px;\n  outline: none;\n  border: 1px solid #b5b5b5;\n}\n#datepicker1 .react-datepicker-popper{\n  left:64px !important;\n}\n#addConsignment-datepicker .react-datepicker-wrapper{\n  width:100% !important;\n}\n\n\n.configuration-menu {\n  padding: 6px;\n  font-size: 17px;\n  font-weight: 400;\n  margin-top: 6px;\n}\n\n.configuration-menu.active {\n  background-color: #356cc9;\n  color: #ffff;\n  border-radius: 13px;\n  transition: all 0.2s ease;\n}\n\n.icon-config {\n  padding: 6px;\n  color: #ffff;\n}\n\n.icon-config.nightdriving {\n  background-color: #6d1fff;\n  border-radius: 11px;\n}\n\n.icon-config.overspeeding {\n  background-color: #f47a16;\n  border-radius: 11px;\n}\n\n.eye-icon2 {\n  position: absolute;\n  top: 69%;\n  transform: translateY(-50%);\n  right: 2rem;\n  cursor: pointer;\n}\n\n.icon-config.nogpsdata {\n  background-color: #38cfae;\n  border-radius: 11px;\n}\n\n.icon-config.enrouteStoppages {\n  background-color: #ff7441;\n  border-radius: 11px;\n}\n\n.icon-config.loadingDelaySettings {\n  background-color: #ff8839;\n  border-radius: 11px;\n}\n\n.icon-config.unloadingDelaySettings {\n  background-color: #DA3E52;\n  border-radius: 11px;\n}\n\n.icon-config.dealerRadius {\n  background-color: #770928;\n  border-radius: 11px;\n}\n\n.flex-left-center {\n  display: flex;\n  justify-content: left;\n  align-items: center;\n}\n\n.configuration-pannel {\n  padding-left: 2rem;\n  padding-top: 2rem;\n}\n\n.configuration-menu:hover {\n  .icon-config {\n    background-color: #356cc9;\n  }\n\n  background-color: #356cc9;\n  color: #ffff;\n  border-radius: 13px;\n}\n\nbutton:focus {\n  outline: none;\n}\n\n.ewayBill-mandatory {\n  font-size: 8px;\n  position: absolute;\n}\n\n@keyframes expands {\n  0% {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateY(0%);\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes expands {\n  0% {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateY(0%);\n    opacity: 1;\n  }\n}\n\n.filter-in {\n  animation: expands 0.5s;\n  -webkit-animation: expands 0.5s;\n}\n\n#webpack-dev-server-client-overlay-div {\n  display: none !important;\n}\n\n#webpack-dev-server-client-overlay {\n  display: none !important;\n}\n\n.poweredByLogo {\n  position: fixed;\n  bottom: 0px;\n  right: 22px;\n}\n.slider-translate{\n  width:25%;\n  transform: translateX(0%);\n}\n.slide30{width:30% !important;transform: translateX(0%);right:0px;}\n/* .nav-tabs {\n  background-color: $sidebar-dark-hover-bg;\n  border-bottom: 0;\n  margin-bottom: 5px;\n\n  .nav-item {\n    margin: 0;\n  }\n\n  .nav-link {\n    border-radius: 0;\n    padding: 10px 20px;\n    position: relative;\n    text-align: center;\n\n    &,\n    &:hover,\n    &:active,\n    &:focus,\n    &.active {\n      border: 0;\n    }\n\n    &:hover,\n    &:active,\n    &:focus,\n    &.active {\n      border-bottom-color: transparent;\n      border-left-color: transparent;\n      border-top-color: transparent;\n      color: $sidebar-dark-hover-color;\n    }\n\n    &.active {\n      background-color: $sidebar-dark-bg;\n    }\n  }\n} */\n.nav-tabs .nav-link {\n  font-weight: bold;\n  color: #555;\n  border-radius: 0;\n  border-bottom: 2px solid transparent;\n  padding: 10px 20px;\n  transition: color 0.3s, border-bottom-color 0.3s;\n}\n\n.nav-tabs .nav-link.active {\n  color: #007bff;\n  border-bottom-color: #007bff;\n}\n\n.nav-tabs .nav-link:hover {\n  color: #0056b3;\n}\n\n.nav-pills .nav-link {\n  font-weight: normal;\n  color: #666;\n  padding: 8px 15px;\n  border-radius: 5px;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.nav-pills .nav-link.active {\n  background-color: #007bff;\n  color: white;\n}\n\n.nav-pills .nav-link:hover {\n  background-color: #0056b3;\n  color: white;\n}\n.dashboard1{\n  width:130px;\n  height:40px;\n  text-align: center;\n  border-radius:10px;\n  background-color: transparent;\n  /* box-shadow: 0 1px 11px 0 rgb(0 0 0 / 10%); */\n  padding-top:10px;\n  cursor:pointer;\n  font-family: \"Public Sans\";\n}\n.activetab{\n  background-color: #c81e27;\n  color:white;\n  /* font-family: 'inter'; */\n  font-weight:14px;\n  \n}\n.inactivetab{\n  background-color: transparent;\n  color: #c81e27;\n  /* font-family: 'inter'; */\n  font-weight:14px;\n \n}\n.filter-styling {\n  height: 33px;\n  width: 34px;\n  cursor: pointer;\n  float: right;\n  background-color: #f5f5f5;\n  margin-right: 15px;\n  vertical-align: middle;\n  line-height: 16px;\n  font-size: 14px;\n  padding: 8px;\n  border: 2px solid transparent; \n  transition: all 0.3s ease; \n  border-radius:4px;\n}\n\n.filter-styling:hover {\n  border-color: #ff0000; \n  background-color: #e0e0e0; \n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  transform: scale(1.05); \n}\n.close-btn-container {\n  position: absolute;\n  top: 10px; /* Adjust this value to move the button up or down */\n  right: 10px; /* Adjust this value to move the button left or right */\n  z-index: 1051; /* Ensure the button is above other content */\n}\n\n.close-button {\n  background: transparent; /* Optional: Set background to transparent */\n  border: none; /* Remove border */\n}\n .card-header2 {\n    padding: 0.75rem 1.25rem;\n    margin-bottom: 0;\n    background-color:white !important;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n    height:350px;\n  }\n  .scrollable-table-container table  {\n    max-height: 235px;\n    overflow-y: auto;\n   }\n   .scrollable-table-container th,\n   .scrollable-table-container td {\n       padding: 4px 8px !important;/* Adjust padding to control row height */\n       text-align: left;\n       vertical-align: middle;\n   }\n   \n.scrollable-table-container th {\n       height: 30px; /* Adjust height for header */\n       font-size: 14px; /* Adjust font size for header */\n   }\n   \n.scrollable-table-container td {\n       height: 25px; /* Adjust height for rows */\n       font-size: 12px; /* Adjust font size for rows */\n   }\n.scrollable-table-container1 table  {\n     max-height: 240px;\n     overflow-y: auto;\n     width:\"97%\" !important;\n    }\n.table-outlookvsorders{\n      background-color:#c81e27;\n      color:#ffffff !important;\n      width:160px;\n      height:10px;\n    }\n.heading3{\n  font-family:\"Public Sans\" !important;\n      /* color:#0664AE; */\n      color:black;\n      font-weight: 600;\n      font-size:15px;\n    }\n.dateStyling{\n  font-size: 10px;\n} \n.smaller-datetime input {\n  width: 80px;  /* Adjust width as needed */\n  height: 25px;  /* Adjust height as needed */\n  font-size:9px; \n  font-weight:bold;\n  margin-right: 15px;\n  background-color: #fff !important;\n}\n.table-small-rows td {\n  height:10px;\n  padding: 7px !important;\n  font-size: 12px;  /* Optionally reduce the font size for better fit */\n}\n.custom-btn1{padding:8px 5px;background:#1cc88a;color:#fff;border:#1cc88a;border-radius:10px; cursor:pointer}\n.legendlist button:last-child{\n  border-right: none !important;\n}\n.mybtn {\n  background: none !important;\n  color: #333;\n  font-size: 12px;\n  padding: 1px 5px;\n  border-right: 1px solid #ccc !important;\n  border-left: 0px solid #ccc !important;\n  border-top: 0px solid #ccc !important;\n  border-bottom: 0px solid #ccc !important;\n}\n.sliderBlock3 {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 35%;\n  height: 30%;\n  background: #fff;\n  box-shadow: 0.5rem 0.5rem 2rem 1rem rgba(0, 0, 0, 0.2);\n  border-radius: 30px;\n  z-index: 1000;\n  overflow-y: hidden;\n  overflow-x: hidden;\n  transition: 0.5s ease-in-out;\n}\n.sliderBlockForConsCreation {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 30%;\n  height: 40%;\n  background: #fff;\n  box-shadow: 0.5rem 0.5rem 2rem 1rem rgba(0, 0, 0, 0.2);\n  border-radius: 10px;\n  z-index: 1000;\n  overflow-y: hidden;\n  overflow-x: hidden;\n  transition: 0.5s ease-in-out;\n  padding:20px;\n}\n\n.slide95 {\n  transform: translate(-50%, -50%) scale(1);\n}\n\n.ffclosebtn1 {\n  cursor: pointer;\n  margin-top: -43px;\n  color: #717171;\n}\n\n.closeIcon {\n  height: 14px;\n  width: 14px;\n  color:black;\n}\n\n.confirm-heading {\n  font-family: \"Public Sans\" !important;\n  font-weight: 500;\n  font-size: 16px;\n  color: #585757;\n  text-align: center;\n}\n\n.btn_confirm_cancel {\n  width: 195px;\n  height: 33px;\n  border: 0.76px solid #565555;\n  color: #565555;\n  border-radius: 7.57px;\n  background-color: transparent;\n  transition: #565555 0.3s ease;\n}\n\n.btn_confirm_cancel:hover {\n  border-color: #426cf5;\n  color: #426cf5;\n}\n\n.btn_hover7 {\n  background-color: green;\n  border-radius: 7.57px;\n  font-weight: bold;\n  color: white;\n  font-size: 15px;\n  height: 33px;\n  width: 195px;\n  border: none;\n}\n.btn_hover8 {\n  background-color: #d12828;\n  border-radius: 7.57px;\n  font-weight: bold;\n  color: white;\n  font-size: 15px;\n  height: 33px;\n  width: 195px;\n  border: none;\n}\n.viewButton{\n  padding: 3px 3px 0px 2px;\n  /* background-color: #d6d3d3; */\n  background-color: white;\n  color: #000;\n  font-size: 12px;\n  border-radius: 5px;\n  border:0px;\n  font-weight: bold;\n  height:20px;\n  width:20px;\n  }\n  .viewButton1{\n    padding: 0px;\n    background-color: #d6d3d3;\n    color: #000;\n    font-size: 12px;\n    }\n    \n.title-heading{\n  /* font-family: \"roboto\"; */\n  font-size:20px !important;\n  color:black;\n}  \n.custom-field-width{\n  max-width: 385px !important;\n}\n.custom-field-width1{\n  max-width: 450px !important;\n}\n.plantstyle{\n  margin-top: 20px !important;\n}\n.toggle-container {\n  margin: 10px 0;\n  display: flex;\n  justify-content: center;\n}\n\n.btn1 {\n  padding: 5px 5px;\n  border-radius: 5px;\n  margin: 0 10px;\n  cursor: pointer;\n  border: none;\n  font-size: 12px;\n}\n\n.btn-active {\n  background-color: #1cc88a;\n  color: white;\n}\n\n.btn-inactive {\n  background-color: #ddd;\n  color: black;\n}\n\n.ag-header-cell-text{\n  font-weight: bold;\n  color:black;\n}\n.btn-h {\n  background-color: #5FC19C !important;\n  border-color: #5FC19C !important;\n  color:#fff !important;\n}\n\n.btn-h.disabled {\n  background-color: #5FC19C !important;\n  border-color: #5FC19C !important;\n}\n\n.btn-h:disabled {\n  background-color: #5FC19C !important;\n  border-color: #5FC19C !important;\n}\n\n.btn-h:hover,\n.btn-h:focus,\n.btn-h:active,\n.btn-h.active {\n  background-color: #359b74 !important;\n  border-color: #359b74 !important;\n  color:#fff !important;\n}\n\n.btn-h:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem #d9ebff;\n  box-shadow: 0 0 0 0.2rem #d9ebff;\n}\n\n.pgtab {\n  border-right: 2px solid #fff;\n  background: #4c99ff2b;\n}\n.pgtab:first-child {\n  border-top-left-radius: 5px;\n}\n.pgtab:last-child {\n  border-top-right-radius: 5px;\n}\n.pgtab:last-child {\n  border-right: 0px;\n}\n.pgtab{border-right:2px solid #fff;background:#E0FAF0;}\n.bgColorDangerDark{ background-color: #ff7289 !important;}\n.disabled-checkbox {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.disabled-cell {\n  background-color: #f0f0f0; /* Light grey */\n}\n.andriomap-pos{position:fixed;bottom:-1%;left:47%;width:40px;height:40px;z-index:999;cursor:pointer;}\n.andriomap-pos2{position: absolute;left:47%;top:-2%; width:40px;height:40px;z-index:999999;cursor:pointer;}\n\n\n.zindex999{z-index:999;}\n.ico-color{color:#ffffff;font-size:32px;background:#333333;padding:5px;}\n.textAlignCenter {\n  text-align: center;\n}\n.route-block{margin-bottom: 15px;border-bottom: 1px solid #ccc;padding-bottom: 10px;}\n.sidebar-label{font-weight: 600;}\n.prel{ position:relative;}\n.remark-text {\n  color: black;\n  font-size: 0.9rem; /* Slightly larger font size */\n  margin-top: 5px;\n  text-decoration: underline; /* Adds underline */\n  font-weight: bold; /* Optional: makes the text bold */\n}\n/* Card styling */\n.document-card {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 10px;\n  margin-bottom: 15px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  background-color: #f9f9f9;\n}\n\n/* Attachment icon */\n.attachment-icon {\n  font-size: 1.2rem;\n  margin-right: 10px;\n  color: #6c757d; /* Neutral color for the icon */\n}\n\n/* Document section */\n.document-section {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.document-details {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.file-input {\n  flex-grow: 1;\n  margin-right: 10px;\n  padding: 5px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: #fff;\n}\n\n/* Remarks section */\n.remarks-section {\n  margin-top: 5px;\n}\n\n.remark-text {\n  color: black;\n  font-size: 0.9rem;\n  font-weight: bold;\n  text-decoration: underline;\n}\n\n/* Cool color palette */\n:root {\n  --primary-color: #3498db; /* Cool blue */\n  --secondary-color: #2ecc71; /* Fresh green */\n  --accent-color: #9b59b6; /* Purple accent */\n  --background-color: #f3f4f7; /* Light background */\n  --text-color: #333; /* Dark text for contrast */\n}\n\n/* Container for the tab buttons */\n.tab-buttons {\n  display: flex;\n  justify-content: left;\n  margin-bottom: 20px;\n}\n\n/* Common styles for the tab buttons */\n.tab-button {\n  flex: 1;\n  padding: 12px;\n  text-align: center;\n  background-color: var(--background-color);\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 16px;\n  color: var(--text-color);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  position: relative;\n}\n\n/* Hover effect for tab buttons */\n.tab-button:hover {\n  background-color: var(--primary-color);\n  color: white;\n}\n\n/* Active state styling for the tab with animation */\n@keyframes loadingAnimation {\n  0% {\n      transform: scale(1);\n      opacity: 1;\n      background-color: var(--primary-color);\n  }\n  50% {\n      transform: scale(1.1);\n      opacity: 0.8;\n      background-color: var(--secondary-color);\n  }\n  100% {\n      transform: scale(1);\n      opacity: 1;\n      background-color: var(--primary-color);\n  }\n}\n\n.tab-button.active {\n  animation: loadingAnimation 1s ease-in-out infinite;\n  color: white;\n  font-weight: 700;\n}\n\n/* Disabled tab button styling */\n.tab-button:disabled {\n  background-color: #f5f5f5;\n  color: #aaa;\n  cursor: not-allowed;\n}\n\n/* Optional: Hover effect when the tab is active */\n.tab-button.active:hover {\n  background-color: var(--secondary-color);\n}\n\n/* Loading button with small bouncing balls animation */\n/* Loading button with small bouncing balls animation */\n.loading-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px 10px;\n  background-color: var(--primary-color);\n  color: white;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  border: none;\n  transition: background-color 0.3s ease;\n}\n.loading-button1 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px 10px;\n  background-color: var(--secondary-color);\n  color: white;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  border: none;\n  transition: background-color 0.3s ease;\n}\n\n.loading-button:hover {\n  background-color: var(--secondary-color);\n}\n\n/* Disabled button styling (grey color and no dots animation) */\n.loading-button:disabled {\n  background-color: #d3d3d3; /* Grey background */\n  color: #aaa;  /* Grey color for text */\n  cursor: not-allowed;\n}\n\n.loading-button:disabled .loading-dots {\n  display: none; /* Hide the dots animation when the button is disabled */\n}\n\n/* Style for the dots */\n.loading-dots {\n  display: inline-block;\n  margin-left: 10px;\n}\n\n/* Reduced size of dots and making them colorful */\n.dot {\n  display: inline-block;\n  width: 8px;  /* Smaller size */\n  height: 8px;  /* Smaller size */\n  margin-right: 5px;\n  border-radius: 50%;\n  opacity: 0;\n  animation: dot-blink 1.5s infinite step-start;\n}\n\n/* Sequential dot appearance with delays */\n.dot:nth-child(1) {\n  animation-delay: 0s;\n  background-color: #ff5733;  /* Red */\n}\n\n.dot:nth-child(2) {\n  animation-delay: 0.3s;\n  background-color: #33ff57;  /* Green */\n}\n\n.dot:nth-child(3) {\n  animation-delay: 0.6s;\n  background-color: #3357ff;  /* Blue */\n}\n\n/* Keyframes for dot blink effect */\n@keyframes dot-blink {\n  0% {\n      opacity: 0;\n  }\n  50% {\n      opacity: 1;\n  }\n  100% {\n      opacity: 0;\n  }\n}\n/* Container for the tab section */\n.tabs-section {\n  margin-bottom: 20px;\n  padding: 10px;\n  border-bottom: 2px solid #ddd; /* Light border under tabs */\n  background-color: #f9f9f9; /* Light background for the tabs section */\n}\n\n/* Style the tab list */\n.tabs1 {\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.tabs {\n  display: flex;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n/* Style individual tab items */\n.tab-item {\n  padding: 10px 20px;\n  cursor: pointer;\n  font-weight: bold;\n  color: #555; /* Default text color */\n  background-color: #fff; /* Background color of inactive tabs */\n  border: 1px solid #ccc; /* Border for each tab */\n  border-radius: 5px 5px 0 0; /* Rounded top corners */\n  margin-right: 10px; /* Space between tabs */\n  transition: background-color 0.3s, color 0.3s, border-color 0.3s; /* Smooth transition for hover/active states */\n}\n\n/* Hover effect for tabs */\n.tab-item:hover {\n  background-color: #f0f0f0; /* Slightly darker background on hover */\n  color: #007bff; /* Blue text color on hover */\n}\n\n/* Active tab styles */\n.tab-item.active {\n  background-color: #007bff; /* Blue background for active tab */\n  color: white; /* White text for active tab */\n  border-color: #007bff; /* Same blue border color */\n}\n\n/* Optionally, you can add some customizations for focus, etc., for accessibility */\n.tab-item:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.5); /* Blue outline on focus */\n}\n.tab-item.active {\n  background-color: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n.custom-label {\n  font-size: 14px;\n}\n\n.custom-input {\n  width: 105%;\n  /* padding: 10px; */\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 14px;\n  /* margin-bottom: 10px; */\n  transition: border-color 0.3s ease;\n}\n\n.custom-input:focus {\n  border-color: #007bff;\n  outline: none;\n}\n.doc-style{\n  font-size: 14px;\n  color:#000;\n  font-weight:bold;\n}\n\ninput:disabled {\n  background-color: #e9ecef;\n  cursor: not-allowed;\n}\n.margin-left-extended {\n  margin-left: 1165px; /* Adjust the value as needed */\n}\n.margin-top-default {\n  margin-top: 0px;\n}\n.margin-top-tablet {\n  margin-top: 0px;\n}\n\n\n/* Larger screen sizes (tablet and above) */\n@media (min-width: 768px) {\n  .margin-top-tablet {\n      margin-top: 25px;\n  }\n}\n\n/* Extra large screens (desktop and above) */\n@media (min-width: 1200px) {\n  .margin-top-default {\n      margin-top: 25px; /* Or any value you want for larger screens */\n  }\n}\n/* General styles for counters */\n.counters-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 0.5rem;\n  margin: 0 auto;\n}\n\n\n\n/* Adjust font sizes for smaller screens */\n.counter-card {\n  flex: 1;\n  text-align: center;\n  padding: 10px 0;\n  border-left: 1px solid #ddd; /* Vertical separator */\n  font-family: \"Public Sans\";\n}\n\n/* Remove the first vertical line */\n.counter-card:first-child {\n  border-left: none;\n}\n\n/* Adjust font sizes for counters */\n.counter-card span {\n  font-size: 30px;\n  /* color: #333; */\n}\n\n.counter-card h4 {\n  font-size: 24px;\n  margin-top: 20px;\n  /* color: #555; */\n  font-weight: bold;\n}\n.counter-card h6 {\n  font-size: 24px;\n  /* margin-top: 20px; */\n  /* color: #555; */\n  font-weight: bold;\n}\n.counter-card h5 {\n  font-size: 24px;\n  margin-top: 5px;\n  /* color: #555; */\n  font-weight: 600px;\n}\n\n/* Responsive breakpoints */\n@media (max-width: 1024px) {\n  .counter-card {\n      flex: 1 1 calc(33.33% - 1rem); /* Adjust for smaller screens */\n  }\n}\n\n@media (max-width: 768px) {\n  .counter-card {\n      flex: 1 1 calc(50% - 1rem); /* Two items per row */\n  }\n}\n\n@media (max-width: 480px) {\n  .counter-card {\n      flex: 1 1 100%; /* One item per row */\n      border-left: none;\n      border-bottom: 1px solid #ddd;\n  }\n\n  .counter-card:last-child {\n      border-bottom: none;\n  }\n}\n\n.btn-bulkupload{\n  border-radius: 4px;\n  border-color: #0664AE;\n  background-color:#ffffff;\n}\n.radio-buttons{\n  margin-left:10px;\n}\n.search-label {\n  position: relative;\n  margin-left: 20px;\n  font-size: 13px;\n}\n\n.filter-label {\n  position: relative;\n  margin-left: 10px;\n  font-size: 13px;\n}\n.search_icon{\n  position: absolute;\n  right: 12px;\n  width: 24px;\n  height: 13px;\n  top: 13px;\n  padding-left: 5px;\n  cursor: pointer;\n}\n\n.gm-ui-hover-effect {\n  opacity: 1 !important;\n  background: #b6b5b5 !important;\n  padding: 0px !important;\n  top: 0px !important;\n  right: 0px !important;\n  height: 34px !important;\n  width: 19px !important;\n  filter: invert(1);\n}\n.modal-header-custom {\n  background-color: #6c5ce7; /* Purple Header */\n  color: white;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.modal-title-custom {\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.modal-body-custom {\n  padding: 20px;\n  font-size: 16px;\n  color: #333;\n}\n\n.otp-label {\n  font-weight: bold;\n  font-size: 15px;\n}\n\n.otp-input {\n  border: 2px solid #6c5ce7;\n  border-radius: 5px;\n  font-size: 16px;\n  padding: 10px;\n}\n\n.modal-footer-custom {\n  display: flex;\n  justify-content: space-between;\n  padding: 15px;\n  background-color: #f1f1f1;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n\n.cancel-btn {\n  background-color: #d6d5d2 !important;\n  color: black !important;\n  border-radius: 5px;\n  /* padding: 8px 16px; */\n  font-size: 14px;\n}\n\n.submit-btn {\n  background-color: green !important;\n  color: white;\n  border-radius: 5px;\n  /* padding: 8px 16px; */\n  font-size: 14px;\n}\n\n.cancel-btn:hover {\n  background-color: #b82b2b;\n}\n\n.submit-btn:hover {\n  background-color: #0875d3;\n}\n.pagination-controls {\n  display: flex;\n  justify-content: center;  /* ✅ Center align */\n  align-items: center;\n  margin-top: 15px;  /* ✅ Add spacing above */\n  gap: 10px;  /* ✅ Space between elements */\n  font-size: 16px;\n  font-weight: bold;\n  color: #333;\n}\n\n.pagination-controls button {\n  background-color: #007bff;  /* ✅ Blue background */\n  color: white;\n  border: none;\n  padding: 8px 15px;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: pointer;\n  border-radius: 5px;\n  transition: background 0.3s ease-in-out;\n}\n\n.pagination-controls button:hover {\n  background-color: #0056b3;  /* ✅ Darker blue on hover */\n}\n\n.pagination-controls button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.pagination-controls span {\n  font-size: 16px;\n  font-weight: bold;\n  color: #555;\n}\n.track-button {\n  background-color: #28a745; /* Green */\n  color: white;\n  border: 2px solid #218838;\n  padding: 4px 12px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n}\n\n.track-button:hover {\n  background-color: #218838; /* Darker Green */\n  border-color: #1e7e34;\n  color: white;\n}\n.border-radius1{\n  border-radius: 4px;\n}\n.defectIcon1{\n  height:30px;\n}\n.login-style{\n  background-color: #a064ba !important;\n  color:#fff;\n  border-radius: 4px;\n}\n.bulk-invalid-text{\n  margin-top: -15px;\n  margin-right: -18px;\n}\n.tms-legend-style{\n  font-size: 15px;\n  font-weight: 400;\n  font-size: 13px;\n}\n.resetgrid-border-radius{\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.savegrid-border-radius{\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.date-container .react-datepicker-wrapper{\n  width: 100%;\n}\n.display-flex-center-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.main-page-button {\n  font-size: 14px;\n  border-radius:4px;\n  \n  /* padding: 4px; */\n}\n.txt-black-light {\n  color: #534949\n}\n.txt-total {\n  color: #4a4a4a; /* Neutral gray for total */\n}\n\n.txt-open {\n  color: #007bff; /* Blue for open */\n}\n\n.txt-assigned {\n  color: #ff8c00; /* Orange for assigned */\n}\n\n.txt-in-progress {\n  color: #ffc107; /* Yellow for in-progress */\n}\n\n.txt-resolved {\n  color: #28a745; /* Green for resolved */\n}\n\n.txt-reopened {\n  color: #dc3545; /* Red for reopened */\n}\n\n.txt-onhold {\n  color: #6c757d; /* Muted gray for on-hold */\n}\n\n.txt-need-info {\n  color: #e83e8c; /* Pink for need info */\n}\n\n.txt-closed {\n  color: #28a745; /* Dark green for closed */\n}\n.back-button {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    padding: 5px 14px;\n    border-radius: 20px; /* Rounded corners */\n    display: flex;\n    align-items: center;\n    font-size: 12px;\n    cursor: pointer;\n}\n\n.back-button::before {\n    content: \"<\"; /* Left arrow */\n    margin-right: 8px;\n}\n\n.back-button:hover {\n    background-color: #e0e0e0;\n    border-color: #bbb;\n}\n\n.back-button:focus {\n    outline: none;\n}\n.form-input{\n  border-radius:3px;\n  border: 1px solid #D3D3D3;\n  height:38px;\n}\n.form-label{\n  font-size:13px;\n  color:grey;\n}\n.logoheader{\n  height:100px !important;\n}\n.create-ticket{\n  padding:0px;\n}\n.editItem1{\n  padding:0px;\n  width:46px;\n  height:21px;\n}\n.editticket-input{\n  width:100%;\n  padding:10px;\n  border-radius: 4px;\n  border:1px solid #ccc;\n}\n.down-arrow{\n  font-size: 30px;\n}\n.cancel-button {\n  background-color: whitesmoke;\n  color: #ff4d79; /* soft red/pink */\n  border: 2px solid #ff4d79;\n  padding: 5px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  height:38px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cancel-button:hover {\n  background-color: #ff4d79;\n  color: white;\n}\n.save-add-new-button {\n  color: #00c896; /* soft green */\n  border: 2px solid #00c896;\n  padding: 5px 16px;\n  border-radius: 6px;\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  height: 38px;\n  width: auto; /* ADD THIS */\n  align-self: center; /* ADD THIS to center it inside flex column */\n}\n\n\n.save-add-new-button:hover {\n  background-color: #00c896;\n  color: white;\n}\n.save-consignment-button {\n  background-color: #00c896; /* same green as the others */\n  color: white;\n  border: none;\n  padding: 5px 16px;\n  border-radius: 6px;\n  font-weight: 500;\n  font-size: 14px;\n  height:38px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.save-consignment-button:hover {\n  background-color: #00b287; /* slightly darker green on hover */\n}\n.consignment-del{\n  font-size: 25px;\n}\n.cons-creation-head{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.proceed-text {\n  color: red; /* Same red color as your button */\n  text-decoration: underline; /* Underline */\n  font-size: 14px;\n  margin: 10px 0px 30px 0px;\n  cursor: pointer; /* So user knows it's clickable */\n  font-weight: 500;\n}\n.success-icon {\n  width: 100px; /* Size of tick */\n  height: 70px;\n  margin-bottom: 10px;\n}\n.cons-creation-card-title-header {\n  padding: 12px 20px;\n  margin-bottom: 0;\n  background-color:#e7f2f9;\n  border-bottom: 1px solid #e7f2f9;\n}\n\n.cons-creation-card-title-header:first-child {\n  border-radius: 3px 3px 0 0;\n}\n\n.cons-creation-card-title-header+.list-group .list-group-item:first-child {\n  border-top: 0;\n}\n.tpt-dropdown-style{\n  margin-top: 6px;\n  padding: 4px;\n  width: 100%;\n  font-size: 13px;\n  border: 1px solid #ccc;\n}\n.tpt-alloc-label{\n  display: block;\n  margin-bottom: 5px;\n}\n.tpt-alloc-input{ \n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.disabled-btn {\n  background-color: #cccccc !important;\n  border-color: #aaaaaa !important;\n  color: #666666 !important;\n  cursor: not-allowed !important;\n  opacity: 0.6;\n  pointer-events: none; /* prevents click or hover */\n}\n.master-title{\n  font-weight: bold;\n}\n/* \n.toggle-button {\n  position: relative;\n  width: 60px;\n  height: 30px;\n  background-color: #ccc;\n  border: none;\n  border-radius: 30px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  overflow: hidden;\n}\n\n.toggle-button::after {\n  content: '';\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 24px;\n  height: 24px;\n  background-color: #fff;\n  border-radius: 50%;\n  transition: transform 0.3s ease;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.3);\n}\n\n.toggle-button.active {\n  background-color: #4caf50;\n  justify-content: flex-end;\n}\n\n.toggle-button.active::after {\n  transform: translateX(-3px); \n}\n\n.toggle-button .off,\n.toggle-button .on {\n  display: none;\n} */\n\n.toggle-button {\n  position: relative;\n  width: 60px;\n  height: 30px;\n  background-color: #ccc;\n  border: none;\n  border-radius: 30px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  padding: 0;\n  overflow: hidden;\n}\n\n/* The knob */\n.toggle-button::after {\n  content: '';\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 24px;\n  height: 24px;\n  background-color: #fff;\n  border-radius: 50%;\n  transition: transform 0.3s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);\n}\n\n/* When active: background turns green */\n.toggle-button.active {\n  background-color: #4caf50;\n}\n\n/* When active: move the knob right */\n.toggle-button.active::after {\n  transform: translateX(30px); /* 60px container - knob width - margin */\n}\n\n/* Hide icons */\n.toggle-button .on,\n.toggle-button .off {\n  display: none;\n}\n\n.btn-sea {\n  background-color: #2CA6A4 !important;  \n  border-color: #2CA6A4 !important;\n  color: #ffffff !important;\n}\n\n.btn-sea.disabled,\n.btn-sea:disabled {\n  background-color: #2CA6A4 !important;\n  border-color: #2CA6A4 !important;\n}\n\n.btn-sea:hover,\n.btn-sea:focus,\n.btn-sea:active,\n.btn-sea.active {\n  background-color: #218c8a !important;  \n  border-color: #218c8a !important;\n  color: #ffffff !important;\n}\n\n.btn-sea:focus {\n  box-shadow: 0 0 0 0.2rem #c8f4f3;\n  -webkit-box-shadow: 0 0 0 0.2rem #c8f4f3;\n}\n\n.sea-tab {\n  border-right: 2px solid #fff;\n  background: #e0fafa;\n}\n\n.sea-tab:first-child {\n  border-top-left-radius: 5px;\n}\n\n.sea-tab:last-child {\n  border-top-right-radius: 5px;\n  border-right: 0px;\n}\n\n.timeline-stripe1 {\n  position: relative;\n  width: 12px;\n  background-color: #1e90ff; /* default blue */\n  margin: 0px 30px;\n}\n\n.timeline-stripe1::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-color: green;\n  transition: height 0.3s ease;\n  border-radius: 2px;\n}\n\n.timeline-event1 {\n  transition: transform 0.3s ease, opacity 0.3s ease;\n  transform-origin: top;\n}\n\n.timeline-stripe1.expanding .timeline-event1 {\n  animation: fadeSlideIn 0.4s ease forwards;\n}\n\n@keyframes fadeSlideIn {\n  from {\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.timeline-event1.newly-shown {\n  animation: popIn 0.3s ease-in;\n  background-color: #e8f5e9; /* light green highlight */\n  border-radius: 6px;\n}\n\n@keyframes popIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.truck-image1.expanded {\n  animation: pulseTruck 0.4s ease-in-out;\n  box-shadow: 0 0 10px 3px rgba(0, 255, 0, 0.4);\n  border-radius: 50%; /* optional: smooth rounded highlight */\n}\n\n@keyframes pulseTruck {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.timeline-content1.in-transit-bg {\n  background-color: #e8f5e9;  /* light green background */\n  border-radius: 8px;\n  padding: 10px 14px;\n  box-shadow: 0 1px 4px rgba(76, 175, 80, 0.2); /* subtle green shadow */\n  transition: background-color 0.3s ease;\n}\n\n.blue-dot1 {\n  width: 20px;\n  height: 20px;\n  background-color: #2196f3; /* blue */\n  border-radius: 50%;\n  position: relative;\n  z-index: 2;\n}\n\n.green-dot1 {\n  width: 20px;\n  height: 20px;\n  background-color: green;\n  border-radius: 50%;\n  position: relative;\n  z-index: 2;\n}\n\n.arrow-toggle {\n  font-size: 20px;\n  font-weight: bold;\n  color: #4caf50; \n  background-color: transparent !important; \n  border: none;\n  outline: none;\n  box-shadow: none;\n  padding: 0;\n  margin-right: 6px;\n  display: inline-block;\n  line-height: 1;\n}\n\n.arrow-toggle:hover {\n  transform: scale(1.2);\n  transition: transform 0.2s ease;\n}\n\n.truck-wrapper {\n  position: relative;\n  width: 36px;\n  height: 36px;\n  background-color: #e0f2f1;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.truck-image-icon1 {\n  width: 28px;\n  height: 28px;\n  object-fit: contain;\n}\n\n.arrow-toggle {\n  position: absolute;\n  font-size: 20px;\n  font-weight: bold;\n  color: #e8f5e9;;\n  background: transparent;\n  pointer-events: none;\n  margin-right: 45px;\n  margin-bottom: 10px;\n  margin-left: -27px;\n}\n\n.collapsed-arrow .arrow-toggle {\n  top: 50%;\n  right: -6px;\n  transform: translateY(-50%);\n}\n\n.expanded-arrow .arrow-toggle {\n  bottom: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.pod-eye-icon button {\n  padding: 2px 8px;\n  font-size: 13px;\n}\n\n.legs-container {\n  background-color: #e6f9f6;\n  padding: 10px 15px;\n  border-left: 3px solid #28a745;\n  margin-top: 8px;\n  border-radius: 4px;\n  max-width: 300px;\n}\n\n.leg-details {\n  font-size: 12px;\n  color: #333;\n  padding: 8px 10px;\n  border-radius: 4px;\n  box-shadow: 0 4px 2px rgba(0, 0, 0, 0.05);\n}\n\n.expand-legs-icon {\n  font-size: 13px;\n}\n\n.legs-scroll-wrapper {\n  min-height: 100px;\n  max-height: 230px;\n  overflow-y: auto;\n  padding-right: 8px;\n  scroll-behavior: smooth;\n  scrollbar-width: thin;\n  scrollbar-color: #888 transparent;\n}\n\n.legs-scroll-wrapper::-webkit-scrollbar {\n  width: 6px;\n}\n\n.legs-scroll-wrapper::-webkit-scrollbar-track {\n  background: transparent; \n}\n\n.legs-scroll-wrapper::-webkit-scrollbar-thumb {\n  background-color: #888;  \n  border-radius: 10px;\n}\n\n.legs-scroll-wrapper::-webkit-scrollbar-thumb:hover {\n  background-color: #555;\n}\n.logo-header-tracking{\n  height: 200px !important;\n}\n.reset-btn-rawcourier {\n  border-radius: 4px; \n  padding: 0.375rem 0.75rem;\n}\n\n.rightModal {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 450px;\n    height: 100%;\n    background: #fff;\n    z-index: 9999;\n    box-shadow: -2px 0 8px rgba(0,0,0,0.2);\n    animation: slideIn 0.3s ease-out;\n    padding: 20px;\n}\n\n@keyframes slideIn {\n    from { right: -500px; }\n    to { right: 0; }\n}\n\n.modalOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0,0,0,0.3);\n    z-index: 9998;\n}\n.duplicate-row {\n    background-color: #ffcccc !important;\n}\n.modalOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0,0,0,0.4);\n    z-index: 9998;\n}\n\n.rightModal {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 420px;       /* or whatever width you want */\n    height: 100vh;      /* full screen height */\n    background: #fff;\n    z-index: 9999;\n    padding: 20px;\n    overflow-y: auto;   /* <-- ENABLE SCROLL */\n    box-shadow: -3px 0 10px rgba(0,0,0,0.2);\n}\n.grid-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0,0,0,0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 3000;\n}\n\n.grid-modal {\n    background: #fff;\n    width: 90%;\n    max-width: 1300px;\n    padding: 20px;\n    border-radius: 10px;\n}\n\n.grid-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.close-btn {\n    background: #dc3545;\n    color: #fff;\n    padding: 6px 15px;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n}\n\n.trip-tabs {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 12px;\n}\n\n.tab, .active-tab {\n    padding: 6px 14px;\n    border-radius: 6px;\n    background: #fff;\n    border: 1px solid #007bff;\n    cursor: pointer;\n}\n\n.active-tab {\n    background: #007bff;\n    color: #fff;\n    font-weight: bold;\n}\n.excel-btn {\n    background: linear-gradient(135deg, #28a745, #218838);\n    color: #fff;\n    padding: 8px 18px;\n    border: none;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);\n    transition: all 0.25s ease-in-out;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.excel-btn:hover {\n    background: linear-gradient(135deg, #1e7e34, #1c7430);\n    transform: translateY(-1px);\n    box-shadow: 0 5px 12px rgba(0, 0, 0, 0.25);\n}\n\n.excel-btn:active {\n    transform: scale(0.98);\n    box-shadow: none;\n}\n.bulk-error-row {\n    background-color: #f8d7da !important;\n    color: #721c24;\n    font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
